import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import { IPublicCompany, ITag } from 'src/models'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
	T extends { [key: string]: unknown },
	K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename'
				? T[P]
				: never
	  }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string }
	String: { input: string; output: string }
	Boolean: { input: boolean; output: boolean }
	Int: { input: number; output: number }
	Float: { input: number; output: number }
	BigFloat: { input: any; output: any }
	BigInt: { input: any; output: any }
	Cursor: { input: any; output: any }
	Date: { input: any; output: any }
	Datetime: { input: any; output: any }
	JSON: { input: any; output: any }
	Opaque: { input: any; output: any }
	Time: { input: any; output: any }
	UUID: { input: any; output: any }
}

export type ActiveArticleTag = Node & {
	__typename?: 'ActiveArticleTag'
	_ActiveArticleTagToUserCollection?: Maybe<_ActiveArticleTagToUserConnection>
	article?: Maybe<Article>
	articleTag?: Maybe<ArticleTag>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	tag?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
	votes?: Maybe<Scalars['Int']['output']>
}

export type ActiveArticleTag_ActiveArticleTagToUserCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_ActiveArticleTagToUserFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_ActiveArticleTagToUserOrderBy>>
}

export type ActiveArticleTagConnection = {
	__typename?: 'ActiveArticleTagConnection'
	edges: Array<ActiveArticleTagEdge>
	pageInfo: PageInfo
}

export type ActiveArticleTagDeleteResponse = {
	__typename?: 'ActiveArticleTagDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ActiveArticleTag>
}

export type ActiveArticleTagEdge = {
	__typename?: 'ActiveArticleTagEdge'
	cursor: Scalars['String']['output']
	node: ActiveArticleTag
}

export type ActiveArticleTagFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ActiveArticleTagFilter>>
	article?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ActiveArticleTagFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ActiveArticleTagFilter>>
	tag?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
	votes?: InputMaybe<IntFilter>
}

export type ActiveArticleTagInsertInput = {
	article?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	tag?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	votes?: InputMaybe<Scalars['Int']['input']>
}

export type ActiveArticleTagInsertResponse = {
	__typename?: 'ActiveArticleTagInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ActiveArticleTag>
}

export type ActiveArticleTagOrderBy = {
	article?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	tag?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	votes?: InputMaybe<OrderByDirection>
}

export type ActiveArticleTagUpdateInput = {
	article?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	tag?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	votes?: InputMaybe<Scalars['Int']['input']>
}

export type ActiveArticleTagUpdateResponse = {
	__typename?: 'ActiveArticleTagUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ActiveArticleTag>
}

export type ActivityField = Node & {
	__typename?: 'ActivityField'
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	jobCollection?: Maybe<JobConnection>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	title: Scalars['String']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type ActivityFieldJobCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<JobFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<JobOrderBy>>
}

export type ActivityFieldConnection = {
	__typename?: 'ActivityFieldConnection'
	edges: Array<ActivityFieldEdge>
	pageInfo: PageInfo
}

export type ActivityFieldDeleteResponse = {
	__typename?: 'ActivityFieldDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ActivityField>
}

export type ActivityFieldEdge = {
	__typename?: 'ActivityFieldEdge'
	cursor: Scalars['String']['output']
	node: ActivityField
}

export type ActivityFieldFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ActivityFieldFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ActivityFieldFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ActivityFieldFilter>>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type ActivityFieldInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ActivityFieldInsertResponse = {
	__typename?: 'ActivityFieldInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ActivityField>
}

export type ActivityFieldOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type ActivityFieldUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ActivityFieldUpdateResponse = {
	__typename?: 'ActivityFieldUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ActivityField>
}

export type Ad = Node & {
	__typename?: 'Ad'
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	updatedAt: Scalars['Datetime']['output']
	url?: Maybe<Scalars['String']['output']>
}

export type AdConnection = {
	__typename?: 'AdConnection'
	edges: Array<AdEdge>
	pageInfo: PageInfo
}

export type AdDeleteResponse = {
	__typename?: 'AdDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Ad>
}

export type AdEdge = {
	__typename?: 'AdEdge'
	cursor: Scalars['String']['output']
	node: Ad
}

export type AdFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<AdFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<AdFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<AdFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
	url?: InputMaybe<StringFilter>
}

export type AdInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	url?: InputMaybe<Scalars['String']['input']>
}

export type AdInsertResponse = {
	__typename?: 'AdInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Ad>
}

export type AdOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	url?: InputMaybe<OrderByDirection>
}

export type AdUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	url?: InputMaybe<Scalars['String']['input']>
}

export type AdUpdateResponse = {
	__typename?: 'AdUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Ad>
}

export type Article = Node & {
	__typename?: 'Article'
	activeArticleTagCollection?: Maybe<ActiveArticleTagConnection>
	allow_comments?: Maybe<Scalars['Boolean']['output']>
	article_mediaCollection?: Maybe<Article_MediaConnection>
	article_sharesCollection?: Maybe<Article_SharesConnection>
	body: Scalars['String']['output']
	company?: Maybe<Company>
	createdAt: Scalars['Datetime']['output']
	description?: Maybe<Scalars['String']['output']>
	descriptionLowerCase?: Maybe<Scalars['String']['output']>
	experience?: Maybe<Experience>
	favorite_user_articlesCollection?: Maybe<Favorite_User_ArticlesConnection>
	featuredImage?: Maybe<Scalars['String']['output']>
	featuredVideo?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	image?: Maybe<Image>
	isAboutMe?: Maybe<Scalars['Boolean']['output']>
	isFeatured?: Maybe<Scalars['Boolean']['output']>
	isPost?: Maybe<Scalars['Boolean']['output']>
	like_type?: Maybe<Scalars['String']['output']>
	liked_user_articlesCollection?: Maybe<Liked_User_ArticlesConnection>
	link?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	pin_date?: Maybe<Scalars['Datetime']['output']>
	postAs?: Maybe<Scalars['String']['output']>
	post_commentsCollection?: Maybe<Post_CommentsConnection>
	postingCompany?: Maybe<Scalars['String']['output']>
	postingTeam?: Maybe<Scalars['String']['output']>
	readDuration?: Maybe<Scalars['Int']['output']>
	searchCollection?: Maybe<SearchConnection>
	searchviewCollection?: Maybe<SearchviewConnection>
	slug?: Maybe<Scalars['String']['output']>
	team?: Maybe<Team>
	title?: Maybe<Scalars['String']['output']>
	total_views_count?: Maybe<Scalars['BigInt']['output']>
	type: Campaign_Type
	updatedAt: Scalars['Datetime']['output']
	user?: Maybe<User>
	viewed_user_articlesCollection?: Maybe<Viewed_User_ArticlesConnection>
	worksAt?: Maybe<Scalars['String']['output']>
}

export type ArticleActiveArticleTagCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ActiveArticleTagFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ActiveArticleTagOrderBy>>
}

export type ArticleArticle_MediaCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Article_MediaFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Article_MediaOrderBy>>
}

export type ArticleArticle_SharesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Article_SharesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Article_SharesOrderBy>>
}

export type ArticleFavorite_User_ArticlesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Favorite_User_ArticlesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Favorite_User_ArticlesOrderBy>>
}

export type ArticleLiked_User_ArticlesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Liked_User_ArticlesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Liked_User_ArticlesOrderBy>>
}

export type ArticlePost_CommentsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Post_CommentsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Post_CommentsOrderBy>>
}

export type ArticleSearchCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<SearchFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SearchOrderBy>>
}

export type ArticleSearchviewCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<SearchviewFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SearchviewOrderBy>>
}

export type ArticleViewed_User_ArticlesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Viewed_User_ArticlesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Viewed_User_ArticlesOrderBy>>
}

export type ArticleConnection = {
	__typename?: 'ArticleConnection'
	edges: Array<ArticleEdge>
	pageInfo: PageInfo
}

export type ArticleDeleteResponse = {
	__typename?: 'ArticleDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Article>
}

export type ArticleEdge = {
	__typename?: 'ArticleEdge'
	cursor: Scalars['String']['output']
	node: Article
}

export type ArticleFilter = {
	allow_comments?: InputMaybe<BooleanFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ArticleFilter>>
	body?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	description?: InputMaybe<StringFilter>
	descriptionLowerCase?: InputMaybe<StringFilter>
	featuredImage?: InputMaybe<StringFilter>
	featuredVideo?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	isAboutMe?: InputMaybe<BooleanFilter>
	isFeatured?: InputMaybe<BooleanFilter>
	isPost?: InputMaybe<BooleanFilter>
	like_type?: InputMaybe<StringFilter>
	link?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ArticleFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ArticleFilter>>
	pin_date?: InputMaybe<DatetimeFilter>
	postAs?: InputMaybe<StringFilter>
	postingCompany?: InputMaybe<StringFilter>
	postingTeam?: InputMaybe<StringFilter>
	readDuration?: InputMaybe<IntFilter>
	slug?: InputMaybe<StringFilter>
	title?: InputMaybe<StringFilter>
	total_views_count?: InputMaybe<BigIntFilter>
	type?: InputMaybe<Campaign_TypeFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
	user?: InputMaybe<StringFilter>
	worksAt?: InputMaybe<StringFilter>
}

export type ArticleInsertInput = {
	allow_comments?: InputMaybe<Scalars['Boolean']['input']>
	body?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	descriptionLowerCase?: InputMaybe<Scalars['String']['input']>
	featuredImage?: InputMaybe<Scalars['String']['input']>
	featuredVideo?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isAboutMe?: InputMaybe<Scalars['Boolean']['input']>
	isFeatured?: InputMaybe<Scalars['Boolean']['input']>
	isPost?: InputMaybe<Scalars['Boolean']['input']>
	like_type?: InputMaybe<Scalars['String']['input']>
	link?: InputMaybe<Scalars['String']['input']>
	pin_date?: InputMaybe<Scalars['Datetime']['input']>
	postAs?: InputMaybe<Scalars['String']['input']>
	postingCompany?: InputMaybe<Scalars['String']['input']>
	postingTeam?: InputMaybe<Scalars['String']['input']>
	readDuration?: InputMaybe<Scalars['Int']['input']>
	slug?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	total_views_count?: InputMaybe<Scalars['BigInt']['input']>
	type?: InputMaybe<Campaign_Type>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
	worksAt?: InputMaybe<Scalars['String']['input']>
}

export type ArticleInsertResponse = {
	__typename?: 'ArticleInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Article>
}

export type ArticleOrderBy = {
	allow_comments?: InputMaybe<OrderByDirection>
	body?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	descriptionLowerCase?: InputMaybe<OrderByDirection>
	featuredImage?: InputMaybe<OrderByDirection>
	featuredVideo?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	isAboutMe?: InputMaybe<OrderByDirection>
	isFeatured?: InputMaybe<OrderByDirection>
	isPost?: InputMaybe<OrderByDirection>
	like_type?: InputMaybe<OrderByDirection>
	link?: InputMaybe<OrderByDirection>
	pin_date?: InputMaybe<OrderByDirection>
	postAs?: InputMaybe<OrderByDirection>
	postingCompany?: InputMaybe<OrderByDirection>
	postingTeam?: InputMaybe<OrderByDirection>
	readDuration?: InputMaybe<OrderByDirection>
	slug?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	total_views_count?: InputMaybe<OrderByDirection>
	type?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	user?: InputMaybe<OrderByDirection>
	worksAt?: InputMaybe<OrderByDirection>
}

export type ArticleTag = Node & {
	__typename?: 'ArticleTag'
	activeArticleTagCollection?: Maybe<ActiveArticleTagConnection>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	title: Scalars['String']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type ArticleTagActiveArticleTagCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ActiveArticleTagFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ActiveArticleTagOrderBy>>
}

export type ArticleTagConnection = {
	__typename?: 'ArticleTagConnection'
	edges: Array<ArticleTagEdge>
	pageInfo: PageInfo
}

export type ArticleTagDeleteResponse = {
	__typename?: 'ArticleTagDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ArticleTag>
}

export type ArticleTagEdge = {
	__typename?: 'ArticleTagEdge'
	cursor: Scalars['String']['output']
	node: ArticleTag
}

export type ArticleTagFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ArticleTagFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ArticleTagFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ArticleTagFilter>>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type ArticleTagInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ArticleTagInsertResponse = {
	__typename?: 'ArticleTagInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ArticleTag>
}

export type ArticleTagOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type ArticleTagUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ArticleTagUpdateResponse = {
	__typename?: 'ArticleTagUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ArticleTag>
}

export type ArticleUpdateInput = {
	allow_comments?: InputMaybe<Scalars['Boolean']['input']>
	body?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	descriptionLowerCase?: InputMaybe<Scalars['String']['input']>
	featuredImage?: InputMaybe<Scalars['String']['input']>
	featuredVideo?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isAboutMe?: InputMaybe<Scalars['Boolean']['input']>
	isFeatured?: InputMaybe<Scalars['Boolean']['input']>
	isPost?: InputMaybe<Scalars['Boolean']['input']>
	like_type?: InputMaybe<Scalars['String']['input']>
	link?: InputMaybe<Scalars['String']['input']>
	pin_date?: InputMaybe<Scalars['Datetime']['input']>
	postAs?: InputMaybe<Scalars['String']['input']>
	postingCompany?: InputMaybe<Scalars['String']['input']>
	postingTeam?: InputMaybe<Scalars['String']['input']>
	readDuration?: InputMaybe<Scalars['Int']['input']>
	slug?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	total_views_count?: InputMaybe<Scalars['BigInt']['input']>
	type?: InputMaybe<Campaign_Type>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
	worksAt?: InputMaybe<Scalars['String']['input']>
}

export type ArticleUpdateResponse = {
	__typename?: 'ArticleUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Article>
}

/** Boolean expression comparing fields on type "BigFloat" */
export type BigFloatFilter = {
	eq?: InputMaybe<Scalars['BigFloat']['input']>
	gt?: InputMaybe<Scalars['BigFloat']['input']>
	gte?: InputMaybe<Scalars['BigFloat']['input']>
	in?: InputMaybe<Array<Scalars['BigFloat']['input']>>
	is?: InputMaybe<FilterIs>
	lt?: InputMaybe<Scalars['BigFloat']['input']>
	lte?: InputMaybe<Scalars['BigFloat']['input']>
	neq?: InputMaybe<Scalars['BigFloat']['input']>
}

/** Boolean expression comparing fields on type "BigFloatList" */
export type BigFloatListFilter = {
	containedBy?: InputMaybe<Array<Scalars['BigFloat']['input']>>
	contains?: InputMaybe<Array<Scalars['BigFloat']['input']>>
	eq?: InputMaybe<Array<Scalars['BigFloat']['input']>>
	is?: InputMaybe<FilterIs>
	overlaps?: InputMaybe<Array<Scalars['BigFloat']['input']>>
}

/** Boolean expression comparing fields on type "BigInt" */
export type BigIntFilter = {
	eq?: InputMaybe<Scalars['BigInt']['input']>
	gt?: InputMaybe<Scalars['BigInt']['input']>
	gte?: InputMaybe<Scalars['BigInt']['input']>
	in?: InputMaybe<Array<Scalars['BigInt']['input']>>
	is?: InputMaybe<FilterIs>
	lt?: InputMaybe<Scalars['BigInt']['input']>
	lte?: InputMaybe<Scalars['BigInt']['input']>
	neq?: InputMaybe<Scalars['BigInt']['input']>
}

/** Boolean expression comparing fields on type "BigIntList" */
export type BigIntListFilter = {
	containedBy?: InputMaybe<Array<Scalars['BigInt']['input']>>
	contains?: InputMaybe<Array<Scalars['BigInt']['input']>>
	eq?: InputMaybe<Array<Scalars['BigInt']['input']>>
	is?: InputMaybe<FilterIs>
	overlaps?: InputMaybe<Array<Scalars['BigInt']['input']>>
}

/** Boolean expression comparing fields on type "Boolean" */
export type BooleanFilter = {
	eq?: InputMaybe<Scalars['Boolean']['input']>
	is?: InputMaybe<FilterIs>
}

/** Boolean expression comparing fields on type "BooleanList" */
export type BooleanListFilter = {
	containedBy?: InputMaybe<Array<Scalars['Boolean']['input']>>
	contains?: InputMaybe<Array<Scalars['Boolean']['input']>>
	eq?: InputMaybe<Array<Scalars['Boolean']['input']>>
	is?: InputMaybe<FilterIs>
	overlaps?: InputMaybe<Array<Scalars['Boolean']['input']>>
}

export type Campaign = Node & {
	__typename?: 'Campaign'
	created_at: Scalars['Datetime']['output']
	description: Scalars['String']['output']
	end_date?: Maybe<Scalars['Date']['output']>
	external_url?: Maybe<Scalars['String']['output']>
	id: Scalars['UUID']['output']
	image?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	start_date?: Maybe<Scalars['Date']['output']>
	title: Scalars['String']['output']
	type?: Maybe<Campaign_Type>
	updated_at: Scalars['Datetime']['output']
}

export type CampaignConnection = {
	__typename?: 'CampaignConnection'
	edges: Array<CampaignEdge>
	pageInfo: PageInfo
}

export type CampaignDeleteResponse = {
	__typename?: 'CampaignDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign>
}

export type CampaignEdge = {
	__typename?: 'CampaignEdge'
	cursor: Scalars['String']['output']
	node: Campaign
}

export type CampaignFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<CampaignFilter>>
	created_at?: InputMaybe<DatetimeFilter>
	description?: InputMaybe<StringFilter>
	end_date?: InputMaybe<DateFilter>
	external_url?: InputMaybe<StringFilter>
	id?: InputMaybe<UuidFilter>
	image?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<CampaignFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<CampaignFilter>>
	start_date?: InputMaybe<DateFilter>
	title?: InputMaybe<StringFilter>
	type?: InputMaybe<Campaign_TypeFilter>
	updated_at?: InputMaybe<DatetimeFilter>
}

export type CampaignInsertInput = {
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	end_date?: InputMaybe<Scalars['Date']['input']>
	external_url?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	image?: InputMaybe<Scalars['String']['input']>
	start_date?: InputMaybe<Scalars['Date']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	type?: InputMaybe<Campaign_Type>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
}

export type CampaignInsertResponse = {
	__typename?: 'CampaignInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign>
}

export type CampaignOrderBy = {
	created_at?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	end_date?: InputMaybe<OrderByDirection>
	external_url?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	image?: InputMaybe<OrderByDirection>
	start_date?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	type?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
}

export type CampaignUpdateInput = {
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	end_date?: InputMaybe<Scalars['Date']['input']>
	external_url?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	image?: InputMaybe<Scalars['String']['input']>
	start_date?: InputMaybe<Scalars['Date']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	type?: InputMaybe<Campaign_Type>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
}

export type CampaignUpdateResponse = {
	__typename?: 'CampaignUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign>
}

export type ChillPackCompany = Node & {
	__typename?: 'ChillPackCompany'
	campaign_recipientsCollection?: Maybe<Campaign_RecipientsConnection>
	chillPackRecipientCollection?: Maybe<ChillPackRecipientConnection>
	createdAt?: Maybe<Scalars['Datetime']['output']>
	details?: Maybe<Scalars['JSON']['output']>
	id: Scalars['String']['output']
	name: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	profileCollection?: Maybe<ProfileConnection>
	updatedAt?: Maybe<Scalars['Datetime']['output']>
}

export type ChillPackCompanyCampaign_RecipientsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Campaign_RecipientsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Campaign_RecipientsOrderBy>>
}

export type ChillPackCompanyChillPackRecipientCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ChillPackRecipientFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ChillPackRecipientOrderBy>>
}

export type ChillPackCompanyProfileCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ProfileFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ProfileOrderBy>>
}

export type ChillPackCompanyConnection = {
	__typename?: 'ChillPackCompanyConnection'
	edges: Array<ChillPackCompanyEdge>
	pageInfo: PageInfo
}

export type ChillPackCompanyDeleteResponse = {
	__typename?: 'ChillPackCompanyDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackCompany>
}

export type ChillPackCompanyEdge = {
	__typename?: 'ChillPackCompanyEdge'
	cursor: Scalars['String']['output']
	node: ChillPackCompany
}

export type ChillPackCompanyFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ChillPackCompanyFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ChillPackCompanyFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ChillPackCompanyFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type ChillPackCompanyInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	details?: InputMaybe<Scalars['JSON']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ChillPackCompanyInsertResponse = {
	__typename?: 'ChillPackCompanyInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackCompany>
}

export type ChillPackCompanyOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	name?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type ChillPackCompanyUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	details?: InputMaybe<Scalars['JSON']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ChillPackCompanyUpdateResponse = {
	__typename?: 'ChillPackCompanyUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackCompany>
}

export type ChillPackEdition = Node & {
	__typename?: 'ChillPackEdition'
	chillPackRecipientCollection?: Maybe<ChillPackRecipientConnection>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	month: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	updatedAt: Scalars['Datetime']['output']
	year: Scalars['String']['output']
}

export type ChillPackEditionChillPackRecipientCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ChillPackRecipientFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ChillPackRecipientOrderBy>>
}

export type ChillPackEditionConnection = {
	__typename?: 'ChillPackEditionConnection'
	edges: Array<ChillPackEditionEdge>
	pageInfo: PageInfo
}

export type ChillPackEditionDeleteResponse = {
	__typename?: 'ChillPackEditionDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackEdition>
}

export type ChillPackEditionEdge = {
	__typename?: 'ChillPackEditionEdge'
	cursor: Scalars['String']['output']
	node: ChillPackEdition
}

export type ChillPackEditionFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ChillPackEditionFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	month?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ChillPackEditionFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ChillPackEditionFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
	year?: InputMaybe<StringFilter>
}

export type ChillPackEditionInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	month?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	year?: InputMaybe<Scalars['String']['input']>
}

export type ChillPackEditionInsertResponse = {
	__typename?: 'ChillPackEditionInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackEdition>
}

export type ChillPackEditionOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	month?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	year?: InputMaybe<OrderByDirection>
}

export type ChillPackEditionUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	month?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	year?: InputMaybe<Scalars['String']['input']>
}

export type ChillPackEditionUpdateResponse = {
	__typename?: 'ChillPackEditionUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackEdition>
}

export type ChillPackRecipient = Node & {
	__typename?: 'ChillPackRecipient'
	chillPackCompany?: Maybe<ChillPackCompany>
	chillPackEdition?: Maybe<ChillPackEdition>
	chillPackRecipientClaim?: Maybe<ChillPackRecipientClaim>
	chillPackRecipientClaimCollection?: Maybe<ChillPackRecipientClaimConnection>
	company?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['Datetime']['output']
	email: Scalars['String']['output']
	emailVerified: Scalars['Boolean']['output']
	firstName: Scalars['String']['output']
	id: Scalars['String']['output']
	lastName: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	pin: Scalars['String']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type ChillPackRecipientChillPackRecipientClaimCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ChillPackRecipientClaimFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ChillPackRecipientClaimOrderBy>>
}

export type ChillPackRecipientClaim = Node & {
	__typename?: 'ChillPackRecipientClaim'
	chillPackRecipient?: Maybe<ChillPackRecipient>
	chillPackRecipientCollection?: Maybe<ChillPackRecipientConnection>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	reviewEmailSent?: Maybe<Scalars['Boolean']['output']>
	scanningAgentFromUserTable?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
	user?: Maybe<User>
}

export type ChillPackRecipientClaimChillPackRecipientCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ChillPackRecipientFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ChillPackRecipientOrderBy>>
}

export type ChillPackRecipientClaimConnection = {
	__typename?: 'ChillPackRecipientClaimConnection'
	edges: Array<ChillPackRecipientClaimEdge>
	pageInfo: PageInfo
}

export type ChillPackRecipientClaimDeleteResponse = {
	__typename?: 'ChillPackRecipientClaimDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackRecipientClaim>
}

export type ChillPackRecipientClaimEdge = {
	__typename?: 'ChillPackRecipientClaimEdge'
	cursor: Scalars['String']['output']
	node: ChillPackRecipientClaim
}

export type ChillPackRecipientClaimFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ChillPackRecipientClaimFilter>>
	chillPackRecipient?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ChillPackRecipientClaimFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ChillPackRecipientClaimFilter>>
	reviewEmailSent?: InputMaybe<BooleanFilter>
	scanningAgentFromUserTable?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type ChillPackRecipientClaimInsertInput = {
	chillPackRecipient?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	reviewEmailSent?: InputMaybe<Scalars['Boolean']['input']>
	scanningAgentFromUserTable?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ChillPackRecipientClaimInsertResponse = {
	__typename?: 'ChillPackRecipientClaimInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackRecipientClaim>
}

export type ChillPackRecipientClaimOrderBy = {
	chillPackRecipient?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	reviewEmailSent?: InputMaybe<OrderByDirection>
	scanningAgentFromUserTable?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type ChillPackRecipientClaimUpdateInput = {
	chillPackRecipient?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	reviewEmailSent?: InputMaybe<Scalars['Boolean']['input']>
	scanningAgentFromUserTable?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ChillPackRecipientClaimUpdateResponse = {
	__typename?: 'ChillPackRecipientClaimUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackRecipientClaim>
}

export type ChillPackRecipientConnection = {
	__typename?: 'ChillPackRecipientConnection'
	edges: Array<ChillPackRecipientEdge>
	pageInfo: PageInfo
}

export type ChillPackRecipientDeleteResponse = {
	__typename?: 'ChillPackRecipientDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackRecipient>
}

export type ChillPackRecipientEdge = {
	__typename?: 'ChillPackRecipientEdge'
	cursor: Scalars['String']['output']
	node: ChillPackRecipient
}

export type ChillPackRecipientFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ChillPackRecipientFilter>>
	chillPackEdition?: InputMaybe<StringFilter>
	chillPackRecipientClaim?: InputMaybe<StringFilter>
	company?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	email?: InputMaybe<StringFilter>
	emailVerified?: InputMaybe<BooleanFilter>
	firstName?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	lastName?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ChillPackRecipientFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ChillPackRecipientFilter>>
	pin?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type ChillPackRecipientInsertInput = {
	chillPackEdition?: InputMaybe<Scalars['String']['input']>
	chillPackRecipientClaim?: InputMaybe<Scalars['String']['input']>
	company?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	emailVerified?: InputMaybe<Scalars['Boolean']['input']>
	firstName?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	lastName?: InputMaybe<Scalars['String']['input']>
	pin?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ChillPackRecipientInsertResponse = {
	__typename?: 'ChillPackRecipientInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackRecipient>
}

export type ChillPackRecipientOrderBy = {
	chillPackEdition?: InputMaybe<OrderByDirection>
	chillPackRecipientClaim?: InputMaybe<OrderByDirection>
	company?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	email?: InputMaybe<OrderByDirection>
	emailVerified?: InputMaybe<OrderByDirection>
	firstName?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	lastName?: InputMaybe<OrderByDirection>
	pin?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type ChillPackRecipientUpdateInput = {
	chillPackEdition?: InputMaybe<Scalars['String']['input']>
	chillPackRecipientClaim?: InputMaybe<Scalars['String']['input']>
	company?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	emailVerified?: InputMaybe<Scalars['Boolean']['input']>
	firstName?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	lastName?: InputMaybe<Scalars['String']['input']>
	pin?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ChillPackRecipientUpdateResponse = {
	__typename?: 'ChillPackRecipientUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackRecipient>
}

export type ChillPackScheduledMailCronjobData = Node & {
	__typename?: 'ChillPackScheduledMailCronjobData'
	createdAt: Scalars['Datetime']['output']
	errorMessage?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	receiverAddress: Scalars['String']['output']
	success: Scalars['Boolean']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type ChillPackScheduledMailCronjobDataConnection = {
	__typename?: 'ChillPackScheduledMailCronjobDataConnection'
	edges: Array<ChillPackScheduledMailCronjobDataEdge>
	pageInfo: PageInfo
}

export type ChillPackScheduledMailCronjobDataDeleteResponse = {
	__typename?: 'ChillPackScheduledMailCronjobDataDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackScheduledMailCronjobData>
}

export type ChillPackScheduledMailCronjobDataEdge = {
	__typename?: 'ChillPackScheduledMailCronjobDataEdge'
	cursor: Scalars['String']['output']
	node: ChillPackScheduledMailCronjobData
}

export type ChillPackScheduledMailCronjobDataFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ChillPackScheduledMailCronjobDataFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	errorMessage?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ChillPackScheduledMailCronjobDataFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ChillPackScheduledMailCronjobDataFilter>>
	receiverAddress?: InputMaybe<StringFilter>
	success?: InputMaybe<BooleanFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type ChillPackScheduledMailCronjobDataInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	errorMessage?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	receiverAddress?: InputMaybe<Scalars['String']['input']>
	success?: InputMaybe<Scalars['Boolean']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ChillPackScheduledMailCronjobDataInsertResponse = {
	__typename?: 'ChillPackScheduledMailCronjobDataInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackScheduledMailCronjobData>
}

export type ChillPackScheduledMailCronjobDataOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	errorMessage?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	receiverAddress?: InputMaybe<OrderByDirection>
	success?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type ChillPackScheduledMailCronjobDataUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	errorMessage?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	receiverAddress?: InputMaybe<Scalars['String']['input']>
	success?: InputMaybe<Scalars['Boolean']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ChillPackScheduledMailCronjobDataUpdateResponse = {
	__typename?: 'ChillPackScheduledMailCronjobDataUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ChillPackScheduledMailCronjobData>
}

export type Company = Node & {
	__typename?: 'Company'
	_CompanyToCompanyTypeCollection?: Maybe<_CompanyToCompanyTypeConnection>
	_OwnerToCompanyCollection?: Maybe<_OwnerToCompanyConnection>
	aboutTeams?: Maybe<Scalars['String']['output']>
	articleCollection?: Maybe<ArticleConnection>
	companyOfficesCollection?: Maybe<CompanyOfficesConnection>
	companyRoleCollection?: Maybe<CompanyRoleConnection>
	coverBackground?: Maybe<Scalars['String']['output']>
	coverContentType?: Maybe<Scalars['String']['output']>
	coverPath?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['Datetime']['output']
	dateFounded?: Maybe<Scalars['String']['output']>
	deletedAt?: Maybe<Scalars['Datetime']['output']>
	description?: Maybe<Scalars['String']['output']>
	emails?: Maybe<Scalars['String']['output']>
	faqCollection?: Maybe<FaqConnection>
	featuredImage?: Maybe<Scalars['String']['output']>
	featuredVideo?: Maybe<Scalars['String']['output']>
	hasCover?: Maybe<Scalars['Boolean']['output']>
	hasLogo?: Maybe<Scalars['Boolean']['output']>
	headline?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	image?: Maybe<Image>
	industry?: Maybe<Industry>
	jobCollection?: Maybe<JobConnection>
	linkedUsersToCompaniesCollection?: Maybe<LinkedUsersToCompaniesConnection>
	logoContentType?: Maybe<Scalars['String']['output']>
	logoPath?: Maybe<Scalars['String']['output']>
	name?: Maybe<Scalars['String']['output']>
	noOfEmployees?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	phones?: Maybe<Scalars['String']['output']>
	productsAndServices?: Maybe<Scalars['String']['output']>
	searchCollection?: Maybe<SearchConnection>
	searchviewCollection?: Maybe<SearchviewConnection>
	slug: Scalars['String']['output']
	teamCollection?: Maybe<TeamConnection>
	teamRoleCollection?: Maybe<TeamRoleConnection>
	updatedAt: Scalars['Datetime']['output']
	website?: Maybe<Scalars['String']['output']>
}

export type Company_CompanyToCompanyTypeCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_CompanyToCompanyTypeFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_CompanyToCompanyTypeOrderBy>>
}

export type Company_OwnerToCompanyCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_OwnerToCompanyFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_OwnerToCompanyOrderBy>>
}

export type CompanyArticleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ArticleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ArticleOrderBy>>
}

export type CompanyCompanyOfficesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyOfficesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyOfficesOrderBy>>
}

export type CompanyCompanyRoleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyRoleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyRoleOrderBy>>
}

export type CompanyFaqCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<FaqFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<FaqOrderBy>>
}

export type CompanyJobCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<JobFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<JobOrderBy>>
}

export type CompanyLinkedUsersToCompaniesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<LinkedUsersToCompaniesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<LinkedUsersToCompaniesOrderBy>>
}

export type CompanySearchCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<SearchFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SearchOrderBy>>
}

export type CompanySearchviewCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<SearchviewFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SearchviewOrderBy>>
}

export type CompanyTeamCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<TeamFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<TeamOrderBy>>
}

export type CompanyTeamRoleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<TeamRoleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<TeamRoleOrderBy>>
}

export type CompanyConnection = {
	__typename?: 'CompanyConnection'
	edges: Array<CompanyEdge>
	pageInfo: PageInfo
}

export type CompanyDeleteResponse = {
	__typename?: 'CompanyDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Company>
}

export type CompanyEdge = {
	__typename?: 'CompanyEdge'
	cursor: Scalars['String']['output']
	node: Company
}

export type CompanyEmails = Node & {
	__typename?: 'CompanyEmails'
	email: Scalars['String']['output']
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	title?: Maybe<Scalars['String']['output']>
}

export type CompanyEmailsConnection = {
	__typename?: 'CompanyEmailsConnection'
	edges: Array<CompanyEmailsEdge>
	pageInfo: PageInfo
}

export type CompanyEmailsDeleteResponse = {
	__typename?: 'CompanyEmailsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyEmails>
}

export type CompanyEmailsEdge = {
	__typename?: 'CompanyEmailsEdge'
	cursor: Scalars['String']['output']
	node: CompanyEmails
}

export type CompanyEmailsFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<CompanyEmailsFilter>>
	email?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<CompanyEmailsFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<CompanyEmailsFilter>>
	title?: InputMaybe<StringFilter>
}

export type CompanyEmailsInsertInput = {
	email?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
}

export type CompanyEmailsInsertResponse = {
	__typename?: 'CompanyEmailsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyEmails>
}

export type CompanyEmailsOrderBy = {
	email?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
}

export type CompanyEmailsUpdateInput = {
	email?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
}

export type CompanyEmailsUpdateResponse = {
	__typename?: 'CompanyEmailsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyEmails>
}

export type CompanyFilter = {
	aboutTeams?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<CompanyFilter>>
	coverBackground?: InputMaybe<StringFilter>
	coverContentType?: InputMaybe<StringFilter>
	coverPath?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	dateFounded?: InputMaybe<StringFilter>
	deletedAt?: InputMaybe<DatetimeFilter>
	description?: InputMaybe<StringFilter>
	emails?: InputMaybe<StringFilter>
	featuredImage?: InputMaybe<StringFilter>
	featuredVideo?: InputMaybe<StringFilter>
	hasCover?: InputMaybe<BooleanFilter>
	hasLogo?: InputMaybe<BooleanFilter>
	headline?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	industry?: InputMaybe<StringFilter>
	logoContentType?: InputMaybe<StringFilter>
	logoPath?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	noOfEmployees?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<CompanyFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<CompanyFilter>>
	phones?: InputMaybe<StringFilter>
	productsAndServices?: InputMaybe<StringFilter>
	slug?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
	website?: InputMaybe<StringFilter>
}

export type CompanyInsertInput = {
	aboutTeams?: InputMaybe<Scalars['String']['input']>
	coverBackground?: InputMaybe<Scalars['String']['input']>
	coverContentType?: InputMaybe<Scalars['String']['input']>
	coverPath?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	dateFounded?: InputMaybe<Scalars['String']['input']>
	deletedAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	emails?: InputMaybe<Scalars['String']['input']>
	featuredImage?: InputMaybe<Scalars['String']['input']>
	featuredVideo?: InputMaybe<Scalars['String']['input']>
	hasCover?: InputMaybe<Scalars['Boolean']['input']>
	hasLogo?: InputMaybe<Scalars['Boolean']['input']>
	headline?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	industry?: InputMaybe<Scalars['String']['input']>
	logoContentType?: InputMaybe<Scalars['String']['input']>
	logoPath?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	noOfEmployees?: InputMaybe<Scalars['String']['input']>
	phones?: InputMaybe<Scalars['String']['input']>
	productsAndServices?: InputMaybe<Scalars['String']['input']>
	slug?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	website?: InputMaybe<Scalars['String']['input']>
}

export type CompanyInsertResponse = {
	__typename?: 'CompanyInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Company>
}

export type CompanyOffices = Node & {
	__typename?: 'CompanyOffices'
	_JobToCompanyOfficesCollection?: Maybe<_JobToCompanyOfficesConnection>
	_TeamToCompanyOfficesCollection?: Maybe<_TeamToCompanyOfficesConnection>
	address?: Maybe<Scalars['String']['output']>
	company?: Maybe<Company>
	companyId?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['Datetime']['output']
	hq?: Maybe<Scalars['Boolean']['output']>
	id: Scalars['String']['output']
	location?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	roLocations?: Maybe<RoLocations>
	updatedAt: Scalars['Datetime']['output']
	zipCode?: Maybe<Scalars['String']['output']>
}

export type CompanyOffices_JobToCompanyOfficesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_JobToCompanyOfficesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_JobToCompanyOfficesOrderBy>>
}

export type CompanyOffices_TeamToCompanyOfficesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_TeamToCompanyOfficesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_TeamToCompanyOfficesOrderBy>>
}

export type CompanyOfficesConnection = {
	__typename?: 'CompanyOfficesConnection'
	edges: Array<CompanyOfficesEdge>
	pageInfo: PageInfo
}

export type CompanyOfficesDeleteResponse = {
	__typename?: 'CompanyOfficesDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyOffices>
}

export type CompanyOfficesEdge = {
	__typename?: 'CompanyOfficesEdge'
	cursor: Scalars['String']['output']
	node: CompanyOffices
}

export type CompanyOfficesFilter = {
	address?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<CompanyOfficesFilter>>
	companyId?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	hq?: InputMaybe<BooleanFilter>
	id?: InputMaybe<StringFilter>
	location?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<CompanyOfficesFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<CompanyOfficesFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
	zipCode?: InputMaybe<StringFilter>
}

export type CompanyOfficesInsertInput = {
	address?: InputMaybe<Scalars['String']['input']>
	companyId?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	hq?: InputMaybe<Scalars['Boolean']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	zipCode?: InputMaybe<Scalars['String']['input']>
}

export type CompanyOfficesInsertResponse = {
	__typename?: 'CompanyOfficesInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyOffices>
}

export type CompanyOfficesOrderBy = {
	address?: InputMaybe<OrderByDirection>
	companyId?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	hq?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	location?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	zipCode?: InputMaybe<OrderByDirection>
}

export type CompanyOfficesUpdateInput = {
	address?: InputMaybe<Scalars['String']['input']>
	companyId?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	hq?: InputMaybe<Scalars['Boolean']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	zipCode?: InputMaybe<Scalars['String']['input']>
}

export type CompanyOfficesUpdateResponse = {
	__typename?: 'CompanyOfficesUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyOffices>
}

export type CompanyOrderBy = {
	aboutTeams?: InputMaybe<OrderByDirection>
	coverBackground?: InputMaybe<OrderByDirection>
	coverContentType?: InputMaybe<OrderByDirection>
	coverPath?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	dateFounded?: InputMaybe<OrderByDirection>
	deletedAt?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	emails?: InputMaybe<OrderByDirection>
	featuredImage?: InputMaybe<OrderByDirection>
	featuredVideo?: InputMaybe<OrderByDirection>
	hasCover?: InputMaybe<OrderByDirection>
	hasLogo?: InputMaybe<OrderByDirection>
	headline?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	industry?: InputMaybe<OrderByDirection>
	logoContentType?: InputMaybe<OrderByDirection>
	logoPath?: InputMaybe<OrderByDirection>
	name?: InputMaybe<OrderByDirection>
	noOfEmployees?: InputMaybe<OrderByDirection>
	phones?: InputMaybe<OrderByDirection>
	productsAndServices?: InputMaybe<OrderByDirection>
	slug?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	website?: InputMaybe<OrderByDirection>
}

export type CompanyPhones = Node & {
	__typename?: 'CompanyPhones'
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	phone: Scalars['String']['output']
	title?: Maybe<Scalars['String']['output']>
}

export type CompanyPhonesConnection = {
	__typename?: 'CompanyPhonesConnection'
	edges: Array<CompanyPhonesEdge>
	pageInfo: PageInfo
}

export type CompanyPhonesDeleteResponse = {
	__typename?: 'CompanyPhonesDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyPhones>
}

export type CompanyPhonesEdge = {
	__typename?: 'CompanyPhonesEdge'
	cursor: Scalars['String']['output']
	node: CompanyPhones
}

export type CompanyPhonesFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<CompanyPhonesFilter>>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<CompanyPhonesFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<CompanyPhonesFilter>>
	phone?: InputMaybe<StringFilter>
	title?: InputMaybe<StringFilter>
}

export type CompanyPhonesInsertInput = {
	id?: InputMaybe<Scalars['String']['input']>
	phone?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
}

export type CompanyPhonesInsertResponse = {
	__typename?: 'CompanyPhonesInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyPhones>
}

export type CompanyPhonesOrderBy = {
	id?: InputMaybe<OrderByDirection>
	phone?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
}

export type CompanyPhonesUpdateInput = {
	id?: InputMaybe<Scalars['String']['input']>
	phone?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
}

export type CompanyPhonesUpdateResponse = {
	__typename?: 'CompanyPhonesUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyPhones>
}

export type CompanyResponse = Node & {
	__typename?: 'CompanyResponse'
	error?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	status?: Maybe<Scalars['Boolean']['output']>
}

export type CompanyResponseConnection = {
	__typename?: 'CompanyResponseConnection'
	edges: Array<CompanyResponseEdge>
	pageInfo: PageInfo
}

export type CompanyResponseDeleteResponse = {
	__typename?: 'CompanyResponseDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyResponse>
}

export type CompanyResponseEdge = {
	__typename?: 'CompanyResponseEdge'
	cursor: Scalars['String']['output']
	node: CompanyResponse
}

export type CompanyResponseFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<CompanyResponseFilter>>
	error?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<CompanyResponseFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<CompanyResponseFilter>>
	status?: InputMaybe<BooleanFilter>
}

export type CompanyResponseInsertInput = {
	error?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	status?: InputMaybe<Scalars['Boolean']['input']>
}

export type CompanyResponseInsertResponse = {
	__typename?: 'CompanyResponseInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyResponse>
}

export type CompanyResponseOrderBy = {
	error?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	status?: InputMaybe<OrderByDirection>
}

export type CompanyResponseUpdateInput = {
	error?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	status?: InputMaybe<Scalars['Boolean']['input']>
}

export type CompanyResponseUpdateResponse = {
	__typename?: 'CompanyResponseUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyResponse>
}

export type CompanyRole = Node & {
	__typename?: 'CompanyRole'
	_UserToCompanyRoleCollection?: Maybe<_UserToCompanyRoleConnection>
	company?: Maybe<Company>
	companyId?: Maybe<Scalars['String']['output']>
	companyRole_rolesCollection?: Maybe<CompanyRole_RolesConnection>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type CompanyRole_UserToCompanyRoleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_UserToCompanyRoleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_UserToCompanyRoleOrderBy>>
}

export type CompanyRoleCompanyRole_RolesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyRole_RolesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyRole_RolesOrderBy>>
}

export type CompanyRoleConnection = {
	__typename?: 'CompanyRoleConnection'
	edges: Array<CompanyRoleEdge>
	pageInfo: PageInfo
}

export type CompanyRoleDeleteResponse = {
	__typename?: 'CompanyRoleDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyRole>
}

export type CompanyRoleEdge = {
	__typename?: 'CompanyRoleEdge'
	cursor: Scalars['String']['output']
	node: CompanyRole
}

export type CompanyRoleFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<CompanyRoleFilter>>
	companyId?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<CompanyRoleFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<CompanyRoleFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type CompanyRoleInsertInput = {
	companyId?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type CompanyRoleInsertResponse = {
	__typename?: 'CompanyRoleInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyRole>
}

export type CompanyRoleOrderBy = {
	companyId?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type CompanyRoleUpdateInput = {
	companyId?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type CompanyRoleUpdateResponse = {
	__typename?: 'CompanyRoleUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyRole>
}

export type CompanyRole_Roles = Node & {
	__typename?: 'CompanyRole_roles'
	companyRole: CompanyRole
	companyRoleId: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	position: Scalars['Int']['output']
	value: Scalars['String']['output']
}

export type CompanyRole_RolesConnection = {
	__typename?: 'CompanyRole_rolesConnection'
	edges: Array<CompanyRole_RolesEdge>
	pageInfo: PageInfo
}

export type CompanyRole_RolesDeleteResponse = {
	__typename?: 'CompanyRole_rolesDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyRole_Roles>
}

export type CompanyRole_RolesEdge = {
	__typename?: 'CompanyRole_rolesEdge'
	cursor: Scalars['String']['output']
	node: CompanyRole_Roles
}

export type CompanyRole_RolesFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<CompanyRole_RolesFilter>>
	companyRoleId?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<CompanyRole_RolesFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<CompanyRole_RolesFilter>>
	position?: InputMaybe<IntFilter>
	value?: InputMaybe<StringFilter>
}

export type CompanyRole_RolesInsertInput = {
	companyRoleId?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['Int']['input']>
	value?: InputMaybe<Scalars['String']['input']>
}

export type CompanyRole_RolesInsertResponse = {
	__typename?: 'CompanyRole_rolesInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyRole_Roles>
}

export type CompanyRole_RolesOrderBy = {
	companyRoleId?: InputMaybe<OrderByDirection>
	position?: InputMaybe<OrderByDirection>
	value?: InputMaybe<OrderByDirection>
}

export type CompanyRole_RolesUpdateInput = {
	companyRoleId?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['Int']['input']>
	value?: InputMaybe<Scalars['String']['input']>
}

export type CompanyRole_RolesUpdateResponse = {
	__typename?: 'CompanyRole_rolesUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyRole_Roles>
}

export type CompanyType = Node & {
	__typename?: 'CompanyType'
	_CompanyToCompanyTypeCollection?: Maybe<_CompanyToCompanyTypeConnection>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	title?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
}

export type CompanyType_CompanyToCompanyTypeCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_CompanyToCompanyTypeFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_CompanyToCompanyTypeOrderBy>>
}

export type CompanyTypeConnection = {
	__typename?: 'CompanyTypeConnection'
	edges: Array<CompanyTypeEdge>
	pageInfo: PageInfo
}

export type CompanyTypeDeleteResponse = {
	__typename?: 'CompanyTypeDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyType>
}

export type CompanyTypeEdge = {
	__typename?: 'CompanyTypeEdge'
	cursor: Scalars['String']['output']
	node: CompanyType
}

export type CompanyTypeFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<CompanyTypeFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<CompanyTypeFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<CompanyTypeFilter>>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type CompanyTypeInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type CompanyTypeInsertResponse = {
	__typename?: 'CompanyTypeInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyType>
}

export type CompanyTypeOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type CompanyTypeUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type CompanyTypeUpdateResponse = {
	__typename?: 'CompanyTypeUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CompanyType>
}

export type CompanyUpdateInput = {
	aboutTeams?: InputMaybe<Scalars['String']['input']>
	coverBackground?: InputMaybe<Scalars['String']['input']>
	coverContentType?: InputMaybe<Scalars['String']['input']>
	coverPath?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	dateFounded?: InputMaybe<Scalars['String']['input']>
	deletedAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	emails?: InputMaybe<Scalars['String']['input']>
	featuredImage?: InputMaybe<Scalars['String']['input']>
	featuredVideo?: InputMaybe<Scalars['String']['input']>
	hasCover?: InputMaybe<Scalars['Boolean']['input']>
	hasLogo?: InputMaybe<Scalars['Boolean']['input']>
	headline?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	industry?: InputMaybe<Scalars['String']['input']>
	logoContentType?: InputMaybe<Scalars['String']['input']>
	logoPath?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	noOfEmployees?: InputMaybe<Scalars['String']['input']>
	phones?: InputMaybe<Scalars['String']['input']>
	productsAndServices?: InputMaybe<Scalars['String']['input']>
	slug?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	website?: InputMaybe<Scalars['String']['input']>
}

export type CompanyUpdateResponse = {
	__typename?: 'CompanyUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Company>
}

export type Contact = Node & {
	__typename?: 'Contact'
	createdAt: Scalars['Datetime']['output']
	email?: Maybe<Scalars['String']['output']>
	facebook?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	linkedin?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	phone?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
}

export type ContactConnection = {
	__typename?: 'ContactConnection'
	edges: Array<ContactEdge>
	pageInfo: PageInfo
}

export type ContactDeleteResponse = {
	__typename?: 'ContactDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Contact>
}

export type ContactEdge = {
	__typename?: 'ContactEdge'
	cursor: Scalars['String']['output']
	node: Contact
}

export type ContactFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ContactFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	email?: InputMaybe<StringFilter>
	facebook?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	linkedin?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ContactFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ContactFilter>>
	phone?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type ContactInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	facebook?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	linkedin?: InputMaybe<Scalars['String']['input']>
	phone?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ContactInsertResponse = {
	__typename?: 'ContactInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Contact>
}

export type ContactOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	email?: InputMaybe<OrderByDirection>
	facebook?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	linkedin?: InputMaybe<OrderByDirection>
	phone?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type ContactUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	facebook?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	linkedin?: InputMaybe<Scalars['String']['input']>
	phone?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ContactUpdateResponse = {
	__typename?: 'ContactUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Contact>
}

export type Country = Node & {
	__typename?: 'Country'
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	name: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type CountryConnection = {
	__typename?: 'CountryConnection'
	edges: Array<CountryEdge>
	pageInfo: PageInfo
}

export type CountryDeleteResponse = {
	__typename?: 'CountryDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Country>
}

export type CountryEdge = {
	__typename?: 'CountryEdge'
	cursor: Scalars['String']['output']
	node: Country
}

export type CountryFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<CountryFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<CountryFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<CountryFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type CountryInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type CountryInsertResponse = {
	__typename?: 'CountryInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Country>
}

export type CountryOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	name?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type CountryUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type CountryUpdateResponse = {
	__typename?: 'CountryUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Country>
}

export type CurrentPosition = Node & {
	__typename?: 'CurrentPosition'
	createdAt: Scalars['Datetime']['output']
	education?: Maybe<Education>
	experience?: Maybe<Experience>
	hobby?: Maybe<Hobby>
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	project?: Maybe<Project>
	updatedAt: Scalars['Datetime']['output']
}

export type CurrentPositionConnection = {
	__typename?: 'CurrentPositionConnection'
	edges: Array<CurrentPositionEdge>
	pageInfo: PageInfo
}

export type CurrentPositionDeleteResponse = {
	__typename?: 'CurrentPositionDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CurrentPosition>
}

export type CurrentPositionEdge = {
	__typename?: 'CurrentPositionEdge'
	cursor: Scalars['String']['output']
	node: CurrentPosition
}

export type CurrentPositionFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<CurrentPositionFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	education?: InputMaybe<StringFilter>
	experience?: InputMaybe<StringFilter>
	hobby?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<CurrentPositionFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<CurrentPositionFilter>>
	project?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type CurrentPositionInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	education?: InputMaybe<Scalars['String']['input']>
	experience?: InputMaybe<Scalars['String']['input']>
	hobby?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	project?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type CurrentPositionInsertResponse = {
	__typename?: 'CurrentPositionInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CurrentPosition>
}

export type CurrentPositionOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	education?: InputMaybe<OrderByDirection>
	experience?: InputMaybe<OrderByDirection>
	hobby?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	project?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type CurrentPositionUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	education?: InputMaybe<Scalars['String']['input']>
	experience?: InputMaybe<Scalars['String']['input']>
	hobby?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	project?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type CurrentPositionUpdateResponse = {
	__typename?: 'CurrentPositionUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CurrentPosition>
}

export type CustomSkills = Node & {
	__typename?: 'CustomSkills'
	_JobToCustomSkillsCollection?: Maybe<_JobToCustomSkillsConnection>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	key: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	title: Scalars['String']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type CustomSkills_JobToCustomSkillsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_JobToCustomSkillsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_JobToCustomSkillsOrderBy>>
}

export type CustomSkillsConnection = {
	__typename?: 'CustomSkillsConnection'
	edges: Array<CustomSkillsEdge>
	pageInfo: PageInfo
}

export type CustomSkillsDeleteResponse = {
	__typename?: 'CustomSkillsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CustomSkills>
}

export type CustomSkillsEdge = {
	__typename?: 'CustomSkillsEdge'
	cursor: Scalars['String']['output']
	node: CustomSkills
}

export type CustomSkillsFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<CustomSkillsFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	key?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<CustomSkillsFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<CustomSkillsFilter>>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type CustomSkillsInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	key?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type CustomSkillsInsertResponse = {
	__typename?: 'CustomSkillsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CustomSkills>
}

export type CustomSkillsOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	key?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type CustomSkillsUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	key?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type CustomSkillsUpdateResponse = {
	__typename?: 'CustomSkillsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<CustomSkills>
}

/** Boolean expression comparing fields on type "Date" */
export type DateFilter = {
	eq?: InputMaybe<Scalars['Date']['input']>
	gt?: InputMaybe<Scalars['Date']['input']>
	gte?: InputMaybe<Scalars['Date']['input']>
	in?: InputMaybe<Array<Scalars['Date']['input']>>
	is?: InputMaybe<FilterIs>
	lt?: InputMaybe<Scalars['Date']['input']>
	lte?: InputMaybe<Scalars['Date']['input']>
	neq?: InputMaybe<Scalars['Date']['input']>
}

/** Boolean expression comparing fields on type "DateList" */
export type DateListFilter = {
	containedBy?: InputMaybe<Array<Scalars['Date']['input']>>
	contains?: InputMaybe<Array<Scalars['Date']['input']>>
	eq?: InputMaybe<Array<Scalars['Date']['input']>>
	is?: InputMaybe<FilterIs>
	overlaps?: InputMaybe<Array<Scalars['Date']['input']>>
}

/** Boolean expression comparing fields on type "Datetime" */
export type DatetimeFilter = {
	eq?: InputMaybe<Scalars['Datetime']['input']>
	gt?: InputMaybe<Scalars['Datetime']['input']>
	gte?: InputMaybe<Scalars['Datetime']['input']>
	in?: InputMaybe<Array<Scalars['Datetime']['input']>>
	is?: InputMaybe<FilterIs>
	lt?: InputMaybe<Scalars['Datetime']['input']>
	lte?: InputMaybe<Scalars['Datetime']['input']>
	neq?: InputMaybe<Scalars['Datetime']['input']>
}

/** Boolean expression comparing fields on type "DatetimeList" */
export type DatetimeListFilter = {
	containedBy?: InputMaybe<Array<Scalars['Datetime']['input']>>
	contains?: InputMaybe<Array<Scalars['Datetime']['input']>>
	eq?: InputMaybe<Array<Scalars['Datetime']['input']>>
	is?: InputMaybe<FilterIs>
	overlaps?: InputMaybe<Array<Scalars['Datetime']['input']>>
}

export enum Employment_Type {
	Apprenticeship = 'APPRENTICESHIP',
	Contract = 'CONTRACT',
	Freelance = 'FREELANCE',
	FullTime = 'FULL_TIME',
	Internship = 'INTERNSHIP',
	PartTime = 'PART_TIME',
	Seasonal = 'SEASONAL',
	SelfEmployed = 'SELF_EMPLOYED',
}

/** Boolean expression comparing fields on type "EMPLOYMENT_TYPE" */
export type Employment_TypeFilter = {
	eq?: InputMaybe<Employment_Type>
	in?: InputMaybe<Array<Employment_Type>>
	is?: InputMaybe<FilterIs>
	neq?: InputMaybe<Employment_Type>
}

export type Education = Node & {
	__typename?: 'Education'
	company: Scalars['String']['output']
	createdAt: Scalars['Datetime']['output']
	currentPositionCollection?: Maybe<CurrentPositionConnection>
	description?: Maybe<Scalars['String']['output']>
	endDate?: Maybe<Scalars['Datetime']['output']>
	id: Scalars['String']['output']
	isCurrent?: Maybe<Scalars['Boolean']['output']>
	location?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	position?: Maybe<Scalars['String']['output']>
	startDate?: Maybe<Scalars['Datetime']['output']>
	title?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
	user?: Maybe<User>
}

export type EducationCurrentPositionCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CurrentPositionFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CurrentPositionOrderBy>>
}

export type EducationConnection = {
	__typename?: 'EducationConnection'
	edges: Array<EducationEdge>
	pageInfo: PageInfo
}

export type EducationDeleteResponse = {
	__typename?: 'EducationDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Education>
}

export type EducationEdge = {
	__typename?: 'EducationEdge'
	cursor: Scalars['String']['output']
	node: Education
}

export type EducationFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<EducationFilter>>
	company?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	description?: InputMaybe<StringFilter>
	endDate?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	isCurrent?: InputMaybe<BooleanFilter>
	location?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<EducationFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<EducationFilter>>
	position?: InputMaybe<StringFilter>
	startDate?: InputMaybe<DatetimeFilter>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
	user?: InputMaybe<StringFilter>
}

export type EducationInsertInput = {
	company?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	endDate?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isCurrent?: InputMaybe<Scalars['Boolean']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['String']['input']>
	startDate?: InputMaybe<Scalars['Datetime']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type EducationInsertResponse = {
	__typename?: 'EducationInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Education>
}

export type EducationOrderBy = {
	company?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	endDate?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	isCurrent?: InputMaybe<OrderByDirection>
	location?: InputMaybe<OrderByDirection>
	position?: InputMaybe<OrderByDirection>
	startDate?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	user?: InputMaybe<OrderByDirection>
}

export type EducationUpdateInput = {
	company?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	endDate?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isCurrent?: InputMaybe<Scalars['Boolean']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['String']['input']>
	startDate?: InputMaybe<Scalars['Datetime']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type EducationUpdateResponse = {
	__typename?: 'EducationUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Education>
}

export type Error = Node & {
	__typename?: 'Error'
	id: Scalars['String']['output']
	name?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	statusCode?: Maybe<Scalars['Int']['output']>
	value?: Maybe<Scalars['String']['output']>
}

export type ErrorConnection = {
	__typename?: 'ErrorConnection'
	edges: Array<ErrorEdge>
	pageInfo: PageInfo
}

export type ErrorDeleteResponse = {
	__typename?: 'ErrorDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Error>
}

export type ErrorEdge = {
	__typename?: 'ErrorEdge'
	cursor: Scalars['String']['output']
	node: Error
}

export type ErrorFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ErrorFilter>>
	id?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ErrorFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ErrorFilter>>
	statusCode?: InputMaybe<IntFilter>
	value?: InputMaybe<StringFilter>
}

export type ErrorInsertInput = {
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	statusCode?: InputMaybe<Scalars['Int']['input']>
	value?: InputMaybe<Scalars['String']['input']>
}

export type ErrorInsertResponse = {
	__typename?: 'ErrorInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Error>
}

export type ErrorOrderBy = {
	id?: InputMaybe<OrderByDirection>
	name?: InputMaybe<OrderByDirection>
	statusCode?: InputMaybe<OrderByDirection>
	value?: InputMaybe<OrderByDirection>
}

export type ErrorUpdateInput = {
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	statusCode?: InputMaybe<Scalars['Int']['input']>
	value?: InputMaybe<Scalars['String']['input']>
}

export type ErrorUpdateResponse = {
	__typename?: 'ErrorUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Error>
}

export type Experience = Node & {
	__typename?: 'Experience'
	articleCollection?: Maybe<ArticleConnection>
	company?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['Datetime']['output']
	currentPositionCollection?: Maybe<CurrentPositionConnection>
	description?: Maybe<Scalars['String']['output']>
	endDate?: Maybe<Scalars['Datetime']['output']>
	id: Scalars['String']['output']
	isCurrent?: Maybe<Scalars['Boolean']['output']>
	isPresent?: Maybe<Scalars['Boolean']['output']>
	location?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	position?: Maybe<Scalars['String']['output']>
	profile?: Maybe<Profile>
	roLocations?: Maybe<RoLocations>
	startDate?: Maybe<Scalars['Datetime']['output']>
	title?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
}

export type ExperienceArticleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ArticleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ArticleOrderBy>>
}

export type ExperienceCurrentPositionCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CurrentPositionFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CurrentPositionOrderBy>>
}

export type ExperienceConnection = {
	__typename?: 'ExperienceConnection'
	edges: Array<ExperienceEdge>
	pageInfo: PageInfo
}

export type ExperienceDeleteResponse = {
	__typename?: 'ExperienceDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Experience>
}

export type ExperienceEdge = {
	__typename?: 'ExperienceEdge'
	cursor: Scalars['String']['output']
	node: Experience
}

export type ExperienceFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ExperienceFilter>>
	company?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	description?: InputMaybe<StringFilter>
	endDate?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	isCurrent?: InputMaybe<BooleanFilter>
	isPresent?: InputMaybe<BooleanFilter>
	location?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ExperienceFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ExperienceFilter>>
	position?: InputMaybe<StringFilter>
	profile?: InputMaybe<StringFilter>
	startDate?: InputMaybe<DatetimeFilter>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type ExperienceInsertInput = {
	company?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	endDate?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isCurrent?: InputMaybe<Scalars['Boolean']['input']>
	isPresent?: InputMaybe<Scalars['Boolean']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['String']['input']>
	profile?: InputMaybe<Scalars['String']['input']>
	startDate?: InputMaybe<Scalars['Datetime']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ExperienceInsertResponse = {
	__typename?: 'ExperienceInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Experience>
}

export type ExperienceOrderBy = {
	company?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	endDate?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	isCurrent?: InputMaybe<OrderByDirection>
	isPresent?: InputMaybe<OrderByDirection>
	location?: InputMaybe<OrderByDirection>
	position?: InputMaybe<OrderByDirection>
	profile?: InputMaybe<OrderByDirection>
	startDate?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type ExperienceUpdateInput = {
	company?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	endDate?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isCurrent?: InputMaybe<Scalars['Boolean']['input']>
	isPresent?: InputMaybe<Scalars['Boolean']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['String']['input']>
	profile?: InputMaybe<Scalars['String']['input']>
	startDate?: InputMaybe<Scalars['Datetime']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ExperienceUpdateResponse = {
	__typename?: 'ExperienceUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Experience>
}

export type FacebookProfile = Node & {
	__typename?: 'FacebookProfile'
	createdAt: Scalars['Datetime']['output']
	fbId?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	profile?: Maybe<Profile>
	updatedAt: Scalars['Datetime']['output']
	user?: Maybe<Scalars['String']['output']>
}

export type FacebookProfileConnection = {
	__typename?: 'FacebookProfileConnection'
	edges: Array<FacebookProfileEdge>
	pageInfo: PageInfo
}

export type FacebookProfileDeleteResponse = {
	__typename?: 'FacebookProfileDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<FacebookProfile>
}

export type FacebookProfileEdge = {
	__typename?: 'FacebookProfileEdge'
	cursor: Scalars['String']['output']
	node: FacebookProfile
}

export type FacebookProfileFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<FacebookProfileFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	fbId?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<FacebookProfileFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<FacebookProfileFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
	user?: InputMaybe<StringFilter>
}

export type FacebookProfileInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	fbId?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type FacebookProfileInsertResponse = {
	__typename?: 'FacebookProfileInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<FacebookProfile>
}

export type FacebookProfileOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	fbId?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	user?: InputMaybe<OrderByDirection>
}

export type FacebookProfileUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	fbId?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type FacebookProfileUpdateResponse = {
	__typename?: 'FacebookProfileUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<FacebookProfile>
}

export type Faculty = Node & {
	__typename?: 'Faculty'
	createdAt: Scalars['Datetime']['output']
	facultySpecializationCollection?: Maybe<FacultySpecializationConnection>
	id: Scalars['String']['output']
	name: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	studentKitCollection?: Maybe<StudentKitConnection>
	university?: Maybe<University>
	updatedAt: Scalars['Datetime']['output']
}

export type FacultyFacultySpecializationCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<FacultySpecializationFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<FacultySpecializationOrderBy>>
}

export type FacultyStudentKitCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentKitFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentKitOrderBy>>
}

export type FacultyConnection = {
	__typename?: 'FacultyConnection'
	edges: Array<FacultyEdge>
	pageInfo: PageInfo
}

export type FacultyDeleteResponse = {
	__typename?: 'FacultyDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Faculty>
}

export type FacultyEdge = {
	__typename?: 'FacultyEdge'
	cursor: Scalars['String']['output']
	node: Faculty
}

export type FacultyFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<FacultyFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<FacultyFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<FacultyFilter>>
	university?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type FacultyInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	university?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type FacultyInsertResponse = {
	__typename?: 'FacultyInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Faculty>
}

export type FacultyOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	name?: InputMaybe<OrderByDirection>
	university?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type FacultySpecialization = Node & {
	__typename?: 'FacultySpecialization'
	createdAt: Scalars['Datetime']['output']
	faculty?: Maybe<Faculty>
	id: Scalars['String']['output']
	name: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	profileCollection?: Maybe<ProfileConnection>
	studentKitCollection?: Maybe<StudentKitConnection>
	updatedAt: Scalars['Datetime']['output']
}

export type FacultySpecializationProfileCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ProfileFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ProfileOrderBy>>
}

export type FacultySpecializationStudentKitCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentKitFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentKitOrderBy>>
}

export type FacultySpecializationConnection = {
	__typename?: 'FacultySpecializationConnection'
	edges: Array<FacultySpecializationEdge>
	pageInfo: PageInfo
}

export type FacultySpecializationDeleteResponse = {
	__typename?: 'FacultySpecializationDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<FacultySpecialization>
}

export type FacultySpecializationEdge = {
	__typename?: 'FacultySpecializationEdge'
	cursor: Scalars['String']['output']
	node: FacultySpecialization
}

export type FacultySpecializationFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<FacultySpecializationFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	faculty?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<FacultySpecializationFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<FacultySpecializationFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type FacultySpecializationInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	faculty?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type FacultySpecializationInsertResponse = {
	__typename?: 'FacultySpecializationInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<FacultySpecialization>
}

export type FacultySpecializationOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	faculty?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	name?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type FacultySpecializationUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	faculty?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type FacultySpecializationUpdateResponse = {
	__typename?: 'FacultySpecializationUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<FacultySpecialization>
}

export type FacultyUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	university?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type FacultyUpdateResponse = {
	__typename?: 'FacultyUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Faculty>
}

export type Faq = Node & {
	__typename?: 'Faq'
	answer: Scalars['String']['output']
	company?: Maybe<Company>
	companyId?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	question: Scalars['String']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type FaqConnection = {
	__typename?: 'FaqConnection'
	edges: Array<FaqEdge>
	pageInfo: PageInfo
}

export type FaqDeleteResponse = {
	__typename?: 'FaqDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Faq>
}

export type FaqEdge = {
	__typename?: 'FaqEdge'
	cursor: Scalars['String']['output']
	node: Faq
}

export type FaqFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<FaqFilter>>
	answer?: InputMaybe<StringFilter>
	companyId?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<FaqFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<FaqFilter>>
	question?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type FaqInsertInput = {
	answer?: InputMaybe<Scalars['String']['input']>
	companyId?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	question?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type FaqInsertResponse = {
	__typename?: 'FaqInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Faq>
}

export type FaqOrderBy = {
	answer?: InputMaybe<OrderByDirection>
	companyId?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	question?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type FaqUpdateInput = {
	answer?: InputMaybe<Scalars['String']['input']>
	companyId?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	question?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type FaqUpdateResponse = {
	__typename?: 'FaqUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Faq>
}

export enum FilterIs {
	NotNull = 'NOT_NULL',
	Null = 'NULL',
}

/** Boolean expression comparing fields on type "Float" */
export type FloatFilter = {
	eq?: InputMaybe<Scalars['Float']['input']>
	gt?: InputMaybe<Scalars['Float']['input']>
	gte?: InputMaybe<Scalars['Float']['input']>
	in?: InputMaybe<Array<Scalars['Float']['input']>>
	is?: InputMaybe<FilterIs>
	lt?: InputMaybe<Scalars['Float']['input']>
	lte?: InputMaybe<Scalars['Float']['input']>
	neq?: InputMaybe<Scalars['Float']['input']>
}

/** Boolean expression comparing fields on type "FloatList" */
export type FloatListFilter = {
	containedBy?: InputMaybe<Array<Scalars['Float']['input']>>
	contains?: InputMaybe<Array<Scalars['Float']['input']>>
	eq?: InputMaybe<Array<Scalars['Float']['input']>>
	is?: InputMaybe<FilterIs>
	overlaps?: InputMaybe<Array<Scalars['Float']['input']>>
}

export enum Genders {
	Female = 'FEMALE',
	Male = 'MALE',
	Other = 'OTHER',
	PreferNotToSay = 'PREFER_NOT_TO_SAY',
}

/** Boolean expression comparing fields on type "GENDERS" */
export type GendersFilter = {
	eq?: InputMaybe<Genders>
	in?: InputMaybe<Array<Genders>>
	is?: InputMaybe<FilterIs>
	neq?: InputMaybe<Genders>
}

export type Hobby = Node & {
	__typename?: 'Hobby'
	createdAt: Scalars['Datetime']['output']
	currentPositionCollection?: Maybe<CurrentPositionConnection>
	description?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	position?: Maybe<Scalars['String']['output']>
	title?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
	user?: Maybe<User>
}

export type HobbyCurrentPositionCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CurrentPositionFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CurrentPositionOrderBy>>
}

export type HobbyConnection = {
	__typename?: 'HobbyConnection'
	edges: Array<HobbyEdge>
	pageInfo: PageInfo
}

export type HobbyDeleteResponse = {
	__typename?: 'HobbyDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Hobby>
}

export type HobbyEdge = {
	__typename?: 'HobbyEdge'
	cursor: Scalars['String']['output']
	node: Hobby
}

export type HobbyFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<HobbyFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	description?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<HobbyFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<HobbyFilter>>
	position?: InputMaybe<StringFilter>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
	user?: InputMaybe<StringFilter>
}

export type HobbyInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type HobbyInsertResponse = {
	__typename?: 'HobbyInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Hobby>
}

export type HobbyOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	position?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	user?: InputMaybe<OrderByDirection>
}

export type HobbyUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type HobbyUpdateResponse = {
	__typename?: 'HobbyUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Hobby>
}

/** Boolean expression comparing fields on type "ID" */
export type IdFilter = {
	eq?: InputMaybe<Scalars['ID']['input']>
}

export type Image = Node & {
	__typename?: 'Image'
	_56?: Maybe<Scalars['Boolean']['output']>
	_100?: Maybe<Scalars['Boolean']['output']>
	_300?: Maybe<Scalars['Boolean']['output']>
	_500?: Maybe<Scalars['Boolean']['output']>
	_750?: Maybe<Scalars['Boolean']['output']>
	_1000?: Maybe<Scalars['Boolean']['output']>
	_1500?: Maybe<Scalars['Boolean']['output']>
	_2500?: Maybe<Scalars['Boolean']['output']>
	articleCollection?: Maybe<ArticleConnection>
	companyCollection?: Maybe<CompanyConnection>
	createdAt: Scalars['Datetime']['output']
	description?: Maybe<Scalars['String']['output']>
	filename?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	isFeatured?: Maybe<Scalars['Boolean']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	originalFilename?: Maybe<Scalars['String']['output']>
	path?: Maybe<Scalars['String']['output']>
	sourceType?: Maybe<Scalars['String']['output']>
	title?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
	user?: Maybe<User>
}

export type ImageArticleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ArticleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ArticleOrderBy>>
}

export type ImageCompanyCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyOrderBy>>
}

export type ImageConnection = {
	__typename?: 'ImageConnection'
	edges: Array<ImageEdge>
	pageInfo: PageInfo
}

export type ImageDeleteResponse = {
	__typename?: 'ImageDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Image>
}

export type ImageEdge = {
	__typename?: 'ImageEdge'
	cursor: Scalars['String']['output']
	node: Image
}

export type ImageFilter = {
	_56?: InputMaybe<BooleanFilter>
	_100?: InputMaybe<BooleanFilter>
	_300?: InputMaybe<BooleanFilter>
	_500?: InputMaybe<BooleanFilter>
	_750?: InputMaybe<BooleanFilter>
	_1000?: InputMaybe<BooleanFilter>
	_1500?: InputMaybe<BooleanFilter>
	_2500?: InputMaybe<BooleanFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ImageFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	description?: InputMaybe<StringFilter>
	filename?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	isFeatured?: InputMaybe<BooleanFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ImageFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ImageFilter>>
	originalFilename?: InputMaybe<StringFilter>
	path?: InputMaybe<StringFilter>
	sourceType?: InputMaybe<StringFilter>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
	user?: InputMaybe<StringFilter>
}

export type ImageInsertInput = {
	_56?: InputMaybe<Scalars['Boolean']['input']>
	_100?: InputMaybe<Scalars['Boolean']['input']>
	_300?: InputMaybe<Scalars['Boolean']['input']>
	_500?: InputMaybe<Scalars['Boolean']['input']>
	_750?: InputMaybe<Scalars['Boolean']['input']>
	_1000?: InputMaybe<Scalars['Boolean']['input']>
	_1500?: InputMaybe<Scalars['Boolean']['input']>
	_2500?: InputMaybe<Scalars['Boolean']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	filename?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isFeatured?: InputMaybe<Scalars['Boolean']['input']>
	originalFilename?: InputMaybe<Scalars['String']['input']>
	path?: InputMaybe<Scalars['String']['input']>
	sourceType?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type ImageInsertResponse = {
	__typename?: 'ImageInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Image>
}

export type ImageOrderBy = {
	_56?: InputMaybe<OrderByDirection>
	_100?: InputMaybe<OrderByDirection>
	_300?: InputMaybe<OrderByDirection>
	_500?: InputMaybe<OrderByDirection>
	_750?: InputMaybe<OrderByDirection>
	_1000?: InputMaybe<OrderByDirection>
	_1500?: InputMaybe<OrderByDirection>
	_2500?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	filename?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	isFeatured?: InputMaybe<OrderByDirection>
	originalFilename?: InputMaybe<OrderByDirection>
	path?: InputMaybe<OrderByDirection>
	sourceType?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	user?: InputMaybe<OrderByDirection>
}

export type ImageUpdateInput = {
	_56?: InputMaybe<Scalars['Boolean']['input']>
	_100?: InputMaybe<Scalars['Boolean']['input']>
	_300?: InputMaybe<Scalars['Boolean']['input']>
	_500?: InputMaybe<Scalars['Boolean']['input']>
	_750?: InputMaybe<Scalars['Boolean']['input']>
	_1000?: InputMaybe<Scalars['Boolean']['input']>
	_1500?: InputMaybe<Scalars['Boolean']['input']>
	_2500?: InputMaybe<Scalars['Boolean']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	filename?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isFeatured?: InputMaybe<Scalars['Boolean']['input']>
	originalFilename?: InputMaybe<Scalars['String']['input']>
	path?: InputMaybe<Scalars['String']['input']>
	sourceType?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type ImageUpdateResponse = {
	__typename?: 'ImageUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Image>
}

export type Industry = Node & {
	__typename?: 'Industry'
	companyCollection?: Maybe<CompanyConnection>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	key: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type IndustryCompanyCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyOrderBy>>
}

export type IndustryConnection = {
	__typename?: 'IndustryConnection'
	edges: Array<IndustryEdge>
	pageInfo: PageInfo
}

export type IndustryDeleteResponse = {
	__typename?: 'IndustryDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Industry>
}

export type IndustryEdge = {
	__typename?: 'IndustryEdge'
	cursor: Scalars['String']['output']
	node: Industry
}

export type IndustryFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<IndustryFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	key?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<IndustryFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<IndustryFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type IndustryInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	key?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type IndustryInsertResponse = {
	__typename?: 'IndustryInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Industry>
}

export type IndustryOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	key?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type IndustryUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	key?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type IndustryUpdateResponse = {
	__typename?: 'IndustryUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Industry>
}

/** Boolean expression comparing fields on type "Int" */
export type IntFilter = {
	eq?: InputMaybe<Scalars['Int']['input']>
	gt?: InputMaybe<Scalars['Int']['input']>
	gte?: InputMaybe<Scalars['Int']['input']>
	in?: InputMaybe<Array<Scalars['Int']['input']>>
	is?: InputMaybe<FilterIs>
	lt?: InputMaybe<Scalars['Int']['input']>
	lte?: InputMaybe<Scalars['Int']['input']>
	neq?: InputMaybe<Scalars['Int']['input']>
}

/** Boolean expression comparing fields on type "IntList" */
export type IntListFilter = {
	containedBy?: InputMaybe<Array<Scalars['Int']['input']>>
	contains?: InputMaybe<Array<Scalars['Int']['input']>>
	eq?: InputMaybe<Array<Scalars['Int']['input']>>
	is?: InputMaybe<FilterIs>
	overlaps?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type Job = Node & {
	__typename?: 'Job'
	_JobToCompanyOfficesCollection?: Maybe<_JobToCompanyOfficesConnection>
	_JobToCustomSkillsCollection?: Maybe<_JobToCustomSkillsConnection>
	_JobToFollowersCollection?: Maybe<_JobToFollowersConnection>
	_JobToSkillCollection?: Maybe<_JobToSkillConnection>
	_TeamToJobCollection?: Maybe<_TeamToJobConnection>
	activityField?: Maybe<ActivityField>
	applyJobExternalUrl?: Maybe<Scalars['String']['output']>
	benefits?: Maybe<Scalars['String']['output']>
	company?: Maybe<Company>
	contractType?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['Datetime']['output']
	description?: Maybe<Scalars['String']['output']>
	email?: Maybe<Scalars['String']['output']>
	expiryDate?: Maybe<Scalars['Datetime']['output']>
	facebook?: Maybe<Scalars['String']['output']>
	featuredImage?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	jobApplicantCollection?: Maybe<JobApplicantConnection>
	jobSalary?: Maybe<JobSalary>
	jobType?: Maybe<Scalars['String']['output']>
	linkedin?: Maybe<Scalars['String']['output']>
	locationType?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	phone?: Maybe<Scalars['String']['output']>
	salary?: Maybe<Scalars['String']['output']>
	searchviewCollection?: Maybe<SearchviewConnection>
	seniorityLevel?: Maybe<Scalars['String']['output']>
	slug: Scalars['String']['output']
	status?: Maybe<Scalars['String']['output']>
	teamLeader?: Maybe<Scalars['String']['output']>
	teamMember?: Maybe<TeamMember>
	title: Scalars['String']['output']
	updatedAt: Scalars['Datetime']['output']
	videoUrl?: Maybe<Scalars['String']['output']>
}

export type Job_JobToCompanyOfficesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_JobToCompanyOfficesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_JobToCompanyOfficesOrderBy>>
}

export type Job_JobToCustomSkillsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_JobToCustomSkillsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_JobToCustomSkillsOrderBy>>
}

export type Job_JobToFollowersCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_JobToFollowersFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_JobToFollowersOrderBy>>
}

export type Job_JobToSkillCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_JobToSkillFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_JobToSkillOrderBy>>
}

export type Job_TeamToJobCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_TeamToJobFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_TeamToJobOrderBy>>
}

export type JobJobApplicantCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<JobApplicantFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<JobApplicantOrderBy>>
}

export type JobSearchviewCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<SearchviewFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SearchviewOrderBy>>
}

export type JobApplicant = Node & {
	__typename?: 'JobApplicant'
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	job: Job
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	updatedAt: Scalars['Datetime']['output']
	user?: Maybe<User>
}

export type JobApplicantConnection = {
	__typename?: 'JobApplicantConnection'
	edges: Array<JobApplicantEdge>
	pageInfo: PageInfo
}

export type JobApplicantDeleteResponse = {
	__typename?: 'JobApplicantDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<JobApplicant>
}

export type JobApplicantEdge = {
	__typename?: 'JobApplicantEdge'
	cursor: Scalars['String']['output']
	node: JobApplicant
}

export type JobApplicantFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<JobApplicantFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	job?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<JobApplicantFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<JobApplicantFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
	user?: InputMaybe<StringFilter>
}

export type JobApplicantInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	job?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type JobApplicantInsertResponse = {
	__typename?: 'JobApplicantInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<JobApplicant>
}

export type JobApplicantOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	job?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	user?: InputMaybe<OrderByDirection>
}

export type JobApplicantUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	job?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type JobApplicantUpdateResponse = {
	__typename?: 'JobApplicantUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<JobApplicant>
}

export type JobConnection = {
	__typename?: 'JobConnection'
	edges: Array<JobEdge>
	pageInfo: PageInfo
}

export type JobDeleteResponse = {
	__typename?: 'JobDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Job>
}

export type JobEdge = {
	__typename?: 'JobEdge'
	cursor: Scalars['String']['output']
	node: Job
}

export type JobFilter = {
	activityField?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<JobFilter>>
	applyJobExternalUrl?: InputMaybe<StringFilter>
	benefits?: InputMaybe<StringFilter>
	company?: InputMaybe<StringFilter>
	contractType?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	description?: InputMaybe<StringFilter>
	email?: InputMaybe<StringFilter>
	expiryDate?: InputMaybe<DatetimeFilter>
	facebook?: InputMaybe<StringFilter>
	featuredImage?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	jobType?: InputMaybe<StringFilter>
	linkedin?: InputMaybe<StringFilter>
	locationType?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<JobFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<JobFilter>>
	phone?: InputMaybe<StringFilter>
	salary?: InputMaybe<StringFilter>
	seniorityLevel?: InputMaybe<StringFilter>
	slug?: InputMaybe<StringFilter>
	status?: InputMaybe<StringFilter>
	teamLeader?: InputMaybe<StringFilter>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
	videoUrl?: InputMaybe<StringFilter>
}

export type JobInsertInput = {
	activityField?: InputMaybe<Scalars['String']['input']>
	applyJobExternalUrl?: InputMaybe<Scalars['String']['input']>
	benefits?: InputMaybe<Scalars['String']['input']>
	company?: InputMaybe<Scalars['String']['input']>
	contractType?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	expiryDate?: InputMaybe<Scalars['Datetime']['input']>
	facebook?: InputMaybe<Scalars['String']['input']>
	featuredImage?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	jobType?: InputMaybe<Scalars['String']['input']>
	linkedin?: InputMaybe<Scalars['String']['input']>
	locationType?: InputMaybe<Scalars['String']['input']>
	phone?: InputMaybe<Scalars['String']['input']>
	salary?: InputMaybe<Scalars['String']['input']>
	seniorityLevel?: InputMaybe<Scalars['String']['input']>
	slug?: InputMaybe<Scalars['String']['input']>
	status?: InputMaybe<Scalars['String']['input']>
	teamLeader?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	videoUrl?: InputMaybe<Scalars['String']['input']>
}

export type JobInsertResponse = {
	__typename?: 'JobInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Job>
}

export type JobOrderBy = {
	activityField?: InputMaybe<OrderByDirection>
	applyJobExternalUrl?: InputMaybe<OrderByDirection>
	benefits?: InputMaybe<OrderByDirection>
	company?: InputMaybe<OrderByDirection>
	contractType?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	email?: InputMaybe<OrderByDirection>
	expiryDate?: InputMaybe<OrderByDirection>
	facebook?: InputMaybe<OrderByDirection>
	featuredImage?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	jobType?: InputMaybe<OrderByDirection>
	linkedin?: InputMaybe<OrderByDirection>
	locationType?: InputMaybe<OrderByDirection>
	phone?: InputMaybe<OrderByDirection>
	salary?: InputMaybe<OrderByDirection>
	seniorityLevel?: InputMaybe<OrderByDirection>
	slug?: InputMaybe<OrderByDirection>
	status?: InputMaybe<OrderByDirection>
	teamLeader?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	videoUrl?: InputMaybe<OrderByDirection>
}

export type JobSalary = Node & {
	__typename?: 'JobSalary'
	amountMax?: Maybe<Scalars['BigFloat']['output']>
	amountMin?: Maybe<Scalars['BigFloat']['output']>
	createdAt: Scalars['Datetime']['output']
	currency?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	jobCollection?: Maybe<JobConnection>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	rate?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
}

export type JobSalaryJobCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<JobFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<JobOrderBy>>
}

export type JobSalaryConnection = {
	__typename?: 'JobSalaryConnection'
	edges: Array<JobSalaryEdge>
	pageInfo: PageInfo
}

export type JobSalaryDeleteResponse = {
	__typename?: 'JobSalaryDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<JobSalary>
}

export type JobSalaryEdge = {
	__typename?: 'JobSalaryEdge'
	cursor: Scalars['String']['output']
	node: JobSalary
}

export type JobSalaryFilter = {
	amountMax?: InputMaybe<BigFloatFilter>
	amountMin?: InputMaybe<BigFloatFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<JobSalaryFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	currency?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<JobSalaryFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<JobSalaryFilter>>
	rate?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type JobSalaryInsertInput = {
	amountMax?: InputMaybe<Scalars['BigFloat']['input']>
	amountMin?: InputMaybe<Scalars['BigFloat']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	currency?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	rate?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type JobSalaryInsertResponse = {
	__typename?: 'JobSalaryInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<JobSalary>
}

export type JobSalaryOrderBy = {
	amountMax?: InputMaybe<OrderByDirection>
	amountMin?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	currency?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	rate?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type JobSalaryUpdateInput = {
	amountMax?: InputMaybe<Scalars['BigFloat']['input']>
	amountMin?: InputMaybe<Scalars['BigFloat']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	currency?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	rate?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type JobSalaryUpdateResponse = {
	__typename?: 'JobSalaryUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<JobSalary>
}

export type JobUpdateInput = {
	activityField?: InputMaybe<Scalars['String']['input']>
	applyJobExternalUrl?: InputMaybe<Scalars['String']['input']>
	benefits?: InputMaybe<Scalars['String']['input']>
	company?: InputMaybe<Scalars['String']['input']>
	contractType?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	expiryDate?: InputMaybe<Scalars['Datetime']['input']>
	facebook?: InputMaybe<Scalars['String']['input']>
	featuredImage?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	jobType?: InputMaybe<Scalars['String']['input']>
	linkedin?: InputMaybe<Scalars['String']['input']>
	locationType?: InputMaybe<Scalars['String']['input']>
	phone?: InputMaybe<Scalars['String']['input']>
	salary?: InputMaybe<Scalars['String']['input']>
	seniorityLevel?: InputMaybe<Scalars['String']['input']>
	slug?: InputMaybe<Scalars['String']['input']>
	status?: InputMaybe<Scalars['String']['input']>
	teamLeader?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	videoUrl?: InputMaybe<Scalars['String']['input']>
}

export type JobUpdateResponse = {
	__typename?: 'JobUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Job>
}

export type LandingPage = Node & {
	__typename?: 'LandingPage'
	coverBackground?: Maybe<Scalars['String']['output']>
	coverContentType?: Maybe<Scalars['String']['output']>
	coverPath?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['Datetime']['output']
	footerCoverBackground?: Maybe<Scalars['String']['output']>
	footerCoverContentType?: Maybe<Scalars['String']['output']>
	footerCoverPath?: Maybe<Scalars['String']['output']>
	hasCover?: Maybe<Scalars['Boolean']['output']>
	hasFooterCover?: Maybe<Scalars['Boolean']['output']>
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type LandingPageConnection = {
	__typename?: 'LandingPageConnection'
	edges: Array<LandingPageEdge>
	pageInfo: PageInfo
}

export type LandingPageDeleteResponse = {
	__typename?: 'LandingPageDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<LandingPage>
}

export type LandingPageEdge = {
	__typename?: 'LandingPageEdge'
	cursor: Scalars['String']['output']
	node: LandingPage
}

export type LandingPageFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<LandingPageFilter>>
	coverBackground?: InputMaybe<StringFilter>
	coverContentType?: InputMaybe<StringFilter>
	coverPath?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	footerCoverBackground?: InputMaybe<StringFilter>
	footerCoverContentType?: InputMaybe<StringFilter>
	footerCoverPath?: InputMaybe<StringFilter>
	hasCover?: InputMaybe<BooleanFilter>
	hasFooterCover?: InputMaybe<BooleanFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<LandingPageFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<LandingPageFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type LandingPageInsertInput = {
	coverBackground?: InputMaybe<Scalars['String']['input']>
	coverContentType?: InputMaybe<Scalars['String']['input']>
	coverPath?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	footerCoverBackground?: InputMaybe<Scalars['String']['input']>
	footerCoverContentType?: InputMaybe<Scalars['String']['input']>
	footerCoverPath?: InputMaybe<Scalars['String']['input']>
	hasCover?: InputMaybe<Scalars['Boolean']['input']>
	hasFooterCover?: InputMaybe<Scalars['Boolean']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type LandingPageInsertResponse = {
	__typename?: 'LandingPageInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<LandingPage>
}

export type LandingPageOrderBy = {
	coverBackground?: InputMaybe<OrderByDirection>
	coverContentType?: InputMaybe<OrderByDirection>
	coverPath?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	footerCoverBackground?: InputMaybe<OrderByDirection>
	footerCoverContentType?: InputMaybe<OrderByDirection>
	footerCoverPath?: InputMaybe<OrderByDirection>
	hasCover?: InputMaybe<OrderByDirection>
	hasFooterCover?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type LandingPageText = Node & {
	__typename?: 'LandingPageText'
	createdAt: Scalars['Datetime']['output']
	footerMessage?: Maybe<Scalars['String']['output']>
	headline?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	language?: Maybe<Language>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type LandingPageTextConnection = {
	__typename?: 'LandingPageTextConnection'
	edges: Array<LandingPageTextEdge>
	pageInfo: PageInfo
}

export type LandingPageTextDeleteResponse = {
	__typename?: 'LandingPageTextDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<LandingPageText>
}

export type LandingPageTextEdge = {
	__typename?: 'LandingPageTextEdge'
	cursor: Scalars['String']['output']
	node: LandingPageText
}

export type LandingPageTextFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<LandingPageTextFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	footerMessage?: InputMaybe<StringFilter>
	headline?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	language?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<LandingPageTextFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<LandingPageTextFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type LandingPageTextInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	footerMessage?: InputMaybe<Scalars['String']['input']>
	headline?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	language?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type LandingPageTextInsertResponse = {
	__typename?: 'LandingPageTextInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<LandingPageText>
}

export type LandingPageTextOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	footerMessage?: InputMaybe<OrderByDirection>
	headline?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	language?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type LandingPageTextUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	footerMessage?: InputMaybe<Scalars['String']['input']>
	headline?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	language?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type LandingPageTextUpdateResponse = {
	__typename?: 'LandingPageTextUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<LandingPageText>
}

export type LandingPageUpdateInput = {
	coverBackground?: InputMaybe<Scalars['String']['input']>
	coverContentType?: InputMaybe<Scalars['String']['input']>
	coverPath?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	footerCoverBackground?: InputMaybe<Scalars['String']['input']>
	footerCoverContentType?: InputMaybe<Scalars['String']['input']>
	footerCoverPath?: InputMaybe<Scalars['String']['input']>
	hasCover?: InputMaybe<Scalars['Boolean']['input']>
	hasFooterCover?: InputMaybe<Scalars['Boolean']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type LandingPageUpdateResponse = {
	__typename?: 'LandingPageUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<LandingPage>
}

export type Language = Node & {
	__typename?: 'Language'
	code?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	label?: Maybe<Scalars['String']['output']>
	landingPageTextCollection?: Maybe<LandingPageTextConnection>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type LanguageLandingPageTextCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<LandingPageTextFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<LandingPageTextOrderBy>>
}

export type LanguageConnection = {
	__typename?: 'LanguageConnection'
	edges: Array<LanguageEdge>
	pageInfo: PageInfo
}

export type LanguageDeleteResponse = {
	__typename?: 'LanguageDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Language>
}

export type LanguageEdge = {
	__typename?: 'LanguageEdge'
	cursor: Scalars['String']['output']
	node: Language
}

export type LanguageFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<LanguageFilter>>
	code?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	label?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<LanguageFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<LanguageFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type LanguageInsertInput = {
	code?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	label?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type LanguageInsertResponse = {
	__typename?: 'LanguageInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Language>
}

export type LanguageOrderBy = {
	code?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	label?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type LanguageUpdateInput = {
	code?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	label?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type LanguageUpdateResponse = {
	__typename?: 'LanguageUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Language>
}

export type LinkedUsersToCompanies = Node & {
	__typename?: 'LinkedUsersToCompanies'
	company?: Maybe<Company>
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	role: Scalars['String']['output']
	user?: Maybe<User>
}

export type LinkedUsersToCompaniesConnection = {
	__typename?: 'LinkedUsersToCompaniesConnection'
	edges: Array<LinkedUsersToCompaniesEdge>
	pageInfo: PageInfo
}

export type LinkedUsersToCompaniesDeleteResponse = {
	__typename?: 'LinkedUsersToCompaniesDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<LinkedUsersToCompanies>
}

export type LinkedUsersToCompaniesEdge = {
	__typename?: 'LinkedUsersToCompaniesEdge'
	cursor: Scalars['String']['output']
	node: LinkedUsersToCompanies
}

export type LinkedUsersToCompaniesFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<LinkedUsersToCompaniesFilter>>
	company?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<LinkedUsersToCompaniesFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<LinkedUsersToCompaniesFilter>>
	role?: InputMaybe<StringFilter>
	user?: InputMaybe<StringFilter>
}

export type LinkedUsersToCompaniesInsertInput = {
	company?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	role?: InputMaybe<Scalars['String']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type LinkedUsersToCompaniesInsertResponse = {
	__typename?: 'LinkedUsersToCompaniesInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<LinkedUsersToCompanies>
}

export type LinkedUsersToCompaniesOrderBy = {
	company?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	role?: InputMaybe<OrderByDirection>
	user?: InputMaybe<OrderByDirection>
}

export type LinkedUsersToCompaniesUpdateInput = {
	company?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	role?: InputMaybe<Scalars['String']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type LinkedUsersToCompaniesUpdateResponse = {
	__typename?: 'LinkedUsersToCompaniesUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<LinkedUsersToCompanies>
}

/** The root type for creating and mutating data */
export type Mutation = {
	__typename?: 'Mutation'
	append_to_seen_by_users?: Maybe<Scalars['Opaque']['output']>
	append_user_to_notifications?: Maybe<Scalars['Opaque']['output']>
	appreciate?: Maybe<StandardresponseConnection>
	check_scanning_agent?: Maybe<Scalars['Boolean']['output']>
	count_sub_comments?: Maybe<Scalars['Int']['output']>
	custom_http_post?: Maybe<Scalars['String']['output']>
	/** Deletes zero or more records from the `ActiveArticleTag` collection */
	deleteFromActiveArticleTagCollection: ActiveArticleTagDeleteResponse
	/** Deletes zero or more records from the `ActivityField` collection */
	deleteFromActivityFieldCollection: ActivityFieldDeleteResponse
	/** Deletes zero or more records from the `Ad` collection */
	deleteFromAdCollection: AdDeleteResponse
	/** Deletes zero or more records from the `Article` collection */
	deleteFromArticleCollection: ArticleDeleteResponse
	/** Deletes zero or more records from the `ArticleTag` collection */
	deleteFromArticleTagCollection: ArticleTagDeleteResponse
	/** Deletes zero or more records from the `Campaign` collection */
	deleteFromCampaignCollection: CampaignDeleteResponse
	/** Deletes zero or more records from the `ChillPackCompany` collection */
	deleteFromChillPackCompanyCollection: ChillPackCompanyDeleteResponse
	/** Deletes zero or more records from the `ChillPackEdition` collection */
	deleteFromChillPackEditionCollection: ChillPackEditionDeleteResponse
	/** Deletes zero or more records from the `ChillPackRecipientClaim` collection */
	deleteFromChillPackRecipientClaimCollection: ChillPackRecipientClaimDeleteResponse
	/** Deletes zero or more records from the `ChillPackRecipient` collection */
	deleteFromChillPackRecipientCollection: ChillPackRecipientDeleteResponse
	/** Deletes zero or more records from the `ChillPackScheduledMailCronjobData` collection */
	deleteFromChillPackScheduledMailCronjobDataCollection: ChillPackScheduledMailCronjobDataDeleteResponse
	/** Deletes zero or more records from the `Company` collection */
	deleteFromCompanyCollection: CompanyDeleteResponse
	/** Deletes zero or more records from the `CompanyEmails` collection */
	deleteFromCompanyEmailsCollection: CompanyEmailsDeleteResponse
	/** Deletes zero or more records from the `CompanyOffices` collection */
	deleteFromCompanyOfficesCollection: CompanyOfficesDeleteResponse
	/** Deletes zero or more records from the `CompanyPhones` collection */
	deleteFromCompanyPhonesCollection: CompanyPhonesDeleteResponse
	/** Deletes zero or more records from the `CompanyResponse` collection */
	deleteFromCompanyResponseCollection: CompanyResponseDeleteResponse
	/** Deletes zero or more records from the `CompanyRole` collection */
	deleteFromCompanyRoleCollection: CompanyRoleDeleteResponse
	/** Deletes zero or more records from the `CompanyRole_roles` collection */
	deleteFromCompanyRole_rolesCollection: CompanyRole_RolesDeleteResponse
	/** Deletes zero or more records from the `CompanyType` collection */
	deleteFromCompanyTypeCollection: CompanyTypeDeleteResponse
	/** Deletes zero or more records from the `Contact` collection */
	deleteFromContactCollection: ContactDeleteResponse
	/** Deletes zero or more records from the `Country` collection */
	deleteFromCountryCollection: CountryDeleteResponse
	/** Deletes zero or more records from the `CurrentPosition` collection */
	deleteFromCurrentPositionCollection: CurrentPositionDeleteResponse
	/** Deletes zero or more records from the `CustomSkills` collection */
	deleteFromCustomSkillsCollection: CustomSkillsDeleteResponse
	/** Deletes zero or more records from the `Education` collection */
	deleteFromEducationCollection: EducationDeleteResponse
	/** Deletes zero or more records from the `Error` collection */
	deleteFromErrorCollection: ErrorDeleteResponse
	/** Deletes zero or more records from the `Experience` collection */
	deleteFromExperienceCollection: ExperienceDeleteResponse
	/** Deletes zero or more records from the `FacebookProfile` collection */
	deleteFromFacebookProfileCollection: FacebookProfileDeleteResponse
	/** Deletes zero or more records from the `Faculty` collection */
	deleteFromFacultyCollection: FacultyDeleteResponse
	/** Deletes zero or more records from the `FacultySpecialization` collection */
	deleteFromFacultySpecializationCollection: FacultySpecializationDeleteResponse
	/** Deletes zero or more records from the `Faq` collection */
	deleteFromFaqCollection: FaqDeleteResponse
	/** Deletes zero or more records from the `Hobby` collection */
	deleteFromHobbyCollection: HobbyDeleteResponse
	/** Deletes zero or more records from the `Image` collection */
	deleteFromImageCollection: ImageDeleteResponse
	/** Deletes zero or more records from the `Industry` collection */
	deleteFromIndustryCollection: IndustryDeleteResponse
	/** Deletes zero or more records from the `JobApplicant` collection */
	deleteFromJobApplicantCollection: JobApplicantDeleteResponse
	/** Deletes zero or more records from the `Job` collection */
	deleteFromJobCollection: JobDeleteResponse
	/** Deletes zero or more records from the `JobSalary` collection */
	deleteFromJobSalaryCollection: JobSalaryDeleteResponse
	/** Deletes zero or more records from the `LandingPage` collection */
	deleteFromLandingPageCollection: LandingPageDeleteResponse
	/** Deletes zero or more records from the `LandingPageText` collection */
	deleteFromLandingPageTextCollection: LandingPageTextDeleteResponse
	/** Deletes zero or more records from the `Language` collection */
	deleteFromLanguageCollection: LanguageDeleteResponse
	/** Deletes zero or more records from the `LinkedUsersToCompanies` collection */
	deleteFromLinkedUsersToCompaniesCollection: LinkedUsersToCompaniesDeleteResponse
	/** Deletes zero or more records from the `Profile` collection */
	deleteFromProfileCollection: ProfileDeleteResponse
	/** Deletes zero or more records from the `Project` collection */
	deleteFromProjectCollection: ProjectDeleteResponse
	/** Deletes zero or more records from the `Role` collection */
	deleteFromRoleCollection: RoleDeleteResponse
	/** Deletes zero or more records from the `ShallowUser` collection */
	deleteFromShallowUserCollection: ShallowUserDeleteResponse
	/** Deletes zero or more records from the `Skill` collection */
	deleteFromSkillCollection: SkillDeleteResponse
	/** Deletes zero or more records from the `Story` collection */
	deleteFromStoryCollection: StoryDeleteResponse
	/** Deletes zero or more records from the `StudentClaimKit` collection */
	deleteFromStudentClaimKitCollection: StudentClaimKitDeleteResponse
	/** Deletes zero or more records from the `StudentKit` collection */
	deleteFromStudentKitCollection: StudentKitDeleteResponse
	/** Deletes zero or more records from the `StudentKitEdition` collection */
	deleteFromStudentKitEditionCollection: StudentKitEditionDeleteResponse
	/** Deletes zero or more records from the `StudentKitScanningAgent` collection */
	deleteFromStudentKitScanningAgentCollection: StudentKitScanningAgentDeleteResponse
	/** Deletes zero or more records from the `StudentKitScheduledMailCronjobData` collection */
	deleteFromStudentKitScheduledMailCronjobDataCollection: StudentKitScheduledMailCronjobDataDeleteResponse
	/** Deletes zero or more records from the `Tag` collection */
	deleteFromTagCollection: TagDeleteResponse
	/** Deletes zero or more records from the `Team` collection */
	deleteFromTeamCollection: TeamDeleteResponse
	/** Deletes zero or more records from the `TeamDepartment` collection */
	deleteFromTeamDepartmentCollection: TeamDepartmentDeleteResponse
	/** Deletes zero or more records from the `TeamMember` collection */
	deleteFromTeamMemberCollection: TeamMemberDeleteResponse
	/** Deletes zero or more records from the `TeamRole` collection */
	deleteFromTeamRoleCollection: TeamRoleDeleteResponse
	/** Deletes zero or more records from the `University` collection */
	deleteFromUniversityCollection: UniversityDeleteResponse
	/** Deletes zero or more records from the `User` collection */
	deleteFromUserCollection: UserDeleteResponse
	/** Deletes zero or more records from the `Value` collection */
	deleteFromValueCollection: ValueDeleteResponse
	/** Deletes zero or more records from the `Video` collection */
	deleteFromVideoCollection: VideoDeleteResponse
	/** Deletes zero or more records from the `ViewCustomUser` collection */
	deleteFromViewCustomUserCollection: ViewCustomUserDeleteResponse
	/** Deletes zero or more records from the `_ActiveArticleTagToUser` collection */
	deleteFrom_ActiveArticleTagToUserCollection: _ActiveArticleTagToUserDeleteResponse
	/** Deletes zero or more records from the `_CompanyToCompanyType` collection */
	deleteFrom_CompanyToCompanyTypeCollection: _CompanyToCompanyTypeDeleteResponse
	/** Deletes zero or more records from the `_JobToCompanyOffices` collection */
	deleteFrom_JobToCompanyOfficesCollection: _JobToCompanyOfficesDeleteResponse
	/** Deletes zero or more records from the `_JobToCustomSkills` collection */
	deleteFrom_JobToCustomSkillsCollection: _JobToCustomSkillsDeleteResponse
	/** Deletes zero or more records from the `_JobToFollowers` collection */
	deleteFrom_JobToFollowersCollection: _JobToFollowersDeleteResponse
	/** Deletes zero or more records from the `_JobToSkill` collection */
	deleteFrom_JobToSkillCollection: _JobToSkillDeleteResponse
	/** Deletes zero or more records from the `_OwnerToCompany` collection */
	deleteFrom_OwnerToCompanyCollection: _OwnerToCompanyDeleteResponse
	/** Deletes zero or more records from the `_ProfileToSkill` collection */
	deleteFrom_ProfileToSkillCollection: _ProfileToSkillDeleteResponse
	/** Deletes zero or more records from the `_ProfileToValue` collection */
	deleteFrom_ProfileToValueCollection: _ProfileToValueDeleteResponse
	/** Deletes zero or more records from the `_TeamToCompanyOffices` collection */
	deleteFrom_TeamToCompanyOfficesCollection: _TeamToCompanyOfficesDeleteResponse
	/** Deletes zero or more records from the `_TeamToJob` collection */
	deleteFrom_TeamToJobCollection: _TeamToJobDeleteResponse
	/** Deletes zero or more records from the `_UserToCompanyRole` collection */
	deleteFrom_UserToCompanyRoleCollection: _UserToCompanyRoleDeleteResponse
	/** Deletes zero or more records from the `application_stage` collection */
	deleteFromapplication_stageCollection: Application_StageDeleteResponse
	/** Deletes zero or more records from the `article_media` collection */
	deleteFromarticle_mediaCollection: Article_MediaDeleteResponse
	/** Deletes zero or more records from the `article_shares` collection */
	deleteFromarticle_sharesCollection: Article_SharesDeleteResponse
	/** Deletes zero or more records from the `campaign_claim_history` collection */
	deleteFromcampaign_claim_historyCollection: Campaign_Claim_HistoryDeleteResponse
	/** Deletes zero or more records from the `campaign_editions` collection */
	deleteFromcampaign_editionsCollection: Campaign_EditionsDeleteResponse
	/** Deletes zero or more records from the `campaign_recipients` collection */
	deleteFromcampaign_recipientsCollection: Campaign_RecipientsDeleteResponse
	/** Deletes zero or more records from the `campaign_scanning_agents` collection */
	deleteFromcampaign_scanning_agentsCollection: Campaign_Scanning_AgentsDeleteResponse
	/** Deletes zero or more records from the `companies` collection */
	deleteFromcompaniesCollection: CompaniesDeleteResponse
	/** Deletes zero or more records from the `custom_notifications` collection */
	deleteFromcustom_notificationsCollection: Custom_NotificationsDeleteResponse
	/** Deletes zero or more records from the `exportchillpackrecipients` collection */
	deleteFromexportchillpackrecipientsCollection: ExportchillpackrecipientsDeleteResponse
	/** Deletes zero or more records from the `exportstudentkitview` collection */
	deleteFromexportstudentkitviewCollection: ExportstudentkitviewDeleteResponse
	/** Deletes zero or more records from the `favorite_user_articles` collection */
	deleteFromfavorite_user_articlesCollection: Favorite_User_ArticlesDeleteResponse
	/** Deletes zero or more records from the `feedtags` collection */
	deleteFromfeedtagsCollection: FeedtagsDeleteResponse
	/** Deletes zero or more records from the `liked_user_articles` collection */
	deleteFromliked_user_articlesCollection: Liked_User_ArticlesDeleteResponse
	/** Deletes zero or more records from the `notifications` collection */
	deleteFromnotificationsCollection: NotificationsDeleteResponse
	/** Deletes zero or more records from the `onesignal` collection */
	deleteFromonesignalCollection: OnesignalDeleteResponse
	/** Deletes zero or more records from the `post_comment_likes` collection */
	deleteFrompost_comment_likesCollection: Post_Comment_LikesDeleteResponse
	/** Deletes zero or more records from the `post_comments` collection */
	deleteFrompost_commentsCollection: Post_CommentsDeleteResponse
	/** Deletes zero or more records from the `roLocations` collection */
	deleteFromroLocationsCollection: RoLocationsDeleteResponse
	/** Deletes zero or more records from the `scanning_agent_invitations` collection */
	deleteFromscanning_agent_invitationsCollection: Scanning_Agent_InvitationsDeleteResponse
	/** Deletes zero or more records from the `search` collection */
	deleteFromsearchCollection: SearchDeleteResponse
	/** Deletes zero or more records from the `searchview` collection */
	deleteFromsearchviewCollection: SearchviewDeleteResponse
	/** Deletes zero or more records from the `segments` collection */
	deleteFromsegmentsCollection: SegmentsDeleteResponse
	/** Deletes zero or more records from the `standardresponse` collection */
	deleteFromstandardresponseCollection: StandardresponseDeleteResponse
	/** Deletes zero or more records from the `viewed_user_articles` collection */
	deleteFromviewed_user_articlesCollection: Viewed_User_ArticlesDeleteResponse
	generate_and_send_report?: Maybe<Scalars['Opaque']['output']>
	generate_random_id?: Maybe<Scalars['String']['output']>
	http_reset_curlopt?: Maybe<Scalars['Boolean']['output']>
	http_set_curlopt?: Maybe<Scalars['Boolean']['output']>
	increment_article_view_counts?: Maybe<Scalars['Opaque']['output']>
	/** Adds one or more `ActiveArticleTag` records to the collection */
	insertIntoActiveArticleTagCollection?: Maybe<ActiveArticleTagInsertResponse>
	/** Adds one or more `ActivityField` records to the collection */
	insertIntoActivityFieldCollection?: Maybe<ActivityFieldInsertResponse>
	/** Adds one or more `Ad` records to the collection */
	insertIntoAdCollection?: Maybe<AdInsertResponse>
	/** Adds one or more `Article` records to the collection */
	insertIntoArticleCollection?: Maybe<ArticleInsertResponse>
	/** Adds one or more `ArticleTag` records to the collection */
	insertIntoArticleTagCollection?: Maybe<ArticleTagInsertResponse>
	/** Adds one or more `Campaign` records to the collection */
	insertIntoCampaignCollection?: Maybe<CampaignInsertResponse>
	/** Adds one or more `ChillPackCompany` records to the collection */
	insertIntoChillPackCompanyCollection?: Maybe<ChillPackCompanyInsertResponse>
	/** Adds one or more `ChillPackEdition` records to the collection */
	insertIntoChillPackEditionCollection?: Maybe<ChillPackEditionInsertResponse>
	/** Adds one or more `ChillPackRecipientClaim` records to the collection */
	insertIntoChillPackRecipientClaimCollection?: Maybe<ChillPackRecipientClaimInsertResponse>
	/** Adds one or more `ChillPackRecipient` records to the collection */
	insertIntoChillPackRecipientCollection?: Maybe<ChillPackRecipientInsertResponse>
	/** Adds one or more `ChillPackScheduledMailCronjobData` records to the collection */
	insertIntoChillPackScheduledMailCronjobDataCollection?: Maybe<ChillPackScheduledMailCronjobDataInsertResponse>
	/** Adds one or more `Company` records to the collection */
	insertIntoCompanyCollection?: Maybe<CompanyInsertResponse>
	/** Adds one or more `CompanyEmails` records to the collection */
	insertIntoCompanyEmailsCollection?: Maybe<CompanyEmailsInsertResponse>
	/** Adds one or more `CompanyOffices` records to the collection */
	insertIntoCompanyOfficesCollection?: Maybe<CompanyOfficesInsertResponse>
	/** Adds one or more `CompanyPhones` records to the collection */
	insertIntoCompanyPhonesCollection?: Maybe<CompanyPhonesInsertResponse>
	/** Adds one or more `CompanyResponse` records to the collection */
	insertIntoCompanyResponseCollection?: Maybe<CompanyResponseInsertResponse>
	/** Adds one or more `CompanyRole` records to the collection */
	insertIntoCompanyRoleCollection?: Maybe<CompanyRoleInsertResponse>
	/** Adds one or more `CompanyRole_roles` records to the collection */
	insertIntoCompanyRole_rolesCollection?: Maybe<CompanyRole_RolesInsertResponse>
	/** Adds one or more `CompanyType` records to the collection */
	insertIntoCompanyTypeCollection?: Maybe<CompanyTypeInsertResponse>
	/** Adds one or more `Contact` records to the collection */
	insertIntoContactCollection?: Maybe<ContactInsertResponse>
	/** Adds one or more `Country` records to the collection */
	insertIntoCountryCollection?: Maybe<CountryInsertResponse>
	/** Adds one or more `CurrentPosition` records to the collection */
	insertIntoCurrentPositionCollection?: Maybe<CurrentPositionInsertResponse>
	/** Adds one or more `CustomSkills` records to the collection */
	insertIntoCustomSkillsCollection?: Maybe<CustomSkillsInsertResponse>
	/** Adds one or more `Education` records to the collection */
	insertIntoEducationCollection?: Maybe<EducationInsertResponse>
	/** Adds one or more `Error` records to the collection */
	insertIntoErrorCollection?: Maybe<ErrorInsertResponse>
	/** Adds one or more `Experience` records to the collection */
	insertIntoExperienceCollection?: Maybe<ExperienceInsertResponse>
	/** Adds one or more `FacebookProfile` records to the collection */
	insertIntoFacebookProfileCollection?: Maybe<FacebookProfileInsertResponse>
	/** Adds one or more `Faculty` records to the collection */
	insertIntoFacultyCollection?: Maybe<FacultyInsertResponse>
	/** Adds one or more `FacultySpecialization` records to the collection */
	insertIntoFacultySpecializationCollection?: Maybe<FacultySpecializationInsertResponse>
	/** Adds one or more `Faq` records to the collection */
	insertIntoFaqCollection?: Maybe<FaqInsertResponse>
	/** Adds one or more `Hobby` records to the collection */
	insertIntoHobbyCollection?: Maybe<HobbyInsertResponse>
	/** Adds one or more `Image` records to the collection */
	insertIntoImageCollection?: Maybe<ImageInsertResponse>
	/** Adds one or more `Industry` records to the collection */
	insertIntoIndustryCollection?: Maybe<IndustryInsertResponse>
	/** Adds one or more `JobApplicant` records to the collection */
	insertIntoJobApplicantCollection?: Maybe<JobApplicantInsertResponse>
	/** Adds one or more `Job` records to the collection */
	insertIntoJobCollection?: Maybe<JobInsertResponse>
	/** Adds one or more `JobSalary` records to the collection */
	insertIntoJobSalaryCollection?: Maybe<JobSalaryInsertResponse>
	/** Adds one or more `LandingPage` records to the collection */
	insertIntoLandingPageCollection?: Maybe<LandingPageInsertResponse>
	/** Adds one or more `LandingPageText` records to the collection */
	insertIntoLandingPageTextCollection?: Maybe<LandingPageTextInsertResponse>
	/** Adds one or more `Language` records to the collection */
	insertIntoLanguageCollection?: Maybe<LanguageInsertResponse>
	/** Adds one or more `LinkedUsersToCompanies` records to the collection */
	insertIntoLinkedUsersToCompaniesCollection?: Maybe<LinkedUsersToCompaniesInsertResponse>
	/** Adds one or more `Profile` records to the collection */
	insertIntoProfileCollection?: Maybe<ProfileInsertResponse>
	/** Adds one or more `Project` records to the collection */
	insertIntoProjectCollection?: Maybe<ProjectInsertResponse>
	/** Adds one or more `Role` records to the collection */
	insertIntoRoleCollection?: Maybe<RoleInsertResponse>
	/** Adds one or more `ShallowUser` records to the collection */
	insertIntoShallowUserCollection?: Maybe<ShallowUserInsertResponse>
	/** Adds one or more `Skill` records to the collection */
	insertIntoSkillCollection?: Maybe<SkillInsertResponse>
	/** Adds one or more `Story` records to the collection */
	insertIntoStoryCollection?: Maybe<StoryInsertResponse>
	/** Adds one or more `StudentClaimKit` records to the collection */
	insertIntoStudentClaimKitCollection?: Maybe<StudentClaimKitInsertResponse>
	/** Adds one or more `StudentKit` records to the collection */
	insertIntoStudentKitCollection?: Maybe<StudentKitInsertResponse>
	/** Adds one or more `StudentKitEdition` records to the collection */
	insertIntoStudentKitEditionCollection?: Maybe<StudentKitEditionInsertResponse>
	/** Adds one or more `StudentKitScanningAgent` records to the collection */
	insertIntoStudentKitScanningAgentCollection?: Maybe<StudentKitScanningAgentInsertResponse>
	/** Adds one or more `StudentKitScheduledMailCronjobData` records to the collection */
	insertIntoStudentKitScheduledMailCronjobDataCollection?: Maybe<StudentKitScheduledMailCronjobDataInsertResponse>
	/** Adds one or more `Tag` records to the collection */
	insertIntoTagCollection?: Maybe<TagInsertResponse>
	/** Adds one or more `Team` records to the collection */
	insertIntoTeamCollection?: Maybe<TeamInsertResponse>
	/** Adds one or more `TeamDepartment` records to the collection */
	insertIntoTeamDepartmentCollection?: Maybe<TeamDepartmentInsertResponse>
	/** Adds one or more `TeamMember` records to the collection */
	insertIntoTeamMemberCollection?: Maybe<TeamMemberInsertResponse>
	/** Adds one or more `TeamRole` records to the collection */
	insertIntoTeamRoleCollection?: Maybe<TeamRoleInsertResponse>
	/** Adds one or more `University` records to the collection */
	insertIntoUniversityCollection?: Maybe<UniversityInsertResponse>
	/** Adds one or more `User` records to the collection */
	insertIntoUserCollection?: Maybe<UserInsertResponse>
	/** Adds one or more `Value` records to the collection */
	insertIntoValueCollection?: Maybe<ValueInsertResponse>
	/** Adds one or more `Video` records to the collection */
	insertIntoVideoCollection?: Maybe<VideoInsertResponse>
	/** Adds one or more `ViewCustomUser` records to the collection */
	insertIntoViewCustomUserCollection?: Maybe<ViewCustomUserInsertResponse>
	/** Adds one or more `_ActiveArticleTagToUser` records to the collection */
	insertInto_ActiveArticleTagToUserCollection?: Maybe<_ActiveArticleTagToUserInsertResponse>
	/** Adds one or more `_CompanyToCompanyType` records to the collection */
	insertInto_CompanyToCompanyTypeCollection?: Maybe<_CompanyToCompanyTypeInsertResponse>
	/** Adds one or more `_JobToCompanyOffices` records to the collection */
	insertInto_JobToCompanyOfficesCollection?: Maybe<_JobToCompanyOfficesInsertResponse>
	/** Adds one or more `_JobToCustomSkills` records to the collection */
	insertInto_JobToCustomSkillsCollection?: Maybe<_JobToCustomSkillsInsertResponse>
	/** Adds one or more `_JobToFollowers` records to the collection */
	insertInto_JobToFollowersCollection?: Maybe<_JobToFollowersInsertResponse>
	/** Adds one or more `_JobToSkill` records to the collection */
	insertInto_JobToSkillCollection?: Maybe<_JobToSkillInsertResponse>
	/** Adds one or more `_OwnerToCompany` records to the collection */
	insertInto_OwnerToCompanyCollection?: Maybe<_OwnerToCompanyInsertResponse>
	/** Adds one or more `_ProfileToSkill` records to the collection */
	insertInto_ProfileToSkillCollection?: Maybe<_ProfileToSkillInsertResponse>
	/** Adds one or more `_ProfileToValue` records to the collection */
	insertInto_ProfileToValueCollection?: Maybe<_ProfileToValueInsertResponse>
	/** Adds one or more `_TeamToCompanyOffices` records to the collection */
	insertInto_TeamToCompanyOfficesCollection?: Maybe<_TeamToCompanyOfficesInsertResponse>
	/** Adds one or more `_TeamToJob` records to the collection */
	insertInto_TeamToJobCollection?: Maybe<_TeamToJobInsertResponse>
	/** Adds one or more `_UserToCompanyRole` records to the collection */
	insertInto_UserToCompanyRoleCollection?: Maybe<_UserToCompanyRoleInsertResponse>
	/** Adds one or more `application_stage` records to the collection */
	insertIntoapplication_stageCollection?: Maybe<Application_StageInsertResponse>
	/** Adds one or more `article_media` records to the collection */
	insertIntoarticle_mediaCollection?: Maybe<Article_MediaInsertResponse>
	/** Adds one or more `article_shares` records to the collection */
	insertIntoarticle_sharesCollection?: Maybe<Article_SharesInsertResponse>
	/** Adds one or more `campaign_claim_history` records to the collection */
	insertIntocampaign_claim_historyCollection?: Maybe<Campaign_Claim_HistoryInsertResponse>
	/** Adds one or more `campaign_editions` records to the collection */
	insertIntocampaign_editionsCollection?: Maybe<Campaign_EditionsInsertResponse>
	/** Adds one or more `campaign_recipients` records to the collection */
	insertIntocampaign_recipientsCollection?: Maybe<Campaign_RecipientsInsertResponse>
	/** Adds one or more `campaign_scanning_agents` records to the collection */
	insertIntocampaign_scanning_agentsCollection?: Maybe<Campaign_Scanning_AgentsInsertResponse>
	/** Adds one or more `companies` records to the collection */
	insertIntocompaniesCollection?: Maybe<CompaniesInsertResponse>
	/** Adds one or more `custom_notifications` records to the collection */
	insertIntocustom_notificationsCollection?: Maybe<Custom_NotificationsInsertResponse>
	/** Adds one or more `exportchillpackrecipients` records to the collection */
	insertIntoexportchillpackrecipientsCollection?: Maybe<ExportchillpackrecipientsInsertResponse>
	/** Adds one or more `exportstudentkitview` records to the collection */
	insertIntoexportstudentkitviewCollection?: Maybe<ExportstudentkitviewInsertResponse>
	/** Adds one or more `favorite_user_articles` records to the collection */
	insertIntofavorite_user_articlesCollection?: Maybe<Favorite_User_ArticlesInsertResponse>
	/** Adds one or more `feedtags` records to the collection */
	insertIntofeedtagsCollection?: Maybe<FeedtagsInsertResponse>
	/** Adds one or more `liked_user_articles` records to the collection */
	insertIntoliked_user_articlesCollection?: Maybe<Liked_User_ArticlesInsertResponse>
	/** Adds one or more `notifications` records to the collection */
	insertIntonotificationsCollection?: Maybe<NotificationsInsertResponse>
	/** Adds one or more `onesignal` records to the collection */
	insertIntoonesignalCollection?: Maybe<OnesignalInsertResponse>
	/** Adds one or more `post_comment_likes` records to the collection */
	insertIntopost_comment_likesCollection?: Maybe<Post_Comment_LikesInsertResponse>
	/** Adds one or more `post_comments` records to the collection */
	insertIntopost_commentsCollection?: Maybe<Post_CommentsInsertResponse>
	/** Adds one or more `roLocations` records to the collection */
	insertIntoroLocationsCollection?: Maybe<RoLocationsInsertResponse>
	/** Adds one or more `scanning_agent_invitations` records to the collection */
	insertIntoscanning_agent_invitationsCollection?: Maybe<Scanning_Agent_InvitationsInsertResponse>
	/** Adds one or more `search` records to the collection */
	insertIntosearchCollection?: Maybe<SearchInsertResponse>
	/** Adds one or more `searchview` records to the collection */
	insertIntosearchviewCollection?: Maybe<SearchviewInsertResponse>
	/** Adds one or more `segments` records to the collection */
	insertIntosegmentsCollection?: Maybe<SegmentsInsertResponse>
	/** Adds one or more `standardresponse` records to the collection */
	insertIntostandardresponseCollection?: Maybe<StandardresponseInsertResponse>
	/** Adds one or more `viewed_user_articles` records to the collection */
	insertIntoviewed_user_articlesCollection?: Maybe<Viewed_User_ArticlesInsertResponse>
	send_qr_code?: Maybe<Scalars['JSON']['output']>
	sendqrcode?: Maybe<Scalars['JSON']['output']>
	setUpProfile?: Maybe<UserConnection>
	setskills?: Maybe<SkillConnection>
	setvalues?: Maybe<ProfileConnection>
	/** Updates zero or more records in the `ActiveArticleTag` collection */
	updateActiveArticleTagCollection: ActiveArticleTagUpdateResponse
	/** Updates zero or more records in the `ActivityField` collection */
	updateActivityFieldCollection: ActivityFieldUpdateResponse
	/** Updates zero or more records in the `Ad` collection */
	updateAdCollection: AdUpdateResponse
	/** Updates zero or more records in the `Article` collection */
	updateArticleCollection: ArticleUpdateResponse
	/** Updates zero or more records in the `ArticleTag` collection */
	updateArticleTagCollection: ArticleTagUpdateResponse
	/** Updates zero or more records in the `Campaign` collection */
	updateCampaignCollection: CampaignUpdateResponse
	/** Updates zero or more records in the `ChillPackCompany` collection */
	updateChillPackCompanyCollection: ChillPackCompanyUpdateResponse
	/** Updates zero or more records in the `ChillPackEdition` collection */
	updateChillPackEditionCollection: ChillPackEditionUpdateResponse
	/** Updates zero or more records in the `ChillPackRecipientClaim` collection */
	updateChillPackRecipientClaimCollection: ChillPackRecipientClaimUpdateResponse
	/** Updates zero or more records in the `ChillPackRecipient` collection */
	updateChillPackRecipientCollection: ChillPackRecipientUpdateResponse
	/** Updates zero or more records in the `ChillPackScheduledMailCronjobData` collection */
	updateChillPackScheduledMailCronjobDataCollection: ChillPackScheduledMailCronjobDataUpdateResponse
	/** Updates zero or more records in the `Company` collection */
	updateCompanyCollection: CompanyUpdateResponse
	/** Updates zero or more records in the `CompanyEmails` collection */
	updateCompanyEmailsCollection: CompanyEmailsUpdateResponse
	/** Updates zero or more records in the `CompanyOffices` collection */
	updateCompanyOfficesCollection: CompanyOfficesUpdateResponse
	/** Updates zero or more records in the `CompanyPhones` collection */
	updateCompanyPhonesCollection: CompanyPhonesUpdateResponse
	/** Updates zero or more records in the `CompanyResponse` collection */
	updateCompanyResponseCollection: CompanyResponseUpdateResponse
	/** Updates zero or more records in the `CompanyRole` collection */
	updateCompanyRoleCollection: CompanyRoleUpdateResponse
	/** Updates zero or more records in the `CompanyRole_roles` collection */
	updateCompanyRole_rolesCollection: CompanyRole_RolesUpdateResponse
	/** Updates zero or more records in the `CompanyType` collection */
	updateCompanyTypeCollection: CompanyTypeUpdateResponse
	/** Updates zero or more records in the `Contact` collection */
	updateContactCollection: ContactUpdateResponse
	/** Updates zero or more records in the `Country` collection */
	updateCountryCollection: CountryUpdateResponse
	/** Updates zero or more records in the `CurrentPosition` collection */
	updateCurrentPositionCollection: CurrentPositionUpdateResponse
	/** Updates zero or more records in the `CustomSkills` collection */
	updateCustomSkillsCollection: CustomSkillsUpdateResponse
	/** Updates zero or more records in the `Education` collection */
	updateEducationCollection: EducationUpdateResponse
	/** Updates zero or more records in the `Error` collection */
	updateErrorCollection: ErrorUpdateResponse
	/** Updates zero or more records in the `Experience` collection */
	updateExperienceCollection: ExperienceUpdateResponse
	/** Updates zero or more records in the `FacebookProfile` collection */
	updateFacebookProfileCollection: FacebookProfileUpdateResponse
	/** Updates zero or more records in the `Faculty` collection */
	updateFacultyCollection: FacultyUpdateResponse
	/** Updates zero or more records in the `FacultySpecialization` collection */
	updateFacultySpecializationCollection: FacultySpecializationUpdateResponse
	/** Updates zero or more records in the `Faq` collection */
	updateFaqCollection: FaqUpdateResponse
	/** Updates zero or more records in the `Hobby` collection */
	updateHobbyCollection: HobbyUpdateResponse
	/** Updates zero or more records in the `Image` collection */
	updateImageCollection: ImageUpdateResponse
	/** Updates zero or more records in the `Industry` collection */
	updateIndustryCollection: IndustryUpdateResponse
	/** Updates zero or more records in the `JobApplicant` collection */
	updateJobApplicantCollection: JobApplicantUpdateResponse
	/** Updates zero or more records in the `Job` collection */
	updateJobCollection: JobUpdateResponse
	/** Updates zero or more records in the `JobSalary` collection */
	updateJobSalaryCollection: JobSalaryUpdateResponse
	/** Updates zero or more records in the `LandingPage` collection */
	updateLandingPageCollection: LandingPageUpdateResponse
	/** Updates zero or more records in the `LandingPageText` collection */
	updateLandingPageTextCollection: LandingPageTextUpdateResponse
	/** Updates zero or more records in the `Language` collection */
	updateLanguageCollection: LanguageUpdateResponse
	/** Updates zero or more records in the `LinkedUsersToCompanies` collection */
	updateLinkedUsersToCompaniesCollection: LinkedUsersToCompaniesUpdateResponse
	/** Updates zero or more records in the `Profile` collection */
	updateProfileCollection: ProfileUpdateResponse
	/** Updates zero or more records in the `Project` collection */
	updateProjectCollection: ProjectUpdateResponse
	/** Updates zero or more records in the `Role` collection */
	updateRoleCollection: RoleUpdateResponse
	/** Updates zero or more records in the `ShallowUser` collection */
	updateShallowUserCollection: ShallowUserUpdateResponse
	/** Updates zero or more records in the `Skill` collection */
	updateSkillCollection: SkillUpdateResponse
	/** Updates zero or more records in the `Story` collection */
	updateStoryCollection: StoryUpdateResponse
	/** Updates zero or more records in the `StudentClaimKit` collection */
	updateStudentClaimKitCollection: StudentClaimKitUpdateResponse
	/** Updates zero or more records in the `StudentKit` collection */
	updateStudentKitCollection: StudentKitUpdateResponse
	/** Updates zero or more records in the `StudentKitEdition` collection */
	updateStudentKitEditionCollection: StudentKitEditionUpdateResponse
	/** Updates zero or more records in the `StudentKitScanningAgent` collection */
	updateStudentKitScanningAgentCollection: StudentKitScanningAgentUpdateResponse
	/** Updates zero or more records in the `StudentKitScheduledMailCronjobData` collection */
	updateStudentKitScheduledMailCronjobDataCollection: StudentKitScheduledMailCronjobDataUpdateResponse
	/** Updates zero or more records in the `Tag` collection */
	updateTagCollection: TagUpdateResponse
	/** Updates zero or more records in the `Team` collection */
	updateTeamCollection: TeamUpdateResponse
	/** Updates zero or more records in the `TeamDepartment` collection */
	updateTeamDepartmentCollection: TeamDepartmentUpdateResponse
	/** Updates zero or more records in the `TeamMember` collection */
	updateTeamMemberCollection: TeamMemberUpdateResponse
	/** Updates zero or more records in the `TeamRole` collection */
	updateTeamRoleCollection: TeamRoleUpdateResponse
	/** Updates zero or more records in the `University` collection */
	updateUniversityCollection: UniversityUpdateResponse
	/** Updates zero or more records in the `User` collection */
	updateUserCollection: UserUpdateResponse
	/** Updates zero or more records in the `Value` collection */
	updateValueCollection: ValueUpdateResponse
	/** Updates zero or more records in the `Video` collection */
	updateVideoCollection: VideoUpdateResponse
	/** Updates zero or more records in the `ViewCustomUser` collection */
	updateViewCustomUserCollection: ViewCustomUserUpdateResponse
	/** Updates zero or more records in the `_ActiveArticleTagToUser` collection */
	update_ActiveArticleTagToUserCollection: _ActiveArticleTagToUserUpdateResponse
	/** Updates zero or more records in the `_CompanyToCompanyType` collection */
	update_CompanyToCompanyTypeCollection: _CompanyToCompanyTypeUpdateResponse
	/** Updates zero or more records in the `_JobToCompanyOffices` collection */
	update_JobToCompanyOfficesCollection: _JobToCompanyOfficesUpdateResponse
	/** Updates zero or more records in the `_JobToCustomSkills` collection */
	update_JobToCustomSkillsCollection: _JobToCustomSkillsUpdateResponse
	/** Updates zero or more records in the `_JobToFollowers` collection */
	update_JobToFollowersCollection: _JobToFollowersUpdateResponse
	/** Updates zero or more records in the `_JobToSkill` collection */
	update_JobToSkillCollection: _JobToSkillUpdateResponse
	/** Updates zero or more records in the `_OwnerToCompany` collection */
	update_OwnerToCompanyCollection: _OwnerToCompanyUpdateResponse
	/** Updates zero or more records in the `_ProfileToSkill` collection */
	update_ProfileToSkillCollection: _ProfileToSkillUpdateResponse
	/** Updates zero or more records in the `_ProfileToValue` collection */
	update_ProfileToValueCollection: _ProfileToValueUpdateResponse
	/** Updates zero or more records in the `_TeamToCompanyOffices` collection */
	update_TeamToCompanyOfficesCollection: _TeamToCompanyOfficesUpdateResponse
	/** Updates zero or more records in the `_TeamToJob` collection */
	update_TeamToJobCollection: _TeamToJobUpdateResponse
	/** Updates zero or more records in the `_UserToCompanyRole` collection */
	update_UserToCompanyRoleCollection: _UserToCompanyRoleUpdateResponse
	/** Updates zero or more records in the `application_stage` collection */
	updateapplication_stageCollection: Application_StageUpdateResponse
	/** Updates zero or more records in the `article_media` collection */
	updatearticle_mediaCollection: Article_MediaUpdateResponse
	/** Updates zero or more records in the `article_shares` collection */
	updatearticle_sharesCollection: Article_SharesUpdateResponse
	/** Updates zero or more records in the `campaign_claim_history` collection */
	updatecampaign_claim_historyCollection: Campaign_Claim_HistoryUpdateResponse
	/** Updates zero or more records in the `campaign_editions` collection */
	updatecampaign_editionsCollection: Campaign_EditionsUpdateResponse
	/** Updates zero or more records in the `campaign_recipients` collection */
	updatecampaign_recipientsCollection: Campaign_RecipientsUpdateResponse
	/** Updates zero or more records in the `campaign_scanning_agents` collection */
	updatecampaign_scanning_agentsCollection: Campaign_Scanning_AgentsUpdateResponse
	/** Updates zero or more records in the `companies` collection */
	updatecompaniesCollection: CompaniesUpdateResponse
	/** Updates zero or more records in the `custom_notifications` collection */
	updatecustom_notificationsCollection: Custom_NotificationsUpdateResponse
	/** Updates zero or more records in the `exportchillpackrecipients` collection */
	updateexportchillpackrecipientsCollection: ExportchillpackrecipientsUpdateResponse
	/** Updates zero or more records in the `exportstudentkitview` collection */
	updateexportstudentkitviewCollection: ExportstudentkitviewUpdateResponse
	/** Updates zero or more records in the `favorite_user_articles` collection */
	updatefavorite_user_articlesCollection: Favorite_User_ArticlesUpdateResponse
	/** Updates zero or more records in the `feedtags` collection */
	updatefeedtagsCollection: FeedtagsUpdateResponse
	/** Updates zero or more records in the `liked_user_articles` collection */
	updateliked_user_articlesCollection: Liked_User_ArticlesUpdateResponse
	/** Updates zero or more records in the `notifications` collection */
	updatenotificationsCollection: NotificationsUpdateResponse
	/** Updates zero or more records in the `onesignal` collection */
	updateonesignalCollection: OnesignalUpdateResponse
	/** Updates zero or more records in the `post_comment_likes` collection */
	updatepost_comment_likesCollection: Post_Comment_LikesUpdateResponse
	/** Updates zero or more records in the `post_comments` collection */
	updatepost_commentsCollection: Post_CommentsUpdateResponse
	/** Updates zero or more records in the `roLocations` collection */
	updateroLocationsCollection: RoLocationsUpdateResponse
	/** Updates zero or more records in the `scanning_agent_invitations` collection */
	updatescanning_agent_invitationsCollection: Scanning_Agent_InvitationsUpdateResponse
	/** Updates zero or more records in the `search` collection */
	updatesearchCollection: SearchUpdateResponse
	/** Updates zero or more records in the `searchview` collection */
	updatesearchviewCollection: SearchviewUpdateResponse
	/** Updates zero or more records in the `segments` collection */
	updatesegmentsCollection: SegmentsUpdateResponse
	/** Updates zero or more records in the `standardresponse` collection */
	updatestandardresponseCollection: StandardresponseUpdateResponse
	/** Updates zero or more records in the `viewed_user_articles` collection */
	updateviewed_user_articlesCollection: Viewed_User_ArticlesUpdateResponse
}

/** The root type for creating and mutating data */
export type MutationAppend_To_Seen_By_UsersArgs = {
	notification_id: Scalars['UUID']['input']
	user_id: Scalars['String']['input']
}

/** The root type for creating and mutating data */
export type MutationAppend_User_To_NotificationsArgs = {
	notification_ids: Array<InputMaybe<Scalars['UUID']['input']>>
	user_id: Scalars['String']['input']
}

/** The root type for creating and mutating data */
export type MutationAppreciateArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	articleId: Scalars['String']['input']
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StandardresponseFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	language: Scalars['String']['input']
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StandardresponseOrderBy>>
	tagId: Scalars['String']['input']
}

/** The root type for creating and mutating data */
export type MutationCheck_Scanning_AgentArgs = {
	user_id: Scalars['String']['input']
}

/** The root type for creating and mutating data */
export type MutationCount_Sub_CommentsArgs = {
	comment_id: Scalars['UUID']['input']
}

/** The root type for creating and mutating data */
export type MutationCustom_Http_PostArgs = {
	body: Scalars['String']['input']
	content_type: Scalars['String']['input']
	headers: Scalars['JSON']['input']
	url: Scalars['String']['input']
}

/** The root type for creating and mutating data */
export type MutationDeleteFromActiveArticleTagCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ActiveArticleTagFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromActivityFieldCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ActivityFieldFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromAdCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<AdFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromArticleCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ArticleFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromArticleTagCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ArticleTagFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromCampaignCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CampaignFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromChillPackCompanyCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ChillPackCompanyFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromChillPackEditionCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ChillPackEditionFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromChillPackRecipientClaimCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ChillPackRecipientClaimFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromChillPackRecipientCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ChillPackRecipientFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromChillPackScheduledMailCronjobDataCollectionArgs =
	{
		atMost?: Scalars['Int']['input']
		filter?: InputMaybe<ChillPackScheduledMailCronjobDataFilter>
	}

/** The root type for creating and mutating data */
export type MutationDeleteFromCompanyCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromCompanyEmailsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyEmailsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromCompanyOfficesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyOfficesFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromCompanyPhonesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyPhonesFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromCompanyResponseCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyResponseFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromCompanyRoleCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyRoleFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromCompanyRole_RolesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyRole_RolesFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromCompanyTypeCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyTypeFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromContactCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ContactFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromCountryCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CountryFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromCurrentPositionCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CurrentPositionFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromCustomSkillsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CustomSkillsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromEducationCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<EducationFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromErrorCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ErrorFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromExperienceCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ExperienceFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromFacebookProfileCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<FacebookProfileFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromFacultyCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<FacultyFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromFacultySpecializationCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<FacultySpecializationFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromFaqCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<FaqFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromHobbyCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<HobbyFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromImageCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ImageFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromIndustryCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<IndustryFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromJobApplicantCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<JobApplicantFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromJobCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<JobFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromJobSalaryCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<JobSalaryFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromLandingPageCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<LandingPageFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromLandingPageTextCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<LandingPageTextFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromLanguageCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<LanguageFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromLinkedUsersToCompaniesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<LinkedUsersToCompaniesFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromProfileCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ProfileFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromProjectCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ProjectFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromRoleCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<RoleFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromShallowUserCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ShallowUserFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromSkillCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<SkillFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromStoryCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<StoryFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromStudentClaimKitCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<StudentClaimKitFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromStudentKitCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<StudentKitFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromStudentKitEditionCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<StudentKitEditionFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromStudentKitScanningAgentCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<StudentKitScanningAgentFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromStudentKitScheduledMailCronjobDataCollectionArgs =
	{
		atMost?: Scalars['Int']['input']
		filter?: InputMaybe<StudentKitScheduledMailCronjobDataFilter>
	}

/** The root type for creating and mutating data */
export type MutationDeleteFromTagCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<TagFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromTeamCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<TeamFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromTeamDepartmentCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<TeamDepartmentFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromTeamMemberCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<TeamMemberFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromTeamRoleCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<TeamRoleFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromUniversityCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<UniversityFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromUserCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<UserFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromValueCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ValueFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromVideoCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<VideoFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromViewCustomUserCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ViewCustomUserFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrom_ActiveArticleTagToUserCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_ActiveArticleTagToUserFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrom_CompanyToCompanyTypeCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_CompanyToCompanyTypeFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrom_JobToCompanyOfficesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_JobToCompanyOfficesFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrom_JobToCustomSkillsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_JobToCustomSkillsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrom_JobToFollowersCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_JobToFollowersFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrom_JobToSkillCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_JobToSkillFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrom_OwnerToCompanyCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_OwnerToCompanyFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrom_ProfileToSkillCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_ProfileToSkillFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrom_ProfileToValueCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_ProfileToValueFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrom_TeamToCompanyOfficesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_TeamToCompanyOfficesFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrom_TeamToJobCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_TeamToJobFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrom_UserToCompanyRoleCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_UserToCompanyRoleFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromapplication_StageCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Application_StageFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromarticle_MediaCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Article_MediaFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromarticle_SharesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Article_SharesFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromcampaign_Claim_HistoryCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Campaign_Claim_HistoryFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromcampaign_EditionsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Campaign_EditionsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromcampaign_RecipientsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Campaign_RecipientsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromcampaign_Scanning_AgentsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Campaign_Scanning_AgentsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromcompaniesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompaniesFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromcustom_NotificationsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Custom_NotificationsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromexportchillpackrecipientsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ExportchillpackrecipientsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromexportstudentkitviewCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ExportstudentkitviewFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromfavorite_User_ArticlesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Favorite_User_ArticlesFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromfeedtagsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<FeedtagsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromliked_User_ArticlesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Liked_User_ArticlesFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromnotificationsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<NotificationsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromonesignalCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<OnesignalFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrompost_Comment_LikesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Post_Comment_LikesFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFrompost_CommentsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Post_CommentsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromroLocationsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<RoLocationsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromscanning_Agent_InvitationsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Scanning_Agent_InvitationsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromsearchCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<SearchFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromsearchviewCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<SearchviewFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromsegmentsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<SegmentsFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromstandardresponseCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<StandardresponseFilter>
}

/** The root type for creating and mutating data */
export type MutationDeleteFromviewed_User_ArticlesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Viewed_User_ArticlesFilter>
}

/** The root type for creating and mutating data */
export type MutationGenerate_And_Send_ReportArgs = {
	destination_email: Scalars['String']['input']
	edition_id?: InputMaybe<Scalars['String']['input']>
	location_id?: InputMaybe<Scalars['String']['input']>
	search?: InputMaybe<Scalars['String']['input']>
}

/** The root type for creating and mutating data */
export type MutationHttp_Set_CurloptArgs = {
	curlopt: Scalars['String']['input']
	value: Scalars['String']['input']
}

/** The root type for creating and mutating data */
export type MutationIncrement_Article_View_CountsArgs = {
	post_ids: Array<InputMaybe<Scalars['String']['input']>>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoActiveArticleTagCollectionArgs = {
	objects: Array<ActiveArticleTagInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoActivityFieldCollectionArgs = {
	objects: Array<ActivityFieldInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoAdCollectionArgs = {
	objects: Array<AdInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoArticleCollectionArgs = {
	objects: Array<ArticleInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoArticleTagCollectionArgs = {
	objects: Array<ArticleTagInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoCampaignCollectionArgs = {
	objects: Array<CampaignInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoChillPackCompanyCollectionArgs = {
	objects: Array<ChillPackCompanyInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoChillPackEditionCollectionArgs = {
	objects: Array<ChillPackEditionInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoChillPackRecipientClaimCollectionArgs = {
	objects: Array<ChillPackRecipientClaimInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoChillPackRecipientCollectionArgs = {
	objects: Array<ChillPackRecipientInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoChillPackScheduledMailCronjobDataCollectionArgs =
	{
		objects: Array<ChillPackScheduledMailCronjobDataInsertInput>
	}

/** The root type for creating and mutating data */
export type MutationInsertIntoCompanyCollectionArgs = {
	objects: Array<CompanyInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoCompanyEmailsCollectionArgs = {
	objects: Array<CompanyEmailsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoCompanyOfficesCollectionArgs = {
	objects: Array<CompanyOfficesInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoCompanyPhonesCollectionArgs = {
	objects: Array<CompanyPhonesInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoCompanyResponseCollectionArgs = {
	objects: Array<CompanyResponseInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoCompanyRoleCollectionArgs = {
	objects: Array<CompanyRoleInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoCompanyRole_RolesCollectionArgs = {
	objects: Array<CompanyRole_RolesInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoCompanyTypeCollectionArgs = {
	objects: Array<CompanyTypeInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoContactCollectionArgs = {
	objects: Array<ContactInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoCountryCollectionArgs = {
	objects: Array<CountryInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoCurrentPositionCollectionArgs = {
	objects: Array<CurrentPositionInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoCustomSkillsCollectionArgs = {
	objects: Array<CustomSkillsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoEducationCollectionArgs = {
	objects: Array<EducationInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoErrorCollectionArgs = {
	objects: Array<ErrorInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoExperienceCollectionArgs = {
	objects: Array<ExperienceInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoFacebookProfileCollectionArgs = {
	objects: Array<FacebookProfileInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoFacultyCollectionArgs = {
	objects: Array<FacultyInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoFacultySpecializationCollectionArgs = {
	objects: Array<FacultySpecializationInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoFaqCollectionArgs = {
	objects: Array<FaqInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoHobbyCollectionArgs = {
	objects: Array<HobbyInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoImageCollectionArgs = {
	objects: Array<ImageInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoIndustryCollectionArgs = {
	objects: Array<IndustryInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoJobApplicantCollectionArgs = {
	objects: Array<JobApplicantInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoJobCollectionArgs = {
	objects: Array<JobInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoJobSalaryCollectionArgs = {
	objects: Array<JobSalaryInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoLandingPageCollectionArgs = {
	objects: Array<LandingPageInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoLandingPageTextCollectionArgs = {
	objects: Array<LandingPageTextInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoLanguageCollectionArgs = {
	objects: Array<LanguageInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoLinkedUsersToCompaniesCollectionArgs = {
	objects: Array<LinkedUsersToCompaniesInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoProfileCollectionArgs = {
	objects: Array<ProfileInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoProjectCollectionArgs = {
	objects: Array<ProjectInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoRoleCollectionArgs = {
	objects: Array<RoleInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoShallowUserCollectionArgs = {
	objects: Array<ShallowUserInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoSkillCollectionArgs = {
	objects: Array<SkillInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoStoryCollectionArgs = {
	objects: Array<StoryInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoStudentClaimKitCollectionArgs = {
	objects: Array<StudentClaimKitInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoStudentKitCollectionArgs = {
	objects: Array<StudentKitInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoStudentKitEditionCollectionArgs = {
	objects: Array<StudentKitEditionInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoStudentKitScanningAgentCollectionArgs = {
	objects: Array<StudentKitScanningAgentInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoStudentKitScheduledMailCronjobDataCollectionArgs =
	{
		objects: Array<StudentKitScheduledMailCronjobDataInsertInput>
	}

/** The root type for creating and mutating data */
export type MutationInsertIntoTagCollectionArgs = {
	objects: Array<TagInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoTeamCollectionArgs = {
	objects: Array<TeamInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoTeamDepartmentCollectionArgs = {
	objects: Array<TeamDepartmentInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoTeamMemberCollectionArgs = {
	objects: Array<TeamMemberInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoTeamRoleCollectionArgs = {
	objects: Array<TeamRoleInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoUniversityCollectionArgs = {
	objects: Array<UniversityInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoUserCollectionArgs = {
	objects: Array<UserInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoValueCollectionArgs = {
	objects: Array<ValueInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoVideoCollectionArgs = {
	objects: Array<VideoInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoViewCustomUserCollectionArgs = {
	objects: Array<ViewCustomUserInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertInto_ActiveArticleTagToUserCollectionArgs = {
	objects: Array<_ActiveArticleTagToUserInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertInto_CompanyToCompanyTypeCollectionArgs = {
	objects: Array<_CompanyToCompanyTypeInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertInto_JobToCompanyOfficesCollectionArgs = {
	objects: Array<_JobToCompanyOfficesInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertInto_JobToCustomSkillsCollectionArgs = {
	objects: Array<_JobToCustomSkillsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertInto_JobToFollowersCollectionArgs = {
	objects: Array<_JobToFollowersInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertInto_JobToSkillCollectionArgs = {
	objects: Array<_JobToSkillInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertInto_OwnerToCompanyCollectionArgs = {
	objects: Array<_OwnerToCompanyInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertInto_ProfileToSkillCollectionArgs = {
	objects: Array<_ProfileToSkillInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertInto_ProfileToValueCollectionArgs = {
	objects: Array<_ProfileToValueInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertInto_TeamToCompanyOfficesCollectionArgs = {
	objects: Array<_TeamToCompanyOfficesInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertInto_TeamToJobCollectionArgs = {
	objects: Array<_TeamToJobInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertInto_UserToCompanyRoleCollectionArgs = {
	objects: Array<_UserToCompanyRoleInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoapplication_StageCollectionArgs = {
	objects: Array<Application_StageInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoarticle_MediaCollectionArgs = {
	objects: Array<Article_MediaInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoarticle_SharesCollectionArgs = {
	objects: Array<Article_SharesInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntocampaign_Claim_HistoryCollectionArgs = {
	objects: Array<Campaign_Claim_HistoryInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntocampaign_EditionsCollectionArgs = {
	objects: Array<Campaign_EditionsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntocampaign_RecipientsCollectionArgs = {
	objects: Array<Campaign_RecipientsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntocampaign_Scanning_AgentsCollectionArgs = {
	objects: Array<Campaign_Scanning_AgentsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntocompaniesCollectionArgs = {
	objects: Array<CompaniesInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntocustom_NotificationsCollectionArgs = {
	objects: Array<Custom_NotificationsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoexportchillpackrecipientsCollectionArgs = {
	objects: Array<ExportchillpackrecipientsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoexportstudentkitviewCollectionArgs = {
	objects: Array<ExportstudentkitviewInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntofavorite_User_ArticlesCollectionArgs = {
	objects: Array<Favorite_User_ArticlesInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntofeedtagsCollectionArgs = {
	objects: Array<FeedtagsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoliked_User_ArticlesCollectionArgs = {
	objects: Array<Liked_User_ArticlesInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntonotificationsCollectionArgs = {
	objects: Array<NotificationsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoonesignalCollectionArgs = {
	objects: Array<OnesignalInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntopost_Comment_LikesCollectionArgs = {
	objects: Array<Post_Comment_LikesInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntopost_CommentsCollectionArgs = {
	objects: Array<Post_CommentsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoroLocationsCollectionArgs = {
	objects: Array<RoLocationsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoscanning_Agent_InvitationsCollectionArgs = {
	objects: Array<Scanning_Agent_InvitationsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntosearchCollectionArgs = {
	objects: Array<SearchInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntosearchviewCollectionArgs = {
	objects: Array<SearchviewInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntosegmentsCollectionArgs = {
	objects: Array<SegmentsInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntostandardresponseCollectionArgs = {
	objects: Array<StandardresponseInsertInput>
}

/** The root type for creating and mutating data */
export type MutationInsertIntoviewed_User_ArticlesCollectionArgs = {
	objects: Array<Viewed_User_ArticlesInsertInput>
}

/** The root type for creating and mutating data */
export type MutationSend_Qr_CodeArgs = {
	email: Scalars['String']['input']
}

/** The root type for creating and mutating data */
export type MutationSendqrcodeArgs = {
	email: Scalars['String']['input']
}

/** The root type for creating and mutating data */
export type MutationSetUpProfileArgs = {
	aboutMe?: InputMaybe<Scalars['String']['input']>
	after?: InputMaybe<Scalars['Cursor']['input']>
	avatarPath?: InputMaybe<Scalars['String']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	coverPath?: InputMaybe<Scalars['String']['input']>
	cvFileOriginalName?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	cvFilePath?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	filter?: InputMaybe<UserFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	firstName?: InputMaybe<Scalars['String']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	lastName?: InputMaybe<Scalars['String']['input']>
	locationId?: InputMaybe<Scalars['String']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<UserOrderBy>>
	profileId: Scalars['String']['input']
	skills?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** The root type for creating and mutating data */
export type MutationSetskillsArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<SkillFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SkillOrderBy>>
	skills: Array<InputMaybe<Scalars['String']['input']>>
}

/** The root type for creating and mutating data */
export type MutationSetvaluesArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ProfileFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ProfileOrderBy>>
	userid: Scalars['String']['input']
	valuetitles: Array<InputMaybe<Scalars['String']['input']>>
}

/** The root type for creating and mutating data */
export type MutationUpdateActiveArticleTagCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ActiveArticleTagFilter>
	set: ActiveArticleTagUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateActivityFieldCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ActivityFieldFilter>
	set: ActivityFieldUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateAdCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<AdFilter>
	set: AdUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateArticleCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ArticleFilter>
	set: ArticleUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateArticleTagCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ArticleTagFilter>
	set: ArticleTagUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateCampaignCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CampaignFilter>
	set: CampaignUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateChillPackCompanyCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ChillPackCompanyFilter>
	set: ChillPackCompanyUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateChillPackEditionCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ChillPackEditionFilter>
	set: ChillPackEditionUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateChillPackRecipientClaimCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ChillPackRecipientClaimFilter>
	set: ChillPackRecipientClaimUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateChillPackRecipientCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ChillPackRecipientFilter>
	set: ChillPackRecipientUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateChillPackScheduledMailCronjobDataCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ChillPackScheduledMailCronjobDataFilter>
	set: ChillPackScheduledMailCronjobDataUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateCompanyCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyFilter>
	set: CompanyUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateCompanyEmailsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyEmailsFilter>
	set: CompanyEmailsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateCompanyOfficesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyOfficesFilter>
	set: CompanyOfficesUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateCompanyPhonesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyPhonesFilter>
	set: CompanyPhonesUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateCompanyResponseCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyResponseFilter>
	set: CompanyResponseUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateCompanyRoleCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyRoleFilter>
	set: CompanyRoleUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateCompanyRole_RolesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyRole_RolesFilter>
	set: CompanyRole_RolesUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateCompanyTypeCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompanyTypeFilter>
	set: CompanyTypeUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateContactCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ContactFilter>
	set: ContactUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateCountryCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CountryFilter>
	set: CountryUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateCurrentPositionCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CurrentPositionFilter>
	set: CurrentPositionUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateCustomSkillsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CustomSkillsFilter>
	set: CustomSkillsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateEducationCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<EducationFilter>
	set: EducationUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateErrorCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ErrorFilter>
	set: ErrorUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateExperienceCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ExperienceFilter>
	set: ExperienceUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateFacebookProfileCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<FacebookProfileFilter>
	set: FacebookProfileUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateFacultyCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<FacultyFilter>
	set: FacultyUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateFacultySpecializationCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<FacultySpecializationFilter>
	set: FacultySpecializationUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateFaqCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<FaqFilter>
	set: FaqUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateHobbyCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<HobbyFilter>
	set: HobbyUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateImageCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ImageFilter>
	set: ImageUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateIndustryCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<IndustryFilter>
	set: IndustryUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateJobApplicantCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<JobApplicantFilter>
	set: JobApplicantUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateJobCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<JobFilter>
	set: JobUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateJobSalaryCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<JobSalaryFilter>
	set: JobSalaryUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateLandingPageCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<LandingPageFilter>
	set: LandingPageUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateLandingPageTextCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<LandingPageTextFilter>
	set: LandingPageTextUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateLanguageCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<LanguageFilter>
	set: LanguageUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateLinkedUsersToCompaniesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<LinkedUsersToCompaniesFilter>
	set: LinkedUsersToCompaniesUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateProfileCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ProfileFilter>
	set: ProfileUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateProjectCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ProjectFilter>
	set: ProjectUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateRoleCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<RoleFilter>
	set: RoleUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateShallowUserCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ShallowUserFilter>
	set: ShallowUserUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateSkillCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<SkillFilter>
	set: SkillUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateStoryCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<StoryFilter>
	set: StoryUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateStudentClaimKitCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<StudentClaimKitFilter>
	set: StudentClaimKitUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateStudentKitCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<StudentKitFilter>
	set: StudentKitUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateStudentKitEditionCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<StudentKitEditionFilter>
	set: StudentKitEditionUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateStudentKitScanningAgentCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<StudentKitScanningAgentFilter>
	set: StudentKitScanningAgentUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateStudentKitScheduledMailCronjobDataCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<StudentKitScheduledMailCronjobDataFilter>
	set: StudentKitScheduledMailCronjobDataUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateTagCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<TagFilter>
	set: TagUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateTeamCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<TeamFilter>
	set: TeamUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateTeamDepartmentCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<TeamDepartmentFilter>
	set: TeamDepartmentUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateTeamMemberCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<TeamMemberFilter>
	set: TeamMemberUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateTeamRoleCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<TeamRoleFilter>
	set: TeamRoleUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateUniversityCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<UniversityFilter>
	set: UniversityUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateUserCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<UserFilter>
	set: UserUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateValueCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ValueFilter>
	set: ValueUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateVideoCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<VideoFilter>
	set: VideoUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateViewCustomUserCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ViewCustomUserFilter>
	set: ViewCustomUserUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdate_ActiveArticleTagToUserCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_ActiveArticleTagToUserFilter>
	set: _ActiveArticleTagToUserUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdate_CompanyToCompanyTypeCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_CompanyToCompanyTypeFilter>
	set: _CompanyToCompanyTypeUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdate_JobToCompanyOfficesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_JobToCompanyOfficesFilter>
	set: _JobToCompanyOfficesUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdate_JobToCustomSkillsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_JobToCustomSkillsFilter>
	set: _JobToCustomSkillsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdate_JobToFollowersCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_JobToFollowersFilter>
	set: _JobToFollowersUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdate_JobToSkillCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_JobToSkillFilter>
	set: _JobToSkillUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdate_OwnerToCompanyCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_OwnerToCompanyFilter>
	set: _OwnerToCompanyUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdate_ProfileToSkillCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_ProfileToSkillFilter>
	set: _ProfileToSkillUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdate_ProfileToValueCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_ProfileToValueFilter>
	set: _ProfileToValueUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdate_TeamToCompanyOfficesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_TeamToCompanyOfficesFilter>
	set: _TeamToCompanyOfficesUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdate_TeamToJobCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_TeamToJobFilter>
	set: _TeamToJobUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdate_UserToCompanyRoleCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<_UserToCompanyRoleFilter>
	set: _UserToCompanyRoleUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateapplication_StageCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Application_StageFilter>
	set: Application_StageUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatearticle_MediaCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Article_MediaFilter>
	set: Article_MediaUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatearticle_SharesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Article_SharesFilter>
	set: Article_SharesUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatecampaign_Claim_HistoryCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Campaign_Claim_HistoryFilter>
	set: Campaign_Claim_HistoryUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatecampaign_EditionsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Campaign_EditionsFilter>
	set: Campaign_EditionsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatecampaign_RecipientsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Campaign_RecipientsFilter>
	set: Campaign_RecipientsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatecampaign_Scanning_AgentsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Campaign_Scanning_AgentsFilter>
	set: Campaign_Scanning_AgentsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatecompaniesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<CompaniesFilter>
	set: CompaniesUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatecustom_NotificationsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Custom_NotificationsFilter>
	set: Custom_NotificationsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateexportchillpackrecipientsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ExportchillpackrecipientsFilter>
	set: ExportchillpackrecipientsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateexportstudentkitviewCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<ExportstudentkitviewFilter>
	set: ExportstudentkitviewUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatefavorite_User_ArticlesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Favorite_User_ArticlesFilter>
	set: Favorite_User_ArticlesUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatefeedtagsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<FeedtagsFilter>
	set: FeedtagsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateliked_User_ArticlesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Liked_User_ArticlesFilter>
	set: Liked_User_ArticlesUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatenotificationsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<NotificationsFilter>
	set: NotificationsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateonesignalCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<OnesignalFilter>
	set: OnesignalUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatepost_Comment_LikesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Post_Comment_LikesFilter>
	set: Post_Comment_LikesUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatepost_CommentsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Post_CommentsFilter>
	set: Post_CommentsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateroLocationsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<RoLocationsFilter>
	set: RoLocationsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatescanning_Agent_InvitationsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Scanning_Agent_InvitationsFilter>
	set: Scanning_Agent_InvitationsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatesearchCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<SearchFilter>
	set: SearchUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatesearchviewCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<SearchviewFilter>
	set: SearchviewUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatesegmentsCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<SegmentsFilter>
	set: SegmentsUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdatestandardresponseCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<StandardresponseFilter>
	set: StandardresponseUpdateInput
}

/** The root type for creating and mutating data */
export type MutationUpdateviewed_User_ArticlesCollectionArgs = {
	atMost?: Scalars['Int']['input']
	filter?: InputMaybe<Viewed_User_ArticlesFilter>
	set: Viewed_User_ArticlesUpdateInput
}

export type Node = {
	/** Retrieves a record by `ID` */
	nodeId: Scalars['ID']['output']
}

/** Boolean expression comparing fields on type "Opaque" */
export type OpaqueFilter = {
	eq?: InputMaybe<Scalars['Opaque']['input']>
	is?: InputMaybe<FilterIs>
}

/** Defines a per-field sorting order */
export enum OrderByDirection {
	/** Ascending order, nulls first */
	AscNullsFirst = 'AscNullsFirst',
	/** Ascending order, nulls last */
	AscNullsLast = 'AscNullsLast',
	/** Descending order, nulls first */
	DescNullsFirst = 'DescNullsFirst',
	/** Descending order, nulls last */
	DescNullsLast = 'DescNullsLast',
}

export type PageInfo = {
	__typename?: 'PageInfo'
	endCursor?: Maybe<Scalars['String']['output']>
	hasNextPage: Scalars['Boolean']['output']
	hasPreviousPage: Scalars['Boolean']['output']
	startCursor?: Maybe<Scalars['String']['output']>
}

export type Profile = Node & {
	__typename?: 'Profile'
	_ProfileToSkillCollection?: Maybe<_ProfileToSkillConnection>
	_ProfileToValueCollection?: Maybe<_ProfileToValueConnection>
	aboutMe?: Maybe<Scalars['String']['output']>
	amount?: Maybe<Scalars['BigFloat']['output']>
	avatarContentType?: Maybe<Scalars['String']['output']>
	avatarPath?: Maybe<Scalars['String']['output']>
	chillPackCompany?: Maybe<ChillPackCompany>
	company?: Maybe<Scalars['String']['output']>
	company_employment_type?: Maybe<Scalars['String']['output']>
	company_name?: Maybe<Scalars['String']['output']>
	coverBackground?: Maybe<Scalars['String']['output']>
	coverPath?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['Datetime']['output']
	currency?: Maybe<Scalars['String']['output']>
	cvFileOriginalName?: Maybe<Scalars['JSON']['output']>
	cvFilePath?: Maybe<Scalars['JSON']['output']>
	email?: Maybe<Scalars['String']['output']>
	experienceCollection?: Maybe<ExperienceConnection>
	facebookProfileCollection?: Maybe<FacebookProfileConnection>
	facultySpecialization?: Maybe<FacultySpecialization>
	featuredVideo?: Maybe<Scalars['String']['output']>
	firstName: Scalars['String']['output']
	full_name?: Maybe<Scalars['String']['output']>
	gender?: Maybe<Genders>
	hasAvatar?: Maybe<Scalars['Boolean']['output']>
	hasCover?: Maybe<Scalars['Boolean']['output']>
	id: Scalars['String']['output']
	isPublic?: Maybe<Scalars['Boolean']['output']>
	lastName: Scalars['String']['output']
	location?: Maybe<Scalars['String']['output']>
	newsletter?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	position?: Maybe<Scalars['String']['output']>
	profileCoverContentType?: Maybe<Scalars['String']['output']>
	roLocations?: Maybe<RoLocations>
	story?: Maybe<Story>
	studentSpecialization?: Maybe<Scalars['String']['output']>
	studentUniversityLevel?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
	user?: Maybe<User>
	userName?: Maybe<Scalars['String']['output']>
	userOnBoardingFormVisited?: Maybe<Scalars['Boolean']['output']>
	year_of_birth?: Maybe<Scalars['Int']['output']>
}

export type Profile_ProfileToSkillCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_ProfileToSkillFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_ProfileToSkillOrderBy>>
}

export type Profile_ProfileToValueCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_ProfileToValueFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_ProfileToValueOrderBy>>
}

export type ProfileExperienceCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ExperienceFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ExperienceOrderBy>>
}

export type ProfileFacebookProfileCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<FacebookProfileFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<FacebookProfileOrderBy>>
}

export type ProfileConnection = {
	__typename?: 'ProfileConnection'
	edges: Array<ProfileEdge>
	pageInfo: PageInfo
}

export type ProfileDeleteResponse = {
	__typename?: 'ProfileDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Profile>
}

export type ProfileEdge = {
	__typename?: 'ProfileEdge'
	cursor: Scalars['String']['output']
	node: Profile
}

export type ProfileFilter = {
	aboutMe?: InputMaybe<StringFilter>
	amount?: InputMaybe<BigFloatFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ProfileFilter>>
	avatarContentType?: InputMaybe<StringFilter>
	avatarPath?: InputMaybe<StringFilter>
	company?: InputMaybe<StringFilter>
	company_employment_type?: InputMaybe<StringFilter>
	company_name?: InputMaybe<StringFilter>
	coverBackground?: InputMaybe<StringFilter>
	coverPath?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	currency?: InputMaybe<StringFilter>
	email?: InputMaybe<StringFilter>
	featuredVideo?: InputMaybe<StringFilter>
	firstName?: InputMaybe<StringFilter>
	full_name?: InputMaybe<StringFilter>
	gender?: InputMaybe<GendersFilter>
	hasAvatar?: InputMaybe<BooleanFilter>
	hasCover?: InputMaybe<BooleanFilter>
	id?: InputMaybe<StringFilter>
	isPublic?: InputMaybe<BooleanFilter>
	lastName?: InputMaybe<StringFilter>
	location?: InputMaybe<StringFilter>
	newsletter?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ProfileFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ProfileFilter>>
	position?: InputMaybe<StringFilter>
	profileCoverContentType?: InputMaybe<StringFilter>
	story?: InputMaybe<StringFilter>
	studentSpecialization?: InputMaybe<StringFilter>
	studentUniversityLevel?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
	user?: InputMaybe<StringFilter>
	userName?: InputMaybe<StringFilter>
	userOnBoardingFormVisited?: InputMaybe<BooleanFilter>
	year_of_birth?: InputMaybe<IntFilter>
}

export type ProfileInsertInput = {
	aboutMe?: InputMaybe<Scalars['String']['input']>
	amount?: InputMaybe<Scalars['BigFloat']['input']>
	avatarContentType?: InputMaybe<Scalars['String']['input']>
	avatarPath?: InputMaybe<Scalars['String']['input']>
	company?: InputMaybe<Scalars['String']['input']>
	company_employment_type?: InputMaybe<Scalars['String']['input']>
	company_name?: InputMaybe<Scalars['String']['input']>
	coverBackground?: InputMaybe<Scalars['String']['input']>
	coverPath?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	currency?: InputMaybe<Scalars['String']['input']>
	cvFileOriginalName?: InputMaybe<Scalars['JSON']['input']>
	cvFilePath?: InputMaybe<Scalars['JSON']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	featuredVideo?: InputMaybe<Scalars['String']['input']>
	firstName?: InputMaybe<Scalars['String']['input']>
	full_name?: InputMaybe<Scalars['String']['input']>
	gender?: InputMaybe<Genders>
	hasAvatar?: InputMaybe<Scalars['Boolean']['input']>
	hasCover?: InputMaybe<Scalars['Boolean']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isPublic?: InputMaybe<Scalars['Boolean']['input']>
	lastName?: InputMaybe<Scalars['String']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	newsletter?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['String']['input']>
	profileCoverContentType?: InputMaybe<Scalars['String']['input']>
	story?: InputMaybe<Scalars['String']['input']>
	studentSpecialization?: InputMaybe<Scalars['String']['input']>
	studentUniversityLevel?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
	userName?: InputMaybe<Scalars['String']['input']>
	userOnBoardingFormVisited?: InputMaybe<Scalars['Boolean']['input']>
	year_of_birth?: InputMaybe<Scalars['Int']['input']>
}

export type ProfileInsertResponse = {
	__typename?: 'ProfileInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Profile>
}

export type ProfileOrderBy = {
	aboutMe?: InputMaybe<OrderByDirection>
	amount?: InputMaybe<OrderByDirection>
	avatarContentType?: InputMaybe<OrderByDirection>
	avatarPath?: InputMaybe<OrderByDirection>
	company?: InputMaybe<OrderByDirection>
	company_employment_type?: InputMaybe<OrderByDirection>
	company_name?: InputMaybe<OrderByDirection>
	coverBackground?: InputMaybe<OrderByDirection>
	coverPath?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	currency?: InputMaybe<OrderByDirection>
	email?: InputMaybe<OrderByDirection>
	featuredVideo?: InputMaybe<OrderByDirection>
	firstName?: InputMaybe<OrderByDirection>
	full_name?: InputMaybe<OrderByDirection>
	gender?: InputMaybe<OrderByDirection>
	hasAvatar?: InputMaybe<OrderByDirection>
	hasCover?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	isPublic?: InputMaybe<OrderByDirection>
	lastName?: InputMaybe<OrderByDirection>
	location?: InputMaybe<OrderByDirection>
	newsletter?: InputMaybe<OrderByDirection>
	position?: InputMaybe<OrderByDirection>
	profileCoverContentType?: InputMaybe<OrderByDirection>
	story?: InputMaybe<OrderByDirection>
	studentSpecialization?: InputMaybe<OrderByDirection>
	studentUniversityLevel?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	user?: InputMaybe<OrderByDirection>
	userName?: InputMaybe<OrderByDirection>
	userOnBoardingFormVisited?: InputMaybe<OrderByDirection>
	year_of_birth?: InputMaybe<OrderByDirection>
}

export type ProfileUpdateInput = {
	aboutMe?: InputMaybe<Scalars['String']['input']>
	amount?: InputMaybe<Scalars['BigFloat']['input']>
	avatarContentType?: InputMaybe<Scalars['String']['input']>
	avatarPath?: InputMaybe<Scalars['String']['input']>
	company?: InputMaybe<Scalars['String']['input']>
	company_employment_type?: InputMaybe<Scalars['String']['input']>
	company_name?: InputMaybe<Scalars['String']['input']>
	coverBackground?: InputMaybe<Scalars['String']['input']>
	coverPath?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	currency?: InputMaybe<Scalars['String']['input']>
	cvFileOriginalName?: InputMaybe<Scalars['JSON']['input']>
	cvFilePath?: InputMaybe<Scalars['JSON']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	featuredVideo?: InputMaybe<Scalars['String']['input']>
	firstName?: InputMaybe<Scalars['String']['input']>
	full_name?: InputMaybe<Scalars['String']['input']>
	gender?: InputMaybe<Genders>
	hasAvatar?: InputMaybe<Scalars['Boolean']['input']>
	hasCover?: InputMaybe<Scalars['Boolean']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isPublic?: InputMaybe<Scalars['Boolean']['input']>
	lastName?: InputMaybe<Scalars['String']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	newsletter?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['String']['input']>
	profileCoverContentType?: InputMaybe<Scalars['String']['input']>
	story?: InputMaybe<Scalars['String']['input']>
	studentSpecialization?: InputMaybe<Scalars['String']['input']>
	studentUniversityLevel?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
	userName?: InputMaybe<Scalars['String']['input']>
	userOnBoardingFormVisited?: InputMaybe<Scalars['Boolean']['input']>
	year_of_birth?: InputMaybe<Scalars['Int']['input']>
}

export type ProfileUpdateResponse = {
	__typename?: 'ProfileUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Profile>
}

export type Project = Node & {
	__typename?: 'Project'
	company?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['Datetime']['output']
	currentPositionCollection?: Maybe<CurrentPositionConnection>
	description?: Maybe<Scalars['String']['output']>
	endDate?: Maybe<Scalars['Datetime']['output']>
	id: Scalars['String']['output']
	isCurrent?: Maybe<Scalars['Boolean']['output']>
	location?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	position?: Maybe<Scalars['String']['output']>
	startDate?: Maybe<Scalars['Datetime']['output']>
	title?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
	user?: Maybe<User>
}

export type ProjectCurrentPositionCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CurrentPositionFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CurrentPositionOrderBy>>
}

export type ProjectConnection = {
	__typename?: 'ProjectConnection'
	edges: Array<ProjectEdge>
	pageInfo: PageInfo
}

export type ProjectDeleteResponse = {
	__typename?: 'ProjectDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Project>
}

export type ProjectEdge = {
	__typename?: 'ProjectEdge'
	cursor: Scalars['String']['output']
	node: Project
}

export type ProjectFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ProjectFilter>>
	company?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	description?: InputMaybe<StringFilter>
	endDate?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	isCurrent?: InputMaybe<BooleanFilter>
	location?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ProjectFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ProjectFilter>>
	position?: InputMaybe<StringFilter>
	startDate?: InputMaybe<DatetimeFilter>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
	user?: InputMaybe<StringFilter>
}

export type ProjectInsertInput = {
	company?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	endDate?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isCurrent?: InputMaybe<Scalars['Boolean']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['String']['input']>
	startDate?: InputMaybe<Scalars['Datetime']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type ProjectInsertResponse = {
	__typename?: 'ProjectInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Project>
}

export type ProjectOrderBy = {
	company?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	endDate?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	isCurrent?: InputMaybe<OrderByDirection>
	location?: InputMaybe<OrderByDirection>
	position?: InputMaybe<OrderByDirection>
	startDate?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	user?: InputMaybe<OrderByDirection>
}

export type ProjectUpdateInput = {
	company?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	endDate?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isCurrent?: InputMaybe<Scalars['Boolean']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['String']['input']>
	startDate?: InputMaybe<Scalars['Datetime']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type ProjectUpdateResponse = {
	__typename?: 'ProjectUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Project>
}

/** The root type for querying data */
export type Query = {
	__typename?: 'Query'
	/** A pagable collection of type `_ActiveArticleTagToUser` */
	_ActiveArticleTagToUserCollection?: Maybe<_ActiveArticleTagToUserConnection>
	/** A pagable collection of type `_CompanyToCompanyType` */
	_CompanyToCompanyTypeCollection?: Maybe<_CompanyToCompanyTypeConnection>
	/** A pagable collection of type `_JobToCompanyOffices` */
	_JobToCompanyOfficesCollection?: Maybe<_JobToCompanyOfficesConnection>
	/** A pagable collection of type `_JobToCustomSkills` */
	_JobToCustomSkillsCollection?: Maybe<_JobToCustomSkillsConnection>
	/** A pagable collection of type `_JobToFollowers` */
	_JobToFollowersCollection?: Maybe<_JobToFollowersConnection>
	/** A pagable collection of type `_JobToSkill` */
	_JobToSkillCollection?: Maybe<_JobToSkillConnection>
	/** A pagable collection of type `_OwnerToCompany` */
	_OwnerToCompanyCollection?: Maybe<_OwnerToCompanyConnection>
	/** A pagable collection of type `_ProfileToSkill` */
	_ProfileToSkillCollection?: Maybe<_ProfileToSkillConnection>
	/** A pagable collection of type `_ProfileToValue` */
	_ProfileToValueCollection?: Maybe<_ProfileToValueConnection>
	/** A pagable collection of type `_TeamToCompanyOffices` */
	_TeamToCompanyOfficesCollection?: Maybe<_TeamToCompanyOfficesConnection>
	/** A pagable collection of type `_TeamToJob` */
	_TeamToJobCollection?: Maybe<_TeamToJobConnection>
	/** A pagable collection of type `_UserToCompanyRole` */
	_UserToCompanyRoleCollection?: Maybe<_UserToCompanyRoleConnection>
	/** A pagable collection of type `ActiveArticleTag` */
	activeArticleTagCollection?: Maybe<ActiveArticleTagConnection>
	/** A pagable collection of type `ActivityField` */
	activityFieldCollection?: Maybe<ActivityFieldConnection>
	/** A pagable collection of type `Ad` */
	adCollection?: Maybe<AdConnection>
	addNums?: Maybe<Scalars['Int']['output']>
	/** A pagable collection of type `application_stage` */
	application_stageCollection?: Maybe<Application_StageConnection>
	/** A pagable collection of type `Article` */
	articleCollection?: Maybe<ArticleConnection>
	/** A pagable collection of type `ArticleTag` */
	articleTagCollection?: Maybe<ArticleTagConnection>
	/** A pagable collection of type `article_media` */
	article_mediaCollection?: Maybe<Article_MediaConnection>
	/** A pagable collection of type `article_shares` */
	article_sharesCollection?: Maybe<Article_SharesConnection>
	bytea_to_text?: Maybe<Scalars['String']['output']>
	/** A pagable collection of type `Campaign` */
	campaignCollection?: Maybe<CampaignConnection>
	/** A pagable collection of type `campaign_claim_history` */
	campaign_claim_historyCollection?: Maybe<Campaign_Claim_HistoryConnection>
	/** A pagable collection of type `campaign_editions` */
	campaign_editionsCollection?: Maybe<Campaign_EditionsConnection>
	/** A pagable collection of type `campaign_recipients` */
	campaign_recipientsCollection?: Maybe<Campaign_RecipientsConnection>
	/** A pagable collection of type `campaign_scanning_agents` */
	campaign_scanning_agentsCollection?: Maybe<Campaign_Scanning_AgentsConnection>
	checkCredentials?: Maybe<User>
	checkusername?: Maybe<Standardresponse>
	/** A pagable collection of type `ChillPackCompany` */
	chillPackCompanyCollection?: Maybe<ChillPackCompanyConnection>
	/** A pagable collection of type `ChillPackEdition` */
	chillPackEditionCollection?: Maybe<ChillPackEditionConnection>
	/** A pagable collection of type `ChillPackRecipientClaim` */
	chillPackRecipientClaimCollection?: Maybe<ChillPackRecipientClaimConnection>
	/** A pagable collection of type `ChillPackRecipient` */
	chillPackRecipientCollection?: Maybe<ChillPackRecipientConnection>
	/** A pagable collection of type `ChillPackScheduledMailCronjobData` */
	chillPackScheduledMailCronjobDataCollection?: Maybe<ChillPackScheduledMailCronjobDataConnection>
	/** A pagable collection of type `companies` */
	companiesCollection?: Maybe<CompaniesConnection>
	/** A pagable collection of type `Company` */
	companyCollection?: Maybe<CompanyConnection>
	/** A pagable collection of type `CompanyEmails` */
	companyEmailsCollection?: Maybe<CompanyEmailsConnection>
	/** A pagable collection of type `CompanyOffices` */
	companyOfficesCollection?: Maybe<CompanyOfficesConnection>
	/** A pagable collection of type `CompanyPhones` */
	companyPhonesCollection?: Maybe<CompanyPhonesConnection>
	/** A pagable collection of type `CompanyResponse` */
	companyResponseCollection?: Maybe<CompanyResponseConnection>
	/** A pagable collection of type `CompanyRole` */
	companyRoleCollection?: Maybe<CompanyRoleConnection>
	/** A pagable collection of type `CompanyRole_roles` */
	companyRole_rolesCollection?: Maybe<CompanyRole_RolesConnection>
	/** A pagable collection of type `CompanyType` */
	companyTypeCollection?: Maybe<CompanyTypeConnection>
	companyoffices?: Maybe<CompanyOffices>
	/** A pagable collection of type `Contact` */
	contactCollection?: Maybe<ContactConnection>
	/** A pagable collection of type `Country` */
	countryCollection?: Maybe<CountryConnection>
	/** A pagable collection of type `CurrentPosition` */
	currentPositionCollection?: Maybe<CurrentPositionConnection>
	/** A pagable collection of type `CustomSkills` */
	customSkillsCollection?: Maybe<CustomSkillsConnection>
	/** A pagable collection of type `custom_notifications` */
	custom_notificationsCollection?: Maybe<Custom_NotificationsConnection>
	/** A pagable collection of type `Education` */
	educationCollection?: Maybe<EducationConnection>
	/** A pagable collection of type `Error` */
	errorCollection?: Maybe<ErrorConnection>
	/** A pagable collection of type `Experience` */
	experienceCollection?: Maybe<ExperienceConnection>
	export_chill_pack_recipients?: Maybe<ExportchillpackrecipientsConnection>
	/** A pagable collection of type `exportchillpackrecipients` */
	exportchillpackrecipientsCollection?: Maybe<ExportchillpackrecipientsConnection>
	/** A pagable collection of type `exportstudentkitview` */
	exportstudentkitviewCollection?: Maybe<ExportstudentkitviewConnection>
	exportstudents?: Maybe<ExportstudentkitviewConnection>
	/** A pagable collection of type `FacebookProfile` */
	facebookProfileCollection?: Maybe<FacebookProfileConnection>
	/** A pagable collection of type `Faculty` */
	facultyCollection?: Maybe<FacultyConnection>
	/** A pagable collection of type `FacultySpecialization` */
	facultySpecializationCollection?: Maybe<FacultySpecializationConnection>
	/** A pagable collection of type `Faq` */
	faqCollection?: Maybe<FaqConnection>
	/** A pagable collection of type `favorite_user_articles` */
	favorite_user_articlesCollection?: Maybe<Favorite_User_ArticlesConnection>
	feedArticles?: Maybe<ArticleConnection>
	// feedarticles?: Maybe<ArticleConnection>
	feedJobApplicants?: Maybe<JobApplicantConnection>
	feed_team_articles?: Maybe<ArticleConnection>
	feedcompanies?: Maybe<CompanyConnection>
	feedjobs?: Maybe<JobConnection>
	/** A pagable collection of type `feedtags` */
	feedtagsCollection?: Maybe<FeedtagsConnection>
	feedteams?: Maybe<TeamConnection>
	getfaculties?: Maybe<Faculty>
	/** A pagable collection of type `Hobby` */
	hobbyCollection?: Maybe<HobbyConnection>
	/** A pagable collection of type `Image` */
	imageCollection?: Maybe<ImageConnection>
	/** A pagable collection of type `Industry` */
	industryCollection?: Maybe<IndustryConnection>
	/** A pagable collection of type `JobApplicant` */
	jobApplicantCollection?: Maybe<JobApplicantConnection>
	/** A pagable collection of type `Job` */
	jobCollection?: Maybe<JobConnection>
	/** A pagable collection of type `JobSalary` */
	jobSalaryCollection?: Maybe<JobSalaryConnection>
	/** A pagable collection of type `LandingPage` */
	landingPageCollection?: Maybe<LandingPageConnection>
	/** A pagable collection of type `LandingPageText` */
	landingPageTextCollection?: Maybe<LandingPageTextConnection>
	/** A pagable collection of type `Language` */
	languageCollection?: Maybe<LanguageConnection>
	/** A pagable collection of type `liked_user_articles` */
	liked_user_articlesCollection?: Maybe<Liked_User_ArticlesConnection>
	/** A pagable collection of type `LinkedUsersToCompanies` */
	linkedUsersToCompaniesCollection?: Maybe<LinkedUsersToCompaniesConnection>
	/** Retrieve a record by its `ID` */
	node?: Maybe<Node>
	/** A pagable collection of type `notifications` */
	notificationsCollection?: Maybe<NotificationsConnection>
	/** A pagable collection of type `onesignal` */
	onesignalCollection?: Maybe<OnesignalConnection>
	/** A pagable collection of type `post_comment_likes` */
	post_comment_likesCollection?: Maybe<Post_Comment_LikesConnection>
	/** A pagable collection of type `post_comments` */
	post_commentsCollection?: Maybe<Post_CommentsConnection>
	/** A pagable collection of type `Profile` */
	profileCollection?: Maybe<ProfileConnection>
	/** A pagable collection of type `Project` */
	projectCollection?: Maybe<ProjectConnection>
	/** A pagable collection of type `roLocations` */
	roLocationsCollection?: Maybe<RoLocationsConnection>
	/** A pagable collection of type `Role` */
	roleCollection?: Maybe<RoleConnection>
	/** A pagable collection of type `scanning_agent_invitations` */
	scanning_agent_invitationsCollection?: Maybe<Scanning_Agent_InvitationsConnection>
	search?: Maybe<SearchviewConnection>
	/** A pagable collection of type `search` */
	searchCollection?: Maybe<SearchConnection>
	/** A pagable collection of type `searchview` */
	searchviewCollection?: Maybe<SearchviewConnection>
	/** A pagable collection of type `segments` */
	segmentsCollection?: Maybe<SegmentsConnection>
	/** A pagable collection of type `ShallowUser` */
	shallowUserCollection?: Maybe<ShallowUserConnection>
	/** A pagable collection of type `Skill` */
	skillCollection?: Maybe<SkillConnection>
	/** A pagable collection of type `standardresponse` */
	standardresponseCollection?: Maybe<StandardresponseConnection>
	/** A pagable collection of type `Story` */
	storyCollection?: Maybe<StoryConnection>
	/** A pagable collection of type `StudentClaimKit` */
	studentClaimKitCollection?: Maybe<StudentClaimKitConnection>
	/** A pagable collection of type `StudentKit` */
	studentKitCollection?: Maybe<StudentKitConnection>
	/** A pagable collection of type `StudentKitEdition` */
	studentKitEditionCollection?: Maybe<StudentKitEditionConnection>
	/** A pagable collection of type `StudentKitScanningAgent` */
	studentKitScanningAgentCollection?: Maybe<StudentKitScanningAgentConnection>
	/** A pagable collection of type `StudentKitScheduledMailCronjobData` */
	studentKitScheduledMailCronjobDataCollection?: Maybe<StudentKitScheduledMailCronjobDataConnection>
	/** A pagable collection of type `Tag` */
	tagCollection?: Maybe<TagConnection>
	/** A pagable collection of type `Team` */
	teamCollection?: Maybe<TeamConnection>
	/** A pagable collection of type `TeamDepartment` */
	teamDepartmentCollection?: Maybe<TeamDepartmentConnection>
	/** A pagable collection of type `TeamMember` */
	teamMemberCollection?: Maybe<TeamMemberConnection>
	/** A pagable collection of type `TeamRole` */
	teamRoleCollection?: Maybe<TeamRoleConnection>
	text_to_bytea?: Maybe<Scalars['Opaque']['output']>
	/** A pagable collection of type `University` */
	universityCollection?: Maybe<UniversityConnection>
	/** A pagable collection of type `User` */
	userCollection?: Maybe<UserConnection>
	user_with_profile?: Maybe<Scalars['JSON']['output']>
	/** A pagable collection of type `Value` */
	valueCollection?: Maybe<ValueConnection>
	/** A pagable collection of type `Video` */
	videoCollection?: Maybe<VideoConnection>
	/** A pagable collection of type `ViewCustomUser` */
	viewCustomUserCollection?: Maybe<ViewCustomUserConnection>
	/** A pagable collection of type `viewed_user_articles` */
	viewed_user_articlesCollection?: Maybe<Viewed_User_ArticlesConnection>
}

/** The root type for querying data */
export type Query_ActiveArticleTagToUserCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_ActiveArticleTagToUserFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_ActiveArticleTagToUserOrderBy>>
}

/** The root type for querying data */
export type Query_CompanyToCompanyTypeCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_CompanyToCompanyTypeFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_CompanyToCompanyTypeOrderBy>>
}

/** The root type for querying data */
export type Query_JobToCompanyOfficesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_JobToCompanyOfficesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_JobToCompanyOfficesOrderBy>>
}

/** The root type for querying data */
export type Query_JobToCustomSkillsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_JobToCustomSkillsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_JobToCustomSkillsOrderBy>>
}

/** The root type for querying data */
export type Query_JobToFollowersCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_JobToFollowersFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_JobToFollowersOrderBy>>
}

/** The root type for querying data */
export type Query_JobToSkillCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_JobToSkillFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_JobToSkillOrderBy>>
}

/** The root type for querying data */
export type Query_OwnerToCompanyCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_OwnerToCompanyFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_OwnerToCompanyOrderBy>>
}

/** The root type for querying data */
export type Query_ProfileToSkillCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_ProfileToSkillFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_ProfileToSkillOrderBy>>
}

/** The root type for querying data */
export type Query_ProfileToValueCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_ProfileToValueFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_ProfileToValueOrderBy>>
}

/** The root type for querying data */
export type Query_TeamToCompanyOfficesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_TeamToCompanyOfficesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_TeamToCompanyOfficesOrderBy>>
}

/** The root type for querying data */
export type Query_TeamToJobCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_TeamToJobFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_TeamToJobOrderBy>>
}

/** The root type for querying data */
export type Query_UserToCompanyRoleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_UserToCompanyRoleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_UserToCompanyRoleOrderBy>>
}

/** The root type for querying data */
export type QueryActiveArticleTagCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ActiveArticleTagFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ActiveArticleTagOrderBy>>
}

/** The root type for querying data */
export type QueryActivityFieldCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ActivityFieldFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ActivityFieldOrderBy>>
}

/** The root type for querying data */
export type QueryAdCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<AdFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<AdOrderBy>>
}

/** The root type for querying data */
export type QueryAddNumsArgs = {
	a: Scalars['Int']['input']
	b: Scalars['Int']['input']
}

/** The root type for querying data */
export type QueryApplication_StageCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Application_StageFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Application_StageOrderBy>>
}

/** The root type for querying data */
export type QueryArticleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ArticleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ArticleOrderBy>>
}

/** The root type for querying data */
export type QueryArticleTagCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ArticleTagFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ArticleTagOrderBy>>
}

/** The root type for querying data */
export type QueryArticle_MediaCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Article_MediaFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Article_MediaOrderBy>>
}

/** The root type for querying data */
export type QueryArticle_SharesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Article_SharesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Article_SharesOrderBy>>
}

/** The root type for querying data */
export type QueryBytea_To_TextArgs = {
	data: Scalars['Opaque']['input']
}

/** The root type for querying data */
export type QueryCampaignCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CampaignFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CampaignOrderBy>>
}

/** The root type for querying data */
export type QueryCampaign_Claim_HistoryCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Campaign_Claim_HistoryFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Campaign_Claim_HistoryOrderBy>>
}

/** The root type for querying data */
export type QueryCampaign_EditionsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Campaign_EditionsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Campaign_EditionsOrderBy>>
}

/** The root type for querying data */
export type QueryCampaign_RecipientsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Campaign_RecipientsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Campaign_RecipientsOrderBy>>
}

/** The root type for querying data */
export type QueryCampaign_Scanning_AgentsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Campaign_Scanning_AgentsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Campaign_Scanning_AgentsOrderBy>>
}

/** The root type for querying data */
export type QueryCheckusernameArgs = {
	uid: Scalars['String']['input']
}

/** The root type for querying data */
export type QueryChillPackCompanyCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ChillPackCompanyFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ChillPackCompanyOrderBy>>
}

/** The root type for querying data */
export type QueryChillPackEditionCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ChillPackEditionFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ChillPackEditionOrderBy>>
}

/** The root type for querying data */
export type QueryChillPackRecipientClaimCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ChillPackRecipientClaimFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ChillPackRecipientClaimOrderBy>>
}

/** The root type for querying data */
export type QueryChillPackRecipientCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ChillPackRecipientFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ChillPackRecipientOrderBy>>
}

/** The root type for querying data */
export type QueryChillPackScheduledMailCronjobDataCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ChillPackScheduledMailCronjobDataFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ChillPackScheduledMailCronjobDataOrderBy>>
}

/** The root type for querying data */
export type QueryCompaniesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompaniesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompaniesOrderBy>>
}

/** The root type for querying data */
export type QueryCompanyCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyOrderBy>>
}

/** The root type for querying data */
export type QueryCompanyEmailsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyEmailsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyEmailsOrderBy>>
}

/** The root type for querying data */
export type QueryCompanyOfficesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyOfficesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyOfficesOrderBy>>
}

/** The root type for querying data */
export type QueryCompanyPhonesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyPhonesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyPhonesOrderBy>>
}

/** The root type for querying data */
export type QueryCompanyResponseCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyResponseFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyResponseOrderBy>>
}

/** The root type for querying data */
export type QueryCompanyRoleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyRoleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyRoleOrderBy>>
}

/** The root type for querying data */
export type QueryCompanyRole_RolesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyRole_RolesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyRole_RolesOrderBy>>
}

/** The root type for querying data */
export type QueryCompanyTypeCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyTypeFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyTypeOrderBy>>
}

/** The root type for querying data */
export type QueryCompanyofficesArgs = {
	companyid: Scalars['String']['input']
	companyslug: Scalars['String']['input']
}

/** The root type for querying data */
export type QueryContactCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ContactFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ContactOrderBy>>
}

/** The root type for querying data */
export type QueryCountryCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CountryFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CountryOrderBy>>
}

/** The root type for querying data */
export type QueryCurrentPositionCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CurrentPositionFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CurrentPositionOrderBy>>
}

/** The root type for querying data */
export type QueryCustomSkillsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CustomSkillsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CustomSkillsOrderBy>>
}

/** The root type for querying data */
export type QueryCustom_NotificationsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Custom_NotificationsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Custom_NotificationsOrderBy>>
}

/** The root type for querying data */
export type QueryEducationCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<EducationFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<EducationOrderBy>>
}

/** The root type for querying data */
export type QueryErrorCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ErrorFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ErrorOrderBy>>
}

/** The root type for querying data */
export type QueryExperienceCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ExperienceFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ExperienceOrderBy>>
}

/** The root type for querying data */
export type QueryExport_Chill_Pack_RecipientsArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ExportchillpackrecipientsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ExportchillpackrecipientsOrderBy>>
}

/** The root type for querying data */
export type QueryExportchillpackrecipientsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ExportchillpackrecipientsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ExportchillpackrecipientsOrderBy>>
}

/** The root type for querying data */
export type QueryExportstudentkitviewCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ExportstudentkitviewFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ExportstudentkitviewOrderBy>>
}

/** The root type for querying data */
export type QueryExportstudentsArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ExportstudentkitviewFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ExportstudentkitviewOrderBy>>
}

/** The root type for querying data */
export type QueryFacebookProfileCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<FacebookProfileFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<FacebookProfileOrderBy>>
}

/** The root type for querying data */
export type QueryFacultyCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<FacultyFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<FacultyOrderBy>>
}

/** The root type for querying data */
export type QueryFacultySpecializationCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<FacultySpecializationFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<FacultySpecializationOrderBy>>
}

/** The root type for querying data */
export type QueryFaqCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<FaqFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<FaqOrderBy>>
}

/** The root type for querying data */
export type QueryFavorite_User_ArticlesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Favorite_User_ArticlesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Favorite_User_ArticlesOrderBy>>
}

/** The root type for querying data */
export type QueryFeedArticlesArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	companyid?: InputMaybe<Scalars['String']['input']>
	companyslug?: InputMaybe<Scalars['String']['input']>
	filter?: InputMaybe<ArticleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ArticleOrderBy>>
	teamid?: InputMaybe<Scalars['String']['input']>
	userid?: InputMaybe<Scalars['String']['input']>
}

/** The root type for querying data */
export type QueryFeedJobApplicantsArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	applicantName?: InputMaybe<Scalars['String']['input']>
	applicationDateEnd?: InputMaybe<Scalars['String']['input']>
	applicationDateStart?: InputMaybe<Scalars['String']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<JobApplicantFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	jobId?: InputMaybe<Scalars['String']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<JobApplicantOrderBy>>
}

/** The root type for querying data */
export type QueryFeed_Team_ArticlesArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	after_cursor?: InputMaybe<Scalars['String']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ArticleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	limit_count: Scalars['Int']['input']
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ArticleOrderBy>>
	team_id: Scalars['String']['input']
}

/** The root type for querying data */
export type QueryFeedarticlesArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	companyid?: InputMaybe<Scalars['String']['input']>
	companyslug?: InputMaybe<Scalars['String']['input']>
	filter?: InputMaybe<ArticleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ArticleOrderBy>>
	teamid?: InputMaybe<Scalars['String']['input']>
	userid?: InputMaybe<Scalars['String']['input']>
}

/** The root type for querying data */
export type QueryFeedcompaniesArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	industryids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	last?: InputMaybe<Scalars['Int']['input']>
	locationids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	name?: InputMaybe<Scalars['String']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyOrderBy>>
	sizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** The root type for querying data */
export type QueryFeedjobsArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	companyname?: InputMaybe<Scalars['String']['input']>
	companyslug?: InputMaybe<Scalars['String']['input']>
	contracttypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	currency?: InputMaybe<Scalars['String']['input']>
	departmentids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	filter?: InputMaybe<JobFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	locationsids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	locationtypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	name?: InputMaybe<Scalars['String']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<JobOrderBy>>
	salarymax?: InputMaybe<Scalars['String']['input']>
	salarymin?: InputMaybe<Scalars['String']['input']>
	senioritylevels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	sizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	skills?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	teamname?: InputMaybe<Scalars['String']['input']>
	typeofjob?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

/** The root type for querying data */
export type QueryFeedtagsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<FeedtagsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<FeedtagsOrderBy>>
}

/** The root type for querying data */
export type QueryFeedteamsArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	averageage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	before?: InputMaybe<Scalars['Cursor']['input']>
	companyid?: InputMaybe<Scalars['String']['input']>
	companyslug?: InputMaybe<Scalars['String']['input']>
	departmentids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	departmentnames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	filter?: InputMaybe<TeamFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	industryids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	last?: InputMaybe<Scalars['Int']['input']>
	locationids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	name?: InputMaybe<Scalars['String']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<TeamOrderBy>>
	size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	slug?: InputMaybe<Scalars['String']['input']>
}

/** The root type for querying data */
export type QueryGetfacultiesArgs = {
	facultyname: Scalars['String']['input']
	universityid: Scalars['String']['input']
}

/** The root type for querying data */
export type QueryHobbyCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<HobbyFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<HobbyOrderBy>>
}

/** The root type for querying data */
export type QueryImageCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ImageFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ImageOrderBy>>
}

/** The root type for querying data */
export type QueryIndustryCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<IndustryFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<IndustryOrderBy>>
}

/** The root type for querying data */
export type QueryJobApplicantCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<JobApplicantFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<JobApplicantOrderBy>>
}

/** The root type for querying data */
export type QueryJobCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<JobFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<JobOrderBy>>
}

/** The root type for querying data */
export type QueryJobSalaryCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<JobSalaryFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<JobSalaryOrderBy>>
}

/** The root type for querying data */
export type QueryLandingPageCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<LandingPageFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<LandingPageOrderBy>>
}

/** The root type for querying data */
export type QueryLandingPageTextCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<LandingPageTextFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<LandingPageTextOrderBy>>
}

/** The root type for querying data */
export type QueryLanguageCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<LanguageFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<LanguageOrderBy>>
}

/** The root type for querying data */
export type QueryLiked_User_ArticlesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Liked_User_ArticlesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Liked_User_ArticlesOrderBy>>
}

/** The root type for querying data */
export type QueryLinkedUsersToCompaniesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<LinkedUsersToCompaniesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<LinkedUsersToCompaniesOrderBy>>
}

/** The root type for querying data */
export type QueryNodeArgs = {
	nodeId: Scalars['ID']['input']
}

/** The root type for querying data */
export type QueryNotificationsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<NotificationsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<NotificationsOrderBy>>
}

/** The root type for querying data */
export type QueryOnesignalCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<OnesignalFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<OnesignalOrderBy>>
}

/** The root type for querying data */
export type QueryPost_Comment_LikesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Post_Comment_LikesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Post_Comment_LikesOrderBy>>
}

/** The root type for querying data */
export type QueryPost_CommentsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Post_CommentsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Post_CommentsOrderBy>>
}

/** The root type for querying data */
export type QueryProfileCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ProfileFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ProfileOrderBy>>
}

/** The root type for querying data */
export type QueryProjectCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ProjectFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ProjectOrderBy>>
}

/** The root type for querying data */
export type QueryRoLocationsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<RoLocationsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<RoLocationsOrderBy>>
}

/** The root type for querying data */
export type QueryRoleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<RoleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<RoleOrderBy>>
}

/** The root type for querying data */
export type QueryScanning_Agent_InvitationsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Scanning_Agent_InvitationsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Scanning_Agent_InvitationsOrderBy>>
}

/** The root type for querying data */
export type QuerySearchArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	data: Scalars['String']['input']
	filter?: InputMaybe<SearchviewFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SearchviewOrderBy>>
}

/** The root type for querying data */
export type QuerySearchCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<SearchFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SearchOrderBy>>
}

/** The root type for querying data */
export type QuerySearchviewCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<SearchviewFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SearchviewOrderBy>>
}

/** The root type for querying data */
export type QuerySegmentsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<SegmentsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SegmentsOrderBy>>
}

/** The root type for querying data */
export type QueryShallowUserCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ShallowUserFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ShallowUserOrderBy>>
}

/** The root type for querying data */
export type QuerySkillCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<SkillFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SkillOrderBy>>
}

/** The root type for querying data */
export type QueryStandardresponseCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StandardresponseFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StandardresponseOrderBy>>
}

/** The root type for querying data */
export type QueryStoryCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StoryFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StoryOrderBy>>
}

/** The root type for querying data */
export type QueryStudentClaimKitCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentClaimKitFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentClaimKitOrderBy>>
}

/** The root type for querying data */
export type QueryStudentKitCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentKitFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentKitOrderBy>>
}

/** The root type for querying data */
export type QueryStudentKitEditionCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentKitEditionFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentKitEditionOrderBy>>
}

/** The root type for querying data */
export type QueryStudentKitScanningAgentCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentKitScanningAgentFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentKitScanningAgentOrderBy>>
}

/** The root type for querying data */
export type QueryStudentKitScheduledMailCronjobDataCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentKitScheduledMailCronjobDataFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentKitScheduledMailCronjobDataOrderBy>>
}

/** The root type for querying data */
export type QueryTagCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<TagFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<TagOrderBy>>
}

/** The root type for querying data */
export type QueryTeamCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<TeamFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<TeamOrderBy>>
}

/** The root type for querying data */
export type QueryTeamDepartmentCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<TeamDepartmentFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<TeamDepartmentOrderBy>>
}

/** The root type for querying data */
export type QueryTeamMemberCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<TeamMemberFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<TeamMemberOrderBy>>
}

/** The root type for querying data */
export type QueryTeamRoleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<TeamRoleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<TeamRoleOrderBy>>
}

/** The root type for querying data */
export type QueryText_To_ByteaArgs = {
	data: Scalars['String']['input']
}

/** The root type for querying data */
export type QueryUniversityCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<UniversityFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<UniversityOrderBy>>
}

/** The root type for querying data */
export type QueryUserCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<UserFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<UserOrderBy>>
}

/** The root type for querying data */
export type QueryValueCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ValueFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ValueOrderBy>>
}

/** The root type for querying data */
export type QueryVideoCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<VideoFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<VideoOrderBy>>
}

/** The root type for querying data */
export type QueryViewCustomUserCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ViewCustomUserFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ViewCustomUserOrderBy>>
}

/** The root type for querying data */
export type QueryViewed_User_ArticlesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Viewed_User_ArticlesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Viewed_User_ArticlesOrderBy>>
}

export type Role = Node & {
	__typename?: 'Role'
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	name: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type RoleConnection = {
	__typename?: 'RoleConnection'
	edges: Array<RoleEdge>
	pageInfo: PageInfo
}

export type RoleDeleteResponse = {
	__typename?: 'RoleDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Role>
}

export type RoleEdge = {
	__typename?: 'RoleEdge'
	cursor: Scalars['String']['output']
	node: Role
}

export type RoleFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<RoleFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<RoleFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<RoleFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type RoleInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type RoleInsertResponse = {
	__typename?: 'RoleInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Role>
}

export type RoleOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	name?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type RoleUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type RoleUpdateResponse = {
	__typename?: 'RoleUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Role>
}

export type ShallowUser = Node & {
	__typename?: 'ShallowUser'
	avatarPath?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['Datetime']['output']
	description?: Maybe<Scalars['String']['output']>
	email: Scalars['String']['output']
	firstName?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	lastName?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	position: Scalars['String']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type ShallowUserConnection = {
	__typename?: 'ShallowUserConnection'
	edges: Array<ShallowUserEdge>
	pageInfo: PageInfo
}

export type ShallowUserDeleteResponse = {
	__typename?: 'ShallowUserDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ShallowUser>
}

export type ShallowUserEdge = {
	__typename?: 'ShallowUserEdge'
	cursor: Scalars['String']['output']
	node: ShallowUser
}

export type ShallowUserFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ShallowUserFilter>>
	avatarPath?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	description?: InputMaybe<StringFilter>
	email?: InputMaybe<StringFilter>
	firstName?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	lastName?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ShallowUserFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ShallowUserFilter>>
	position?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type ShallowUserInsertInput = {
	avatarPath?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	firstName?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	lastName?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ShallowUserInsertResponse = {
	__typename?: 'ShallowUserInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ShallowUser>
}

export type ShallowUserOrderBy = {
	avatarPath?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	email?: InputMaybe<OrderByDirection>
	firstName?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	lastName?: InputMaybe<OrderByDirection>
	position?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type ShallowUserUpdateInput = {
	avatarPath?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	firstName?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	lastName?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ShallowUserUpdateResponse = {
	__typename?: 'ShallowUserUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ShallowUser>
}

export type Skill = Node & {
	__typename?: 'Skill'
	_JobToSkillCollection?: Maybe<_JobToSkillConnection>
	_ProfileToSkillCollection?: Maybe<_ProfileToSkillConnection>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	key: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	title: Scalars['String']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type Skill_JobToSkillCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_JobToSkillFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_JobToSkillOrderBy>>
}

export type Skill_ProfileToSkillCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_ProfileToSkillFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_ProfileToSkillOrderBy>>
}

export type SkillConnection = {
	__typename?: 'SkillConnection'
	edges: Array<SkillEdge>
	pageInfo: PageInfo
}

export type SkillDeleteResponse = {
	__typename?: 'SkillDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Skill>
}

export type SkillEdge = {
	__typename?: 'SkillEdge'
	cursor: Scalars['String']['output']
	node: Skill
}

export type SkillFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<SkillFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	key?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<SkillFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<SkillFilter>>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type SkillInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	key?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type SkillInsertResponse = {
	__typename?: 'SkillInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Skill>
}

export type SkillOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	key?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type SkillUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	key?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type SkillUpdateResponse = {
	__typename?: 'SkillUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Skill>
}

export type Story = Node & {
	__typename?: 'Story'
	createdAt: Scalars['Datetime']['output']
	description?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	profileCollection?: Maybe<ProfileConnection>
	title?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
}

export type StoryProfileCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ProfileFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ProfileOrderBy>>
}

export type StoryConnection = {
	__typename?: 'StoryConnection'
	edges: Array<StoryEdge>
	pageInfo: PageInfo
}

export type StoryDeleteResponse = {
	__typename?: 'StoryDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Story>
}

export type StoryEdge = {
	__typename?: 'StoryEdge'
	cursor: Scalars['String']['output']
	node: Story
}

export type StoryFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<StoryFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	description?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<StoryFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<StoryFilter>>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type StoryInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type StoryInsertResponse = {
	__typename?: 'StoryInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Story>
}

export type StoryOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type StoryUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type StoryUpdateResponse = {
	__typename?: 'StoryUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Story>
}

/** Boolean expression comparing fields on type "String" */
export type StringFilter = {
	eq?: InputMaybe<Scalars['String']['input']>
	gt?: InputMaybe<Scalars['String']['input']>
	gte?: InputMaybe<Scalars['String']['input']>
	ilike?: InputMaybe<Scalars['String']['input']>
	in?: InputMaybe<Array<Scalars['String']['input']>>
	iregex?: InputMaybe<Scalars['String']['input']>
	is?: InputMaybe<FilterIs>
	like?: InputMaybe<Scalars['String']['input']>
	lt?: InputMaybe<Scalars['String']['input']>
	lte?: InputMaybe<Scalars['String']['input']>
	neq?: InputMaybe<Scalars['String']['input']>
	regex?: InputMaybe<Scalars['String']['input']>
	startsWith?: InputMaybe<Scalars['String']['input']>
}

/** Boolean expression comparing fields on type "StringList" */
export type StringListFilter = {
	containedBy?: InputMaybe<Array<Scalars['String']['input']>>
	contains?: InputMaybe<Array<Scalars['String']['input']>>
	eq?: InputMaybe<Array<Scalars['String']['input']>>
	is?: InputMaybe<FilterIs>
	overlaps?: InputMaybe<Array<Scalars['String']['input']>>
}

export type StudentClaimKit = Node & {
	__typename?: 'StudentClaimKit'
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	reviewEmailSent?: Maybe<Scalars['Boolean']['output']>
	scanningAgent?: Maybe<Scalars['String']['output']>
	scanningAgentFromUserTable?: Maybe<Scalars['String']['output']>
	studentEmail: Scalars['String']['output']
	studentKit?: Maybe<StudentKit>
	studentKitCollection?: Maybe<StudentKitConnection>
	studentKitEdition?: Maybe<StudentKitEdition>
	studentKitScanningAgent?: Maybe<StudentKitScanningAgent>
	updatedAt: Scalars['Datetime']['output']
	user?: Maybe<User>
}

export type StudentClaimKitStudentKitCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentKitFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentKitOrderBy>>
}

export type StudentClaimKitConnection = {
	__typename?: 'StudentClaimKitConnection'
	edges: Array<StudentClaimKitEdge>
	pageInfo: PageInfo
}

export type StudentClaimKitDeleteResponse = {
	__typename?: 'StudentClaimKitDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentClaimKit>
}

export type StudentClaimKitEdge = {
	__typename?: 'StudentClaimKitEdge'
	cursor: Scalars['String']['output']
	node: StudentClaimKit
}

export type StudentClaimKitFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<StudentClaimKitFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<StudentClaimKitFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<StudentClaimKitFilter>>
	reviewEmailSent?: InputMaybe<BooleanFilter>
	scanningAgent?: InputMaybe<StringFilter>
	scanningAgentFromUserTable?: InputMaybe<StringFilter>
	studentEmail?: InputMaybe<StringFilter>
	studentKit?: InputMaybe<StringFilter>
	studentKitEdition?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type StudentClaimKitInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	reviewEmailSent?: InputMaybe<Scalars['Boolean']['input']>
	scanningAgent?: InputMaybe<Scalars['String']['input']>
	scanningAgentFromUserTable?: InputMaybe<Scalars['String']['input']>
	studentEmail?: InputMaybe<Scalars['String']['input']>
	studentKit?: InputMaybe<Scalars['String']['input']>
	studentKitEdition?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type StudentClaimKitInsertResponse = {
	__typename?: 'StudentClaimKitInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentClaimKit>
}

export type StudentClaimKitOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	reviewEmailSent?: InputMaybe<OrderByDirection>
	scanningAgent?: InputMaybe<OrderByDirection>
	scanningAgentFromUserTable?: InputMaybe<OrderByDirection>
	studentEmail?: InputMaybe<OrderByDirection>
	studentKit?: InputMaybe<OrderByDirection>
	studentKitEdition?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type StudentClaimKitUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	reviewEmailSent?: InputMaybe<Scalars['Boolean']['input']>
	scanningAgent?: InputMaybe<Scalars['String']['input']>
	scanningAgentFromUserTable?: InputMaybe<Scalars['String']['input']>
	studentEmail?: InputMaybe<Scalars['String']['input']>
	studentKit?: InputMaybe<Scalars['String']['input']>
	studentKitEdition?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type StudentClaimKitUpdateResponse = {
	__typename?: 'StudentClaimKitUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentClaimKit>
}

export type StudentKit = Node & {
	__typename?: 'StudentKit'
	createdAt: Scalars['Datetime']['output']
	email: Scalars['String']['output']
	emailVerified: Scalars['Boolean']['output']
	faculty?: Maybe<Faculty>
	facultySpecialization?: Maybe<FacultySpecialization>
	firstName: Scalars['String']['output']
	id: Scalars['String']['output']
	lastName: Scalars['String']['output']
	location?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	pin: Scalars['String']['output']
	roLocations?: Maybe<RoLocations>
	specialization?: Maybe<Scalars['String']['output']>
	studentClaimKit?: Maybe<StudentClaimKit>
	studentClaimKitCollection?: Maybe<StudentClaimKitConnection>
	studentKitEdition: Scalars['String']['output']
	university?: Maybe<University>
	universityLevel: Scalars['String']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type StudentKitStudentClaimKitCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentClaimKitFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentClaimKitOrderBy>>
}

export type StudentKitConnection = {
	__typename?: 'StudentKitConnection'
	edges: Array<StudentKitEdge>
	pageInfo: PageInfo
}

export type StudentKitDeleteResponse = {
	__typename?: 'StudentKitDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentKit>
}

export type StudentKitEdge = {
	__typename?: 'StudentKitEdge'
	cursor: Scalars['String']['output']
	node: StudentKit
}

export type StudentKitEdition = Node & {
	__typename?: 'StudentKitEdition'
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	month: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	studentClaimKitCollection?: Maybe<StudentClaimKitConnection>
	updatedAt: Scalars['Datetime']['output']
	year: Scalars['String']['output']
}

export type StudentKitEditionStudentClaimKitCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentClaimKitFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentClaimKitOrderBy>>
}

export type StudentKitEditionConnection = {
	__typename?: 'StudentKitEditionConnection'
	edges: Array<StudentKitEditionEdge>
	pageInfo: PageInfo
}

export type StudentKitEditionDeleteResponse = {
	__typename?: 'StudentKitEditionDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentKitEdition>
}

export type StudentKitEditionEdge = {
	__typename?: 'StudentKitEditionEdge'
	cursor: Scalars['String']['output']
	node: StudentKitEdition
}

export type StudentKitEditionFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<StudentKitEditionFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	month?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<StudentKitEditionFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<StudentKitEditionFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
	year?: InputMaybe<StringFilter>
}

export type StudentKitEditionInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	month?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	year?: InputMaybe<Scalars['String']['input']>
}

export type StudentKitEditionInsertResponse = {
	__typename?: 'StudentKitEditionInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentKitEdition>
}

export type StudentKitEditionOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	month?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	year?: InputMaybe<OrderByDirection>
}

export type StudentKitEditionUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	month?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	year?: InputMaybe<Scalars['String']['input']>
}

export type StudentKitEditionUpdateResponse = {
	__typename?: 'StudentKitEditionUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentKitEdition>
}

export type StudentKitFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<StudentKitFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	email?: InputMaybe<StringFilter>
	emailVerified?: InputMaybe<BooleanFilter>
	faculty?: InputMaybe<StringFilter>
	firstName?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	lastName?: InputMaybe<StringFilter>
	location?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<StudentKitFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<StudentKitFilter>>
	pin?: InputMaybe<StringFilter>
	specialization?: InputMaybe<StringFilter>
	studentClaimKit?: InputMaybe<StringFilter>
	studentKitEdition?: InputMaybe<StringFilter>
	university?: InputMaybe<StringFilter>
	universityLevel?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type StudentKitInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	emailVerified?: InputMaybe<Scalars['Boolean']['input']>
	faculty?: InputMaybe<Scalars['String']['input']>
	firstName?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	lastName?: InputMaybe<Scalars['String']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	pin?: InputMaybe<Scalars['String']['input']>
	specialization?: InputMaybe<Scalars['String']['input']>
	studentClaimKit?: InputMaybe<Scalars['String']['input']>
	studentKitEdition?: InputMaybe<Scalars['String']['input']>
	university?: InputMaybe<Scalars['String']['input']>
	universityLevel?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type StudentKitInsertResponse = {
	__typename?: 'StudentKitInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentKit>
}

export type StudentKitOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	email?: InputMaybe<OrderByDirection>
	emailVerified?: InputMaybe<OrderByDirection>
	faculty?: InputMaybe<OrderByDirection>
	firstName?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	lastName?: InputMaybe<OrderByDirection>
	location?: InputMaybe<OrderByDirection>
	pin?: InputMaybe<OrderByDirection>
	specialization?: InputMaybe<OrderByDirection>
	studentClaimKit?: InputMaybe<OrderByDirection>
	studentKitEdition?: InputMaybe<OrderByDirection>
	university?: InputMaybe<OrderByDirection>
	universityLevel?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type StudentKitScanningAgent = Node & {
	__typename?: 'StudentKitScanningAgent'
	code: Scalars['String']['output']
	createdAt: Scalars['Datetime']['output']
	email?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	name: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	studentClaimKitCollection?: Maybe<StudentClaimKitConnection>
	updatedAt: Scalars['Datetime']['output']
}

export type StudentKitScanningAgentStudentClaimKitCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentClaimKitFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentClaimKitOrderBy>>
}

export type StudentKitScanningAgentConnection = {
	__typename?: 'StudentKitScanningAgentConnection'
	edges: Array<StudentKitScanningAgentEdge>
	pageInfo: PageInfo
}

export type StudentKitScanningAgentDeleteResponse = {
	__typename?: 'StudentKitScanningAgentDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentKitScanningAgent>
}

export type StudentKitScanningAgentEdge = {
	__typename?: 'StudentKitScanningAgentEdge'
	cursor: Scalars['String']['output']
	node: StudentKitScanningAgent
}

export type StudentKitScanningAgentFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<StudentKitScanningAgentFilter>>
	code?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	email?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<StudentKitScanningAgentFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<StudentKitScanningAgentFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type StudentKitScanningAgentInsertInput = {
	code?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type StudentKitScanningAgentInsertResponse = {
	__typename?: 'StudentKitScanningAgentInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentKitScanningAgent>
}

export type StudentKitScanningAgentOrderBy = {
	code?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	email?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	name?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type StudentKitScanningAgentUpdateInput = {
	code?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type StudentKitScanningAgentUpdateResponse = {
	__typename?: 'StudentKitScanningAgentUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentKitScanningAgent>
}

export type StudentKitScheduledMailCronjobData = Node & {
	__typename?: 'StudentKitScheduledMailCronjobData'
	createdAt: Scalars['Datetime']['output']
	errorMessage?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	receiverAddress: Scalars['String']['output']
	success: Scalars['Boolean']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type StudentKitScheduledMailCronjobDataConnection = {
	__typename?: 'StudentKitScheduledMailCronjobDataConnection'
	edges: Array<StudentKitScheduledMailCronjobDataEdge>
	pageInfo: PageInfo
}

export type StudentKitScheduledMailCronjobDataDeleteResponse = {
	__typename?: 'StudentKitScheduledMailCronjobDataDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentKitScheduledMailCronjobData>
}

export type StudentKitScheduledMailCronjobDataEdge = {
	__typename?: 'StudentKitScheduledMailCronjobDataEdge'
	cursor: Scalars['String']['output']
	node: StudentKitScheduledMailCronjobData
}

export type StudentKitScheduledMailCronjobDataFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<StudentKitScheduledMailCronjobDataFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	errorMessage?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<StudentKitScheduledMailCronjobDataFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<StudentKitScheduledMailCronjobDataFilter>>
	receiverAddress?: InputMaybe<StringFilter>
	success?: InputMaybe<BooleanFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type StudentKitScheduledMailCronjobDataInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	errorMessage?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	receiverAddress?: InputMaybe<Scalars['String']['input']>
	success?: InputMaybe<Scalars['Boolean']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type StudentKitScheduledMailCronjobDataInsertResponse = {
	__typename?: 'StudentKitScheduledMailCronjobDataInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentKitScheduledMailCronjobData>
}

export type StudentKitScheduledMailCronjobDataOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	errorMessage?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	receiverAddress?: InputMaybe<OrderByDirection>
	success?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type StudentKitScheduledMailCronjobDataUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	errorMessage?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	receiverAddress?: InputMaybe<Scalars['String']['input']>
	success?: InputMaybe<Scalars['Boolean']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type StudentKitScheduledMailCronjobDataUpdateResponse = {
	__typename?: 'StudentKitScheduledMailCronjobDataUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentKitScheduledMailCronjobData>
}

export type StudentKitUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	emailVerified?: InputMaybe<Scalars['Boolean']['input']>
	faculty?: InputMaybe<Scalars['String']['input']>
	firstName?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	lastName?: InputMaybe<Scalars['String']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	pin?: InputMaybe<Scalars['String']['input']>
	specialization?: InputMaybe<Scalars['String']['input']>
	studentClaimKit?: InputMaybe<Scalars['String']['input']>
	studentKitEdition?: InputMaybe<Scalars['String']['input']>
	university?: InputMaybe<Scalars['String']['input']>
	universityLevel?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type StudentKitUpdateResponse = {
	__typename?: 'StudentKitUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<StudentKit>
}

export type Tag = Node & {
	__typename?: 'Tag'
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	title?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
}

export type TagConnection = {
	__typename?: 'TagConnection'
	edges: Array<TagEdge>
	pageInfo: PageInfo
}

export type TagDeleteResponse = {
	__typename?: 'TagDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Tag>
}

export type TagEdge = {
	__typename?: 'TagEdge'
	cursor: Scalars['String']['output']
	node: Tag
}

export type TagFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<TagFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<TagFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<TagFilter>>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type TagInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type TagInsertResponse = {
	__typename?: 'TagInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Tag>
}

export type TagOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type TagUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type TagUpdateResponse = {
	__typename?: 'TagUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Tag>
}

export type Team = Node & {
	__typename?: 'Team'
	_TeamToCompanyOfficesCollection?: Maybe<_TeamToCompanyOfficesConnection>
	_TeamToJobCollection?: Maybe<_TeamToJobConnection>
	active?: Maybe<Scalars['Boolean']['output']>
	articleCollection?: Maybe<ArticleConnection>
	averageAge?: Maybe<Scalars['Int']['output']>
	company?: Maybe<Company>
	coverBackground?: Maybe<Scalars['String']['output']>
	coverContentType?: Maybe<Scalars['String']['output']>
	coverPath?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['Datetime']['output']
	department?: Maybe<Scalars['String']['output']>
	description?: Maybe<Scalars['String']['output']>
	disabilityRatio?: Maybe<Scalars['Int']['output']>
	featuredVideo?: Maybe<Scalars['String']['output']>
	femaleRatio?: Maybe<Scalars['Int']['output']>
	hasCover?: Maybe<Scalars['Boolean']['output']>
	hasCoverBackground?: Maybe<Scalars['Boolean']['output']>
	hasLogo?: Maybe<Scalars['Boolean']['output']>
	id: Scalars['String']['output']
	logoContentType?: Maybe<Scalars['String']['output']>
	logoPath?: Maybe<Scalars['String']['output']>
	maleRatio?: Maybe<Scalars['Int']['output']>
	name: Scalars['String']['output']
	noOfMembers?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	searchviewCollection?: Maybe<SearchviewConnection>
	slug: Scalars['String']['output']
	teamDepartment?: Maybe<TeamDepartment>
	teamMemberCollection?: Maybe<TeamMemberConnection>
	teamRoleCollection?: Maybe<TeamRoleConnection>
	updatedAt: Scalars['Datetime']['output']
}

export type Team_TeamToCompanyOfficesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_TeamToCompanyOfficesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_TeamToCompanyOfficesOrderBy>>
}

export type Team_TeamToJobCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_TeamToJobFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_TeamToJobOrderBy>>
}

export type TeamArticleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ArticleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ArticleOrderBy>>
}

export type TeamSearchviewCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<SearchviewFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SearchviewOrderBy>>
}

export type TeamTeamMemberCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<TeamMemberFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<TeamMemberOrderBy>>
}

export type TeamTeamRoleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<TeamRoleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<TeamRoleOrderBy>>
}

export type TeamConnection = {
	__typename?: 'TeamConnection'
	edges: Array<TeamEdge>
	pageInfo: PageInfo
}

export type TeamDeleteResponse = {
	__typename?: 'TeamDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Team>
}

export type TeamDepartment = Node & {
	__typename?: 'TeamDepartment'
	createdAt: Scalars['Datetime']['output']
	enCategory?: Maybe<Scalars['String']['output']>
	enTitle: Scalars['String']['output']
	id: Scalars['String']['output']
	key: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	roCategory?: Maybe<Scalars['String']['output']>
	roTitle: Scalars['String']['output']
	teamCollection?: Maybe<TeamConnection>
	updatedAt: Scalars['Datetime']['output']
}

export type TeamDepartmentTeamCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<TeamFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<TeamOrderBy>>
}

export type TeamDepartmentConnection = {
	__typename?: 'TeamDepartmentConnection'
	edges: Array<TeamDepartmentEdge>
	pageInfo: PageInfo
}

export type TeamDepartmentDeleteResponse = {
	__typename?: 'TeamDepartmentDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<TeamDepartment>
}

export type TeamDepartmentEdge = {
	__typename?: 'TeamDepartmentEdge'
	cursor: Scalars['String']['output']
	node: TeamDepartment
}

export type TeamDepartmentFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<TeamDepartmentFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	enCategory?: InputMaybe<StringFilter>
	enTitle?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	key?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<TeamDepartmentFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<TeamDepartmentFilter>>
	roCategory?: InputMaybe<StringFilter>
	roTitle?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type TeamDepartmentInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	enCategory?: InputMaybe<Scalars['String']['input']>
	enTitle?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	key?: InputMaybe<Scalars['String']['input']>
	roCategory?: InputMaybe<Scalars['String']['input']>
	roTitle?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type TeamDepartmentInsertResponse = {
	__typename?: 'TeamDepartmentInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<TeamDepartment>
}

export type TeamDepartmentOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	enCategory?: InputMaybe<OrderByDirection>
	enTitle?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	key?: InputMaybe<OrderByDirection>
	roCategory?: InputMaybe<OrderByDirection>
	roTitle?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type TeamDepartmentUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	enCategory?: InputMaybe<Scalars['String']['input']>
	enTitle?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	key?: InputMaybe<Scalars['String']['input']>
	roCategory?: InputMaybe<Scalars['String']['input']>
	roTitle?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type TeamDepartmentUpdateResponse = {
	__typename?: 'TeamDepartmentUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<TeamDepartment>
}

export type TeamEdge = {
	__typename?: 'TeamEdge'
	cursor: Scalars['String']['output']
	node: Team
}

export type TeamFilter = {
	active?: InputMaybe<BooleanFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<TeamFilter>>
	averageAge?: InputMaybe<IntFilter>
	company?: InputMaybe<StringFilter>
	coverBackground?: InputMaybe<StringFilter>
	coverContentType?: InputMaybe<StringFilter>
	coverPath?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	department?: InputMaybe<StringFilter>
	description?: InputMaybe<StringFilter>
	disabilityRatio?: InputMaybe<IntFilter>
	featuredVideo?: InputMaybe<StringFilter>
	femaleRatio?: InputMaybe<IntFilter>
	hasCover?: InputMaybe<BooleanFilter>
	hasCoverBackground?: InputMaybe<BooleanFilter>
	hasLogo?: InputMaybe<BooleanFilter>
	id?: InputMaybe<StringFilter>
	logoContentType?: InputMaybe<StringFilter>
	logoPath?: InputMaybe<StringFilter>
	maleRatio?: InputMaybe<IntFilter>
	name?: InputMaybe<StringFilter>
	noOfMembers?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<TeamFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<TeamFilter>>
	slug?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type TeamInsertInput = {
	active?: InputMaybe<Scalars['Boolean']['input']>
	averageAge?: InputMaybe<Scalars['Int']['input']>
	company?: InputMaybe<Scalars['String']['input']>
	coverBackground?: InputMaybe<Scalars['String']['input']>
	coverContentType?: InputMaybe<Scalars['String']['input']>
	coverPath?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	department?: InputMaybe<Scalars['String']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	disabilityRatio?: InputMaybe<Scalars['Int']['input']>
	featuredVideo?: InputMaybe<Scalars['String']['input']>
	femaleRatio?: InputMaybe<Scalars['Int']['input']>
	hasCover?: InputMaybe<Scalars['Boolean']['input']>
	hasCoverBackground?: InputMaybe<Scalars['Boolean']['input']>
	hasLogo?: InputMaybe<Scalars['Boolean']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	logoContentType?: InputMaybe<Scalars['String']['input']>
	logoPath?: InputMaybe<Scalars['String']['input']>
	maleRatio?: InputMaybe<Scalars['Int']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	noOfMembers?: InputMaybe<Scalars['String']['input']>
	slug?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type TeamInsertResponse = {
	__typename?: 'TeamInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Team>
}

export type TeamMember = Node & {
	__typename?: 'TeamMember'
	active?: Maybe<Scalars['Boolean']['output']>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	jobCollection?: Maybe<JobConnection>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	team?: Maybe<Team>
	teamId?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
	user?: Maybe<User>
	userId?: Maybe<Scalars['String']['output']>
}

export type TeamMemberJobCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<JobFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<JobOrderBy>>
}

export type TeamMemberConnection = {
	__typename?: 'TeamMemberConnection'
	edges: Array<TeamMemberEdge>
	pageInfo: PageInfo
}

export type TeamMemberDeleteResponse = {
	__typename?: 'TeamMemberDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<TeamMember>
}

export type TeamMemberEdge = {
	__typename?: 'TeamMemberEdge'
	cursor: Scalars['String']['output']
	node: TeamMember
}

export type TeamMemberFilter = {
	active?: InputMaybe<BooleanFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<TeamMemberFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<TeamMemberFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<TeamMemberFilter>>
	teamId?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
	userId?: InputMaybe<StringFilter>
}

export type TeamMemberInsertInput = {
	active?: InputMaybe<Scalars['Boolean']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	teamId?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	userId?: InputMaybe<Scalars['String']['input']>
}

export type TeamMemberInsertResponse = {
	__typename?: 'TeamMemberInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<TeamMember>
}

export type TeamMemberOrderBy = {
	active?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	teamId?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	userId?: InputMaybe<OrderByDirection>
}

export type TeamMemberUpdateInput = {
	active?: InputMaybe<Scalars['Boolean']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	teamId?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	userId?: InputMaybe<Scalars['String']['input']>
}

export type TeamMemberUpdateResponse = {
	__typename?: 'TeamMemberUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<TeamMember>
}

export type TeamOrderBy = {
	active?: InputMaybe<OrderByDirection>
	averageAge?: InputMaybe<OrderByDirection>
	company?: InputMaybe<OrderByDirection>
	coverBackground?: InputMaybe<OrderByDirection>
	coverContentType?: InputMaybe<OrderByDirection>
	coverPath?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	department?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	disabilityRatio?: InputMaybe<OrderByDirection>
	featuredVideo?: InputMaybe<OrderByDirection>
	femaleRatio?: InputMaybe<OrderByDirection>
	hasCover?: InputMaybe<OrderByDirection>
	hasCoverBackground?: InputMaybe<OrderByDirection>
	hasLogo?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	logoContentType?: InputMaybe<OrderByDirection>
	logoPath?: InputMaybe<OrderByDirection>
	maleRatio?: InputMaybe<OrderByDirection>
	name?: InputMaybe<OrderByDirection>
	noOfMembers?: InputMaybe<OrderByDirection>
	slug?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type TeamRole = Node & {
	__typename?: 'TeamRole'
	company?: Maybe<Company>
	companyId?: Maybe<Scalars['String']['output']>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	team?: Maybe<Team>
	teamId?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
	user?: Maybe<User>
	userId?: Maybe<Scalars['String']['output']>
}

export type TeamRoleConnection = {
	__typename?: 'TeamRoleConnection'
	edges: Array<TeamRoleEdge>
	pageInfo: PageInfo
}

export type TeamRoleDeleteResponse = {
	__typename?: 'TeamRoleDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<TeamRole>
}

export type TeamRoleEdge = {
	__typename?: 'TeamRoleEdge'
	cursor: Scalars['String']['output']
	node: TeamRole
}

export type TeamRoleFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<TeamRoleFilter>>
	companyId?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<TeamRoleFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<TeamRoleFilter>>
	teamId?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
	userId?: InputMaybe<StringFilter>
}

export type TeamRoleInsertInput = {
	companyId?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	teamId?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	userId?: InputMaybe<Scalars['String']['input']>
}

export type TeamRoleInsertResponse = {
	__typename?: 'TeamRoleInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<TeamRole>
}

export type TeamRoleOrderBy = {
	companyId?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	teamId?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	userId?: InputMaybe<OrderByDirection>
}

export type TeamRoleUpdateInput = {
	companyId?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	teamId?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	userId?: InputMaybe<Scalars['String']['input']>
}

export type TeamRoleUpdateResponse = {
	__typename?: 'TeamRoleUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<TeamRole>
}

export type TeamUpdateInput = {
	active?: InputMaybe<Scalars['Boolean']['input']>
	averageAge?: InputMaybe<Scalars['Int']['input']>
	company?: InputMaybe<Scalars['String']['input']>
	coverBackground?: InputMaybe<Scalars['String']['input']>
	coverContentType?: InputMaybe<Scalars['String']['input']>
	coverPath?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	department?: InputMaybe<Scalars['String']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	disabilityRatio?: InputMaybe<Scalars['Int']['input']>
	featuredVideo?: InputMaybe<Scalars['String']['input']>
	femaleRatio?: InputMaybe<Scalars['Int']['input']>
	hasCover?: InputMaybe<Scalars['Boolean']['input']>
	hasCoverBackground?: InputMaybe<Scalars['Boolean']['input']>
	hasLogo?: InputMaybe<Scalars['Boolean']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	logoContentType?: InputMaybe<Scalars['String']['input']>
	logoPath?: InputMaybe<Scalars['String']['input']>
	maleRatio?: InputMaybe<Scalars['Int']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	noOfMembers?: InputMaybe<Scalars['String']['input']>
	slug?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type TeamUpdateResponse = {
	__typename?: 'TeamUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Team>
}

/** Boolean expression comparing fields on type "Time" */
export type TimeFilter = {
	eq?: InputMaybe<Scalars['Time']['input']>
	gt?: InputMaybe<Scalars['Time']['input']>
	gte?: InputMaybe<Scalars['Time']['input']>
	in?: InputMaybe<Array<Scalars['Time']['input']>>
	is?: InputMaybe<FilterIs>
	lt?: InputMaybe<Scalars['Time']['input']>
	lte?: InputMaybe<Scalars['Time']['input']>
	neq?: InputMaybe<Scalars['Time']['input']>
}

/** Boolean expression comparing fields on type "TimeList" */
export type TimeListFilter = {
	containedBy?: InputMaybe<Array<Scalars['Time']['input']>>
	contains?: InputMaybe<Array<Scalars['Time']['input']>>
	eq?: InputMaybe<Array<Scalars['Time']['input']>>
	is?: InputMaybe<FilterIs>
	overlaps?: InputMaybe<Array<Scalars['Time']['input']>>
}

/** Boolean expression comparing fields on type "UUID" */
export type UuidFilter = {
	eq?: InputMaybe<Scalars['UUID']['input']>
	in?: InputMaybe<Array<Scalars['UUID']['input']>>
	is?: InputMaybe<FilterIs>
	neq?: InputMaybe<Scalars['UUID']['input']>
}

/** Boolean expression comparing fields on type "UUIDList" */
export type UuidListFilter = {
	containedBy?: InputMaybe<Array<Scalars['UUID']['input']>>
	contains?: InputMaybe<Array<Scalars['UUID']['input']>>
	eq?: InputMaybe<Array<Scalars['UUID']['input']>>
	is?: InputMaybe<FilterIs>
	overlaps?: InputMaybe<Array<Scalars['UUID']['input']>>
}

export type University = Node & {
	__typename?: 'University'
	createdAt: Scalars['Datetime']['output']
	facultyCollection?: Maybe<FacultyConnection>
	id: Scalars['String']['output']
	name: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	studentKitCollection?: Maybe<StudentKitConnection>
	updatedAt: Scalars['Datetime']['output']
}

export type UniversityFacultyCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<FacultyFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<FacultyOrderBy>>
}

export type UniversityStudentKitCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentKitFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentKitOrderBy>>
}

export type UniversityConnection = {
	__typename?: 'UniversityConnection'
	edges: Array<UniversityEdge>
	pageInfo: PageInfo
}

export type UniversityDeleteResponse = {
	__typename?: 'UniversityDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<University>
}

export type UniversityEdge = {
	__typename?: 'UniversityEdge'
	cursor: Scalars['String']['output']
	node: University
}

export type UniversityFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<UniversityFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<UniversityFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<UniversityFilter>>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type UniversityInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type UniversityInsertResponse = {
	__typename?: 'UniversityInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<University>
}

export type UniversityOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	name?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type UniversityUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type UniversityUpdateResponse = {
	__typename?: 'UniversityUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<University>
}

export type User = Node & {
	__typename?: 'User'
	_ActiveArticleTagToUserCollection?: Maybe<_ActiveArticleTagToUserConnection>
	_JobToFollowersCollection?: Maybe<_JobToFollowersConnection>
	_OwnerToCompanyCollection?: Maybe<_OwnerToCompanyConnection>
	_UserToCompanyRoleCollection?: Maybe<_UserToCompanyRoleConnection>
	activationToken?: Maybe<Scalars['UUID']['output']>
	articleCollection?: Maybe<ArticleConnection>
	auth_user_id?: Maybe<Scalars['UUID']['output']>
	campaign_claim_historyCollection?: Maybe<Campaign_Claim_HistoryConnection>
	campaign_editionsCollection?: Maybe<Campaign_EditionsConnection>
	campaign_recipientsCollection?: Maybe<Campaign_RecipientsConnection>
	campaign_scanning_agentsCollection?: Maybe<Campaign_Scanning_AgentsConnection>
	chillPackRecipientClaimCollection?: Maybe<ChillPackRecipientClaimConnection>
	createdAt: Scalars['Datetime']['output']
	deletedAt?: Maybe<Scalars['Datetime']['output']>
	educationCollection?: Maybe<EducationConnection>
	email: Scalars['String']['output']
	firebaseToken?: Maybe<Scalars['String']['output']>
	god: Scalars['Boolean']['output']
	hash: Scalars['String']['output']
	hobbyCollection?: Maybe<HobbyConnection>
	id: Scalars['String']['output']
	imageCollection?: Maybe<ImageConnection>
	jobApplicantCollection?: Maybe<JobApplicantConnection>
	linkedUsersToCompaniesCollection?: Maybe<LinkedUsersToCompaniesConnection>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	onesignal_id?: Maybe<Scalars['String']['output']>
	passwordResetToken?: Maybe<Scalars['UUID']['output']>
	post_comment_likesCollection?: Maybe<Post_Comment_LikesConnection>
	post_commentsCollection?: Maybe<Post_CommentsConnection>
	profileCollection?: Maybe<ProfileConnection>
	projectCollection?: Maybe<ProjectConnection>
	rememberToken?: Maybe<Scalars['UUID']['output']>
	salt: Scalars['String']['output']
	scanning_agent_invitationsCollection?: Maybe<Scanning_Agent_InvitationsConnection>
	searchviewCollection?: Maybe<SearchviewConnection>
	status: Scalars['String']['output']
	studentClaimKitCollection?: Maybe<StudentClaimKitConnection>
	studentKitsScanningAgent?: Maybe<Scalars['Boolean']['output']>
	teamMemberCollection?: Maybe<TeamMemberConnection>
	teamRoleCollection?: Maybe<TeamRoleConnection>
	temporaryEmail?: Maybe<Scalars['String']['output']>
	uid: Scalars['String']['output']
	ukey?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
	validateEmailToken?: Maybe<Scalars['String']['output']>
	videoCollection?: Maybe<VideoConnection>
	viewCustomUserCollection?: Maybe<ViewCustomUserConnection>
}

export type User_ActiveArticleTagToUserCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_ActiveArticleTagToUserFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_ActiveArticleTagToUserOrderBy>>
}

export type User_JobToFollowersCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_JobToFollowersFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_JobToFollowersOrderBy>>
}

export type User_OwnerToCompanyCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_OwnerToCompanyFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_OwnerToCompanyOrderBy>>
}

export type User_UserToCompanyRoleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_UserToCompanyRoleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_UserToCompanyRoleOrderBy>>
}

export type UserArticleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ArticleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ArticleOrderBy>>
}

export type UserCampaign_Claim_HistoryCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Campaign_Claim_HistoryFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Campaign_Claim_HistoryOrderBy>>
}

export type UserCampaign_EditionsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Campaign_EditionsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Campaign_EditionsOrderBy>>
}

export type UserCampaign_RecipientsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Campaign_RecipientsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Campaign_RecipientsOrderBy>>
}

export type UserCampaign_Scanning_AgentsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Campaign_Scanning_AgentsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Campaign_Scanning_AgentsOrderBy>>
}

export type UserChillPackRecipientClaimCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ChillPackRecipientClaimFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ChillPackRecipientClaimOrderBy>>
}

export type UserEducationCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<EducationFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<EducationOrderBy>>
}

export type UserHobbyCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<HobbyFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<HobbyOrderBy>>
}

export type UserImageCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ImageFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ImageOrderBy>>
}

export type UserJobApplicantCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<JobApplicantFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<JobApplicantOrderBy>>
}

export type UserLinkedUsersToCompaniesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<LinkedUsersToCompaniesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<LinkedUsersToCompaniesOrderBy>>
}

export type UserPost_Comment_LikesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Post_Comment_LikesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Post_Comment_LikesOrderBy>>
}

export type UserPost_CommentsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Post_CommentsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Post_CommentsOrderBy>>
}

export type UserProfileCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ProfileFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ProfileOrderBy>>
}

export type UserProjectCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ProjectFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ProjectOrderBy>>
}

export type UserScanning_Agent_InvitationsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Scanning_Agent_InvitationsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Scanning_Agent_InvitationsOrderBy>>
}

export type UserSearchviewCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<SearchviewFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<SearchviewOrderBy>>
}

export type UserStudentClaimKitCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentClaimKitFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentClaimKitOrderBy>>
}

export type UserTeamMemberCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<TeamMemberFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<TeamMemberOrderBy>>
}

export type UserTeamRoleCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<TeamRoleFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<TeamRoleOrderBy>>
}

export type UserVideoCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<VideoFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<VideoOrderBy>>
}

export type UserViewCustomUserCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ViewCustomUserFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ViewCustomUserOrderBy>>
}

export type UserConnection = {
	__typename?: 'UserConnection'
	edges: Array<UserEdge>
	pageInfo: PageInfo
}

export type UserDeleteResponse = {
	__typename?: 'UserDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<User>
}

export type UserEdge = {
	__typename?: 'UserEdge'
	cursor: Scalars['String']['output']
	node: User
}

export type UserFilter = {
	activationToken?: InputMaybe<UuidFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<UserFilter>>
	auth_user_id?: InputMaybe<UuidFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	deletedAt?: InputMaybe<DatetimeFilter>
	email?: InputMaybe<StringFilter>
	firebaseToken?: InputMaybe<StringFilter>
	god?: InputMaybe<BooleanFilter>
	hash?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<UserFilter>
	onesignal_id?: InputMaybe<StringFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<UserFilter>>
	passwordResetToken?: InputMaybe<UuidFilter>
	rememberToken?: InputMaybe<UuidFilter>
	salt?: InputMaybe<StringFilter>
	status?: InputMaybe<StringFilter>
	studentKitsScanningAgent?: InputMaybe<BooleanFilter>
	temporaryEmail?: InputMaybe<StringFilter>
	uid?: InputMaybe<StringFilter>
	ukey?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
	validateEmailToken?: InputMaybe<StringFilter>
}

export type UserInsertInput = {
	activationToken?: InputMaybe<Scalars['UUID']['input']>
	auth_user_id?: InputMaybe<Scalars['UUID']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	deletedAt?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	firebaseToken?: InputMaybe<Scalars['String']['input']>
	god?: InputMaybe<Scalars['Boolean']['input']>
	hash?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	onesignal_id?: InputMaybe<Scalars['String']['input']>
	passwordResetToken?: InputMaybe<Scalars['UUID']['input']>
	rememberToken?: InputMaybe<Scalars['UUID']['input']>
	salt?: InputMaybe<Scalars['String']['input']>
	status?: InputMaybe<Scalars['String']['input']>
	studentKitsScanningAgent?: InputMaybe<Scalars['Boolean']['input']>
	temporaryEmail?: InputMaybe<Scalars['String']['input']>
	uid?: InputMaybe<Scalars['String']['input']>
	ukey?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	validateEmailToken?: InputMaybe<Scalars['String']['input']>
}

export type UserInsertResponse = {
	__typename?: 'UserInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<User>
}

export type UserOrderBy = {
	activationToken?: InputMaybe<OrderByDirection>
	auth_user_id?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	deletedAt?: InputMaybe<OrderByDirection>
	email?: InputMaybe<OrderByDirection>
	firebaseToken?: InputMaybe<OrderByDirection>
	god?: InputMaybe<OrderByDirection>
	hash?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	onesignal_id?: InputMaybe<OrderByDirection>
	passwordResetToken?: InputMaybe<OrderByDirection>
	rememberToken?: InputMaybe<OrderByDirection>
	salt?: InputMaybe<OrderByDirection>
	status?: InputMaybe<OrderByDirection>
	studentKitsScanningAgent?: InputMaybe<OrderByDirection>
	temporaryEmail?: InputMaybe<OrderByDirection>
	uid?: InputMaybe<OrderByDirection>
	ukey?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	validateEmailToken?: InputMaybe<OrderByDirection>
}

export type UserUpdateInput = {
	activationToken?: InputMaybe<Scalars['UUID']['input']>
	auth_user_id?: InputMaybe<Scalars['UUID']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	deletedAt?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	firebaseToken?: InputMaybe<Scalars['String']['input']>
	god?: InputMaybe<Scalars['Boolean']['input']>
	hash?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	onesignal_id?: InputMaybe<Scalars['String']['input']>
	passwordResetToken?: InputMaybe<Scalars['UUID']['input']>
	rememberToken?: InputMaybe<Scalars['UUID']['input']>
	salt?: InputMaybe<Scalars['String']['input']>
	status?: InputMaybe<Scalars['String']['input']>
	studentKitsScanningAgent?: InputMaybe<Scalars['Boolean']['input']>
	temporaryEmail?: InputMaybe<Scalars['String']['input']>
	uid?: InputMaybe<Scalars['String']['input']>
	ukey?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	validateEmailToken?: InputMaybe<Scalars['String']['input']>
}

export type UserUpdateResponse = {
	__typename?: 'UserUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<User>
}

export type Value = Node & {
	__typename?: 'Value'
	_ProfileToValueCollection?: Maybe<_ProfileToValueConnection>
	createdAt: Scalars['Datetime']['output']
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	title?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
}

export type Value_ProfileToValueCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<_ProfileToValueFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<_ProfileToValueOrderBy>>
}

export type ValueConnection = {
	__typename?: 'ValueConnection'
	edges: Array<ValueEdge>
	pageInfo: PageInfo
}

export type ValueDeleteResponse = {
	__typename?: 'ValueDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Value>
}

export type ValueEdge = {
	__typename?: 'ValueEdge'
	cursor: Scalars['String']['output']
	node: Value
}

export type ValueFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ValueFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ValueFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ValueFilter>>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type ValueInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ValueInsertResponse = {
	__typename?: 'ValueInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Value>
}

export type ValueOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type ValueUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type ValueUpdateResponse = {
	__typename?: 'ValueUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Value>
}

export type Video = Node & {
	__typename?: 'Video'
	createdAt: Scalars['Datetime']['output']
	description?: Maybe<Scalars['String']['output']>
	filename?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	isFeatured?: Maybe<Scalars['Boolean']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	originalFilename?: Maybe<Scalars['String']['output']>
	path?: Maybe<Scalars['String']['output']>
	sourceType?: Maybe<Scalars['String']['output']>
	title?: Maybe<Scalars['String']['output']>
	updatedAt: Scalars['Datetime']['output']
	url?: Maybe<Scalars['String']['output']>
	user?: Maybe<User>
}

export type VideoConnection = {
	__typename?: 'VideoConnection'
	edges: Array<VideoEdge>
	pageInfo: PageInfo
}

export type VideoDeleteResponse = {
	__typename?: 'VideoDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Video>
}

export type VideoEdge = {
	__typename?: 'VideoEdge'
	cursor: Scalars['String']['output']
	node: Video
}

export type VideoFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<VideoFilter>>
	createdAt?: InputMaybe<DatetimeFilter>
	description?: InputMaybe<StringFilter>
	filename?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	isFeatured?: InputMaybe<BooleanFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<VideoFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<VideoFilter>>
	originalFilename?: InputMaybe<StringFilter>
	path?: InputMaybe<StringFilter>
	sourceType?: InputMaybe<StringFilter>
	title?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
	url?: InputMaybe<StringFilter>
	user?: InputMaybe<StringFilter>
}

export type VideoInsertInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	filename?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isFeatured?: InputMaybe<Scalars['Boolean']['input']>
	originalFilename?: InputMaybe<Scalars['String']['input']>
	path?: InputMaybe<Scalars['String']['input']>
	sourceType?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	url?: InputMaybe<Scalars['String']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type VideoInsertResponse = {
	__typename?: 'VideoInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Video>
}

export type VideoOrderBy = {
	createdAt?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	filename?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	isFeatured?: InputMaybe<OrderByDirection>
	originalFilename?: InputMaybe<OrderByDirection>
	path?: InputMaybe<OrderByDirection>
	sourceType?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
	url?: InputMaybe<OrderByDirection>
	user?: InputMaybe<OrderByDirection>
}

export type VideoUpdateInput = {
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	filename?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	isFeatured?: InputMaybe<Scalars['Boolean']['input']>
	originalFilename?: InputMaybe<Scalars['String']['input']>
	path?: InputMaybe<Scalars['String']['input']>
	sourceType?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
	url?: InputMaybe<Scalars['String']['input']>
	user?: InputMaybe<Scalars['String']['input']>
}

export type VideoUpdateResponse = {
	__typename?: 'VideoUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Video>
}

export type ViewCustomUser = Node & {
	__typename?: 'ViewCustomUser'
	name: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	user?: Maybe<User>
	user_id?: Maybe<Scalars['String']['output']>
}

export type ViewCustomUserConnection = {
	__typename?: 'ViewCustomUserConnection'
	edges: Array<ViewCustomUserEdge>
	pageInfo: PageInfo
}

export type ViewCustomUserDeleteResponse = {
	__typename?: 'ViewCustomUserDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ViewCustomUser>
}

export type ViewCustomUserEdge = {
	__typename?: 'ViewCustomUserEdge'
	cursor: Scalars['String']['output']
	node: ViewCustomUser
}

export type ViewCustomUserFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ViewCustomUserFilter>>
	name?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ViewCustomUserFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ViewCustomUserFilter>>
	user_id?: InputMaybe<StringFilter>
}

export type ViewCustomUserInsertInput = {
	name?: InputMaybe<Scalars['String']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type ViewCustomUserInsertResponse = {
	__typename?: 'ViewCustomUserInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ViewCustomUser>
}

export type ViewCustomUserOrderBy = {
	name?: InputMaybe<OrderByDirection>
	user_id?: InputMaybe<OrderByDirection>
}

export type ViewCustomUserUpdateInput = {
	name?: InputMaybe<Scalars['String']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type ViewCustomUserUpdateResponse = {
	__typename?: 'ViewCustomUserUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<ViewCustomUser>
}

export type _ActiveArticleTagToUser = Node & {
	__typename?: '_ActiveArticleTagToUser'
	A: Scalars['String']['output']
	B: Scalars['String']['output']
	activeArticleTag: ActiveArticleTag
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	user: User
}

export type _ActiveArticleTagToUserConnection = {
	__typename?: '_ActiveArticleTagToUserConnection'
	edges: Array<_ActiveArticleTagToUserEdge>
	pageInfo: PageInfo
}

export type _ActiveArticleTagToUserDeleteResponse = {
	__typename?: '_ActiveArticleTagToUserDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_ActiveArticleTagToUser>
}

export type _ActiveArticleTagToUserEdge = {
	__typename?: '_ActiveArticleTagToUserEdge'
	cursor: Scalars['String']['output']
	node: _ActiveArticleTagToUser
}

export type _ActiveArticleTagToUserFilter = {
	A?: InputMaybe<StringFilter>
	B?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<_ActiveArticleTagToUserFilter>>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<_ActiveArticleTagToUserFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<_ActiveArticleTagToUserFilter>>
}

export type _ActiveArticleTagToUserInsertInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _ActiveArticleTagToUserInsertResponse = {
	__typename?: '_ActiveArticleTagToUserInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_ActiveArticleTagToUser>
}

export type _ActiveArticleTagToUserOrderBy = {
	A?: InputMaybe<OrderByDirection>
	B?: InputMaybe<OrderByDirection>
}

export type _ActiveArticleTagToUserUpdateInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _ActiveArticleTagToUserUpdateResponse = {
	__typename?: '_ActiveArticleTagToUserUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_ActiveArticleTagToUser>
}

export type _CompanyToCompanyType = Node & {
	__typename?: '_CompanyToCompanyType'
	A: Scalars['String']['output']
	B: Scalars['String']['output']
	company: Company
	companyType: CompanyType
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
}

export type _CompanyToCompanyTypeConnection = {
	__typename?: '_CompanyToCompanyTypeConnection'
	edges: Array<_CompanyToCompanyTypeEdge>
	pageInfo: PageInfo
}

export type _CompanyToCompanyTypeDeleteResponse = {
	__typename?: '_CompanyToCompanyTypeDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_CompanyToCompanyType>
}

export type _CompanyToCompanyTypeEdge = {
	__typename?: '_CompanyToCompanyTypeEdge'
	cursor: Scalars['String']['output']
	node: _CompanyToCompanyType
}

export type _CompanyToCompanyTypeFilter = {
	A?: InputMaybe<StringFilter>
	B?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<_CompanyToCompanyTypeFilter>>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<_CompanyToCompanyTypeFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<_CompanyToCompanyTypeFilter>>
}

export type _CompanyToCompanyTypeInsertInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _CompanyToCompanyTypeInsertResponse = {
	__typename?: '_CompanyToCompanyTypeInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_CompanyToCompanyType>
}

export type _CompanyToCompanyTypeOrderBy = {
	A?: InputMaybe<OrderByDirection>
	B?: InputMaybe<OrderByDirection>
}

export type _CompanyToCompanyTypeUpdateInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _CompanyToCompanyTypeUpdateResponse = {
	__typename?: '_CompanyToCompanyTypeUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_CompanyToCompanyType>
}

export type _JobToCompanyOffices = Node & {
	__typename?: '_JobToCompanyOffices'
	A: Scalars['String']['output']
	B: Scalars['String']['output']
	companyOffices: CompanyOffices
	job: Job
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
}

export type _JobToCompanyOfficesConnection = {
	__typename?: '_JobToCompanyOfficesConnection'
	edges: Array<_JobToCompanyOfficesEdge>
	pageInfo: PageInfo
}

export type _JobToCompanyOfficesDeleteResponse = {
	__typename?: '_JobToCompanyOfficesDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_JobToCompanyOffices>
}

export type _JobToCompanyOfficesEdge = {
	__typename?: '_JobToCompanyOfficesEdge'
	cursor: Scalars['String']['output']
	node: _JobToCompanyOffices
}

export type _JobToCompanyOfficesFilter = {
	A?: InputMaybe<StringFilter>
	B?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<_JobToCompanyOfficesFilter>>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<_JobToCompanyOfficesFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<_JobToCompanyOfficesFilter>>
}

export type _JobToCompanyOfficesInsertInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _JobToCompanyOfficesInsertResponse = {
	__typename?: '_JobToCompanyOfficesInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_JobToCompanyOffices>
}

export type _JobToCompanyOfficesOrderBy = {
	A?: InputMaybe<OrderByDirection>
	B?: InputMaybe<OrderByDirection>
}

export type _JobToCompanyOfficesUpdateInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _JobToCompanyOfficesUpdateResponse = {
	__typename?: '_JobToCompanyOfficesUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_JobToCompanyOffices>
}

export type _JobToCustomSkills = Node & {
	__typename?: '_JobToCustomSkills'
	A: Scalars['String']['output']
	B: Scalars['String']['output']
	customSkills: CustomSkills
	job: Job
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
}

export type _JobToCustomSkillsConnection = {
	__typename?: '_JobToCustomSkillsConnection'
	edges: Array<_JobToCustomSkillsEdge>
	pageInfo: PageInfo
}

export type _JobToCustomSkillsDeleteResponse = {
	__typename?: '_JobToCustomSkillsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_JobToCustomSkills>
}

export type _JobToCustomSkillsEdge = {
	__typename?: '_JobToCustomSkillsEdge'
	cursor: Scalars['String']['output']
	node: _JobToCustomSkills
}

export type _JobToCustomSkillsFilter = {
	A?: InputMaybe<StringFilter>
	B?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<_JobToCustomSkillsFilter>>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<_JobToCustomSkillsFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<_JobToCustomSkillsFilter>>
}

export type _JobToCustomSkillsInsertInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _JobToCustomSkillsInsertResponse = {
	__typename?: '_JobToCustomSkillsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_JobToCustomSkills>
}

export type _JobToCustomSkillsOrderBy = {
	A?: InputMaybe<OrderByDirection>
	B?: InputMaybe<OrderByDirection>
}

export type _JobToCustomSkillsUpdateInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _JobToCustomSkillsUpdateResponse = {
	__typename?: '_JobToCustomSkillsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_JobToCustomSkills>
}

export type _JobToFollowers = Node & {
	__typename?: '_JobToFollowers'
	A: Scalars['String']['output']
	B: Scalars['String']['output']
	job: Job
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	user: User
}

export type _JobToFollowersConnection = {
	__typename?: '_JobToFollowersConnection'
	edges: Array<_JobToFollowersEdge>
	pageInfo: PageInfo
}

export type _JobToFollowersDeleteResponse = {
	__typename?: '_JobToFollowersDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_JobToFollowers>
}

export type _JobToFollowersEdge = {
	__typename?: '_JobToFollowersEdge'
	cursor: Scalars['String']['output']
	node: _JobToFollowers
}

export type _JobToFollowersFilter = {
	A?: InputMaybe<StringFilter>
	B?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<_JobToFollowersFilter>>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<_JobToFollowersFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<_JobToFollowersFilter>>
}

export type _JobToFollowersInsertInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _JobToFollowersInsertResponse = {
	__typename?: '_JobToFollowersInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_JobToFollowers>
}

export type _JobToFollowersOrderBy = {
	A?: InputMaybe<OrderByDirection>
	B?: InputMaybe<OrderByDirection>
}

export type _JobToFollowersUpdateInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _JobToFollowersUpdateResponse = {
	__typename?: '_JobToFollowersUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_JobToFollowers>
}

export type _JobToSkill = Node & {
	__typename?: '_JobToSkill'
	A: Scalars['String']['output']
	B: Scalars['String']['output']
	job: Job
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	skill: Skill
}

export type _JobToSkillConnection = {
	__typename?: '_JobToSkillConnection'
	edges: Array<_JobToSkillEdge>
	pageInfo: PageInfo
}

export type _JobToSkillDeleteResponse = {
	__typename?: '_JobToSkillDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_JobToSkill>
}

export type _JobToSkillEdge = {
	__typename?: '_JobToSkillEdge'
	cursor: Scalars['String']['output']
	node: _JobToSkill
}

export type _JobToSkillFilter = {
	A?: InputMaybe<StringFilter>
	B?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<_JobToSkillFilter>>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<_JobToSkillFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<_JobToSkillFilter>>
}

export type _JobToSkillInsertInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _JobToSkillInsertResponse = {
	__typename?: '_JobToSkillInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_JobToSkill>
}

export type _JobToSkillOrderBy = {
	A?: InputMaybe<OrderByDirection>
	B?: InputMaybe<OrderByDirection>
}

export type _JobToSkillUpdateInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _JobToSkillUpdateResponse = {
	__typename?: '_JobToSkillUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_JobToSkill>
}

export type _OwnerToCompany = Node & {
	__typename?: '_OwnerToCompany'
	A: Scalars['String']['output']
	B: Scalars['String']['output']
	company: Company
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	user: User
}

export type _OwnerToCompanyConnection = {
	__typename?: '_OwnerToCompanyConnection'
	edges: Array<_OwnerToCompanyEdge>
	pageInfo: PageInfo
}

export type _OwnerToCompanyDeleteResponse = {
	__typename?: '_OwnerToCompanyDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_OwnerToCompany>
}

export type _OwnerToCompanyEdge = {
	__typename?: '_OwnerToCompanyEdge'
	cursor: Scalars['String']['output']
	node: _OwnerToCompany
}

export type _OwnerToCompanyFilter = {
	A?: InputMaybe<StringFilter>
	B?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<_OwnerToCompanyFilter>>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<_OwnerToCompanyFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<_OwnerToCompanyFilter>>
}

export type _OwnerToCompanyInsertInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _OwnerToCompanyInsertResponse = {
	__typename?: '_OwnerToCompanyInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_OwnerToCompany>
}

export type _OwnerToCompanyOrderBy = {
	A?: InputMaybe<OrderByDirection>
	B?: InputMaybe<OrderByDirection>
}

export type _OwnerToCompanyUpdateInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _OwnerToCompanyUpdateResponse = {
	__typename?: '_OwnerToCompanyUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_OwnerToCompany>
}

export type _ProfileToSkill = Node & {
	__typename?: '_ProfileToSkill'
	A: Scalars['String']['output']
	B: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	profile: Profile
	skill: Skill
}

export type _ProfileToSkillConnection = {
	__typename?: '_ProfileToSkillConnection'
	edges: Array<_ProfileToSkillEdge>
	pageInfo: PageInfo
}

export type _ProfileToSkillDeleteResponse = {
	__typename?: '_ProfileToSkillDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_ProfileToSkill>
}

export type _ProfileToSkillEdge = {
	__typename?: '_ProfileToSkillEdge'
	cursor: Scalars['String']['output']
	node: _ProfileToSkill
}

export type _ProfileToSkillFilter = {
	A?: InputMaybe<StringFilter>
	B?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<_ProfileToSkillFilter>>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<_ProfileToSkillFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<_ProfileToSkillFilter>>
}

export type _ProfileToSkillInsertInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _ProfileToSkillInsertResponse = {
	__typename?: '_ProfileToSkillInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_ProfileToSkill>
}

export type _ProfileToSkillOrderBy = {
	A?: InputMaybe<OrderByDirection>
	B?: InputMaybe<OrderByDirection>
}

export type _ProfileToSkillUpdateInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _ProfileToSkillUpdateResponse = {
	__typename?: '_ProfileToSkillUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_ProfileToSkill>
}

export type _ProfileToValue = Node & {
	__typename?: '_ProfileToValue'
	A: Scalars['String']['output']
	B: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	profile: Profile
	value: Value
}

export type _ProfileToValueConnection = {
	__typename?: '_ProfileToValueConnection'
	edges: Array<_ProfileToValueEdge>
	pageInfo: PageInfo
}

export type _ProfileToValueDeleteResponse = {
	__typename?: '_ProfileToValueDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_ProfileToValue>
}

export type _ProfileToValueEdge = {
	__typename?: '_ProfileToValueEdge'
	cursor: Scalars['String']['output']
	node: _ProfileToValue
}

export type _ProfileToValueFilter = {
	A?: InputMaybe<StringFilter>
	B?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<_ProfileToValueFilter>>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<_ProfileToValueFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<_ProfileToValueFilter>>
}

export type _ProfileToValueInsertInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _ProfileToValueInsertResponse = {
	__typename?: '_ProfileToValueInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_ProfileToValue>
}

export type _ProfileToValueOrderBy = {
	A?: InputMaybe<OrderByDirection>
	B?: InputMaybe<OrderByDirection>
}

export type _ProfileToValueUpdateInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _ProfileToValueUpdateResponse = {
	__typename?: '_ProfileToValueUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_ProfileToValue>
}

export type _TeamToCompanyOffices = Node & {
	__typename?: '_TeamToCompanyOffices'
	A: Scalars['String']['output']
	B: Scalars['String']['output']
	companyOffices: CompanyOffices
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	team: Team
}

export type _TeamToCompanyOfficesConnection = {
	__typename?: '_TeamToCompanyOfficesConnection'
	edges: Array<_TeamToCompanyOfficesEdge>
	pageInfo: PageInfo
}

export type _TeamToCompanyOfficesDeleteResponse = {
	__typename?: '_TeamToCompanyOfficesDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_TeamToCompanyOffices>
}

export type _TeamToCompanyOfficesEdge = {
	__typename?: '_TeamToCompanyOfficesEdge'
	cursor: Scalars['String']['output']
	node: _TeamToCompanyOffices
}

export type _TeamToCompanyOfficesFilter = {
	A?: InputMaybe<StringFilter>
	B?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<_TeamToCompanyOfficesFilter>>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<_TeamToCompanyOfficesFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<_TeamToCompanyOfficesFilter>>
}

export type _TeamToCompanyOfficesInsertInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _TeamToCompanyOfficesInsertResponse = {
	__typename?: '_TeamToCompanyOfficesInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_TeamToCompanyOffices>
}

export type _TeamToCompanyOfficesOrderBy = {
	A?: InputMaybe<OrderByDirection>
	B?: InputMaybe<OrderByDirection>
}

export type _TeamToCompanyOfficesUpdateInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _TeamToCompanyOfficesUpdateResponse = {
	__typename?: '_TeamToCompanyOfficesUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_TeamToCompanyOffices>
}

export type _TeamToJob = Node & {
	__typename?: '_TeamToJob'
	A: Scalars['String']['output']
	B: Scalars['String']['output']
	job: Job
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	team: Team
}

export type _TeamToJobConnection = {
	__typename?: '_TeamToJobConnection'
	edges: Array<_TeamToJobEdge>
	pageInfo: PageInfo
}

export type _TeamToJobDeleteResponse = {
	__typename?: '_TeamToJobDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_TeamToJob>
}

export type _TeamToJobEdge = {
	__typename?: '_TeamToJobEdge'
	cursor: Scalars['String']['output']
	node: _TeamToJob
}

export type _TeamToJobFilter = {
	A?: InputMaybe<StringFilter>
	B?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<_TeamToJobFilter>>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<_TeamToJobFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<_TeamToJobFilter>>
}

export type _TeamToJobInsertInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _TeamToJobInsertResponse = {
	__typename?: '_TeamToJobInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_TeamToJob>
}

export type _TeamToJobOrderBy = {
	A?: InputMaybe<OrderByDirection>
	B?: InputMaybe<OrderByDirection>
}

export type _TeamToJobUpdateInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _TeamToJobUpdateResponse = {
	__typename?: '_TeamToJobUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_TeamToJob>
}

export type _UserToCompanyRole = Node & {
	__typename?: '_UserToCompanyRole'
	A: Scalars['String']['output']
	B: Scalars['String']['output']
	companyRole: CompanyRole
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	user: User
}

export type _UserToCompanyRoleConnection = {
	__typename?: '_UserToCompanyRoleConnection'
	edges: Array<_UserToCompanyRoleEdge>
	pageInfo: PageInfo
}

export type _UserToCompanyRoleDeleteResponse = {
	__typename?: '_UserToCompanyRoleDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_UserToCompanyRole>
}

export type _UserToCompanyRoleEdge = {
	__typename?: '_UserToCompanyRoleEdge'
	cursor: Scalars['String']['output']
	node: _UserToCompanyRole
}

export type _UserToCompanyRoleFilter = {
	A?: InputMaybe<StringFilter>
	B?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<_UserToCompanyRoleFilter>>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<_UserToCompanyRoleFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<_UserToCompanyRoleFilter>>
}

export type _UserToCompanyRoleInsertInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _UserToCompanyRoleInsertResponse = {
	__typename?: '_UserToCompanyRoleInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_UserToCompanyRole>
}

export type _UserToCompanyRoleOrderBy = {
	A?: InputMaybe<OrderByDirection>
	B?: InputMaybe<OrderByDirection>
}

export type _UserToCompanyRoleUpdateInput = {
	A?: InputMaybe<Scalars['String']['input']>
	B?: InputMaybe<Scalars['String']['input']>
}

export type _UserToCompanyRoleUpdateResponse = {
	__typename?: '_UserToCompanyRoleUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<_UserToCompanyRole>
}

export type Application_Stage = Node & {
	__typename?: 'application_stage'
	created_at: Scalars['Datetime']['output']
	id: Scalars['UUID']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	status: Scalars['String']['output']
	updated_at?: Maybe<Scalars['Datetime']['output']>
}

export type Application_StageConnection = {
	__typename?: 'application_stageConnection'
	edges: Array<Application_StageEdge>
	pageInfo: PageInfo
}

export type Application_StageDeleteResponse = {
	__typename?: 'application_stageDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Application_Stage>
}

export type Application_StageEdge = {
	__typename?: 'application_stageEdge'
	cursor: Scalars['String']['output']
	node: Application_Stage
}

export type Application_StageFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Application_StageFilter>>
	created_at?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<UuidFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Application_StageFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Application_StageFilter>>
	status?: InputMaybe<StringFilter>
	updated_at?: InputMaybe<DatetimeFilter>
}

export type Application_StageInsertInput = {
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	status?: InputMaybe<Scalars['String']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
}

export type Application_StageInsertResponse = {
	__typename?: 'application_stageInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Application_Stage>
}

export type Application_StageOrderBy = {
	created_at?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	status?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
}

export type Application_StageUpdateInput = {
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	status?: InputMaybe<Scalars['String']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
}

export type Application_StageUpdateResponse = {
	__typename?: 'application_stageUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Application_Stage>
}

export type Article_Media = Node & {
	__typename?: 'article_media'
	article: Article
	article_id: Scalars['String']['output']
	created_at: Scalars['Datetime']['output']
	height?: Maybe<Scalars['BigInt']['output']>
	id: Scalars['UUID']['output']
	media_type: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	path: Scalars['String']['output']
	updated_at: Scalars['Datetime']['output']
	width?: Maybe<Scalars['BigInt']['output']>
}

export type Article_MediaConnection = {
	__typename?: 'article_mediaConnection'
	edges: Array<Article_MediaEdge>
	pageInfo: PageInfo
}

export type Article_MediaDeleteResponse = {
	__typename?: 'article_mediaDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Article_Media>
}

export type Article_MediaEdge = {
	__typename?: 'article_mediaEdge'
	cursor: Scalars['String']['output']
	node: Article_Media
}

export type Article_MediaFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Article_MediaFilter>>
	article_id?: InputMaybe<StringFilter>
	created_at?: InputMaybe<DatetimeFilter>
	height?: InputMaybe<BigIntFilter>
	id?: InputMaybe<UuidFilter>
	media_type?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Article_MediaFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Article_MediaFilter>>
	path?: InputMaybe<StringFilter>
	updated_at?: InputMaybe<DatetimeFilter>
	width?: InputMaybe<BigIntFilter>
}

export type Article_MediaInsertInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	height?: InputMaybe<Scalars['BigInt']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	media_type?: InputMaybe<Scalars['String']['input']>
	path?: InputMaybe<Scalars['String']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	width?: InputMaybe<Scalars['BigInt']['input']>
}

export type Article_MediaInsertResponse = {
	__typename?: 'article_mediaInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Article_Media>
}

export type Article_MediaOrderBy = {
	article_id?: InputMaybe<OrderByDirection>
	created_at?: InputMaybe<OrderByDirection>
	height?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	media_type?: InputMaybe<OrderByDirection>
	path?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
	width?: InputMaybe<OrderByDirection>
}

export type Article_MediaUpdateInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	height?: InputMaybe<Scalars['BigInt']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	media_type?: InputMaybe<Scalars['String']['input']>
	path?: InputMaybe<Scalars['String']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	width?: InputMaybe<Scalars['BigInt']['input']>
}

export type Article_MediaUpdateResponse = {
	__typename?: 'article_mediaUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Article_Media>
}

export type Article_Shares = Node & {
	__typename?: 'article_shares'
	article: Article
	article_id: Scalars['String']['output']
	created_at: Scalars['Datetime']['output']
	id: Scalars['UUID']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	total?: Maybe<Scalars['BigInt']['output']>
	updated_at: Scalars['Datetime']['output']
	user_id: Scalars['String']['output']
}

export type Article_SharesConnection = {
	__typename?: 'article_sharesConnection'
	edges: Array<Article_SharesEdge>
	pageInfo: PageInfo
}

export type Article_SharesDeleteResponse = {
	__typename?: 'article_sharesDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Article_Shares>
}

export type Article_SharesEdge = {
	__typename?: 'article_sharesEdge'
	cursor: Scalars['String']['output']
	node: Article_Shares
}

export type Article_SharesFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Article_SharesFilter>>
	article_id?: InputMaybe<StringFilter>
	created_at?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<UuidFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Article_SharesFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Article_SharesFilter>>
	total?: InputMaybe<BigIntFilter>
	updated_at?: InputMaybe<DatetimeFilter>
	user_id?: InputMaybe<StringFilter>
}

export type Article_SharesInsertInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	total?: InputMaybe<Scalars['BigInt']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Article_SharesInsertResponse = {
	__typename?: 'article_sharesInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Article_Shares>
}

export type Article_SharesOrderBy = {
	article_id?: InputMaybe<OrderByDirection>
	created_at?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	total?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
	user_id?: InputMaybe<OrderByDirection>
}

export type Article_SharesUpdateInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	total?: InputMaybe<Scalars['BigInt']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Article_SharesUpdateResponse = {
	__typename?: 'article_sharesUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Article_Shares>
}

export type Campaign_Claim_History = Node & {
	__typename?: 'campaign_claim_history'
	campaign_edition?: Maybe<Scalars['UUID']['output']>
	campaign_editions?: Maybe<Campaign_Editions>
	campaign_recipient_id?: Maybe<Scalars['UUID']['output']>
	campaign_recipients?: Maybe<Campaign_Recipients>
	created_at: Scalars['Datetime']['output']
	emailed_at?: Maybe<Scalars['Datetime']['output']>
	id: Scalars['UUID']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	review_email_sent?: Maybe<Scalars['Boolean']['output']>
	scanning_agent_id?: Maybe<Scalars['String']['output']>
	updated_at: Scalars['Datetime']['output']
	user?: Maybe<User>
}

export type Campaign_Claim_HistoryConnection = {
	__typename?: 'campaign_claim_historyConnection'
	edges: Array<Campaign_Claim_HistoryEdge>
	pageInfo: PageInfo
}

export type Campaign_Claim_HistoryDeleteResponse = {
	__typename?: 'campaign_claim_historyDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign_Claim_History>
}

export type Campaign_Claim_HistoryEdge = {
	__typename?: 'campaign_claim_historyEdge'
	cursor: Scalars['String']['output']
	node: Campaign_Claim_History
}

export type Campaign_Claim_HistoryFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Campaign_Claim_HistoryFilter>>
	campaign_edition?: InputMaybe<UuidFilter>
	campaign_recipient_id?: InputMaybe<UuidFilter>
	created_at?: InputMaybe<DatetimeFilter>
	emailed_at?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<UuidFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Campaign_Claim_HistoryFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Campaign_Claim_HistoryFilter>>
	review_email_sent?: InputMaybe<BooleanFilter>
	scanning_agent_id?: InputMaybe<StringFilter>
	updated_at?: InputMaybe<DatetimeFilter>
}

export type Campaign_Claim_HistoryInsertInput = {
	campaign_edition?: InputMaybe<Scalars['UUID']['input']>
	campaign_recipient_id?: InputMaybe<Scalars['UUID']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	emailed_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	review_email_sent?: InputMaybe<Scalars['Boolean']['input']>
	scanning_agent_id?: InputMaybe<Scalars['String']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
}

export type Campaign_Claim_HistoryInsertResponse = {
	__typename?: 'campaign_claim_historyInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign_Claim_History>
}

export type Campaign_Claim_HistoryOrderBy = {
	campaign_edition?: InputMaybe<OrderByDirection>
	campaign_recipient_id?: InputMaybe<OrderByDirection>
	created_at?: InputMaybe<OrderByDirection>
	emailed_at?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	review_email_sent?: InputMaybe<OrderByDirection>
	scanning_agent_id?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
}

export type Campaign_Claim_HistoryUpdateInput = {
	campaign_edition?: InputMaybe<Scalars['UUID']['input']>
	campaign_recipient_id?: InputMaybe<Scalars['UUID']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	emailed_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	review_email_sent?: InputMaybe<Scalars['Boolean']['input']>
	scanning_agent_id?: InputMaybe<Scalars['String']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
}

export type Campaign_Claim_HistoryUpdateResponse = {
	__typename?: 'campaign_claim_historyUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign_Claim_History>
}

export type Campaign_Editions = Node & {
	__typename?: 'campaign_editions'
	campaign_claim_historyCollection?: Maybe<Campaign_Claim_HistoryConnection>
	campaign_recipientsCollection?: Maybe<Campaign_RecipientsConnection>
	campaign_scanning_agentsCollection?: Maybe<Campaign_Scanning_AgentsConnection>
	created_at: Scalars['Datetime']['output']
	created_by?: Maybe<Scalars['String']['output']>
	description: Scalars['String']['output']
	expires_at: Scalars['Datetime']['output']
	id: Scalars['UUID']['output']
	month?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	picture: Scalars['String']['output']
	scanning_agent_invitationsCollection?: Maybe<Scanning_Agent_InvitationsConnection>
	slug?: Maybe<Scalars['String']['output']>
	starts_at: Scalars['Datetime']['output']
	title: Scalars['String']['output']
	type: Scalars['String']['output']
	updated_at: Scalars['Datetime']['output']
	url?: Maybe<Scalars['String']['output']>
	user?: Maybe<User>
	year?: Maybe<Scalars['String']['output']>
}

export type Campaign_EditionsCampaign_Claim_HistoryCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Campaign_Claim_HistoryFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Campaign_Claim_HistoryOrderBy>>
}

export type Campaign_EditionsCampaign_RecipientsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Campaign_RecipientsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Campaign_RecipientsOrderBy>>
}

export type Campaign_EditionsCampaign_Scanning_AgentsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Campaign_Scanning_AgentsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Campaign_Scanning_AgentsOrderBy>>
}

export type Campaign_EditionsScanning_Agent_InvitationsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Scanning_Agent_InvitationsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Scanning_Agent_InvitationsOrderBy>>
}

export type Campaign_EditionsConnection = {
	__typename?: 'campaign_editionsConnection'
	edges: Array<Campaign_EditionsEdge>
	pageInfo: PageInfo
}

export type Campaign_EditionsDeleteResponse = {
	__typename?: 'campaign_editionsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign_Editions>
}

export type Campaign_EditionsEdge = {
	__typename?: 'campaign_editionsEdge'
	cursor: Scalars['String']['output']
	node: Campaign_Editions
}

export type Campaign_EditionsFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Campaign_EditionsFilter>>
	created_at?: InputMaybe<DatetimeFilter>
	created_by?: InputMaybe<StringFilter>
	description?: InputMaybe<StringFilter>
	expires_at?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<UuidFilter>
	month?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Campaign_EditionsFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Campaign_EditionsFilter>>
	picture?: InputMaybe<StringFilter>
	slug?: InputMaybe<StringFilter>
	starts_at?: InputMaybe<DatetimeFilter>
	title?: InputMaybe<StringFilter>
	type?: InputMaybe<StringFilter>
	updated_at?: InputMaybe<DatetimeFilter>
	url?: InputMaybe<StringFilter>
	year?: InputMaybe<StringFilter>
}

export type Campaign_EditionsInsertInput = {
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	created_by?: InputMaybe<Scalars['String']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	expires_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	month?: InputMaybe<Scalars['String']['input']>
	picture?: InputMaybe<Scalars['String']['input']>
	slug?: InputMaybe<Scalars['String']['input']>
	starts_at?: InputMaybe<Scalars['Datetime']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	type?: InputMaybe<Scalars['String']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	url?: InputMaybe<Scalars['String']['input']>
	year?: InputMaybe<Scalars['String']['input']>
}

export type Campaign_EditionsInsertResponse = {
	__typename?: 'campaign_editionsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign_Editions>
}

export type Campaign_EditionsOrderBy = {
	created_at?: InputMaybe<OrderByDirection>
	created_by?: InputMaybe<OrderByDirection>
	description?: InputMaybe<OrderByDirection>
	expires_at?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	month?: InputMaybe<OrderByDirection>
	picture?: InputMaybe<OrderByDirection>
	slug?: InputMaybe<OrderByDirection>
	starts_at?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	type?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
	url?: InputMaybe<OrderByDirection>
	year?: InputMaybe<OrderByDirection>
}

export type Campaign_EditionsUpdateInput = {
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	created_by?: InputMaybe<Scalars['String']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	expires_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	month?: InputMaybe<Scalars['String']['input']>
	picture?: InputMaybe<Scalars['String']['input']>
	slug?: InputMaybe<Scalars['String']['input']>
	starts_at?: InputMaybe<Scalars['Datetime']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	type?: InputMaybe<Scalars['String']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	url?: InputMaybe<Scalars['String']['input']>
	year?: InputMaybe<Scalars['String']['input']>
}

export type Campaign_EditionsUpdateResponse = {
	__typename?: 'campaign_editionsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign_Editions>
}

export type Campaign_Recipients = Node & {
	__typename?: 'campaign_recipients'
	campaign_claim_historyCollection?: Maybe<Campaign_Claim_HistoryConnection>
	campaign_edition_id: Scalars['UUID']['output']
	campaign_editions: Campaign_Editions
	chillPackCompany?: Maybe<ChillPackCompany>
	company?: Maybe<Scalars['String']['output']>
	created_at: Scalars['Datetime']['output']
	email: Scalars['String']['output']
	email_verified: Scalars['Boolean']['output']
	first_name: Scalars['String']['output']
	full_name?: Maybe<Scalars['String']['output']>
	id: Scalars['UUID']['output']
	invite_accepted_at?: Maybe<Scalars['Datetime']['output']>
	invited_at?: Maybe<Scalars['Datetime']['output']>
	invited_by?: Maybe<Scalars['String']['output']>
	last_name: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	pin?: Maybe<Scalars['String']['output']>
	updated_at: Scalars['Datetime']['output']
	user?: Maybe<User>
	user_id?: Maybe<Scalars['String']['output']>
}

export type Campaign_RecipientsCampaign_Claim_HistoryCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Campaign_Claim_HistoryFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Campaign_Claim_HistoryOrderBy>>
}

export type Campaign_RecipientsConnection = {
	__typename?: 'campaign_recipientsConnection'
	edges: Array<Campaign_RecipientsEdge>
	pageInfo: PageInfo
}

export type Campaign_RecipientsDeleteResponse = {
	__typename?: 'campaign_recipientsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign_Recipients>
}

export type Campaign_RecipientsEdge = {
	__typename?: 'campaign_recipientsEdge'
	cursor: Scalars['String']['output']
	node: Campaign_Recipients
}

export type Campaign_RecipientsFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Campaign_RecipientsFilter>>
	campaign_edition_id?: InputMaybe<UuidFilter>
	company?: InputMaybe<StringFilter>
	created_at?: InputMaybe<DatetimeFilter>
	email?: InputMaybe<StringFilter>
	email_verified?: InputMaybe<BooleanFilter>
	first_name?: InputMaybe<StringFilter>
	full_name?: InputMaybe<StringFilter>
	id?: InputMaybe<UuidFilter>
	invite_accepted_at?: InputMaybe<DatetimeFilter>
	invited_at?: InputMaybe<DatetimeFilter>
	invited_by?: InputMaybe<StringFilter>
	last_name?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Campaign_RecipientsFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Campaign_RecipientsFilter>>
	pin?: InputMaybe<StringFilter>
	updated_at?: InputMaybe<DatetimeFilter>
	user_id?: InputMaybe<StringFilter>
}

export type Campaign_RecipientsInsertInput = {
	campaign_edition_id?: InputMaybe<Scalars['UUID']['input']>
	company?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	email_verified?: InputMaybe<Scalars['Boolean']['input']>
	first_name?: InputMaybe<Scalars['String']['input']>
	full_name?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	invite_accepted_at?: InputMaybe<Scalars['Datetime']['input']>
	invited_at?: InputMaybe<Scalars['Datetime']['input']>
	invited_by?: InputMaybe<Scalars['String']['input']>
	last_name?: InputMaybe<Scalars['String']['input']>
	pin?: InputMaybe<Scalars['String']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Campaign_RecipientsInsertResponse = {
	__typename?: 'campaign_recipientsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign_Recipients>
}

export type Campaign_RecipientsOrderBy = {
	campaign_edition_id?: InputMaybe<OrderByDirection>
	company?: InputMaybe<OrderByDirection>
	created_at?: InputMaybe<OrderByDirection>
	email?: InputMaybe<OrderByDirection>
	email_verified?: InputMaybe<OrderByDirection>
	first_name?: InputMaybe<OrderByDirection>
	full_name?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	invite_accepted_at?: InputMaybe<OrderByDirection>
	invited_at?: InputMaybe<OrderByDirection>
	invited_by?: InputMaybe<OrderByDirection>
	last_name?: InputMaybe<OrderByDirection>
	pin?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
	user_id?: InputMaybe<OrderByDirection>
}

export type Campaign_RecipientsUpdateInput = {
	campaign_edition_id?: InputMaybe<Scalars['UUID']['input']>
	company?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	email_verified?: InputMaybe<Scalars['Boolean']['input']>
	first_name?: InputMaybe<Scalars['String']['input']>
	full_name?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	invite_accepted_at?: InputMaybe<Scalars['Datetime']['input']>
	invited_at?: InputMaybe<Scalars['Datetime']['input']>
	invited_by?: InputMaybe<Scalars['String']['input']>
	last_name?: InputMaybe<Scalars['String']['input']>
	pin?: InputMaybe<Scalars['String']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Campaign_RecipientsUpdateResponse = {
	__typename?: 'campaign_recipientsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign_Recipients>
}

export type Campaign_Scanning_Agents = Node & {
	__typename?: 'campaign_scanning_agents'
	campaign?: Maybe<Scalars['UUID']['output']>
	campaign_editions?: Maybe<Campaign_Editions>
	id: Scalars['UUID']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	scanning_agent?: Maybe<Scalars['String']['output']>
	user?: Maybe<User>
}

export type Campaign_Scanning_AgentsConnection = {
	__typename?: 'campaign_scanning_agentsConnection'
	edges: Array<Campaign_Scanning_AgentsEdge>
	pageInfo: PageInfo
}

export type Campaign_Scanning_AgentsDeleteResponse = {
	__typename?: 'campaign_scanning_agentsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign_Scanning_Agents>
}

export type Campaign_Scanning_AgentsEdge = {
	__typename?: 'campaign_scanning_agentsEdge'
	cursor: Scalars['String']['output']
	node: Campaign_Scanning_Agents
}

export type Campaign_Scanning_AgentsFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Campaign_Scanning_AgentsFilter>>
	campaign?: InputMaybe<UuidFilter>
	id?: InputMaybe<UuidFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Campaign_Scanning_AgentsFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Campaign_Scanning_AgentsFilter>>
	scanning_agent?: InputMaybe<StringFilter>
}

export type Campaign_Scanning_AgentsInsertInput = {
	campaign?: InputMaybe<Scalars['UUID']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	scanning_agent?: InputMaybe<Scalars['String']['input']>
}

export type Campaign_Scanning_AgentsInsertResponse = {
	__typename?: 'campaign_scanning_agentsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign_Scanning_Agents>
}

export type Campaign_Scanning_AgentsOrderBy = {
	campaign?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	scanning_agent?: InputMaybe<OrderByDirection>
}

export type Campaign_Scanning_AgentsUpdateInput = {
	campaign?: InputMaybe<Scalars['UUID']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	scanning_agent?: InputMaybe<Scalars['String']['input']>
}

export type Campaign_Scanning_AgentsUpdateResponse = {
	__typename?: 'campaign_scanning_agentsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Campaign_Scanning_Agents>
}

export enum Campaign_Type {
	All = 'ALL',
	Chillpack = 'CHILLPACK',
	StudentsKit = 'STUDENTS_KIT',
}

/** Boolean expression comparing fields on type "campaign_type" */
export type Campaign_TypeFilter = {
	eq?: InputMaybe<Campaign_Type>
	in?: InputMaybe<Array<Campaign_Type>>
	is?: InputMaybe<FilterIs>
	neq?: InputMaybe<Campaign_Type>
}

export type Companies = Node & {
	__typename?: 'companies'
	ADRESA_COMPLETA?: Maybe<Scalars['String']['output']>
	ADR_APARTAMENT?: Maybe<Scalars['String']['output']>
	ADR_BLOC?: Maybe<Scalars['String']['output']>
	ADR_COD_POSTAL?: Maybe<Scalars['String']['output']>
	ADR_COMPLETARE?: Maybe<Scalars['String']['output']>
	ADR_DEN_NR_STRADA?: Maybe<Scalars['String']['output']>
	ADR_DEN_STRADA?: Maybe<Scalars['String']['output']>
	ADR_ETAJ?: Maybe<Scalars['String']['output']>
	ADR_JUDET?: Maybe<Scalars['String']['output']>
	ADR_LOCALITATE?: Maybe<Scalars['String']['output']>
	ADR_SCARA?: Maybe<Scalars['String']['output']>
	ADR_SECTOR?: Maybe<Scalars['String']['output']>
	ADR_TARA?: Maybe<Scalars['String']['output']>
	COD_INMATRICULARE: Scalars['String']['output']
	CUI: Scalars['String']['output']
	DENUMIRE?: Maybe<Scalars['String']['output']>
	EUID: Scalars['String']['output']
	STARE_FIRMA: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
}

export type CompaniesConnection = {
	__typename?: 'companiesConnection'
	edges: Array<CompaniesEdge>
	pageInfo: PageInfo
}

export type CompaniesDeleteResponse = {
	__typename?: 'companiesDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Companies>
}

export type CompaniesEdge = {
	__typename?: 'companiesEdge'
	cursor: Scalars['String']['output']
	node: Companies
}

export type CompaniesFilter = {
	ADRESA_COMPLETA?: InputMaybe<StringFilter>
	ADR_APARTAMENT?: InputMaybe<StringFilter>
	ADR_BLOC?: InputMaybe<StringFilter>
	ADR_COD_POSTAL?: InputMaybe<StringFilter>
	ADR_COMPLETARE?: InputMaybe<StringFilter>
	ADR_DEN_NR_STRADA?: InputMaybe<StringFilter>
	ADR_DEN_STRADA?: InputMaybe<StringFilter>
	ADR_ETAJ?: InputMaybe<StringFilter>
	ADR_JUDET?: InputMaybe<StringFilter>
	ADR_LOCALITATE?: InputMaybe<StringFilter>
	ADR_SCARA?: InputMaybe<StringFilter>
	ADR_SECTOR?: InputMaybe<StringFilter>
	ADR_TARA?: InputMaybe<StringFilter>
	COD_INMATRICULARE?: InputMaybe<StringFilter>
	CUI?: InputMaybe<StringFilter>
	DENUMIRE?: InputMaybe<StringFilter>
	EUID?: InputMaybe<StringFilter>
	STARE_FIRMA?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<CompaniesFilter>>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<CompaniesFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<CompaniesFilter>>
}

export type CompaniesInsertInput = {
	ADRESA_COMPLETA?: InputMaybe<Scalars['String']['input']>
	ADR_APARTAMENT?: InputMaybe<Scalars['String']['input']>
	ADR_BLOC?: InputMaybe<Scalars['String']['input']>
	ADR_COD_POSTAL?: InputMaybe<Scalars['String']['input']>
	ADR_COMPLETARE?: InputMaybe<Scalars['String']['input']>
	ADR_DEN_NR_STRADA?: InputMaybe<Scalars['String']['input']>
	ADR_DEN_STRADA?: InputMaybe<Scalars['String']['input']>
	ADR_ETAJ?: InputMaybe<Scalars['String']['input']>
	ADR_JUDET?: InputMaybe<Scalars['String']['input']>
	ADR_LOCALITATE?: InputMaybe<Scalars['String']['input']>
	ADR_SCARA?: InputMaybe<Scalars['String']['input']>
	ADR_SECTOR?: InputMaybe<Scalars['String']['input']>
	ADR_TARA?: InputMaybe<Scalars['String']['input']>
	COD_INMATRICULARE?: InputMaybe<Scalars['String']['input']>
	CUI?: InputMaybe<Scalars['String']['input']>
	DENUMIRE?: InputMaybe<Scalars['String']['input']>
	EUID?: InputMaybe<Scalars['String']['input']>
	STARE_FIRMA?: InputMaybe<Scalars['String']['input']>
}

export type CompaniesInsertResponse = {
	__typename?: 'companiesInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Companies>
}

export type CompaniesOrderBy = {
	ADRESA_COMPLETA?: InputMaybe<OrderByDirection>
	ADR_APARTAMENT?: InputMaybe<OrderByDirection>
	ADR_BLOC?: InputMaybe<OrderByDirection>
	ADR_COD_POSTAL?: InputMaybe<OrderByDirection>
	ADR_COMPLETARE?: InputMaybe<OrderByDirection>
	ADR_DEN_NR_STRADA?: InputMaybe<OrderByDirection>
	ADR_DEN_STRADA?: InputMaybe<OrderByDirection>
	ADR_ETAJ?: InputMaybe<OrderByDirection>
	ADR_JUDET?: InputMaybe<OrderByDirection>
	ADR_LOCALITATE?: InputMaybe<OrderByDirection>
	ADR_SCARA?: InputMaybe<OrderByDirection>
	ADR_SECTOR?: InputMaybe<OrderByDirection>
	ADR_TARA?: InputMaybe<OrderByDirection>
	COD_INMATRICULARE?: InputMaybe<OrderByDirection>
	CUI?: InputMaybe<OrderByDirection>
	DENUMIRE?: InputMaybe<OrderByDirection>
	EUID?: InputMaybe<OrderByDirection>
	STARE_FIRMA?: InputMaybe<OrderByDirection>
}

export type CompaniesUpdateInput = {
	ADRESA_COMPLETA?: InputMaybe<Scalars['String']['input']>
	ADR_APARTAMENT?: InputMaybe<Scalars['String']['input']>
	ADR_BLOC?: InputMaybe<Scalars['String']['input']>
	ADR_COD_POSTAL?: InputMaybe<Scalars['String']['input']>
	ADR_COMPLETARE?: InputMaybe<Scalars['String']['input']>
	ADR_DEN_NR_STRADA?: InputMaybe<Scalars['String']['input']>
	ADR_DEN_STRADA?: InputMaybe<Scalars['String']['input']>
	ADR_ETAJ?: InputMaybe<Scalars['String']['input']>
	ADR_JUDET?: InputMaybe<Scalars['String']['input']>
	ADR_LOCALITATE?: InputMaybe<Scalars['String']['input']>
	ADR_SCARA?: InputMaybe<Scalars['String']['input']>
	ADR_SECTOR?: InputMaybe<Scalars['String']['input']>
	ADR_TARA?: InputMaybe<Scalars['String']['input']>
	COD_INMATRICULARE?: InputMaybe<Scalars['String']['input']>
	CUI?: InputMaybe<Scalars['String']['input']>
	DENUMIRE?: InputMaybe<Scalars['String']['input']>
	EUID?: InputMaybe<Scalars['String']['input']>
	STARE_FIRMA?: InputMaybe<Scalars['String']['input']>
}

export type CompaniesUpdateResponse = {
	__typename?: 'companiesUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Companies>
}

export type Custom_Notifications = Node & {
	__typename?: 'custom_notifications'
	companies?: Maybe<Scalars['JSON']['output']>
	contents?: Maybe<Scalars['JSON']['output']>
	created_at: Scalars['Datetime']['output']
	exclude_android?: Maybe<Scalars['Boolean']['output']>
	exclude_ios: Scalars['Boolean']['output']
	external_ids?: Maybe<Scalars['JSON']['output']>
	headings?: Maybe<Scalars['JSON']['output']>
	id: Scalars['BigInt']['output']
	max_recipients: Scalars['BigInt']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	segment_id?: Maybe<Scalars['UUID']['output']>
	segments?: Maybe<Segments>
	students?: Maybe<Scalars['JSON']['output']>
}

export type Custom_NotificationsConnection = {
	__typename?: 'custom_notificationsConnection'
	edges: Array<Custom_NotificationsEdge>
	pageInfo: PageInfo
}

export type Custom_NotificationsDeleteResponse = {
	__typename?: 'custom_notificationsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Custom_Notifications>
}

export type Custom_NotificationsEdge = {
	__typename?: 'custom_notificationsEdge'
	cursor: Scalars['String']['output']
	node: Custom_Notifications
}

export type Custom_NotificationsFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Custom_NotificationsFilter>>
	created_at?: InputMaybe<DatetimeFilter>
	exclude_android?: InputMaybe<BooleanFilter>
	exclude_ios?: InputMaybe<BooleanFilter>
	id?: InputMaybe<BigIntFilter>
	max_recipients?: InputMaybe<BigIntFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Custom_NotificationsFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Custom_NotificationsFilter>>
	segment_id?: InputMaybe<UuidFilter>
}

export type Custom_NotificationsInsertInput = {
	companies?: InputMaybe<Scalars['JSON']['input']>
	contents?: InputMaybe<Scalars['JSON']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	exclude_android?: InputMaybe<Scalars['Boolean']['input']>
	exclude_ios?: InputMaybe<Scalars['Boolean']['input']>
	external_ids?: InputMaybe<Scalars['JSON']['input']>
	headings?: InputMaybe<Scalars['JSON']['input']>
	max_recipients?: InputMaybe<Scalars['BigInt']['input']>
	segment_id?: InputMaybe<Scalars['UUID']['input']>
	students?: InputMaybe<Scalars['JSON']['input']>
}

export type Custom_NotificationsInsertResponse = {
	__typename?: 'custom_notificationsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Custom_Notifications>
}

export type Custom_NotificationsOrderBy = {
	created_at?: InputMaybe<OrderByDirection>
	exclude_android?: InputMaybe<OrderByDirection>
	exclude_ios?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	max_recipients?: InputMaybe<OrderByDirection>
	segment_id?: InputMaybe<OrderByDirection>
}

export type Custom_NotificationsUpdateInput = {
	companies?: InputMaybe<Scalars['JSON']['input']>
	contents?: InputMaybe<Scalars['JSON']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	exclude_android?: InputMaybe<Scalars['Boolean']['input']>
	exclude_ios?: InputMaybe<Scalars['Boolean']['input']>
	external_ids?: InputMaybe<Scalars['JSON']['input']>
	headings?: InputMaybe<Scalars['JSON']['input']>
	max_recipients?: InputMaybe<Scalars['BigInt']['input']>
	segment_id?: InputMaybe<Scalars['UUID']['input']>
	students?: InputMaybe<Scalars['JSON']['input']>
}

export type Custom_NotificationsUpdateResponse = {
	__typename?: 'custom_notificationsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Custom_Notifications>
}

export type Exportchillpackrecipients = Node & {
	__typename?: 'exportchillpackrecipients'
	chillpackrecipientclaim?: Maybe<Scalars['String']['output']>
	companyname?: Maybe<Scalars['String']['output']>
	createdat?: Maybe<Scalars['Datetime']['output']>
	email: Scalars['String']['output']
	emailverified?: Maybe<Scalars['Boolean']['output']>
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	recipientfirstname?: Maybe<Scalars['String']['output']>
	recipientlastname?: Maybe<Scalars['String']['output']>
}

export type ExportchillpackrecipientsConnection = {
	__typename?: 'exportchillpackrecipientsConnection'
	edges: Array<ExportchillpackrecipientsEdge>
	pageInfo: PageInfo
}

export type ExportchillpackrecipientsDeleteResponse = {
	__typename?: 'exportchillpackrecipientsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Exportchillpackrecipients>
}

export type ExportchillpackrecipientsEdge = {
	__typename?: 'exportchillpackrecipientsEdge'
	cursor: Scalars['String']['output']
	node: Exportchillpackrecipients
}

export type ExportchillpackrecipientsFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ExportchillpackrecipientsFilter>>
	chillpackrecipientclaim?: InputMaybe<StringFilter>
	companyname?: InputMaybe<StringFilter>
	createdat?: InputMaybe<DatetimeFilter>
	email?: InputMaybe<StringFilter>
	emailverified?: InputMaybe<BooleanFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ExportchillpackrecipientsFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ExportchillpackrecipientsFilter>>
	recipientfirstname?: InputMaybe<StringFilter>
	recipientlastname?: InputMaybe<StringFilter>
}

export type ExportchillpackrecipientsInsertInput = {
	chillpackrecipientclaim?: InputMaybe<Scalars['String']['input']>
	companyname?: InputMaybe<Scalars['String']['input']>
	createdat?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	emailverified?: InputMaybe<Scalars['Boolean']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	recipientfirstname?: InputMaybe<Scalars['String']['input']>
	recipientlastname?: InputMaybe<Scalars['String']['input']>
}

export type ExportchillpackrecipientsInsertResponse = {
	__typename?: 'exportchillpackrecipientsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Exportchillpackrecipients>
}

export type ExportchillpackrecipientsOrderBy = {
	chillpackrecipientclaim?: InputMaybe<OrderByDirection>
	companyname?: InputMaybe<OrderByDirection>
	createdat?: InputMaybe<OrderByDirection>
	email?: InputMaybe<OrderByDirection>
	emailverified?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	recipientfirstname?: InputMaybe<OrderByDirection>
	recipientlastname?: InputMaybe<OrderByDirection>
}

export type ExportchillpackrecipientsUpdateInput = {
	chillpackrecipientclaim?: InputMaybe<Scalars['String']['input']>
	companyname?: InputMaybe<Scalars['String']['input']>
	createdat?: InputMaybe<Scalars['Datetime']['input']>
	email?: InputMaybe<Scalars['String']['input']>
	emailverified?: InputMaybe<Scalars['Boolean']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	recipientfirstname?: InputMaybe<Scalars['String']['input']>
	recipientlastname?: InputMaybe<Scalars['String']['input']>
}

export type ExportchillpackrecipientsUpdateResponse = {
	__typename?: 'exportchillpackrecipientsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Exportchillpackrecipients>
}

export type Exportstudentkitview = Node & {
	__typename?: 'exportstudentkitview'
	email: Scalars['String']['output']
	faculty: Scalars['String']['output']
	firstname: Scalars['String']['output']
	hasaccount: Scalars['String']['output']
	lastname: Scalars['String']['output']
	location: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	scandate: Scalars['Datetime']['output']
	scanningagentemail: Scalars['String']['output']
	scanningagentname: Scalars['String']['output']
	specialization: Scalars['String']['output']
	university: Scalars['String']['output']
}

export type ExportstudentkitviewConnection = {
	__typename?: 'exportstudentkitviewConnection'
	edges: Array<ExportstudentkitviewEdge>
	pageInfo: PageInfo
}

export type ExportstudentkitviewDeleteResponse = {
	__typename?: 'exportstudentkitviewDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Exportstudentkitview>
}

export type ExportstudentkitviewEdge = {
	__typename?: 'exportstudentkitviewEdge'
	cursor: Scalars['String']['output']
	node: Exportstudentkitview
}

export type ExportstudentkitviewFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<ExportstudentkitviewFilter>>
	email?: InputMaybe<StringFilter>
	faculty?: InputMaybe<StringFilter>
	firstname?: InputMaybe<StringFilter>
	hasaccount?: InputMaybe<StringFilter>
	lastname?: InputMaybe<StringFilter>
	location?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<ExportstudentkitviewFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<ExportstudentkitviewFilter>>
	scandate?: InputMaybe<DatetimeFilter>
	scanningagentemail?: InputMaybe<StringFilter>
	scanningagentname?: InputMaybe<StringFilter>
	specialization?: InputMaybe<StringFilter>
	university?: InputMaybe<StringFilter>
}

export type ExportstudentkitviewInsertInput = {
	email?: InputMaybe<Scalars['String']['input']>
	faculty?: InputMaybe<Scalars['String']['input']>
	firstname?: InputMaybe<Scalars['String']['input']>
	hasaccount?: InputMaybe<Scalars['String']['input']>
	lastname?: InputMaybe<Scalars['String']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	scandate?: InputMaybe<Scalars['Datetime']['input']>
	scanningagentemail?: InputMaybe<Scalars['String']['input']>
	scanningagentname?: InputMaybe<Scalars['String']['input']>
	specialization?: InputMaybe<Scalars['String']['input']>
	university?: InputMaybe<Scalars['String']['input']>
}

export type ExportstudentkitviewInsertResponse = {
	__typename?: 'exportstudentkitviewInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Exportstudentkitview>
}

export type ExportstudentkitviewOrderBy = {
	email?: InputMaybe<OrderByDirection>
	faculty?: InputMaybe<OrderByDirection>
	firstname?: InputMaybe<OrderByDirection>
	hasaccount?: InputMaybe<OrderByDirection>
	lastname?: InputMaybe<OrderByDirection>
	location?: InputMaybe<OrderByDirection>
	scandate?: InputMaybe<OrderByDirection>
	scanningagentemail?: InputMaybe<OrderByDirection>
	scanningagentname?: InputMaybe<OrderByDirection>
	specialization?: InputMaybe<OrderByDirection>
	university?: InputMaybe<OrderByDirection>
}

export type ExportstudentkitviewUpdateInput = {
	email?: InputMaybe<Scalars['String']['input']>
	faculty?: InputMaybe<Scalars['String']['input']>
	firstname?: InputMaybe<Scalars['String']['input']>
	hasaccount?: InputMaybe<Scalars['String']['input']>
	lastname?: InputMaybe<Scalars['String']['input']>
	location?: InputMaybe<Scalars['String']['input']>
	scandate?: InputMaybe<Scalars['Datetime']['input']>
	scanningagentemail?: InputMaybe<Scalars['String']['input']>
	scanningagentname?: InputMaybe<Scalars['String']['input']>
	specialization?: InputMaybe<Scalars['String']['input']>
	university?: InputMaybe<Scalars['String']['input']>
}

export type ExportstudentkitviewUpdateResponse = {
	__typename?: 'exportstudentkitviewUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Exportstudentkitview>
}

export type Favorite_User_Articles = Node & {
	__typename?: 'favorite_user_articles'
	article: Article
	article_id: Scalars['String']['output']
	created_at: Scalars['Datetime']['output']
	id: Scalars['UUID']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	updated_at: Scalars['Datetime']['output']
	user_id: Scalars['String']['output']
}

export type Favorite_User_ArticlesConnection = {
	__typename?: 'favorite_user_articlesConnection'
	edges: Array<Favorite_User_ArticlesEdge>
	pageInfo: PageInfo
}

export type Favorite_User_ArticlesDeleteResponse = {
	__typename?: 'favorite_user_articlesDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Favorite_User_Articles>
}

export type Favorite_User_ArticlesEdge = {
	__typename?: 'favorite_user_articlesEdge'
	cursor: Scalars['String']['output']
	node: Favorite_User_Articles
}

export type Favorite_User_ArticlesFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Favorite_User_ArticlesFilter>>
	article_id?: InputMaybe<StringFilter>
	created_at?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<UuidFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Favorite_User_ArticlesFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Favorite_User_ArticlesFilter>>
	updated_at?: InputMaybe<DatetimeFilter>
	user_id?: InputMaybe<StringFilter>
}

export type Favorite_User_ArticlesInsertInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Favorite_User_ArticlesInsertResponse = {
	__typename?: 'favorite_user_articlesInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Favorite_User_Articles>
}

export type Favorite_User_ArticlesOrderBy = {
	article_id?: InputMaybe<OrderByDirection>
	created_at?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
	user_id?: InputMaybe<OrderByDirection>
}

export type Favorite_User_ArticlesUpdateInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Favorite_User_ArticlesUpdateResponse = {
	__typename?: 'favorite_user_articlesUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Favorite_User_Articles>
}

export type Feedtags = Node & {
	__typename?: 'feedtags'
	can_vote?: Maybe<Scalars['Boolean']['output']>
	id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	title?: Maybe<Scalars['String']['output']>
	unique_identifier?: Maybe<Scalars['String']['output']>
	votes?: Maybe<Scalars['Int']['output']>
}

export type FeedtagsConnection = {
	__typename?: 'feedtagsConnection'
	edges: Array<FeedtagsEdge>
	pageInfo: PageInfo
}

export type FeedtagsDeleteResponse = {
	__typename?: 'feedtagsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Feedtags>
}

export type FeedtagsEdge = {
	__typename?: 'feedtagsEdge'
	cursor: Scalars['String']['output']
	node: Feedtags
}

export type FeedtagsFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<FeedtagsFilter>>
	can_vote?: InputMaybe<BooleanFilter>
	id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<FeedtagsFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<FeedtagsFilter>>
	title?: InputMaybe<StringFilter>
	unique_identifier?: InputMaybe<StringFilter>
	votes?: InputMaybe<IntFilter>
}

export type FeedtagsInsertInput = {
	can_vote?: InputMaybe<Scalars['Boolean']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	unique_identifier?: InputMaybe<Scalars['String']['input']>
	votes?: InputMaybe<Scalars['Int']['input']>
}

export type FeedtagsInsertResponse = {
	__typename?: 'feedtagsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Feedtags>
}

export type FeedtagsOrderBy = {
	can_vote?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	title?: InputMaybe<OrderByDirection>
	unique_identifier?: InputMaybe<OrderByDirection>
	votes?: InputMaybe<OrderByDirection>
}

export type FeedtagsUpdateInput = {
	can_vote?: InputMaybe<Scalars['Boolean']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	unique_identifier?: InputMaybe<Scalars['String']['input']>
	votes?: InputMaybe<Scalars['Int']['input']>
}

export type FeedtagsUpdateResponse = {
	__typename?: 'feedtagsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Feedtags>
}

export type Liked_User_Articles = Node & {
	__typename?: 'liked_user_articles'
	article: Article
	article_id: Scalars['String']['output']
	created_at: Scalars['Datetime']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	updated_at: Scalars['Datetime']['output']
	user_id: Scalars['String']['output']
}

export type Liked_User_ArticlesConnection = {
	__typename?: 'liked_user_articlesConnection'
	edges: Array<Liked_User_ArticlesEdge>
	pageInfo: PageInfo
}

export type Liked_User_ArticlesDeleteResponse = {
	__typename?: 'liked_user_articlesDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Liked_User_Articles>
}

export type Liked_User_ArticlesEdge = {
	__typename?: 'liked_user_articlesEdge'
	cursor: Scalars['String']['output']
	node: Liked_User_Articles
}

export type Liked_User_ArticlesFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Liked_User_ArticlesFilter>>
	article_id?: InputMaybe<StringFilter>
	created_at?: InputMaybe<DatetimeFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Liked_User_ArticlesFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Liked_User_ArticlesFilter>>
	updated_at?: InputMaybe<DatetimeFilter>
	user_id?: InputMaybe<StringFilter>
}

export type Liked_User_ArticlesInsertInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Liked_User_ArticlesInsertResponse = {
	__typename?: 'liked_user_articlesInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Liked_User_Articles>
}

export type Liked_User_ArticlesOrderBy = {
	article_id?: InputMaybe<OrderByDirection>
	created_at?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
	user_id?: InputMaybe<OrderByDirection>
}

export type Liked_User_ArticlesUpdateInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Liked_User_ArticlesUpdateResponse = {
	__typename?: 'liked_user_articlesUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Liked_User_Articles>
}

export type Notifications = Node & {
	__typename?: 'notifications'
	contents: Scalars['JSON']['output']
	converted: Scalars['BigInt']['output']
	created_at: Scalars['Datetime']['output']
	data?: Maybe<Scalars['JSON']['output']>
	errored: Scalars['BigInt']['output']
	excluded_segments: Array<Maybe<Scalars['String']['output']>>
	failed: Scalars['BigInt']['output']
	headings: Scalars['JSON']['output']
	id: Scalars['UUID']['output']
	include_aliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>
	include_external_user_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>
	include_player_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>
	include_unsubscribed: Scalars['Boolean']['output']
	included_segments: Array<Maybe<Scalars['String']['output']>>
	name?: Maybe<Scalars['String']['output']>
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	platform_delivery_stats: Scalars['JSON']['output']
	received?: Maybe<Scalars['BigInt']['output']>
	seen_by_users: Array<Maybe<Scalars['String']['output']>>
	subtitle?: Maybe<Scalars['JSON']['output']>
	successful: Scalars['BigInt']['output']
	updated_at: Scalars['Datetime']['output']
}

export type NotificationsConnection = {
	__typename?: 'notificationsConnection'
	edges: Array<NotificationsEdge>
	pageInfo: PageInfo
}

export type NotificationsDeleteResponse = {
	__typename?: 'notificationsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Notifications>
}

export type NotificationsEdge = {
	__typename?: 'notificationsEdge'
	cursor: Scalars['String']['output']
	node: Notifications
}

export type NotificationsFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<NotificationsFilter>>
	converted?: InputMaybe<BigIntFilter>
	created_at?: InputMaybe<DatetimeFilter>
	errored?: InputMaybe<BigIntFilter>
	excluded_segments?: InputMaybe<StringListFilter>
	failed?: InputMaybe<BigIntFilter>
	id?: InputMaybe<UuidFilter>
	include_aliases?: InputMaybe<StringListFilter>
	include_external_user_ids?: InputMaybe<StringListFilter>
	include_player_ids?: InputMaybe<StringListFilter>
	include_unsubscribed?: InputMaybe<BooleanFilter>
	included_segments?: InputMaybe<StringListFilter>
	name?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<NotificationsFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<NotificationsFilter>>
	received?: InputMaybe<BigIntFilter>
	seen_by_users?: InputMaybe<StringListFilter>
	successful?: InputMaybe<BigIntFilter>
	updated_at?: InputMaybe<DatetimeFilter>
}

export type NotificationsInsertInput = {
	contents?: InputMaybe<Scalars['JSON']['input']>
	converted?: InputMaybe<Scalars['BigInt']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	data?: InputMaybe<Scalars['JSON']['input']>
	errored?: InputMaybe<Scalars['BigInt']['input']>
	excluded_segments?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	failed?: InputMaybe<Scalars['BigInt']['input']>
	headings?: InputMaybe<Scalars['JSON']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	include_aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	include_external_user_ids?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	include_player_ids?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	include_unsubscribed?: InputMaybe<Scalars['Boolean']['input']>
	included_segments?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	name?: InputMaybe<Scalars['String']['input']>
	platform_delivery_stats?: InputMaybe<Scalars['JSON']['input']>
	received?: InputMaybe<Scalars['BigInt']['input']>
	seen_by_users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	subtitle?: InputMaybe<Scalars['JSON']['input']>
	successful?: InputMaybe<Scalars['BigInt']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
}

export type NotificationsInsertResponse = {
	__typename?: 'notificationsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Notifications>
}

export type NotificationsOrderBy = {
	converted?: InputMaybe<OrderByDirection>
	created_at?: InputMaybe<OrderByDirection>
	errored?: InputMaybe<OrderByDirection>
	failed?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	include_unsubscribed?: InputMaybe<OrderByDirection>
	name?: InputMaybe<OrderByDirection>
	received?: InputMaybe<OrderByDirection>
	successful?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
}

export type NotificationsUpdateInput = {
	contents?: InputMaybe<Scalars['JSON']['input']>
	converted?: InputMaybe<Scalars['BigInt']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	data?: InputMaybe<Scalars['JSON']['input']>
	errored?: InputMaybe<Scalars['BigInt']['input']>
	excluded_segments?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	failed?: InputMaybe<Scalars['BigInt']['input']>
	headings?: InputMaybe<Scalars['JSON']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	include_aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	include_external_user_ids?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	include_player_ids?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	include_unsubscribed?: InputMaybe<Scalars['Boolean']['input']>
	included_segments?: InputMaybe<
		Array<InputMaybe<Scalars['String']['input']>>
	>
	name?: InputMaybe<Scalars['String']['input']>
	platform_delivery_stats?: InputMaybe<Scalars['JSON']['input']>
	received?: InputMaybe<Scalars['BigInt']['input']>
	seen_by_users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
	subtitle?: InputMaybe<Scalars['JSON']['input']>
	successful?: InputMaybe<Scalars['BigInt']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
}

export type NotificationsUpdateResponse = {
	__typename?: 'notificationsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Notifications>
}

export type Onesignal = Node & {
	__typename?: 'onesignal'
	ad_id: Scalars['String']['output']
	amount_spent: Scalars['String']['output']
	created_at: Scalars['Datetime']['output']
	device_model: Scalars['String']['output']
	device_os: Scalars['String']['output']
	device_type: Scalars['String']['output']
	external_user_id: Scalars['String']['output']
	game_version: Scalars['String']['output']
	id: Scalars['String']['output']
	identifier: Scalars['String']['output']
	invalid_identifier: Scalars['String']['output']
	language: Scalars['String']['output']
	last_active: Scalars['Datetime']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	onesignal_id: Scalars['String']['output']
	playtime: Scalars['String']['output']
	session_count: Scalars['String']['output']
	tags: Scalars['JSON']['output']
	timezone: Scalars['String']['output']
}

export type OnesignalConnection = {
	__typename?: 'onesignalConnection'
	edges: Array<OnesignalEdge>
	pageInfo: PageInfo
}

export type OnesignalDeleteResponse = {
	__typename?: 'onesignalDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Onesignal>
}

export type OnesignalEdge = {
	__typename?: 'onesignalEdge'
	cursor: Scalars['String']['output']
	node: Onesignal
}

export type OnesignalFilter = {
	ad_id?: InputMaybe<StringFilter>
	amount_spent?: InputMaybe<StringFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<OnesignalFilter>>
	created_at?: InputMaybe<DatetimeFilter>
	device_model?: InputMaybe<StringFilter>
	device_os?: InputMaybe<StringFilter>
	device_type?: InputMaybe<StringFilter>
	external_user_id?: InputMaybe<StringFilter>
	game_version?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	identifier?: InputMaybe<StringFilter>
	invalid_identifier?: InputMaybe<StringFilter>
	language?: InputMaybe<StringFilter>
	last_active?: InputMaybe<DatetimeFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<OnesignalFilter>
	onesignal_id?: InputMaybe<StringFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<OnesignalFilter>>
	playtime?: InputMaybe<StringFilter>
	session_count?: InputMaybe<StringFilter>
	timezone?: InputMaybe<StringFilter>
}

export type OnesignalInsertInput = {
	ad_id?: InputMaybe<Scalars['String']['input']>
	amount_spent?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	device_model?: InputMaybe<Scalars['String']['input']>
	device_os?: InputMaybe<Scalars['String']['input']>
	device_type?: InputMaybe<Scalars['String']['input']>
	external_user_id?: InputMaybe<Scalars['String']['input']>
	game_version?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	identifier?: InputMaybe<Scalars['String']['input']>
	invalid_identifier?: InputMaybe<Scalars['String']['input']>
	language?: InputMaybe<Scalars['String']['input']>
	last_active?: InputMaybe<Scalars['Datetime']['input']>
	onesignal_id?: InputMaybe<Scalars['String']['input']>
	playtime?: InputMaybe<Scalars['String']['input']>
	session_count?: InputMaybe<Scalars['String']['input']>
	tags?: InputMaybe<Scalars['JSON']['input']>
	timezone?: InputMaybe<Scalars['String']['input']>
}

export type OnesignalInsertResponse = {
	__typename?: 'onesignalInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Onesignal>
}

export type OnesignalOrderBy = {
	ad_id?: InputMaybe<OrderByDirection>
	amount_spent?: InputMaybe<OrderByDirection>
	created_at?: InputMaybe<OrderByDirection>
	device_model?: InputMaybe<OrderByDirection>
	device_os?: InputMaybe<OrderByDirection>
	device_type?: InputMaybe<OrderByDirection>
	external_user_id?: InputMaybe<OrderByDirection>
	game_version?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	identifier?: InputMaybe<OrderByDirection>
	invalid_identifier?: InputMaybe<OrderByDirection>
	language?: InputMaybe<OrderByDirection>
	last_active?: InputMaybe<OrderByDirection>
	onesignal_id?: InputMaybe<OrderByDirection>
	playtime?: InputMaybe<OrderByDirection>
	session_count?: InputMaybe<OrderByDirection>
	timezone?: InputMaybe<OrderByDirection>
}

export type OnesignalUpdateInput = {
	ad_id?: InputMaybe<Scalars['String']['input']>
	amount_spent?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	device_model?: InputMaybe<Scalars['String']['input']>
	device_os?: InputMaybe<Scalars['String']['input']>
	device_type?: InputMaybe<Scalars['String']['input']>
	external_user_id?: InputMaybe<Scalars['String']['input']>
	game_version?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	identifier?: InputMaybe<Scalars['String']['input']>
	invalid_identifier?: InputMaybe<Scalars['String']['input']>
	language?: InputMaybe<Scalars['String']['input']>
	last_active?: InputMaybe<Scalars['Datetime']['input']>
	onesignal_id?: InputMaybe<Scalars['String']['input']>
	playtime?: InputMaybe<Scalars['String']['input']>
	session_count?: InputMaybe<Scalars['String']['input']>
	tags?: InputMaybe<Scalars['JSON']['input']>
	timezone?: InputMaybe<Scalars['String']['input']>
}

export type OnesignalUpdateResponse = {
	__typename?: 'onesignalUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Onesignal>
}

export type Post_Comment_Likes = Node & {
	__typename?: 'post_comment_likes'
	created_at: Scalars['Datetime']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	post_comment_id: Scalars['UUID']['output']
	post_comments: Post_Comments
	updated_at: Scalars['Datetime']['output']
	user: User
	user_id: Scalars['String']['output']
}

export type Post_Comment_LikesConnection = {
	__typename?: 'post_comment_likesConnection'
	edges: Array<Post_Comment_LikesEdge>
	pageInfo: PageInfo
}

export type Post_Comment_LikesDeleteResponse = {
	__typename?: 'post_comment_likesDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Post_Comment_Likes>
}

export type Post_Comment_LikesEdge = {
	__typename?: 'post_comment_likesEdge'
	cursor: Scalars['String']['output']
	node: Post_Comment_Likes
}

export type Post_Comment_LikesFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Post_Comment_LikesFilter>>
	created_at?: InputMaybe<DatetimeFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Post_Comment_LikesFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Post_Comment_LikesFilter>>
	post_comment_id?: InputMaybe<UuidFilter>
	updated_at?: InputMaybe<DatetimeFilter>
	user_id?: InputMaybe<StringFilter>
}

export type Post_Comment_LikesInsertInput = {
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	post_comment_id?: InputMaybe<Scalars['UUID']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Post_Comment_LikesInsertResponse = {
	__typename?: 'post_comment_likesInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Post_Comment_Likes>
}

export type Post_Comment_LikesOrderBy = {
	created_at?: InputMaybe<OrderByDirection>
	post_comment_id?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
	user_id?: InputMaybe<OrderByDirection>
}

export type Post_Comment_LikesUpdateInput = {
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	post_comment_id?: InputMaybe<Scalars['UUID']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Post_Comment_LikesUpdateResponse = {
	__typename?: 'post_comment_likesUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Post_Comment_Likes>
}

export type Post_Comments = Node & {
	__typename?: 'post_comments'
	article: Article
	content: Scalars['String']['output']
	created_at: Scalars['Datetime']['output']
	deleted_at?: Maybe<Scalars['Datetime']['output']>
	deleted_by?: Maybe<Scalars['String']['output']>
	id: Scalars['UUID']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	parent_post_comment_id?: Maybe<Scalars['UUID']['output']>
	post_comment_likesCollection?: Maybe<Post_Comment_LikesConnection>
	post_comments?: Maybe<Post_Comments>
	post_commentsCollection?: Maybe<Post_CommentsConnection>
	post_id: Scalars['String']['output']
	total_sub_comments?: Maybe<Scalars['Int']['output']>
	updated_at: Scalars['Datetime']['output']
	user: User
	user_id: Scalars['String']['output']
}

export type Post_CommentsPost_Comment_LikesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Post_Comment_LikesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Post_Comment_LikesOrderBy>>
}

export type Post_CommentsPost_CommentsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Post_CommentsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Post_CommentsOrderBy>>
}

export type Post_CommentsConnection = {
	__typename?: 'post_commentsConnection'
	edges: Array<Post_CommentsEdge>
	pageInfo: PageInfo
}

export type Post_CommentsDeleteResponse = {
	__typename?: 'post_commentsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Post_Comments>
}

export type Post_CommentsEdge = {
	__typename?: 'post_commentsEdge'
	cursor: Scalars['String']['output']
	node: Post_Comments
}

export type Post_CommentsFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Post_CommentsFilter>>
	content?: InputMaybe<StringFilter>
	created_at?: InputMaybe<DatetimeFilter>
	deleted_at?: InputMaybe<DatetimeFilter>
	deleted_by?: InputMaybe<StringFilter>
	id?: InputMaybe<UuidFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Post_CommentsFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Post_CommentsFilter>>
	parent_post_comment_id?: InputMaybe<UuidFilter>
	post_id?: InputMaybe<StringFilter>
	total_sub_comments?: InputMaybe<IntFilter>
	updated_at?: InputMaybe<DatetimeFilter>
	user_id?: InputMaybe<StringFilter>
}

export type Post_CommentsInsertInput = {
	content?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	deleted_at?: InputMaybe<Scalars['Datetime']['input']>
	deleted_by?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	parent_post_comment_id?: InputMaybe<Scalars['UUID']['input']>
	post_id?: InputMaybe<Scalars['String']['input']>
	total_sub_comments?: InputMaybe<Scalars['Int']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Post_CommentsInsertResponse = {
	__typename?: 'post_commentsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Post_Comments>
}

export type Post_CommentsOrderBy = {
	content?: InputMaybe<OrderByDirection>
	created_at?: InputMaybe<OrderByDirection>
	deleted_at?: InputMaybe<OrderByDirection>
	deleted_by?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	parent_post_comment_id?: InputMaybe<OrderByDirection>
	post_id?: InputMaybe<OrderByDirection>
	total_sub_comments?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
	user_id?: InputMaybe<OrderByDirection>
}

export type Post_CommentsUpdateInput = {
	content?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	deleted_at?: InputMaybe<Scalars['Datetime']['input']>
	deleted_by?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	parent_post_comment_id?: InputMaybe<Scalars['UUID']['input']>
	post_id?: InputMaybe<Scalars['String']['input']>
	total_sub_comments?: InputMaybe<Scalars['Int']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Post_CommentsUpdateResponse = {
	__typename?: 'post_commentsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Post_Comments>
}

export type RoLocations = Node & {
	__typename?: 'roLocations'
	companyOfficesCollection?: Maybe<CompanyOfficesConnection>
	country: Scalars['String']['output']
	createdAt: Scalars['Datetime']['output']
	experienceCollection?: Maybe<ExperienceConnection>
	fips?: Maybe<Scalars['String']['output']>
	hasc?: Maybe<Scalars['String']['output']>
	id: Scalars['String']['output']
	iso: Scalars['String']['output']
	iso2?: Maybe<Scalars['String']['output']>
	language: Scalars['String']['output']
	level?: Maybe<Scalars['Int']['output']>
	lowerCaseName?: Maybe<Scalars['String']['output']>
	lowerCaseRegion2?: Maybe<Scalars['String']['output']>
	name: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	nuts?: Maybe<Scalars['String']['output']>
	profileCollection?: Maybe<ProfileConnection>
	region1?: Maybe<Scalars['String']['output']>
	region2?: Maybe<Scalars['String']['output']>
	region3?: Maybe<Scalars['String']['output']>
	region4?: Maybe<Scalars['String']['output']>
	stat?: Maybe<Scalars['String']['output']>
	studentKitCollection?: Maybe<StudentKitConnection>
	type: Scalars['String']['output']
	updatedAt: Scalars['Datetime']['output']
}

export type RoLocationsCompanyOfficesCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<CompanyOfficesFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<CompanyOfficesOrderBy>>
}

export type RoLocationsExperienceCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ExperienceFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ExperienceOrderBy>>
}

export type RoLocationsProfileCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<ProfileFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<ProfileOrderBy>>
}

export type RoLocationsStudentKitCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<StudentKitFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<StudentKitOrderBy>>
}

export type RoLocationsConnection = {
	__typename?: 'roLocationsConnection'
	edges: Array<RoLocationsEdge>
	pageInfo: PageInfo
}

export type RoLocationsDeleteResponse = {
	__typename?: 'roLocationsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<RoLocations>
}

export type RoLocationsEdge = {
	__typename?: 'roLocationsEdge'
	cursor: Scalars['String']['output']
	node: RoLocations
}

export type RoLocationsFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<RoLocationsFilter>>
	country?: InputMaybe<StringFilter>
	createdAt?: InputMaybe<DatetimeFilter>
	fips?: InputMaybe<StringFilter>
	hasc?: InputMaybe<StringFilter>
	id?: InputMaybe<StringFilter>
	iso?: InputMaybe<StringFilter>
	iso2?: InputMaybe<StringFilter>
	language?: InputMaybe<StringFilter>
	level?: InputMaybe<IntFilter>
	lowerCaseName?: InputMaybe<StringFilter>
	lowerCaseRegion2?: InputMaybe<StringFilter>
	name?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<RoLocationsFilter>
	nuts?: InputMaybe<StringFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<RoLocationsFilter>>
	region1?: InputMaybe<StringFilter>
	region2?: InputMaybe<StringFilter>
	region3?: InputMaybe<StringFilter>
	region4?: InputMaybe<StringFilter>
	stat?: InputMaybe<StringFilter>
	type?: InputMaybe<StringFilter>
	updatedAt?: InputMaybe<DatetimeFilter>
}

export type RoLocationsInsertInput = {
	country?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	fips?: InputMaybe<Scalars['String']['input']>
	hasc?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	iso?: InputMaybe<Scalars['String']['input']>
	iso2?: InputMaybe<Scalars['String']['input']>
	language?: InputMaybe<Scalars['String']['input']>
	level?: InputMaybe<Scalars['Int']['input']>
	lowerCaseName?: InputMaybe<Scalars['String']['input']>
	lowerCaseRegion2?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	nuts?: InputMaybe<Scalars['String']['input']>
	region1?: InputMaybe<Scalars['String']['input']>
	region2?: InputMaybe<Scalars['String']['input']>
	region3?: InputMaybe<Scalars['String']['input']>
	region4?: InputMaybe<Scalars['String']['input']>
	stat?: InputMaybe<Scalars['String']['input']>
	type?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type RoLocationsInsertResponse = {
	__typename?: 'roLocationsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<RoLocations>
}

export type RoLocationsOrderBy = {
	country?: InputMaybe<OrderByDirection>
	createdAt?: InputMaybe<OrderByDirection>
	fips?: InputMaybe<OrderByDirection>
	hasc?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	iso?: InputMaybe<OrderByDirection>
	iso2?: InputMaybe<OrderByDirection>
	language?: InputMaybe<OrderByDirection>
	level?: InputMaybe<OrderByDirection>
	lowerCaseName?: InputMaybe<OrderByDirection>
	lowerCaseRegion2?: InputMaybe<OrderByDirection>
	name?: InputMaybe<OrderByDirection>
	nuts?: InputMaybe<OrderByDirection>
	region1?: InputMaybe<OrderByDirection>
	region2?: InputMaybe<OrderByDirection>
	region3?: InputMaybe<OrderByDirection>
	region4?: InputMaybe<OrderByDirection>
	stat?: InputMaybe<OrderByDirection>
	type?: InputMaybe<OrderByDirection>
	updatedAt?: InputMaybe<OrderByDirection>
}

export type RoLocationsUpdateInput = {
	country?: InputMaybe<Scalars['String']['input']>
	createdAt?: InputMaybe<Scalars['Datetime']['input']>
	fips?: InputMaybe<Scalars['String']['input']>
	hasc?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	iso?: InputMaybe<Scalars['String']['input']>
	iso2?: InputMaybe<Scalars['String']['input']>
	language?: InputMaybe<Scalars['String']['input']>
	level?: InputMaybe<Scalars['Int']['input']>
	lowerCaseName?: InputMaybe<Scalars['String']['input']>
	lowerCaseRegion2?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	nuts?: InputMaybe<Scalars['String']['input']>
	region1?: InputMaybe<Scalars['String']['input']>
	region2?: InputMaybe<Scalars['String']['input']>
	region3?: InputMaybe<Scalars['String']['input']>
	region4?: InputMaybe<Scalars['String']['input']>
	stat?: InputMaybe<Scalars['String']['input']>
	type?: InputMaybe<Scalars['String']['input']>
	updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type RoLocationsUpdateResponse = {
	__typename?: 'roLocationsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<RoLocations>
}

export type Scanning_Agent_Invitations = Node & {
	__typename?: 'scanning_agent_invitations'
	accepted_at?: Maybe<Scalars['Datetime']['output']>
	campaign_edition_id: Scalars['UUID']['output']
	campaign_editions: Campaign_Editions
	created_at: Scalars['Datetime']['output']
	id: Scalars['UUID']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	rejected_at?: Maybe<Scalars['Datetime']['output']>
	updated_at: Scalars['Datetime']['output']
	user: User
	user_id: Scalars['String']['output']
}

export type Scanning_Agent_InvitationsConnection = {
	__typename?: 'scanning_agent_invitationsConnection'
	edges: Array<Scanning_Agent_InvitationsEdge>
	pageInfo: PageInfo
}

export type Scanning_Agent_InvitationsDeleteResponse = {
	__typename?: 'scanning_agent_invitationsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Scanning_Agent_Invitations>
}

export type Scanning_Agent_InvitationsEdge = {
	__typename?: 'scanning_agent_invitationsEdge'
	cursor: Scalars['String']['output']
	node: Scanning_Agent_Invitations
}

export type Scanning_Agent_InvitationsFilter = {
	accepted_at?: InputMaybe<DatetimeFilter>
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Scanning_Agent_InvitationsFilter>>
	campaign_edition_id?: InputMaybe<UuidFilter>
	created_at?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<UuidFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Scanning_Agent_InvitationsFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Scanning_Agent_InvitationsFilter>>
	rejected_at?: InputMaybe<DatetimeFilter>
	updated_at?: InputMaybe<DatetimeFilter>
	user_id?: InputMaybe<StringFilter>
}

export type Scanning_Agent_InvitationsInsertInput = {
	accepted_at?: InputMaybe<Scalars['Datetime']['input']>
	campaign_edition_id?: InputMaybe<Scalars['UUID']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	rejected_at?: InputMaybe<Scalars['Datetime']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Scanning_Agent_InvitationsInsertResponse = {
	__typename?: 'scanning_agent_invitationsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Scanning_Agent_Invitations>
}

export type Scanning_Agent_InvitationsOrderBy = {
	accepted_at?: InputMaybe<OrderByDirection>
	campaign_edition_id?: InputMaybe<OrderByDirection>
	created_at?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	rejected_at?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
	user_id?: InputMaybe<OrderByDirection>
}

export type Scanning_Agent_InvitationsUpdateInput = {
	accepted_at?: InputMaybe<Scalars['Datetime']['input']>
	campaign_edition_id?: InputMaybe<Scalars['UUID']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	rejected_at?: InputMaybe<Scalars['Datetime']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Scanning_Agent_InvitationsUpdateResponse = {
	__typename?: 'scanning_agent_invitationsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Scanning_Agent_Invitations>
}

export type Search = Node & {
	__typename?: 'search'
	article: Article
	article_id: Scalars['String']['output']
	company: Company
	company_id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
}

export type SearchConnection = {
	__typename?: 'searchConnection'
	edges: Array<SearchEdge>
	pageInfo: PageInfo
}

export type SearchDeleteResponse = {
	__typename?: 'searchDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Search>
}

export type SearchEdge = {
	__typename?: 'searchEdge'
	cursor: Scalars['String']['output']
	node: Search
}

export type SearchFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<SearchFilter>>
	article_id?: InputMaybe<StringFilter>
	company_id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<SearchFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<SearchFilter>>
}

export type SearchInsertInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	company_id?: InputMaybe<Scalars['String']['input']>
}

export type SearchInsertResponse = {
	__typename?: 'searchInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Search>
}

export type SearchOrderBy = {
	article_id?: InputMaybe<OrderByDirection>
	company_id?: InputMaybe<OrderByDirection>
}

export type SearchUpdateInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	company_id?: InputMaybe<Scalars['String']['input']>
}

export type SearchUpdateResponse = {
	__typename?: 'searchUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Search>
}

export type Searchview = Node & {
	__typename?: 'searchview'
	article: Article
	article_id: Scalars['String']['output']
	company: Company
	company_id: Scalars['String']['output']
	job: Job
	job_id: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	team: Team
	team_id: Scalars['String']['output']
	user: User
	user_id: Scalars['String']['output']
}

export type SearchviewConnection = {
	__typename?: 'searchviewConnection'
	edges: Array<SearchviewEdge>
	pageInfo: PageInfo
}

export type SearchviewDeleteResponse = {
	__typename?: 'searchviewDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Searchview>
}

export type SearchviewEdge = {
	__typename?: 'searchviewEdge'
	cursor: Scalars['String']['output']
	node: Searchview
}

export type SearchviewFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<SearchviewFilter>>
	article_id?: InputMaybe<StringFilter>
	company_id?: InputMaybe<StringFilter>
	job_id?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<SearchviewFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<SearchviewFilter>>
	team_id?: InputMaybe<StringFilter>
	user_id?: InputMaybe<StringFilter>
}

export type SearchviewInsertInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	company_id?: InputMaybe<Scalars['String']['input']>
	job_id?: InputMaybe<Scalars['String']['input']>
	team_id?: InputMaybe<Scalars['String']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type SearchviewInsertResponse = {
	__typename?: 'searchviewInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Searchview>
}

export type SearchviewOrderBy = {
	article_id?: InputMaybe<OrderByDirection>
	company_id?: InputMaybe<OrderByDirection>
	job_id?: InputMaybe<OrderByDirection>
	team_id?: InputMaybe<OrderByDirection>
	user_id?: InputMaybe<OrderByDirection>
}

export type SearchviewUpdateInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	company_id?: InputMaybe<Scalars['String']['input']>
	job_id?: InputMaybe<Scalars['String']['input']>
	team_id?: InputMaybe<Scalars['String']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type SearchviewUpdateResponse = {
	__typename?: 'searchviewUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Searchview>
}

export type Segments = Node & {
	__typename?: 'segments'
	companies?: Maybe<Scalars['JSON']['output']>
	created_at: Scalars['Datetime']['output']
	custom_notificationsCollection?: Maybe<Custom_NotificationsConnection>
	external_ids?: Maybe<Scalars['JSON']['output']>
	id: Scalars['UUID']['output']
	name: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	students?: Maybe<Scalars['JSON']['output']>
}

export type SegmentsCustom_NotificationsCollectionArgs = {
	after?: InputMaybe<Scalars['Cursor']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	filter?: InputMaybe<Custom_NotificationsFilter>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	orderBy?: InputMaybe<Array<Custom_NotificationsOrderBy>>
}

export type SegmentsConnection = {
	__typename?: 'segmentsConnection'
	edges: Array<SegmentsEdge>
	pageInfo: PageInfo
}

export type SegmentsDeleteResponse = {
	__typename?: 'segmentsDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Segments>
}

export type SegmentsEdge = {
	__typename?: 'segmentsEdge'
	cursor: Scalars['String']['output']
	node: Segments
}

export type SegmentsFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<SegmentsFilter>>
	created_at?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<UuidFilter>
	name?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<SegmentsFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<SegmentsFilter>>
}

export type SegmentsInsertInput = {
	companies?: InputMaybe<Scalars['JSON']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	external_ids?: InputMaybe<Scalars['JSON']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	students?: InputMaybe<Scalars['JSON']['input']>
}

export type SegmentsInsertResponse = {
	__typename?: 'segmentsInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Segments>
}

export type SegmentsOrderBy = {
	created_at?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	name?: InputMaybe<OrderByDirection>
}

export type SegmentsUpdateInput = {
	companies?: InputMaybe<Scalars['JSON']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	external_ids?: InputMaybe<Scalars['JSON']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	students?: InputMaybe<Scalars['JSON']['input']>
}

export type SegmentsUpdateResponse = {
	__typename?: 'segmentsUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Segments>
}

export type Standardresponse = Node & {
	__typename?: 'standardresponse'
	error: Scalars['String']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	status: Scalars['Boolean']['output']
}

export type StandardresponseConnection = {
	__typename?: 'standardresponseConnection'
	edges: Array<StandardresponseEdge>
	pageInfo: PageInfo
}

export type StandardresponseDeleteResponse = {
	__typename?: 'standardresponseDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Standardresponse>
}

export type StandardresponseEdge = {
	__typename?: 'standardresponseEdge'
	cursor: Scalars['String']['output']
	node: Standardresponse
}

export type StandardresponseFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<StandardresponseFilter>>
	error?: InputMaybe<StringFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<StandardresponseFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<StandardresponseFilter>>
	status?: InputMaybe<BooleanFilter>
}

export type StandardresponseInsertInput = {
	error?: InputMaybe<Scalars['String']['input']>
	status?: InputMaybe<Scalars['Boolean']['input']>
}

export type StandardresponseInsertResponse = {
	__typename?: 'standardresponseInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Standardresponse>
}

export type StandardresponseOrderBy = {
	error?: InputMaybe<OrderByDirection>
	status?: InputMaybe<OrderByDirection>
}

export type StandardresponseUpdateInput = {
	error?: InputMaybe<Scalars['String']['input']>
	status?: InputMaybe<Scalars['Boolean']['input']>
}

export type StandardresponseUpdateResponse = {
	__typename?: 'standardresponseUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Standardresponse>
}

export type Viewed_User_Articles = Node & {
	__typename?: 'viewed_user_articles'
	article: Article
	article_id: Scalars['String']['output']
	created_at: Scalars['Datetime']['output']
	id: Scalars['UUID']['output']
	/** Globally Unique Record Identifier */
	nodeId: Scalars['ID']['output']
	updated_at: Scalars['Datetime']['output']
	user_id: Scalars['String']['output']
}

export type Viewed_User_ArticlesConnection = {
	__typename?: 'viewed_user_articlesConnection'
	edges: Array<Viewed_User_ArticlesEdge>
	pageInfo: PageInfo
}

export type Viewed_User_ArticlesDeleteResponse = {
	__typename?: 'viewed_user_articlesDeleteResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Viewed_User_Articles>
}

export type Viewed_User_ArticlesEdge = {
	__typename?: 'viewed_user_articlesEdge'
	cursor: Scalars['String']['output']
	node: Viewed_User_Articles
}

export type Viewed_User_ArticlesFilter = {
	/** Returns true only if all its inner filters are true, otherwise returns false */
	and?: InputMaybe<Array<Viewed_User_ArticlesFilter>>
	article_id?: InputMaybe<StringFilter>
	created_at?: InputMaybe<DatetimeFilter>
	id?: InputMaybe<UuidFilter>
	nodeId?: InputMaybe<IdFilter>
	/** Negates a filter */
	not?: InputMaybe<Viewed_User_ArticlesFilter>
	/** Returns true if at least one of its inner filters is true, otherwise returns false */
	or?: InputMaybe<Array<Viewed_User_ArticlesFilter>>
	updated_at?: InputMaybe<DatetimeFilter>
	user_id?: InputMaybe<StringFilter>
}

export type Viewed_User_ArticlesInsertInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Viewed_User_ArticlesInsertResponse = {
	__typename?: 'viewed_user_articlesInsertResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Viewed_User_Articles>
}

export type Viewed_User_ArticlesOrderBy = {
	article_id?: InputMaybe<OrderByDirection>
	created_at?: InputMaybe<OrderByDirection>
	id?: InputMaybe<OrderByDirection>
	updated_at?: InputMaybe<OrderByDirection>
	user_id?: InputMaybe<OrderByDirection>
}

export type Viewed_User_ArticlesUpdateInput = {
	article_id?: InputMaybe<Scalars['String']['input']>
	created_at?: InputMaybe<Scalars['Datetime']['input']>
	id?: InputMaybe<Scalars['UUID']['input']>
	updated_at?: InputMaybe<Scalars['Datetime']['input']>
	user_id?: InputMaybe<Scalars['String']['input']>
}

export type Viewed_User_ArticlesUpdateResponse = {
	__typename?: 'viewed_user_articlesUpdateResponse'
	/** Count of the records impacted by the mutation */
	affectedCount: Scalars['Int']['output']
	/** Array of records impacted by the mutation */
	records: Array<Viewed_User_Articles>
}

export type ArticlesByEntityResultsFragment = {
	__typename?: 'Article'
	id: string
	title?: string | null
	body: string
	slug?: string | null
	description?: string | null
	isPost?: boolean | null
	featuredVideo?: string | null
	user?: {
		__typename?: 'User'
		id: string
		email: string
		profileCollection?: {
			__typename?: 'ProfileConnection'
			edges: Array<{
				__typename?: 'ProfileEdge'
				node: {
					__typename?: 'Profile'
					id: string
					firstName: string
					lastName: string
				}
			}>
		} | null
	} | null
	image?: {
		__typename?: 'Image'
		id: string
		filename?: string | null
	} | null
}

export type StandardArticleResultFragment = {
	__typename?: 'Article'
	id: string
	worksAt?: string | null
	readDuration?: number | null
	title?: string | null
	body: string
	slug?: string | null
	description?: string | null
	isPost?: boolean | null
	postAs?: string | null
	postingCompany?: string | null
	createdAt: any
	updatedAt: any
	featuredVideo?: string | null
	post_as?: string | null
	company_name?: string | null
	company_avatar_path?: string | null
	company_industry?: string | null
	public_companies?: IPublicCompany | null
	user?: {
		__typename?: 'User'
		id: string
		uid: string
		email: string
		god: boolean
		profileCollection?: {
			__typename?: 'ProfileConnection'
			edges: Array<{
				__typename?: 'ProfileEdge'
				node: {
					__typename?: 'Profile'
					id: string
					firstName: string
					lastName: string
					cvFilePath?: any | null
					cvFileOriginalName?: any | null
					hasAvatar?: boolean | null
					avatarContentType?: string | null
					avatarPath?: string | null
					experienceCollection?: {
						__typename?: 'ExperienceConnection'
						edges: Array<{
							__typename?: 'ExperienceEdge'
							node: {
								__typename?: 'Experience'
								position?: string | null
								company?: string | null
							}
						}>
					} | null
				}
			}>
		} | null
	} | null
	company?: {
		__typename?: 'Company'
		id: string
		name?: string | null
		slug: string
		hasLogo?: boolean | null
		logoPath?: string | null
		industry?: { __typename?: 'Industry'; id: string; key: string } | null
	} | null
	tags: ITag[]
	// activeAtagrticleTagCollection?: {
	// 	__typename?: 'ActiveArticleTagConnection'
	// 	edges: Array<{
	// 		__typename?: 'ActiveArticleTagEdge'
	// 		node: {
	// 			__typename?: 'ActiveArticleTag'
	// 			id: string
	// 			votes?: number | null
	// 			articleTag?: { __typename?: 'ArticleTag'; title: string } | null
	// 			_ActiveArticleTagToUserCollection?: {
	// 				__typename?: '_ActiveArticleTagToUserConnection'
	// 				edges: Array<{
	// 					__typename?: '_ActiveArticleTagToUserEdge'
	// 					node: {
	// 						__typename?: '_ActiveArticleTagToUser'
	// 						user: {
	// 							__typename?: 'User'
	// 							profileCollection?: {
	// 								__typename?: 'ProfileConnection'
	// 								edges: Array<{
	// 									__typename?: 'ProfileEdge'
	// 									node: {
	// 										__typename?: 'Profile'
	// 										firstName: string
	// 										lastName: string
	// 										user?: {
	// 											__typename?: 'User'
	// 											id: string
	// 											uid: string
	// 										} | null
	// 									}
	// 								}>
	// 							} | null
	// 						}
	// 					}
	// 				}>
	// 			} | null
	// 		}
	// 	}>
	// } | null
	featuredImage?: {
		__typename?: 'Image'
		id?: string
		filename?: string | null
	} | null
	featuredVideoWidth?: number | null
	featuredVideoHeight?: number | null
}

export type ArticleConnectionDataFragment = {
	__typename?: 'ArticleConnection'
	edges: Array<{
		__typename?: 'ArticleEdge'
		cursor: string
		node: {
			__typename?: 'Article'
			id: string
			worksAt?: string | null
			readDuration?: number | null
			title?: string | null
			body: string
			slug?: string | null
			description?: string | null
			isPost?: boolean | null
			postAs?: string | null
			postingCompany?: string | null
			createdAt: any
			updatedAt: any
			featuredVideo?: string | null
			user?: {
				__typename?: 'User'
				id: string
				uid: string
				email: string
				god: boolean
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							firstName: string
							lastName: string
							cvFilePath?: any | null
							cvFileOriginalName?: any | null
							hasAvatar?: boolean | null
							avatarContentType?: string | null
							avatarPath?: string | null
							experienceCollection?: {
								__typename?: 'ExperienceConnection'
								edges: Array<{
									__typename?: 'ExperienceEdge'
									node: {
										__typename?: 'Experience'
										position?: string | null
										company?: string | null
									}
								}>
							} | null
						}
					}>
				} | null
			} | null
			company?: {
				__typename?: 'Company'
				id: string
				name?: string | null
				slug: string
				hasLogo?: boolean | null
				logoPath?: string | null
				industry?: {
					__typename?: 'Industry'
					id: string
					key: string
				} | null
			} | null
			activeArticleTagCollection?: {
				__typename?: 'ActiveArticleTagConnection'
				edges: Array<{
					__typename?: 'ActiveArticleTagEdge'
					node: {
						__typename?: 'ActiveArticleTag'
						id: string
						votes?: number | null
						articleTag?: {
							__typename?: 'ArticleTag'
							title: string
						} | null
						_ActiveArticleTagToUserCollection?: {
							__typename?: '_ActiveArticleTagToUserConnection'
							edges: Array<{
								__typename?: '_ActiveArticleTagToUserEdge'
								node: {
									__typename?: '_ActiveArticleTagToUser'
									user: {
										__typename?: 'User'
										profileCollection?: {
											__typename?: 'ProfileConnection'
											edges: Array<{
												__typename?: 'ProfileEdge'
												node: {
													__typename?: 'Profile'
													firstName: string
													lastName: string
													user?: {
														__typename?: 'User'
														id: string
														uid: string
													} | null
												}
											}>
										} | null
									}
								}
							}>
						} | null
					}
				}>
			} | null
			image?: {
				__typename?: 'Image'
				id: string
				filename?: string | null
			} | null
		}
	}>
	pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean }
}

export type PageInfoDataFragment = {
	__typename?: 'PageInfo'
	hasNextPage: boolean
}

export type StandardCompanyResultFragment = {
	__typename: 'Company'
	id: string
	name?: string | null
	slug: string
	dateFounded?: string | null
	headline?: string | null
	description?: string | null
	productsAndServices?: string | null
	noOfEmployees?: string | null
	website?: string | null
	phones?: string | null
	emails?: string | null
	featuredVideo?: string | null
	hasLogo?: boolean | null
	logoPath?: string | null
	hasCover?: boolean | null
	aboutTeams?: string | null
	coverPath?: string | null
	_OwnerToCompanyCollection?: {
		__typename?: '_OwnerToCompanyConnection'
		edges: Array<{
			__typename?: '_OwnerToCompanyEdge'
			node: {
				__typename?: '_OwnerToCompany'
				user: { __typename?: 'User'; id: string; uid: string }
			}
		}>
	} | null
	industry?: { __typename?: 'Industry'; id: string; key: string } | null
	companyOfficesCollection?: {
		__typename?: 'CompanyOfficesConnection'
		edges: Array<{
			__typename?: 'CompanyOfficesEdge'
			node: {
				__typename?: 'CompanyOffices'
				id: string
				address?: string | null
				zipCode?: string | null
				hq?: boolean | null
				roLocations?: {
					__typename?: 'roLocations'
					id: string
					name: string
					region2?: string | null
				} | null
			}
		}>
	} | null
	jobCollection?: {
		__typename?: 'JobConnection'
		edges: Array<{
			__typename?: 'JobEdge'
			node: { __typename?: 'Job'; id: string }
		}>
	} | null
}

export type CompanyOfficesResultFragment = {
	__typename?: 'CompanyOffices'
	id: string
	address?: string | null
	zipCode?: string | null
	hq?: boolean | null
	roLocations?: {
		__typename?: 'roLocations'
		id: string
		region2?: string | null
		name: string
	} | null
}

export type NodeFragment = {
	__typename: 'Company'
	id: string
	name?: string | null
	slug: string
	dateFounded?: string | null
	headline?: string | null
	description?: string | null
	productsAndServices?: string | null
	noOfEmployees?: string | null
	website?: string | null
	phones?: string | null
	emails?: string | null
	featuredVideo?: string | null
	hasLogo?: boolean | null
	logoPath?: string | null
	hasCover?: boolean | null
	aboutTeams?: string | null
	coverPath?: string | null
	_OwnerToCompanyCollection?: {
		__typename?: '_OwnerToCompanyConnection'
		edges: Array<{
			__typename?: '_OwnerToCompanyEdge'
			node: {
				__typename?: '_OwnerToCompany'
				user: { __typename?: 'User'; id: string; uid: string }
			}
		}>
	} | null
	industry?: { __typename?: 'Industry'; id: string; key: string } | null
	companyOfficesCollection?: {
		__typename?: 'CompanyOfficesConnection'
		edges: Array<{
			__typename?: 'CompanyOfficesEdge'
			node: {
				__typename?: 'CompanyOffices'
				id: string
				address?: string | null
				zipCode?: string | null
				hq?: boolean | null
				roLocations?: {
					__typename?: 'roLocations'
					id: string
					name: string
					region2?: string | null
				} | null
			}
		}>
	} | null
	jobCollection?: {
		__typename?: 'JobConnection'
		edges: Array<{
			__typename?: 'JobEdge'
			node: { __typename?: 'Job'; id: string }
		}>
	} | null
}

export type StandardJobResultFragment = {
	__typename: 'Job'
	id: string
	slug: string
	description?: string | null
	title: string
	expiryDate?: any | null
	contractType?: string | null
	seniorityLevel?: string | null
	jobType?: string | null
	locationType?: string | null
	featuredImage?: string | null
	videoUrl?: string | null
	applyJobExternalUrl?: string | null
	teamLeader?: string | null
	benefits?: string | null
	company?: {
		__typename: 'Company'
		id: string
		logoPath?: string | null
		hasCover?: boolean | null
		hasLogo?: boolean | null
		name?: string | null
		slug: string
		description?: string | null
		coverPath?: string | null
		featuredVideo?: string | null
		industry?: { __typename: 'Industry'; id: string; key: string } | null
	} | null
	_TeamToJobCollection?: {
		__typename?: '_TeamToJobConnection'
		edges: Array<{
			__typename?: '_TeamToJobEdge'
			node: {
				__typename?: '_TeamToJob'
				team: {
					__typename: 'Team'
					id: string
					name: string
					slug: string
					description?: string | null
					hasCover?: boolean | null
					coverPath?: string | null
					teamMemberCollection?: {
						__typename?: 'TeamMemberConnection'
						edges: Array<{
							__typename?: 'TeamMemberEdge'
							node: {
								__typename?: 'TeamMember'
								id: string
								user?: {
									__typename?: 'User'
									id: string
									profileCollection?: {
										__typename?: 'ProfileConnection'
										edges: Array<{
											__typename?: 'ProfileEdge'
											node: {
												__typename?: 'Profile'
												id: string
												firstName: string
												lastName: string
											}
										}>
									} | null
								} | null
							}
						}>
					} | null
				}
			}
		}>
	} | null
	jobSalary?: {
		__typename: 'JobSalary'
		id: string
		currency?: string | null
		amountMin?: any | null
		amountMax?: any | null
		rate?: string | null
	} | null
	_JobToCustomSkillsCollection?: {
		__typename?: '_JobToCustomSkillsConnection'
		edges: Array<{
			__typename?: '_JobToCustomSkillsEdge'
			node: {
				__typename?: '_JobToCustomSkills'
				customSkills: {
					__typename: 'CustomSkills'
					id: string
					key: string
					title: string
				}
			}
		}>
	} | null
	_JobToCompanyOfficesCollection?: {
		__typename?: '_JobToCompanyOfficesConnection'
		edges: Array<{
			__typename?: '_JobToCompanyOfficesEdge'
			node: {
				__typename?: '_JobToCompanyOffices'
				A: string
				B: string
				companyOffices: {
					__typename?: 'CompanyOffices'
					id: string
					address?: string | null
					zipCode?: string | null
					hq?: boolean | null
					roLocations?: {
						__typename?: 'roLocations'
						id: string
						region2?: string | null
						name: string
					} | null
				}
			}
		}>
	} | null
	jobApplicantCollection?: {
		__typename?: 'JobApplicantConnection'
		edges: Array<{
			__typename?: 'JobApplicantEdge'
			node: { __typename: 'JobApplicant'; id: string }
		}>
	} | null
}

export type JobConnectionDataFragment = {
	__typename: 'Job'
	id: string
	slug: string
	description?: string | null
	title: string
	expiryDate?: any | null
	contractType?: string | null
	seniorityLevel?: string | null
	jobType?: string | null
	locationType?: string | null
	featuredImage?: string | null
	videoUrl?: string | null
	applyJobExternalUrl?: string | null
	teamLeader?: string | null
	benefits?: string | null
	company?: {
		__typename: 'Company'
		id: string
		logoPath?: string | null
		hasCover?: boolean | null
		hasLogo?: boolean | null
		name?: string | null
		slug: string
		description?: string | null
		coverPath?: string | null
		featuredVideo?: string | null
		industry?: { __typename: 'Industry'; id: string; key: string } | null
	} | null
	_TeamToJobCollection?: {
		__typename?: '_TeamToJobConnection'
		edges: Array<{
			__typename?: '_TeamToJobEdge'
			node: {
				__typename?: '_TeamToJob'
				team: {
					__typename: 'Team'
					id: string
					name: string
					slug: string
					description?: string | null
					hasCover?: boolean | null
					coverPath?: string | null
					teamMemberCollection?: {
						__typename?: 'TeamMemberConnection'
						edges: Array<{
							__typename?: 'TeamMemberEdge'
							node: {
								__typename?: 'TeamMember'
								id: string
								user?: {
									__typename?: 'User'
									id: string
									profileCollection?: {
										__typename?: 'ProfileConnection'
										edges: Array<{
											__typename?: 'ProfileEdge'
											node: {
												__typename?: 'Profile'
												id: string
												firstName: string
												lastName: string
											}
										}>
									} | null
								} | null
							}
						}>
					} | null
				}
			}
		}>
	} | null
	jobSalary?: {
		__typename: 'JobSalary'
		id: string
		currency?: string | null
		amountMin?: any | null
		amountMax?: any | null
		rate?: string | null
	} | null
	_JobToCustomSkillsCollection?: {
		__typename?: '_JobToCustomSkillsConnection'
		edges: Array<{
			__typename?: '_JobToCustomSkillsEdge'
			node: {
				__typename?: '_JobToCustomSkills'
				customSkills: {
					__typename: 'CustomSkills'
					id: string
					key: string
					title: string
				}
			}
		}>
	} | null
	_JobToCompanyOfficesCollection?: {
		__typename?: '_JobToCompanyOfficesConnection'
		edges: Array<{
			__typename?: '_JobToCompanyOfficesEdge'
			node: {
				__typename?: '_JobToCompanyOffices'
				A: string
				B: string
				companyOffices: {
					__typename?: 'CompanyOffices'
					id: string
					address?: string | null
					zipCode?: string | null
					hq?: boolean | null
					roLocations?: {
						__typename?: 'roLocations'
						id: string
						region2?: string | null
						name: string
					} | null
				}
			}
		}>
	} | null
	jobApplicantCollection?: {
		__typename?: 'JobApplicantConnection'
		edges: Array<{
			__typename?: 'JobApplicantEdge'
			node: { __typename: 'JobApplicant'; id: string }
		}>
	} | null
}

export type JobApplicantsConnectionDataFragment = {
	__typename?: 'JobApplicantConnection'
	edges: Array<{
		__typename?: 'JobApplicantEdge'
		cursor: string
		node: {
			__typename?: 'JobApplicant'
			createdAt: any
			user?: {
				__typename?: 'User'
				id: string
				uid: string
				god: boolean
				firebaseToken?: string | null
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							aboutMe?: string | null
							email?: string | null
							firstName: string
							lastName: string
							hasAvatar?: boolean | null
							avatarPath?: string | null
							hasCover?: boolean | null
							coverPath?: string | null
							cvFilePath?: any | null
							cvFileOriginalName?: any | null
							featuredVideo?: string | null
							company_name?: string | null
							userOnBoardingFormVisited?: boolean | null
							user?: {
								__typename?: 'User'
								id: string
								email: string
								_OwnerToCompanyCollection?: {
									__typename?: '_OwnerToCompanyConnection'
									edges: Array<{
										__typename?: '_OwnerToCompanyEdge'
										node: {
											__typename?: '_OwnerToCompany'
											company: {
												__typename?: 'Company'
												id: string
												hasLogo?: boolean | null
												name?: string | null
												slug: string
												logoPath?: string | null
											}
										}
									}>
								} | null
							} | null
							_ProfileToValueCollection?: {
								__typename?: '_ProfileToValueConnection'
								edges: Array<{
									__typename?: '_ProfileToValueEdge'
									node: {
										__typename?: '_ProfileToValue'
										value: {
											__typename?: 'Value'
											id: string
											title?: string | null
										}
									}
								}>
							} | null
							_ProfileToSkillCollection?: {
								__typename?: '_ProfileToSkillConnection'
								edges: Array<{
									__typename?: '_ProfileToSkillEdge'
									node: {
										__typename?: '_ProfileToSkill'
										skill: {
											__typename?: 'Skill'
											id: string
											title: string
										}
									}
								}>
							} | null
							experienceCollection?: {
								__typename?: 'ExperienceConnection'
								edges: Array<{
									__typename?: 'ExperienceEdge'
									node: {
										__typename?: 'Experience'
										id: string
										position?: string | null
										company?: string | null
										startDate?: any | null
										endDate?: any | null
										isCurrent?: boolean | null
										isPresent?: boolean | null
										title?: string | null
										description?: string | null
										roLocations?: {
											__typename?: 'roLocations'
											id: string
											type: string
											name: string
											region2?: string | null
										} | null
									}
								}>
							} | null
						}
					}>
				} | null
				_UserToCompanyRoleCollection?: {
					__typename?: '_UserToCompanyRoleConnection'
					edges: Array<{
						__typename?: '_UserToCompanyRoleEdge'
						node: {
							__typename?: '_UserToCompanyRole'
							companyRole: {
								__typename?: 'CompanyRole'
								id: string
								company?: {
									__typename?: 'Company'
									id: string
									slug: string
									name?: string | null
									hasLogo?: boolean | null
									logoPath?: string | null
									coverPath?: string | null
									hasCover?: boolean | null
									description?: string | null
								} | null
								companyRole_rolesCollection?: {
									__typename?: 'CompanyRole_rolesConnection'
									edges: Array<{
										__typename?: 'CompanyRole_rolesEdge'
										node: {
											__typename?: 'CompanyRole_roles'
											value: string
										}
									}>
								} | null
							}
						}
					}>
				} | null
			} | null
		}
	}>
	pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean }
}

export type UserProfileFragmentFragment = {
	__typename?: 'Profile'
	id: string
	aboutMe?: string | null
	email?: string | null
	firstName: string
	lastName: string
	hasAvatar?: boolean | null
	avatarPath?: string | null
	hasCover?: boolean | null
	coverPath?: string | null
	cvFilePath?: any | null
	cvFileOriginalName?: any | null
	featuredVideo?: string | null
	company_name?: string | null
	userOnBoardingFormVisited?: boolean | null
	user?: {
		__typename?: 'User'
		id: string
		email: string
		_OwnerToCompanyCollection?: {
			__typename?: '_OwnerToCompanyConnection'
			edges: Array<{
				__typename?: '_OwnerToCompanyEdge'
				node: {
					__typename?: '_OwnerToCompany'
					company: {
						__typename?: 'Company'
						id: string
						hasLogo?: boolean | null
						name?: string | null
						slug: string
						logoPath?: string | null
					}
				}
			}>
		} | null
	} | null
	_ProfileToValueCollection?: {
		__typename?: '_ProfileToValueConnection'
		edges: Array<{
			__typename?: '_ProfileToValueEdge'
			node: {
				__typename?: '_ProfileToValue'
				value: {
					__typename?: 'Value'
					id: string
					title?: string | null
				}
			}
		}>
	} | null
	_ProfileToSkillCollection?: {
		__typename?: '_ProfileToSkillConnection'
		edges: Array<{
			__typename?: '_ProfileToSkillEdge'
			node: {
				__typename?: '_ProfileToSkill'
				skill: { __typename?: 'Skill'; id: string; title: string }
			}
		}>
	} | null
	experienceCollection?: {
		__typename?: 'ExperienceConnection'
		edges: Array<{
			__typename?: 'ExperienceEdge'
			node: {
				__typename?: 'Experience'
				id: string
				position?: string | null
				company?: string | null
				startDate?: any | null
				endDate?: any | null
				isCurrent?: boolean | null
				isPresent?: boolean | null
				title?: string | null
				description?: string | null
				roLocations?: {
					__typename?: 'roLocations'
					id: string
					type: string
					name: string
					region2?: string | null
				} | null
			}
		}>
	} | null
}

export type OwnerToCompanyFragmentFragment = {
	__typename?: '_OwnerToCompany'
	A: string
	B: string
	company: {
		__typename: 'Company'
		id: string
		name?: string | null
		slug: string
		dateFounded?: string | null
		headline?: string | null
		description?: string | null
		productsAndServices?: string | null
		noOfEmployees?: string | null
		website?: string | null
		phones?: string | null
		emails?: string | null
		featuredVideo?: string | null
		hasLogo?: boolean | null
		logoPath?: string | null
		hasCover?: boolean | null
		aboutTeams?: string | null
		coverPath?: string | null
		_OwnerToCompanyCollection?: {
			__typename?: '_OwnerToCompanyConnection'
			edges: Array<{
				__typename?: '_OwnerToCompanyEdge'
				node: {
					__typename?: '_OwnerToCompany'
					user: { __typename?: 'User'; id: string; uid: string }
				}
			}>
		} | null
		industry?: { __typename?: 'Industry'; id: string; key: string } | null
		companyOfficesCollection?: {
			__typename?: 'CompanyOfficesConnection'
			edges: Array<{
				__typename?: 'CompanyOfficesEdge'
				node: {
					__typename?: 'CompanyOffices'
					id: string
					address?: string | null
					zipCode?: string | null
					hq?: boolean | null
					roLocations?: {
						__typename?: 'roLocations'
						id: string
						name: string
						region2?: string | null
					} | null
				}
			}>
		} | null
		jobCollection?: {
			__typename?: 'JobConnection'
			edges: Array<{
				__typename?: 'JobEdge'
				node: { __typename?: 'Job'; id: string }
			}>
		} | null
	}
	user: {
		__typename?: 'User'
		id: string
		uid: string
		god: boolean
		firebaseToken?: string | null
		profileCollection?: {
			__typename?: 'ProfileConnection'
			edges: Array<{
				__typename?: 'ProfileEdge'
				node: {
					__typename?: 'Profile'
					id: string
					aboutMe?: string | null
					email?: string | null
					firstName: string
					lastName: string
					hasAvatar?: boolean | null
					avatarPath?: string | null
					hasCover?: boolean | null
					coverPath?: string | null
					cvFilePath?: any | null
					cvFileOriginalName?: any | null
					featuredVideo?: string | null
					company_name?: string | null
					userOnBoardingFormVisited?: boolean | null
					user?: {
						__typename?: 'User'
						id: string
						email: string
						_OwnerToCompanyCollection?: {
							__typename?: '_OwnerToCompanyConnection'
							edges: Array<{
								__typename?: '_OwnerToCompanyEdge'
								node: {
									__typename?: '_OwnerToCompany'
									company: {
										__typename?: 'Company'
										id: string
										hasLogo?: boolean | null
										name?: string | null
										slug: string
										logoPath?: string | null
									}
								}
							}>
						} | null
					} | null
					_ProfileToValueCollection?: {
						__typename?: '_ProfileToValueConnection'
						edges: Array<{
							__typename?: '_ProfileToValueEdge'
							node: {
								__typename?: '_ProfileToValue'
								value: {
									__typename?: 'Value'
									id: string
									title?: string | null
								}
							}
						}>
					} | null
					_ProfileToSkillCollection?: {
						__typename?: '_ProfileToSkillConnection'
						edges: Array<{
							__typename?: '_ProfileToSkillEdge'
							node: {
								__typename?: '_ProfileToSkill'
								skill: {
									__typename?: 'Skill'
									id: string
									title: string
								}
							}
						}>
					} | null
					experienceCollection?: {
						__typename?: 'ExperienceConnection'
						edges: Array<{
							__typename?: 'ExperienceEdge'
							node: {
								__typename?: 'Experience'
								id: string
								position?: string | null
								company?: string | null
								startDate?: any | null
								endDate?: any | null
								isCurrent?: boolean | null
								isPresent?: boolean | null
								title?: string | null
								description?: string | null
								roLocations?: {
									__typename?: 'roLocations'
									id: string
									type: string
									name: string
									region2?: string | null
								} | null
							}
						}>
					} | null
				}
			}>
		} | null
		_UserToCompanyRoleCollection?: {
			__typename?: '_UserToCompanyRoleConnection'
			edges: Array<{
				__typename?: '_UserToCompanyRoleEdge'
				node: {
					__typename?: '_UserToCompanyRole'
					companyRole: {
						__typename?: 'CompanyRole'
						id: string
						company?: {
							__typename?: 'Company'
							id: string
							slug: string
							name?: string | null
							hasLogo?: boolean | null
							logoPath?: string | null
							coverPath?: string | null
							hasCover?: boolean | null
							description?: string | null
						} | null
						companyRole_rolesCollection?: {
							__typename?: 'CompanyRole_rolesConnection'
							edges: Array<{
								__typename?: 'CompanyRole_rolesEdge'
								node: {
									__typename?: 'CompanyRole_roles'
									value: string
								}
							}>
						} | null
					}
				}
			}>
		} | null
	}
}

export type StandardTeamResultFragment = {
	__typename?: 'Team'
	id: string
	name: string
	slug: string
	description?: string | null
	noOfMembers?: string | null
	disabilityRatio?: number | null
	averageAge?: number | null
	maleRatio?: number | null
	femaleRatio?: number | null
	coverContentType?: string | null
	coverPath?: string | null
	coverBackground?: string | null
	hasLogo?: boolean | null
	logoContentType?: string | null
	logoPath?: string | null
	hasCover?: boolean | null
	featuredVideo?: string | null
	teamDepartment?: {
		__typename?: 'TeamDepartment'
		id: string
		key: string
		roTitle: string
		enTitle: string
		roCategory?: string | null
		enCategory?: string | null
	} | null
	teamMemberCollection?: {
		__typename?: 'TeamMemberConnection'
		edges: Array<{
			__typename?: 'TeamMemberEdge'
			node: {
				__typename?: 'TeamMember'
				id: string
				user?: {
					__typename?: 'User'
					id: string
					uid: string
					profileCollection?: {
						__typename?: 'ProfileConnection'
						edges: Array<{
							__typename?: 'ProfileEdge'
							node: {
								__typename?: 'Profile'
								id: string
								aboutMe?: string | null
								email?: string | null
								firstName: string
								lastName: string
								hasAvatar?: boolean | null
								avatarPath?: string | null
								hasCover?: boolean | null
								coverPath?: string | null
								experienceCollection?: {
									__typename?: 'ExperienceConnection'
									edges: Array<{
										__typename?: 'ExperienceEdge'
										node: {
											__typename?: 'Experience'
											position?: string | null
											company?: string | null
										}
									}>
								} | null
							}
						}>
					} | null
				} | null
			}
		}>
	} | null
	_TeamToCompanyOfficesCollection?: {
		__typename?: '_TeamToCompanyOfficesConnection'
		edges: Array<{
			__typename?: '_TeamToCompanyOfficesEdge'
			node: {
				__typename?: '_TeamToCompanyOffices'
				companyOffices: {
					__typename?: 'CompanyOffices'
					id: string
					address?: string | null
					zipCode?: string | null
					hq?: boolean | null
					roLocations?: {
						__typename?: 'roLocations'
						id: string
						region2?: string | null
						name: string
					} | null
				}
			}
		}>
	} | null
	company?: {
		__typename?: 'Company'
		id: string
		name?: string | null
		slug: string
		hasLogo?: boolean | null
		logoPath?: string | null
		hasCover?: boolean | null
		coverPath?: string | null
		_OwnerToCompanyCollection?: {
			__typename?: '_OwnerToCompanyConnection'
			edges: Array<{
				__typename?: '_OwnerToCompanyEdge'
				node: {
					__typename?: '_OwnerToCompany'
					A: string
					B: string
					company: {
						__typename: 'Company'
						id: string
						name?: string | null
						slug: string
						dateFounded?: string | null
						headline?: string | null
						description?: string | null
						productsAndServices?: string | null
						noOfEmployees?: string | null
						website?: string | null
						phones?: string | null
						emails?: string | null
						featuredVideo?: string | null
						hasLogo?: boolean | null
						logoPath?: string | null
						hasCover?: boolean | null
						aboutTeams?: string | null
						coverPath?: string | null
						_OwnerToCompanyCollection?: {
							__typename?: '_OwnerToCompanyConnection'
							edges: Array<{
								__typename?: '_OwnerToCompanyEdge'
								node: {
									__typename?: '_OwnerToCompany'
									user: {
										__typename?: 'User'
										id: string
										uid: string
									}
								}
							}>
						} | null
						industry?: {
							__typename?: 'Industry'
							id: string
							key: string
						} | null
						companyOfficesCollection?: {
							__typename?: 'CompanyOfficesConnection'
							edges: Array<{
								__typename?: 'CompanyOfficesEdge'
								node: {
									__typename?: 'CompanyOffices'
									id: string
									address?: string | null
									zipCode?: string | null
									hq?: boolean | null
									roLocations?: {
										__typename?: 'roLocations'
										id: string
										name: string
										region2?: string | null
									} | null
								}
							}>
						} | null
						jobCollection?: {
							__typename?: 'JobConnection'
							edges: Array<{
								__typename?: 'JobEdge'
								node: { __typename?: 'Job'; id: string }
							}>
						} | null
					}
					user: {
						__typename?: 'User'
						id: string
						uid: string
						god: boolean
						firebaseToken?: string | null
						profileCollection?: {
							__typename?: 'ProfileConnection'
							edges: Array<{
								__typename?: 'ProfileEdge'
								node: {
									__typename?: 'Profile'
									id: string
									aboutMe?: string | null
									email?: string | null
									firstName: string
									lastName: string
									hasAvatar?: boolean | null
									avatarPath?: string | null
									hasCover?: boolean | null
									coverPath?: string | null
									cvFilePath?: any | null
									cvFileOriginalName?: any | null
									featuredVideo?: string | null
									company_name?: string | null
									userOnBoardingFormVisited?: boolean | null
									user?: {
										__typename?: 'User'
										id: string
										email: string
										_OwnerToCompanyCollection?: {
											__typename?: '_OwnerToCompanyConnection'
											edges: Array<{
												__typename?: '_OwnerToCompanyEdge'
												node: {
													__typename?: '_OwnerToCompany'
													company: {
														__typename?: 'Company'
														id: string
														hasLogo?: boolean | null
														name?: string | null
														slug: string
														logoPath?: string | null
													}
												}
											}>
										} | null
									} | null
									_ProfileToValueCollection?: {
										__typename?: '_ProfileToValueConnection'
										edges: Array<{
											__typename?: '_ProfileToValueEdge'
											node: {
												__typename?: '_ProfileToValue'
												value: {
													__typename?: 'Value'
													id: string
													title?: string | null
												}
											}
										}>
									} | null
									_ProfileToSkillCollection?: {
										__typename?: '_ProfileToSkillConnection'
										edges: Array<{
											__typename?: '_ProfileToSkillEdge'
											node: {
												__typename?: '_ProfileToSkill'
												skill: {
													__typename?: 'Skill'
													id: string
													title: string
												}
											}
										}>
									} | null
									experienceCollection?: {
										__typename?: 'ExperienceConnection'
										edges: Array<{
											__typename?: 'ExperienceEdge'
											node: {
												__typename?: 'Experience'
												id: string
												position?: string | null
												company?: string | null
												startDate?: any | null
												endDate?: any | null
												isCurrent?: boolean | null
												isPresent?: boolean | null
												title?: string | null
												description?: string | null
												roLocations?: {
													__typename?: 'roLocations'
													id: string
													type: string
													name: string
													region2?: string | null
												} | null
											}
										}>
									} | null
								}
							}>
						} | null
						_UserToCompanyRoleCollection?: {
							__typename?: '_UserToCompanyRoleConnection'
							edges: Array<{
								__typename?: '_UserToCompanyRoleEdge'
								node: {
									__typename?: '_UserToCompanyRole'
									companyRole: {
										__typename?: 'CompanyRole'
										id: string
										company?: {
											__typename?: 'Company'
											id: string
											slug: string
											name?: string | null
											hasLogo?: boolean | null
											logoPath?: string | null
											coverPath?: string | null
											hasCover?: boolean | null
											description?: string | null
										} | null
										companyRole_rolesCollection?: {
											__typename?: 'CompanyRole_rolesConnection'
											edges: Array<{
												__typename?: 'CompanyRole_rolesEdge'
												node: {
													__typename?: 'CompanyRole_roles'
													value: string
												}
											}>
										} | null
									}
								}
							}>
						} | null
					}
				}
			}>
		} | null
		industry?: { __typename?: 'Industry'; id: string; key: string } | null
		companyOfficesCollection?: {
			__typename?: 'CompanyOfficesConnection'
			edges: Array<{
				__typename?: 'CompanyOfficesEdge'
				node: {
					__typename?: 'CompanyOffices'
					id: string
					address?: string | null
					zipCode?: string | null
					hq?: boolean | null
					roLocations?: {
						__typename?: 'roLocations'
						id: string
						name: string
						region2?: string | null
					} | null
				}
			}>
		} | null
	} | null
}

export type TeamConnectionDataFragment = {
	__typename?: 'TeamConnection'
	edges: Array<{
		__typename?: 'TeamEdge'
		cursor: string
		node: {
			__typename?: 'Team'
			id: string
			name: string
			slug: string
			description?: string | null
			noOfMembers?: string | null
			disabilityRatio?: number | null
			averageAge?: number | null
			maleRatio?: number | null
			femaleRatio?: number | null
			coverContentType?: string | null
			coverPath?: string | null
			coverBackground?: string | null
			hasLogo?: boolean | null
			logoContentType?: string | null
			logoPath?: string | null
			hasCover?: boolean | null
			featuredVideo?: string | null
			teamDepartment?: {
				__typename?: 'TeamDepartment'
				id: string
				key: string
				roTitle: string
				enTitle: string
				roCategory?: string | null
				enCategory?: string | null
			} | null
			teamMemberCollection?: {
				__typename?: 'TeamMemberConnection'
				edges: Array<{
					__typename?: 'TeamMemberEdge'
					node: {
						__typename?: 'TeamMember'
						id: string
						user?: {
							__typename?: 'User'
							id: string
							uid: string
							profileCollection?: {
								__typename?: 'ProfileConnection'
								edges: Array<{
									__typename?: 'ProfileEdge'
									node: {
										__typename?: 'Profile'
										id: string
										aboutMe?: string | null
										email?: string | null
										firstName: string
										lastName: string
										hasAvatar?: boolean | null
										avatarPath?: string | null
										hasCover?: boolean | null
										coverPath?: string | null
										experienceCollection?: {
											__typename?: 'ExperienceConnection'
											edges: Array<{
												__typename?: 'ExperienceEdge'
												node: {
													__typename?: 'Experience'
													position?: string | null
													company?: string | null
												}
											}>
										} | null
									}
								}>
							} | null
						} | null
					}
				}>
			} | null
			_TeamToCompanyOfficesCollection?: {
				__typename?: '_TeamToCompanyOfficesConnection'
				edges: Array<{
					__typename?: '_TeamToCompanyOfficesEdge'
					node: {
						__typename?: '_TeamToCompanyOffices'
						companyOffices: {
							__typename?: 'CompanyOffices'
							id: string
							address?: string | null
							zipCode?: string | null
							hq?: boolean | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								region2?: string | null
								name: string
							} | null
						}
					}
				}>
			} | null
			company?: {
				__typename?: 'Company'
				id: string
				name?: string | null
				slug: string
				hasLogo?: boolean | null
				logoPath?: string | null
				hasCover?: boolean | null
				coverPath?: string | null
				_OwnerToCompanyCollection?: {
					__typename?: '_OwnerToCompanyConnection'
					edges: Array<{
						__typename?: '_OwnerToCompanyEdge'
						node: {
							__typename?: '_OwnerToCompany'
							A: string
							B: string
							company: {
								__typename: 'Company'
								id: string
								name?: string | null
								slug: string
								dateFounded?: string | null
								headline?: string | null
								description?: string | null
								productsAndServices?: string | null
								noOfEmployees?: string | null
								website?: string | null
								phones?: string | null
								emails?: string | null
								featuredVideo?: string | null
								hasLogo?: boolean | null
								logoPath?: string | null
								hasCover?: boolean | null
								aboutTeams?: string | null
								coverPath?: string | null
								_OwnerToCompanyCollection?: {
									__typename?: '_OwnerToCompanyConnection'
									edges: Array<{
										__typename?: '_OwnerToCompanyEdge'
										node: {
											__typename?: '_OwnerToCompany'
											user: {
												__typename?: 'User'
												id: string
												uid: string
											}
										}
									}>
								} | null
								industry?: {
									__typename?: 'Industry'
									id: string
									key: string
								} | null
								companyOfficesCollection?: {
									__typename?: 'CompanyOfficesConnection'
									edges: Array<{
										__typename?: 'CompanyOfficesEdge'
										node: {
											__typename?: 'CompanyOffices'
											id: string
											address?: string | null
											zipCode?: string | null
											hq?: boolean | null
											roLocations?: {
												__typename?: 'roLocations'
												id: string
												name: string
												region2?: string | null
											} | null
										}
									}>
								} | null
								jobCollection?: {
									__typename?: 'JobConnection'
									edges: Array<{
										__typename?: 'JobEdge'
										node: { __typename?: 'Job'; id: string }
									}>
								} | null
							}
							user: {
								__typename?: 'User'
								id: string
								uid: string
								god: boolean
								firebaseToken?: string | null
								profileCollection?: {
									__typename?: 'ProfileConnection'
									edges: Array<{
										__typename?: 'ProfileEdge'
										node: {
											__typename?: 'Profile'
											id: string
											aboutMe?: string | null
											email?: string | null
											firstName: string
											lastName: string
											hasAvatar?: boolean | null
											avatarPath?: string | null
											hasCover?: boolean | null
											coverPath?: string | null
											cvFilePath?: any | null
											cvFileOriginalName?: any | null
											featuredVideo?: string | null
											company_name?: string | null
											userOnBoardingFormVisited?:
												| boolean
												| null
											user?: {
												__typename?: 'User'
												id: string
												email: string
												_OwnerToCompanyCollection?: {
													__typename?: '_OwnerToCompanyConnection'
													edges: Array<{
														__typename?: '_OwnerToCompanyEdge'
														node: {
															__typename?: '_OwnerToCompany'
															company: {
																__typename?: 'Company'
																id: string
																hasLogo?:
																	| boolean
																	| null
																name?:
																	| string
																	| null
																slug: string
																logoPath?:
																	| string
																	| null
															}
														}
													}>
												} | null
											} | null
											_ProfileToValueCollection?: {
												__typename?: '_ProfileToValueConnection'
												edges: Array<{
													__typename?: '_ProfileToValueEdge'
													node: {
														__typename?: '_ProfileToValue'
														value: {
															__typename?: 'Value'
															id: string
															title?:
																| string
																| null
														}
													}
												}>
											} | null
											_ProfileToSkillCollection?: {
												__typename?: '_ProfileToSkillConnection'
												edges: Array<{
													__typename?: '_ProfileToSkillEdge'
													node: {
														__typename?: '_ProfileToSkill'
														skill: {
															__typename?: 'Skill'
															id: string
															title: string
														}
													}
												}>
											} | null
											experienceCollection?: {
												__typename?: 'ExperienceConnection'
												edges: Array<{
													__typename?: 'ExperienceEdge'
													node: {
														__typename?: 'Experience'
														id: string
														position?: string | null
														company?: string | null
														startDate?: any | null
														endDate?: any | null
														isCurrent?:
															| boolean
															| null
														isPresent?:
															| boolean
															| null
														title?: string | null
														description?:
															| string
															| null
														roLocations?: {
															__typename?: 'roLocations'
															id: string
															type: string
															name: string
															region2?:
																| string
																| null
														} | null
													}
												}>
											} | null
										}
									}>
								} | null
								_UserToCompanyRoleCollection?: {
									__typename?: '_UserToCompanyRoleConnection'
									edges: Array<{
										__typename?: '_UserToCompanyRoleEdge'
										node: {
											__typename?: '_UserToCompanyRole'
											companyRole: {
												__typename?: 'CompanyRole'
												id: string
												company?: {
													__typename?: 'Company'
													id: string
													slug: string
													name?: string | null
													hasLogo?: boolean | null
													logoPath?: string | null
													coverPath?: string | null
													hasCover?: boolean | null
													description?: string | null
												} | null
												companyRole_rolesCollection?: {
													__typename?: 'CompanyRole_rolesConnection'
													edges: Array<{
														__typename?: 'CompanyRole_rolesEdge'
														node: {
															__typename?: 'CompanyRole_roles'
															value: string
														}
													}>
												} | null
											}
										}
									}>
								} | null
							}
						}
					}>
				} | null
				industry?: {
					__typename?: 'Industry'
					id: string
					key: string
				} | null
				companyOfficesCollection?: {
					__typename?: 'CompanyOfficesConnection'
					edges: Array<{
						__typename?: 'CompanyOfficesEdge'
						node: {
							__typename?: 'CompanyOffices'
							id: string
							address?: string | null
							zipCode?: string | null
							hq?: boolean | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								name: string
								region2?: string | null
							} | null
						}
					}>
				} | null
			} | null
		}
	}>
	pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean }
}

export type AuthenticationUserFragment = {
	__typename?: 'User'
	id: string
	uid: string
	god: boolean
	firebaseToken?: string | null
	profileCollection?: {
		__typename?: 'ProfileConnection'
		edges: Array<{
			__typename?: 'ProfileEdge'
			node: {
				__typename?: 'Profile'
				id: string
				aboutMe?: string | null
				email?: string | null
				firstName: string
				lastName: string
				hasAvatar?: boolean | null
				avatarPath?: string | null
				hasCover?: boolean | null
				coverPath?: string | null
				cvFilePath?: any | null
				cvFileOriginalName?: any | null
				featuredVideo?: string | null
				company_name?: string | null
				userOnBoardingFormVisited?: boolean | null
				worksAt?: {
					company: string
				}
				user?: {
					__typename?: 'User'
					id: string
					email: string
					_OwnerToCompanyCollection?: {
						__typename?: '_OwnerToCompanyConnection'
						edges: Array<{
							__typename?: '_OwnerToCompanyEdge'
							node: {
								__typename?: '_OwnerToCompany'
								company: {
									__typename?: 'Company'
									id: string
									hasLogo?: boolean | null
									name?: string | null
									slug: string
									logoPath?: string | null
								}
							}
						}>
					} | null
				} | null
				_ProfileToValueCollection?: {
					__typename?: '_ProfileToValueConnection'
					edges: Array<{
						__typename?: '_ProfileToValueEdge'
						node: {
							__typename?: '_ProfileToValue'
							value: {
								__typename?: 'Value'
								id: string
								title?: string | null
							}
						}
					}>
				} | null
				_ProfileToSkillCollection?: {
					__typename?: '_ProfileToSkillConnection'
					edges: Array<{
						__typename?: '_ProfileToSkillEdge'
						node: {
							__typename?: '_ProfileToSkill'
							skill: {
								__typename?: 'Skill'
								id: string
								title: string
							}
						}
					}>
				} | null
				experienceCollection?: {
					__typename?: 'ExperienceConnection'
					edges: Array<{
						__typename?: 'ExperienceEdge'
						node: {
							__typename?: 'Experience'
							id: string
							position?: string | null
							company?: string | null
							startDate?: any | null
							endDate?: any | null
							isCurrent?: boolean | null
							isPresent?: boolean | null
							title?: string | null
							description?: string | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								type: string
								name: string
								region2?: string | null
							} | null
						}
					}>
				} | null
			}
		}>
	} | null
	_UserToCompanyRoleCollection?: {
		__typename?: '_UserToCompanyRoleConnection'
		edges: Array<{
			__typename?: '_UserToCompanyRoleEdge'
			node: {
				__typename?: '_UserToCompanyRole'
				companyRole: {
					__typename?: 'CompanyRole'
					id: string
					company?: {
						__typename?: 'Company'
						id: string
						slug: string
						name?: string | null
						hasLogo?: boolean | null
						logoPath?: string | null
						coverPath?: string | null
						hasCover?: boolean | null
						description?: string | null
					} | null
					companyRole_rolesCollection?: {
						__typename?: 'CompanyRole_rolesConnection'
						edges: Array<{
							__typename?: 'CompanyRole_rolesEdge'
							node: {
								__typename?: 'CompanyRole_roles'
								value: string
							}
						}>
					} | null
				}
			}
		}>
	} | null
}

export type UserExperienceFragment = {
	__typename?: 'Experience'
	id: string
	position?: string | null
	company?: string | null
	startDate?: any | null
	endDate?: any | null
	isCurrent?: boolean | null
	title?: string | null
	description?: string | null
	roLocations?: {
		__typename?: 'roLocations'
		id: string
		type: string
		name: string
		region2?: string | null
	} | null
}

export type UserRoleFragmentFragment = {
	__typename?: '_UserToCompanyRole'
	A: string
	B: string
	user: {
		__typename?: 'User'
		id: string
		profileCollection?: {
			__typename?: 'ProfileConnection'
			edges: Array<{
				__typename?: 'ProfileEdge'
				node: {
					__typename?: 'Profile'
					id: string
					firstName: string
					lastName: string
					avatarPath?: string | null
				}
			}>
		} | null
	}
}

export type HandleArticleMutationVariables = Exact<{
	articleId: Scalars['String']['input']
	userId: Scalars['String']['input']
	companyId: Scalars['String']['input']
	teamId: Scalars['String']['input']
	postAs: Scalars['String']['input']
	title: Scalars['String']['input']
	description: Scalars['String']['input']
	body: Scalars['String']['input']
	imageId: Scalars['String']['input']
	images: Array<ImageInsertInput> | ImageInsertInput
}>

export type HandleArticleMutation = {
	__typename?: 'Mutation'
	insertIntoImageCollection?: {
		__typename?: 'ImageInsertResponse'
		affectedCount: number
		records: Array<{
			__typename?: 'Image'
			id: string
			title?: string | null
		}>
	} | null
	updateArticleCollection: {
		__typename?: 'ArticleUpdateResponse'
		affectedCount: number
		records: Array<{
			__typename?: 'Article'
			id: string
			worksAt?: string | null
			readDuration?: number | null
			title?: string | null
			body: string
			slug?: string | null
			description?: string | null
			isPost?: boolean | null
			postAs?: string | null
			postingCompany?: string | null
			createdAt: any
			updatedAt: any
			featuredVideo?: string | null
			user?: {
				__typename?: 'User'
				id: string
				uid: string
				email: string
				god: boolean
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							firstName: string
							lastName: string
							cvFilePath?: any | null
							cvFileOriginalName?: any | null
							hasAvatar?: boolean | null
							avatarContentType?: string | null
							avatarPath?: string | null
							experienceCollection?: {
								__typename?: 'ExperienceConnection'
								edges: Array<{
									__typename?: 'ExperienceEdge'
									node: {
										__typename?: 'Experience'
										position?: string | null
										company?: string | null
									}
								}>
							} | null
						}
					}>
				} | null
			} | null
			company?: {
				__typename?: 'Company'
				id: string
				name?: string | null
				slug: string
				hasLogo?: boolean | null
				logoPath?: string | null
				industry?: {
					__typename?: 'Industry'
					id: string
					key: string
				} | null
			} | null
			activeArticleTagCollection?: {
				__typename?: 'ActiveArticleTagConnection'
				edges: Array<{
					__typename?: 'ActiveArticleTagEdge'
					node: {
						__typename?: 'ActiveArticleTag'
						id: string
						votes?: number | null
						articleTag?: {
							__typename?: 'ArticleTag'
							title: string
						} | null
						_ActiveArticleTagToUserCollection?: {
							__typename?: '_ActiveArticleTagToUserConnection'
							edges: Array<{
								__typename?: '_ActiveArticleTagToUserEdge'
								node: {
									__typename?: '_ActiveArticleTagToUser'
									user: {
										__typename?: 'User'
										profileCollection?: {
											__typename?: 'ProfileConnection'
											edges: Array<{
												__typename?: 'ProfileEdge'
												node: {
													__typename?: 'Profile'
													firstName: string
													lastName: string
													user?: {
														__typename?: 'User'
														id: string
														uid: string
													} | null
												}
											}>
										} | null
									}
								}
							}>
						} | null
					}
				}>
			} | null
			image?: {
				__typename?: 'Image'
				id: string
				filename?: string | null
			} | null
		}>
	}
}

export type DeleteArticleMutationVariables = Exact<{
	id: Scalars['String']['input']
}>

export type DeleteArticleMutation = {
	__typename?: 'Mutation'
	deleteFromArticleCollection: {
		__typename?: 'ArticleDeleteResponse'
		records: Array<{
			__typename?: 'Article'
			id: string
			worksAt?: string | null
			readDuration?: number | null
			title?: string | null
			body: string
			slug?: string | null
			description?: string | null
			isPost?: boolean | null
			postAs?: string | null
			postingCompany?: string | null
			createdAt: any
			updatedAt: any
			featuredVideo?: string | null
			user?: {
				__typename?: 'User'
				id: string
				uid: string
				email: string
				god: boolean
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							firstName: string
							lastName: string
							cvFilePath?: any | null
							cvFileOriginalName?: any | null
							hasAvatar?: boolean | null
							avatarContentType?: string | null
							avatarPath?: string | null
							experienceCollection?: {
								__typename?: 'ExperienceConnection'
								edges: Array<{
									__typename?: 'ExperienceEdge'
									node: {
										__typename?: 'Experience'
										position?: string | null
										company?: string | null
									}
								}>
							} | null
						}
					}>
				} | null
			} | null
			company?: {
				__typename?: 'Company'
				id: string
				name?: string | null
				slug: string
				hasLogo?: boolean | null
				logoPath?: string | null
				industry?: {
					__typename?: 'Industry'
					id: string
					key: string
				} | null
			} | null
			activeArticleTagCollection?: {
				__typename?: 'ActiveArticleTagConnection'
				edges: Array<{
					__typename?: 'ActiveArticleTagEdge'
					node: {
						__typename?: 'ActiveArticleTag'
						id: string
						votes?: number | null
						articleTag?: {
							__typename?: 'ArticleTag'
							title: string
						} | null
						_ActiveArticleTagToUserCollection?: {
							__typename?: '_ActiveArticleTagToUserConnection'
							edges: Array<{
								__typename?: '_ActiveArticleTagToUserEdge'
								node: {
									__typename?: '_ActiveArticleTagToUser'
									user: {
										__typename?: 'User'
										profileCollection?: {
											__typename?: 'ProfileConnection'
											edges: Array<{
												__typename?: 'ProfileEdge'
												node: {
													__typename?: 'Profile'
													firstName: string
													lastName: string
													user?: {
														__typename?: 'User'
														id: string
														uid: string
													} | null
												}
											}>
										} | null
									}
								}
							}>
						} | null
					}
				}>
			} | null
			image?: {
				__typename?: 'Image'
				id: string
				filename?: string | null
			} | null
		}>
	}
}

export type ArticlesByEntityQueryVariables = Exact<{
	userId?: InputMaybe<Scalars['String']['input']>
	companyId?: InputMaybe<Scalars['String']['input']>
	teamId?: InputMaybe<Scalars['String']['input']>
}>

export type ArticlesByEntityQuery = {
	__typename?: 'Query'
	feedArticles?: {
		__typename?: 'ArticleConnection'
		edges: Array<{
			__typename?: 'ArticleEdge'
			node: {
				__typename?: 'Article'
				id: string
				title?: string | null
				body: string
				slug?: string | null
				description?: string | null
				isPost?: boolean | null
				featuredVideo?: string | null
				updatedAt?: string
				user?: {
					__typename?: 'User'
					id: string
					email: string
					profileCollection?: {
						__typename?: 'ProfileConnection'
						edges: Array<{
							__typename?: 'ProfileEdge'
							node: {
								__typename?: 'Profile'
								id: string
								firstName: string
								lastName: string
							}
						}>
					} | null
				} | null
				image?: {
					__typename?: 'Image'
					id: string
					filename?: string | null
				} | null
			}
		}>
	} | null
}

export type ArticleQueryVariables = Exact<{
	id?: InputMaybe<Scalars['String']['input']>
	slug?: InputMaybe<Scalars['String']['input']>
}>

export type ArticleQuery = {
	__typename?: 'Query'
	feedArticles?: {
		__typename?: 'ArticleConnection'
		edges: Array<{
			__typename?: 'ArticleEdge'
			node: {
				__typename?: 'Article'
				id: string
				worksAt?: string | null
				readDuration?: number | null
				title?: string | null
				body: string
				slug?: string | null
				description?: string | null
				isPost?: boolean | null
				postAs?: string | null
				postingCompany?: string | null
				createdAt: any
				updatedAt: any
				featuredVideo?: string | null
				user?: {
					__typename?: 'User'
					id: string
					uid: string
					email: string
					god: boolean
					profileCollection?: {
						__typename?: 'ProfileConnection'
						edges: Array<{
							__typename?: 'ProfileEdge'
							node: {
								__typename?: 'Profile'
								id: string
								firstName: string
								lastName: string
								cvFilePath?: any | null
								cvFileOriginalName?: any | null
								hasAvatar?: boolean | null
								avatarContentType?: string | null
								avatarPath?: string | null
								experienceCollection?: {
									__typename?: 'ExperienceConnection'
									edges: Array<{
										__typename?: 'ExperienceEdge'
										node: {
											__typename?: 'Experience'
											position?: string | null
											company?: string | null
										}
									}>
								} | null
							}
						}>
					} | null
				} | null
				company?: {
					__typename?: 'Company'
					id: string
					name?: string | null
					slug: string
					hasLogo?: boolean | null
					logoPath?: string | null
					industry?: {
						__typename?: 'Industry'
						id: string
						key: string
					} | null
				} | null
				activeArticleTagCollection?: {
					__typename?: 'ActiveArticleTagConnection'
					edges: Array<{
						__typename?: 'ActiveArticleTagEdge'
						node: {
							__typename?: 'ActiveArticleTag'
							id: string
							votes?: number | null
							articleTag?: {
								__typename?: 'ArticleTag'
								title: string
							} | null
							_ActiveArticleTagToUserCollection?: {
								__typename?: '_ActiveArticleTagToUserConnection'
								edges: Array<{
									__typename?: '_ActiveArticleTagToUserEdge'
									node: {
										__typename?: '_ActiveArticleTagToUser'
										user: {
											__typename?: 'User'
											profileCollection?: {
												__typename?: 'ProfileConnection'
												edges: Array<{
													__typename?: 'ProfileEdge'
													node: {
														__typename?: 'Profile'
														firstName: string
														lastName: string
														user?: {
															__typename?: 'User'
															id: string
															uid: string
														} | null
													}
												}>
											} | null
										}
									}
								}>
							} | null
						}
					}>
				} | null
				image?: {
					__typename?: 'Image'
					id: string
					filename?: string | null
				} | null
			}
		}>
	} | null
}

export type FeedarticlesQueryVariables = Exact<{
	userid?: InputMaybe<Scalars['String']['input']>
	companyslug?: InputMaybe<Scalars['String']['input']>
	teamid?: InputMaybe<Scalars['String']['input']>
	first?: InputMaybe<Scalars['Int']['input']>
	after?: InputMaybe<Scalars['Cursor']['input']>
}>

export type FeedarticlesQuery = {
	__typename?: 'Query'
	feedArticles?: {
		__typename?: 'ArticleConnection'
		edges: Array<{
			__typename?: 'ArticleEdge'
			cursor: string
			node: {
				__typename?: 'Article'
				id: string
				worksAt?: string | null
				readDuration?: number | null
				title?: string | null
				body: string
				slug?: string | null
				description?: string | null
				isPost?: boolean | null
				postAs?: string | null
				postingCompany?: string | null
				createdAt: any
				updatedAt: any
				featuredVideo?: string | null
				user?: {
					__typename?: 'User'
					id: string
					uid: string
					email: string
					god: boolean
					profileCollection?: {
						__typename?: 'ProfileConnection'
						edges: Array<{
							__typename?: 'ProfileEdge'
							node: {
								__typename?: 'Profile'
								id: string
								firstName: string
								lastName: string
								cvFilePath?: any | null
								cvFileOriginalName?: any | null
								hasAvatar?: boolean | null
								avatarContentType?: string | null
								avatarPath?: string | null
								experienceCollection?: {
									__typename?: 'ExperienceConnection'
									edges: Array<{
										__typename?: 'ExperienceEdge'
										node: {
											__typename?: 'Experience'
											position?: string | null
											company?: string | null
										}
									}>
								} | null
							}
						}>
					} | null
				} | null
				company?: {
					__typename?: 'Company'
					id: string
					name?: string | null
					slug: string
					hasLogo?: boolean | null
					logoPath?: string | null
					industry?: {
						__typename?: 'Industry'
						id: string
						key: string
					} | null
				} | null
				activeArticleTagCollection?: {
					__typename?: 'ActiveArticleTagConnection'
					edges: Array<{
						__typename?: 'ActiveArticleTagEdge'
						node: {
							__typename?: 'ActiveArticleTag'
							id: string
							votes?: number | null
							articleTag?: {
								__typename?: 'ArticleTag'
								id: string
								title: string
							} | null
							_ActiveArticleTagToUserCollection?: {
								__typename?: '_ActiveArticleTagToUserConnection'
								edges: Array<{
									__typename?: '_ActiveArticleTagToUserEdge'
									node: {
										__typename?: '_ActiveArticleTagToUser'
										user: {
											__typename?: 'User'
											profileCollection?: {
												__typename?: 'ProfileConnection'
												edges: Array<{
													__typename?: 'ProfileEdge'
													node: {
														__typename?: 'Profile'
														firstName: string
														lastName: string
														user?: {
															__typename?: 'User'
															id: string
															uid: string
														} | null
													}
												}>
											} | null
										}
									}
								}>
							} | null
						}
					}>
				} | null
				image?: {
					__typename?: 'Image'
					id: string
					filename?: string | null
				} | null
			}
		}>
		pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean }
	} | null
}

export type FeedTeamArticlesQueryVariables = Exact<{
	teamId: Scalars['String']['input']
	first: Scalars['Int']['input']
	after?: InputMaybe<Scalars['Cursor']['input']>
}>

export type FeedTeamArticlesQuery = {
	__typename?: 'Query'
	feed_team_articles?: {
		__typename?: 'ArticleConnection'
		edges: Array<{
			__typename?: 'ArticleEdge'
			cursor: string
			node: {
				__typename?: 'Article'
				id: string
				worksAt?: string | null
				readDuration?: number | null
				title?: string | null
				body: string
				slug?: string | null
				description?: string | null
				isPost?: boolean | null
				postAs?: string | null
				postingCompany?: string | null
				createdAt: any
				updatedAt: any
				featuredVideo?: string | null
				user?: {
					__typename?: 'User'
					id: string
					uid: string
					email: string
					god: boolean
					profileCollection?: {
						__typename?: 'ProfileConnection'
						edges: Array<{
							__typename?: 'ProfileEdge'
							node: {
								__typename?: 'Profile'
								id: string
								firstName: string
								lastName: string
								cvFilePath?: any | null
								cvFileOriginalName?: any | null
								hasAvatar?: boolean | null
								avatarContentType?: string | null
								avatarPath?: string | null
								experienceCollection?: {
									__typename?: 'ExperienceConnection'
									edges: Array<{
										__typename?: 'ExperienceEdge'
										node: {
											__typename?: 'Experience'
											position?: string | null
											company?: string | null
										}
									}>
								} | null
							}
						}>
					} | null
				} | null
				company?: {
					__typename?: 'Company'
					id: string
					name?: string | null
					slug: string
					hasLogo?: boolean | null
					logoPath?: string | null
					industry?: {
						__typename?: 'Industry'
						id: string
						key: string
					} | null
				} | null
				activeArticleTagCollection?: {
					__typename?: 'ActiveArticleTagConnection'
					edges: Array<{
						__typename?: 'ActiveArticleTagEdge'
						node: {
							__typename?: 'ActiveArticleTag'
							id: string
							votes?: number | null
							articleTag?: {
								__typename?: 'ArticleTag'
								title: string
							} | null
							_ActiveArticleTagToUserCollection?: {
								__typename?: '_ActiveArticleTagToUserConnection'
								edges: Array<{
									__typename?: '_ActiveArticleTagToUserEdge'
									node: {
										__typename?: '_ActiveArticleTagToUser'
										user: {
											__typename?: 'User'
											profileCollection?: {
												__typename?: 'ProfileConnection'
												edges: Array<{
													__typename?: 'ProfileEdge'
													node: {
														__typename?: 'Profile'
														firstName: string
														lastName: string
														user?: {
															__typename?: 'User'
															id: string
															uid: string
														} | null
													}
												}>
											} | null
										}
									}
								}>
							} | null
						}
					}>
				} | null
				image?: {
					__typename?: 'Image'
					id: string
					filename?: string | null
				} | null
			}
		}>
		pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean }
	} | null
}

export type GetArticleTagVotersQueryVariables = Exact<{
	articleId: Scalars['String']['input']
}>

export type GetArticleTagVotersQuery = {
	__typename?: 'Query'
	activeArticleTagCollection?: {
		__typename?: 'ActiveArticleTagConnection'
		edges: Array<{
			__typename?: 'ActiveArticleTagEdge'
			node: {
				__typename?: 'ActiveArticleTag'
				articleTag?: {
					__typename?: 'ArticleTag'
					id: string
					title: string
				} | null
				_ActiveArticleTagToUserCollection?: {
					__typename?: '_ActiveArticleTagToUserConnection'
					edges: Array<{
						__typename?: '_ActiveArticleTagToUserEdge'
						node: {
							__typename?: '_ActiveArticleTagToUser'
							user: {
								__typename?: 'User'
								id: string
								uid: string
								profileCollection?: {
									__typename?: 'ProfileConnection'
									edges: Array<{
										__typename?: 'ProfileEdge'
										node: {
											__typename?: 'Profile'
											id: string
											firstName: string
											lastName: string
											avatarPath?: string | null
											experienceCollection?: {
												__typename?: 'ExperienceConnection'
												edges: Array<{
													__typename?: 'ExperienceEdge'
													node: {
														__typename?: 'Experience'
														position?: string | null
														company?: string | null
													}
												}>
											} | null
										}
									}>
								} | null
							}
							activeArticleTag: {
								__typename?: 'ActiveArticleTag'
								votes?: number | null
								tag?: string | null
								articleTag?: {
									__typename?: 'ArticleTag'
									id: string
									title: string
								} | null
								article?: {
									__typename?: 'Article'
									id: string
									title?: string | null
									slug?: string | null
								} | null
							}
						}
					}>
				} | null
			}
		}>
	} | null
}

export type UserCollectionQueryVariables = Exact<{
	filter?: InputMaybe<UserFilter>
}>

export type UserCollectionQuery = {
	__typename?: 'Query'
	userCollection?: {
		__typename?: 'UserConnection'
		edges: Array<{
			__typename?: 'UserEdge'
			node: {
				__typename?: 'User'
				id: string
				uid: string
				god: boolean
				firebaseToken?: string | null
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							aboutMe?: string | null
							email?: string | null
							firstName: string
							lastName: string
							hasAvatar?: boolean | null
							avatarPath?: string | null
							hasCover?: boolean | null
							coverPath?: string | null
							cvFilePath?: any | null
							cvFileOriginalName?: any | null
							featuredVideo?: string | null
							company_name?: string | null
							userOnBoardingFormVisited?: boolean | null
							user?: {
								__typename?: 'User'
								id: string
								email: string
								_OwnerToCompanyCollection?: {
									__typename?: '_OwnerToCompanyConnection'
									edges: Array<{
										__typename?: '_OwnerToCompanyEdge'
										node: {
											__typename?: '_OwnerToCompany'
											company: {
												__typename?: 'Company'
												id: string
												hasLogo?: boolean | null
												name?: string | null
												slug: string
												logoPath?: string | null
											}
										}
									}>
								} | null
							} | null
							_ProfileToValueCollection?: {
								__typename?: '_ProfileToValueConnection'
								edges: Array<{
									__typename?: '_ProfileToValueEdge'
									node: {
										__typename?: '_ProfileToValue'
										value: {
											__typename?: 'Value'
											id: string
											title?: string | null
										}
									}
								}>
							} | null
							_ProfileToSkillCollection?: {
								__typename?: '_ProfileToSkillConnection'
								edges: Array<{
									__typename?: '_ProfileToSkillEdge'
									node: {
										__typename?: '_ProfileToSkill'
										skill: {
											__typename?: 'Skill'
											id: string
											title: string
										}
									}
								}>
							} | null
							experienceCollection?: {
								__typename?: 'ExperienceConnection'
								edges: Array<{
									__typename?: 'ExperienceEdge'
									node: {
										__typename?: 'Experience'
										id: string
										position?: string | null
										company?: string | null
										startDate?: any | null
										endDate?: any | null
										isCurrent?: boolean | null
										isPresent?: boolean | null
										title?: string | null
										description?: string | null
										roLocations?: {
											__typename?: 'roLocations'
											id: string
											type: string
											name: string
											region2?: string | null
										} | null
									}
								}>
							} | null
						}
					}>
				} | null
				_UserToCompanyRoleCollection?: {
					__typename?: '_UserToCompanyRoleConnection'
					edges: Array<{
						__typename?: '_UserToCompanyRoleEdge'
						node: {
							__typename?: '_UserToCompanyRole'
							companyRole: {
								__typename?: 'CompanyRole'
								id: string
								company?: {
									__typename?: 'Company'
									id: string
									slug: string
									name?: string | null
									hasLogo?: boolean | null
									logoPath?: string | null
									coverPath?: string | null
									hasCover?: boolean | null
									description?: string | null
								} | null
								companyRole_rolesCollection?: {
									__typename?: 'CompanyRole_rolesConnection'
									edges: Array<{
										__typename?: 'CompanyRole_rolesEdge'
										node: {
											__typename?: 'CompanyRole_roles'
											value: string
										}
									}>
								} | null
							}
						}
					}>
				} | null
			}
		}>
	} | null
}

export type CheckCredentialsQueryVariables = Exact<{ token?: string }>

export type CheckCredentialsQuery = {
	__typename?: 'Query'
	checkCredentials?: {
		__typename?: 'User'
		id: string
		uid: string
		god: boolean
		firebaseToken?: string | null
		profileCollection?: {
			__typename?: 'ProfileConnection'
			edges: Array<{
				__typename?: 'ProfileEdge'
				node: {
					__typename?: 'Profile'
					id: string
					aboutMe?: string | null
					email?: string | null
					firstName: string
					lastName: string
					hasAvatar?: boolean | null
					avatarPath?: string | null
					hasCover?: boolean | null
					coverPath?: string | null
					cvFilePath?: any | null
					cvFileOriginalName?: any | null
					featuredVideo?: string | null
					company_name?: string | null
					userOnBoardingFormVisited?: boolean | null
					user?: {
						__typename?: 'User'
						id: string
						email: string
						_OwnerToCompanyCollection?: {
							__typename?: '_OwnerToCompanyConnection'
							edges: Array<{
								__typename?: '_OwnerToCompanyEdge'
								node: {
									__typename?: '_OwnerToCompany'
									company: {
										__typename?: 'Company'
										id: string
										hasLogo?: boolean | null
										name?: string | null
										slug: string
										logoPath?: string | null
									}
								}
							}>
						} | null
					} | null
					_ProfileToValueCollection?: {
						__typename?: '_ProfileToValueConnection'
						edges: Array<{
							__typename?: '_ProfileToValueEdge'
							node: {
								__typename?: '_ProfileToValue'
								value: {
									__typename?: 'Value'
									id: string
									title?: string | null
								}
							}
						}>
					} | null
					_ProfileToSkillCollection?: {
						__typename?: '_ProfileToSkillConnection'
						edges: Array<{
							__typename?: '_ProfileToSkillEdge'
							node: {
								__typename?: '_ProfileToSkill'
								skill: {
									__typename?: 'Skill'
									id: string
									title: string
								}
							}
						}>
					} | null
					experienceCollection?: {
						__typename?: 'ExperienceConnection'
						edges: Array<{
							__typename?: 'ExperienceEdge'
							node: {
								__typename?: 'Experience'
								id: string
								position?: string | null
								company?: string | null
								startDate?: any | null
								endDate?: any | null
								isCurrent?: boolean | null
								isPresent?: boolean | null
								title?: string | null
								description?: string | null
								roLocations?: {
									__typename?: 'roLocations'
									id: string
									type: string
									name: string
									region2?: string | null
								} | null
							}
						}>
					} | null
				}
			}>
		} | null
		_UserToCompanyRoleCollection?: {
			__typename?: '_UserToCompanyRoleConnection'
			edges: Array<{
				__typename?: '_UserToCompanyRoleEdge'
				node: {
					__typename?: '_UserToCompanyRole'
					companyRole: {
						__typename?: 'CompanyRole'
						id: string
						company?: {
							__typename?: 'Company'
							id: string
							slug: string
							name?: string | null
							hasLogo?: boolean | null
							logoPath?: string | null
							coverPath?: string | null
							hasCover?: boolean | null
							description?: string | null
						} | null
						companyRole_rolesCollection?: {
							__typename?: 'CompanyRole_rolesConnection'
							edges: Array<{
								__typename?: 'CompanyRole_rolesEdge'
								node: {
									__typename?: 'CompanyRole_roles'
									value: string
								}
							}>
						} | null
					}
				}
			}>
		} | null
	} | null
}

export type GetChillPackCompaniesQueryVariables = Exact<{
	[key: string]: never
}>

export type GetChillPackCompaniesQuery = {
	__typename?: 'Query'
	chillPackCompanyCollection?: {
		__typename?: 'ChillPackCompanyConnection'
		edges: Array<{
			__typename?: 'ChillPackCompanyEdge'
			node: { __typename?: 'ChillPackCompany'; id: string; name: string }
		}>
	} | null
}

export type ExportChillPackRecipientsQueryVariables = Exact<{
	[key: string]: never
}>

export type ExportChillPackRecipientsQuery = {
	__typename?: 'Query'
	export_chill_pack_recipients?: {
		__typename?: 'exportchillpackrecipientsConnection'
		edges: Array<{
			__typename?: 'exportchillpackrecipientsEdge'
			node: {
				__typename?: 'exportchillpackrecipients'
				id: string
				email: string
				chillpackrecipientclaim?: string | null
				createdat?: any | null
				recipientlastname?: string | null
				recipientfirstname?: string | null
				companyname?: string | null
			}
		}>
	} | null
}

export type AddChillPackRecipientMutationVariables = Exact<{
	data: Array<ChillPackRecipientInsertInput> | ChillPackRecipientInsertInput
}>

export type AddChillPackRecipientMutation = {
	__typename?: 'Mutation'
	insertIntoChillPackRecipientCollection?: {
		__typename?: 'ChillPackRecipientInsertResponse'
		records: Array<{
			__typename?: 'ChillPackRecipient'
			firstName: string
			lastName: string
			email: string
			chillPackCompany?: {
				__typename?: 'ChillPackCompany'
				id: string
				name: string
			} | null
		}>
	} | null
}

export type IndustryCollectionQueryVariables = Exact<{ [key: string]: never }>

export type IndustryCollectionQuery = {
	__typename?: 'Query'
	industryCollection?: {
		__typename?: 'IndustryConnection'
		edges: Array<{
			__typename?: 'IndustryEdge'
			node: { __typename?: 'Industry'; id: string; key: string }
		}>
	} | null
}

export type CompanyTypeCollectionQueryVariables = Exact<{
	[key: string]: never
}>

export type CompanyTypeCollectionQuery = {
	__typename?: 'Query'
	companyTypeCollection?: {
		__typename?: 'CompanyTypeConnection'
		edges: Array<{
			__typename?: 'CompanyTypeEdge'
			node: {
				__typename?: 'CompanyType'
				id: string
				title?: string | null
			}
		}>
	} | null
}

export type CompaniesQueryVariables = Exact<{
	filter?: InputMaybe<CompanyFilter>
}>

export type CompaniesQuery = {
	__typename?: 'Query'
	companyCollection?: {
		__typename?: 'CompanyConnection'
		edges: Array<{
			__typename?: 'CompanyEdge'
			node: {
				__typename?: 'Company'
				id: string
				name?: string | null
				slug: string
			}
		}>
	} | null
}

export type CompanyQueryVariables = Exact<{
	id?: InputMaybe<Scalars['String']['input']>
	name?: InputMaybe<Scalars['String']['input']>
	slug?: InputMaybe<Scalars['String']['input']>
}>

export type CompanyQuery = {
	__typename?: 'Query'
	companyCollection?: {
		__typename?: 'CompanyConnection'
		edges: Array<{
			__typename?: 'CompanyEdge'
			node: {
				__typename: 'Company'
				id: string
				name?: string | null
				slug: string
				dateFounded?: string | null
				headline?: string | null
				description?: string | null
				productsAndServices?: string | null
				noOfEmployees?: string | null
				website?: string | null
				phones?: string | null
				emails?: string | null
				featuredVideo?: string | null
				hasLogo?: boolean | null
				logoPath?: string | null
				hasCover?: boolean | null
				aboutTeams?: string | null
				coverPath?: string | null
				_OwnerToCompanyCollection?: {
					__typename?: '_OwnerToCompanyConnection'
					edges: Array<{
						__typename?: '_OwnerToCompanyEdge'
						node: {
							__typename?: '_OwnerToCompany'
							user: {
								__typename?: 'User'
								id: string
								uid: string
							}
						}
					}>
				} | null
				industry?: {
					__typename?: 'Industry'
					id: string
					key: string
				} | null
				companyOfficesCollection?: {
					__typename?: 'CompanyOfficesConnection'
					edges: Array<{
						__typename?: 'CompanyOfficesEdge'
						node: {
							__typename?: 'CompanyOffices'
							id: string
							address?: string | null
							zipCode?: string | null
							hq?: boolean | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								name: string
								region2?: string | null
							} | null
						}
					}>
				} | null
				jobCollection?: {
					__typename?: 'JobConnection'
					edges: Array<{
						__typename?: 'JobEdge'
						node: { __typename?: 'Job'; id: string }
					}>
				} | null
			}
		}>
	} | null
}

export type CompanyOfficeQueryVariables = Exact<{
	id?: InputMaybe<Scalars['String']['input']>
}>

export type CompanyOfficeQuery = {
	__typename?: 'Query'
	companyOfficesCollection?: {
		__typename?: 'CompanyOfficesConnection'
		edges: Array<{
			__typename?: 'CompanyOfficesEdge'
			node: {
				__typename?: 'CompanyOffices'
				id: string
				address?: string | null
				zipCode?: string | null
				hq?: boolean | null
				roLocations?: {
					__typename?: 'roLocations'
					id: string
					region2?: string | null
					name: string
				} | null
			}
		}>
	} | null
}

export type CompanyOfficesQueryVariables = Exact<{
	companySlug?: InputMaybe<Scalars['String']['input']>
	companyId?: InputMaybe<Scalars['String']['input']>
}>

export type CompanyOfficesQuery = {
	__typename?: 'Query'
	companyOfficesCollection?: {
		__typename?: 'CompanyOfficesConnection'
		edges: Array<{
			__typename?: 'CompanyOfficesEdge'
			node: {
				__typename?: 'CompanyOffices'
				id: string
				address?: string | null
				zipCode?: string | null
				hq?: boolean | null
				roLocations?: {
					__typename?: 'roLocations'
					id: string
					region2?: string | null
					name: string
				} | null
			}
		}>
	} | null
}

export type FeedcompaniesQueryVariables = Exact<{
	name?: InputMaybe<Scalars['String']['input']>
	sizes?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	industryids?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	locationsids?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	after?: InputMaybe<Scalars['Cursor']['input']>
	first?: InputMaybe<Scalars['Int']['input']>
}>

export type FeedcompaniesQuery = {
	__typename?: 'Query'
	feedcompanies?: {
		__typename?: 'CompanyConnection'
		edges: Array<{
			__typename?: 'CompanyEdge'
			cursor: string
			node: {
				__typename: 'Company'
				id: string
				name?: string | null
				slug: string
				dateFounded?: string | null
				headline?: string | null
				description?: string | null
				productsAndServices?: string | null
				noOfEmployees?: string | null
				website?: string | null
				phones?: string | null
				emails?: string | null
				featuredVideo?: string | null
				hasLogo?: boolean | null
				logoPath?: string | null
				hasCover?: boolean | null
				aboutTeams?: string | null
				coverPath?: string | null
				_OwnerToCompanyCollection?: {
					__typename?: '_OwnerToCompanyConnection'
					edges: Array<{
						__typename?: '_OwnerToCompanyEdge'
						node: {
							__typename?: '_OwnerToCompany'
							user: {
								__typename?: 'User'
								id: string
								uid: string
							}
						}
					}>
				} | null
				industry?: {
					__typename?: 'Industry'
					id: string
					key: string
				} | null
				companyOfficesCollection?: {
					__typename?: 'CompanyOfficesConnection'
					edges: Array<{
						__typename?: 'CompanyOfficesEdge'
						node: {
							__typename?: 'CompanyOffices'
							id: string
							address?: string | null
							zipCode?: string | null
							hq?: boolean | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								name: string
								region2?: string | null
							} | null
						}
					}>
				} | null
				jobCollection?: {
					__typename?: 'JobConnection'
					edges: Array<{
						__typename?: 'JobEdge'
						node: { __typename?: 'Job'; id: string }
					}>
				} | null
			}
		}>
		pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean }
	} | null
}

export type InsertIntoCompanyCollectionMutationVariables = Exact<{
	details: Array<CompanyInsertInput> | CompanyInsertInput
}>

export type InsertIntoCompanyCollectionMutation = {
	__typename?: 'Mutation'
	insertIntoCompanyCollection?: {
		__typename?: 'CompanyInsertResponse'
		records: Array<{
			__typename: 'Company'
			id: string
			name?: string | null
			slug: string
			dateFounded?: string | null
			headline?: string | null
			description?: string | null
			productsAndServices?: string | null
			noOfEmployees?: string | null
			website?: string | null
			phones?: string | null
			emails?: string | null
			featuredVideo?: string | null
			hasLogo?: boolean | null
			logoPath?: string | null
			hasCover?: boolean | null
			aboutTeams?: string | null
			coverPath?: string | null
			_OwnerToCompanyCollection?: {
				__typename?: '_OwnerToCompanyConnection'
				edges: Array<{
					__typename?: '_OwnerToCompanyEdge'
					node: {
						__typename?: '_OwnerToCompany'
						user: { __typename?: 'User'; id: string; uid: string }
					}
				}>
			} | null
			industry?: {
				__typename?: 'Industry'
				id: string
				key: string
			} | null
			companyOfficesCollection?: {
				__typename?: 'CompanyOfficesConnection'
				edges: Array<{
					__typename?: 'CompanyOfficesEdge'
					node: {
						__typename?: 'CompanyOffices'
						id: string
						address?: string | null
						zipCode?: string | null
						hq?: boolean | null
						roLocations?: {
							__typename?: 'roLocations'
							id: string
							name: string
							region2?: string | null
						} | null
					}
				}>
			} | null
			jobCollection?: {
				__typename?: 'JobConnection'
				edges: Array<{
					__typename?: 'JobEdge'
					node: { __typename?: 'Job'; id: string }
				}>
			} | null
		}>
	} | null
}

export type UpdateCompanyCollectionMutationVariables = Exact<{
	details: CompanyUpdateInput
}>

export type UpdateCompanyCollectionMutation = {
	__typename?: 'Mutation'
	updateCompanyCollection: {
		__typename?: 'CompanyUpdateResponse'
		records: Array<{
			__typename: 'Company'
			id: string
			name?: string | null
			slug: string
			dateFounded?: string | null
			headline?: string | null
			description?: string | null
			productsAndServices?: string | null
			noOfEmployees?: string | null
			website?: string | null
			phones?: string | null
			emails?: string | null
			featuredVideo?: string | null
			hasLogo?: boolean | null
			logoPath?: string | null
			hasCover?: boolean | null
			aboutTeams?: string | null
			coverPath?: string | null
			_OwnerToCompanyCollection?: {
				__typename?: '_OwnerToCompanyConnection'
				edges: Array<{
					__typename?: '_OwnerToCompanyEdge'
					node: {
						__typename?: '_OwnerToCompany'
						user: { __typename?: 'User'; id: string; uid: string }
					}
				}>
			} | null
			industry?: {
				__typename?: 'Industry'
				id: string
				key: string
			} | null
			companyOfficesCollection?: {
				__typename?: 'CompanyOfficesConnection'
				edges: Array<{
					__typename?: 'CompanyOfficesEdge'
					node: {
						__typename?: 'CompanyOffices'
						id: string
						address?: string | null
						zipCode?: string | null
						hq?: boolean | null
						roLocations?: {
							__typename?: 'roLocations'
							id: string
							name: string
							region2?: string | null
						} | null
					}
				}>
			} | null
			jobCollection?: {
				__typename?: 'JobConnection'
				edges: Array<{
					__typename?: 'JobEdge'
					node: { __typename?: 'Job'; id: string }
				}>
			} | null
		}>
	}
}

export type InsertIntoArticleCollectionMutationVariables = Exact<{
	story: Array<ArticleInsertInput> | ArticleInsertInput
}>

export type InsertIntoArticleCollectionMutation = {
	__typename?: 'Mutation'
	insertIntoArticleCollection?: {
		__typename?: 'ArticleInsertResponse'
		records: Array<{
			__typename?: 'Article'
			id: string
			worksAt?: string | null
			readDuration?: number | null
			title?: string | null
			body: string
			slug?: string | null
			description?: string | null
			isPost?: boolean | null
			postAs?: string | null
			postingCompany?: string | null
			createdAt: any
			updatedAt: any
			featuredVideo?: string | null
			user?: {
				__typename?: 'User'
				id: string
				uid: string
				email: string
				god: boolean
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							firstName: string
							lastName: string
							cvFilePath?: any | null
							cvFileOriginalName?: any | null
							hasAvatar?: boolean | null
							avatarContentType?: string | null
							avatarPath?: string | null
							experienceCollection?: {
								__typename?: 'ExperienceConnection'
								edges: Array<{
									__typename?: 'ExperienceEdge'
									node: {
										__typename?: 'Experience'
										position?: string | null
										company?: string | null
									}
								}>
							} | null
						}
					}>
				} | null
			} | null
			company?: {
				__typename?: 'Company'
				id: string
				name?: string | null
				slug: string
				hasLogo?: boolean | null
				logoPath?: string | null
				industry?: {
					__typename?: 'Industry'
					id: string
					key: string
				} | null
			} | null
			activeArticleTagCollection?: {
				__typename?: 'ActiveArticleTagConnection'
				edges: Array<{
					__typename?: 'ActiveArticleTagEdge'
					node: {
						__typename?: 'ActiveArticleTag'
						id: string
						votes?: number | null
						articleTag?: {
							__typename?: 'ArticleTag'
							title: string
						} | null
						_ActiveArticleTagToUserCollection?: {
							__typename?: '_ActiveArticleTagToUserConnection'
							edges: Array<{
								__typename?: '_ActiveArticleTagToUserEdge'
								node: {
									__typename?: '_ActiveArticleTagToUser'
									user: {
										__typename?: 'User'
										profileCollection?: {
											__typename?: 'ProfileConnection'
											edges: Array<{
												__typename?: 'ProfileEdge'
												node: {
													__typename?: 'Profile'
													firstName: string
													lastName: string
													user?: {
														__typename?: 'User'
														id: string
														uid: string
													} | null
												}
											}>
										} | null
									}
								}
							}>
						} | null
					}
				}>
			} | null
			image?: {
				__typename?: 'Image'
				id: string
				filename?: string | null
			} | null
		}>
	} | null
}

export type DeleteFromArticleCollectionMutationVariables = Exact<{
	storyId: Scalars['String']['input']
}>

export type DeleteFromArticleCollectionMutation = {
	__typename?: 'Mutation'
	deleteFromArticleCollection: {
		__typename?: 'ArticleDeleteResponse'
		records: Array<{
			__typename?: 'Article'
			id: string
			worksAt?: string | null
			readDuration?: number | null
			title?: string | null
			body: string
			slug?: string | null
			description?: string | null
			isPost?: boolean | null
			postAs?: string | null
			postingCompany?: string | null
			createdAt: any
			updatedAt: any
			featuredVideo?: string | null
			user?: {
				__typename?: 'User'
				id: string
				uid: string
				email: string
				god: boolean
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							firstName: string
							lastName: string
							cvFilePath?: any | null
							cvFileOriginalName?: any | null
							hasAvatar?: boolean | null
							avatarContentType?: string | null
							avatarPath?: string | null
							experienceCollection?: {
								__typename?: 'ExperienceConnection'
								edges: Array<{
									__typename?: 'ExperienceEdge'
									node: {
										__typename?: 'Experience'
										position?: string | null
										company?: string | null
									}
								}>
							} | null
						}
					}>
				} | null
			} | null
			company?: {
				__typename?: 'Company'
				id: string
				name?: string | null
				slug: string
				hasLogo?: boolean | null
				logoPath?: string | null
				industry?: {
					__typename?: 'Industry'
					id: string
					key: string
				} | null
			} | null
			activeArticleTagCollection?: {
				__typename?: 'ActiveArticleTagConnection'
				edges: Array<{
					__typename?: 'ActiveArticleTagEdge'
					node: {
						__typename?: 'ActiveArticleTag'
						id: string
						votes?: number | null
						articleTag?: {
							__typename?: 'ArticleTag'
							title: string
						} | null
						_ActiveArticleTagToUserCollection?: {
							__typename?: '_ActiveArticleTagToUserConnection'
							edges: Array<{
								__typename?: '_ActiveArticleTagToUserEdge'
								node: {
									__typename?: '_ActiveArticleTagToUser'
									user: {
										__typename?: 'User'
										profileCollection?: {
											__typename?: 'ProfileConnection'
											edges: Array<{
												__typename?: 'ProfileEdge'
												node: {
													__typename?: 'Profile'
													firstName: string
													lastName: string
													user?: {
														__typename?: 'User'
														id: string
														uid: string
													} | null
												}
											}>
										} | null
									}
								}
							}>
						} | null
					}
				}>
			} | null
			image?: {
				__typename?: 'Image'
				id: string
				filename?: string | null
			} | null
		}>
	}
}

export type InsertIntoCompanyOfficesCollectionMutationVariables = Exact<{
	data: Array<CompanyOfficesInsertInput> | CompanyOfficesInsertInput
}>

export type InsertIntoCompanyOfficesCollectionMutation = {
	__typename?: 'Mutation'
	insertIntoCompanyOfficesCollection?: {
		__typename?: 'CompanyOfficesInsertResponse'
		records: Array<{
			__typename?: 'CompanyOffices'
			id: string
			address?: string | null
			zipCode?: string | null
			hq?: boolean | null
			roLocations?: {
				__typename?: 'roLocations'
				id: string
				region2?: string | null
				name: string
			} | null
		}>
	} | null
}

export type HandleCompanyOfficesMutationVariables = Exact<{
	data: CompanyOfficesUpdateInput
}>

export type HandleCompanyOfficesMutation = {
	__typename?: 'Mutation'
	updateCompanyOfficesCollection: {
		__typename?: 'CompanyOfficesUpdateResponse'
		records: Array<{
			__typename?: 'CompanyOffices'
			id: string
			address?: string | null
			zipCode?: string | null
			hq?: boolean | null
			roLocations?: {
				__typename?: 'roLocations'
				id: string
				region2?: string | null
				name: string
			} | null
		}>
	}
}

export type DeleteFromCompanyOfficesCollectionMutationVariables = Exact<{
	id?: InputMaybe<Scalars['String']['input']>
}>

export type DeleteFromCompanyOfficesCollectionMutation = {
	__typename?: 'Mutation'
	deleteFromCompanyOfficesCollection: {
		__typename?: 'CompanyOfficesDeleteResponse'
		records: Array<{
			__typename?: 'CompanyOffices'
			id: string
			address?: string | null
			zipCode?: string | null
			hq?: boolean | null
			roLocations?: {
				__typename?: 'roLocations'
				id: string
				region2?: string | null
				name: string
			} | null
		}>
	}
}

export type ChangeCompanyHqMutationVariables = Exact<{
	companyId: Scalars['String']['input']
	officeId: Scalars['String']['input']
}>

export type ChangeCompanyHqMutation = {
	__typename?: 'Mutation'
	resetHq: {
		__typename?: 'CompanyOfficesUpdateResponse'
		records: Array<{
			__typename?: 'CompanyOffices'
			id: string
			address?: string | null
			zipCode?: string | null
			hq?: boolean | null
			roLocations?: {
				__typename?: 'roLocations'
				id: string
				region2?: string | null
				name: string
			} | null
		}>
	}
	setNewHq: {
		__typename?: 'CompanyOfficesUpdateResponse'
		records: Array<{
			__typename?: 'CompanyOffices'
			id: string
			address?: string | null
			zipCode?: string | null
			hq?: boolean | null
			roLocations?: {
				__typename?: 'roLocations'
				id: string
				region2?: string | null
				name: string
			} | null
		}>
	}
}

export type DeleteCompanyMutationMutationVariables = Exact<{
	id?: InputMaybe<Scalars['String']['input']>
	checkText: Scalars['String']['input']
}>

export type DeleteCompanyMutationMutation = {
	__typename?: 'Mutation'
	deleteFromCompanyCollection: {
		__typename?: 'CompanyDeleteResponse'
		records: Array<{
			__typename: 'Company'
			id: string
			name?: string | null
			slug: string
			dateFounded?: string | null
			headline?: string | null
			description?: string | null
			productsAndServices?: string | null
			noOfEmployees?: string | null
			website?: string | null
			phones?: string | null
			emails?: string | null
			featuredVideo?: string | null
			hasLogo?: boolean | null
			logoPath?: string | null
			hasCover?: boolean | null
			aboutTeams?: string | null
			coverPath?: string | null
			_OwnerToCompanyCollection?: {
				__typename?: '_OwnerToCompanyConnection'
				edges: Array<{
					__typename?: '_OwnerToCompanyEdge'
					node: {
						__typename?: '_OwnerToCompany'
						user: { __typename?: 'User'; id: string; uid: string }
					}
				}>
			} | null
			industry?: {
				__typename?: 'Industry'
				id: string
				key: string
			} | null
			companyOfficesCollection?: {
				__typename?: 'CompanyOfficesConnection'
				edges: Array<{
					__typename?: 'CompanyOfficesEdge'
					node: {
						__typename?: 'CompanyOffices'
						id: string
						address?: string | null
						zipCode?: string | null
						hq?: boolean | null
						roLocations?: {
							__typename?: 'roLocations'
							id: string
							name: string
							region2?: string | null
						} | null
					}
				}>
			} | null
			jobCollection?: {
				__typename?: 'JobConnection'
				edges: Array<{
					__typename?: 'JobEdge'
					node: { __typename?: 'Job'; id: string }
				}>
			} | null
		}>
	}
}

export type JobQueryQueryVariables = Exact<{
	filter?: InputMaybe<JobFilter>
}>

export type JobQueryQuery = {
	__typename?: 'Query'
	jobCollection?: {
		__typename?: 'JobConnection'
		edges: Array<{
			__typename?: 'JobEdge'
			node: {
				__typename: 'Job'
				id: string
				slug: string
				description?: string | null
				title: string
				expiryDate?: any | null
				contractType?: string | null
				seniorityLevel?: string | null
				jobType?: string | null
				locationType?: string | null
				featuredImage?: string | null
				videoUrl?: string | null
				applyJobExternalUrl?: string | null
				teamLeader?: string | null
				benefits?: string | null
				company?: {
					__typename: 'Company'
					id: string
					logoPath?: string | null
					hasCover?: boolean | null
					hasLogo?: boolean | null
					name?: string | null
					slug: string
					description?: string | null
					coverPath?: string | null
					featuredVideo?: string | null
					industry?: {
						__typename: 'Industry'
						id: string
						key: string
					} | null
				} | null
				_TeamToJobCollection?: {
					__typename?: '_TeamToJobConnection'
					edges: Array<{
						__typename?: '_TeamToJobEdge'
						node: {
							__typename?: '_TeamToJob'
							team: {
								__typename: 'Team'
								id: string
								name: string
								slug: string
								description?: string | null
								hasCover?: boolean | null
								coverPath?: string | null
								teamMemberCollection?: {
									__typename?: 'TeamMemberConnection'
									edges: Array<{
										__typename?: 'TeamMemberEdge'
										node: {
											__typename?: 'TeamMember'
											id: string
											user?: {
												__typename?: 'User'
												id: string
												profileCollection?: {
													__typename?: 'ProfileConnection'
													edges: Array<{
														__typename?: 'ProfileEdge'
														node: {
															__typename?: 'Profile'
															id: string
															firstName: string
															lastName: string
														}
													}>
												} | null
											} | null
										}
									}>
								} | null
							}
						}
					}>
				} | null
				jobSalary?: {
					__typename: 'JobSalary'
					id: string
					currency?: string | null
					amountMin?: any | null
					amountMax?: any | null
					rate?: string | null
				} | null
				_JobToCustomSkillsCollection?: {
					__typename?: '_JobToCustomSkillsConnection'
					edges: Array<{
						__typename?: '_JobToCustomSkillsEdge'
						node: {
							__typename?: '_JobToCustomSkills'
							customSkills: {
								__typename: 'CustomSkills'
								id: string
								key: string
								title: string
							}
						}
					}>
				} | null
				_JobToCompanyOfficesCollection?: {
					__typename?: '_JobToCompanyOfficesConnection'
					edges: Array<{
						__typename?: '_JobToCompanyOfficesEdge'
						node: {
							__typename?: '_JobToCompanyOffices'
							A: string
							B: string
							companyOffices: {
								__typename?: 'CompanyOffices'
								id: string
								address?: string | null
								zipCode?: string | null
								hq?: boolean | null
								roLocations?: {
									__typename?: 'roLocations'
									id: string
									region2?: string | null
									name: string
								} | null
							}
						}
					}>
				} | null
				jobApplicantCollection?: {
					__typename?: 'JobApplicantConnection'
					edges: Array<{
						__typename?: 'JobApplicantEdge'
						node: { __typename: 'JobApplicant'; id: string }
					}>
				} | null
			}
		}>
	} | null
}

export type FeedJobsQueryVariables = Exact<{
	name?: InputMaybe<Scalars['String']['input']>
	companyname?: InputMaybe<Scalars['String']['input']>
	companyslug?: InputMaybe<Scalars['String']['input']>
	teamname?: InputMaybe<Scalars['String']['input']>
	locationsids?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	departmentids?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	sizes?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	salarymin?: InputMaybe<Scalars['String']['input']>
	salarymax?: InputMaybe<Scalars['String']['input']>
	typeofjob?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	senioritylevels?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	currency?: InputMaybe<Scalars['String']['input']>
	contracttypes?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	locationtypes?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	skills?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	after?: InputMaybe<Scalars['Cursor']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
	filter?: InputMaybe<JobFilter>
	orderBy?: InputMaybe<Array<JobOrderBy> | JobOrderBy>
}>

export type FeedJobsQuery = {
	__typename?: 'Query'
	feedjobs?: {
		__typename?: 'JobConnection'
		edges: Array<{
			__typename?: 'JobEdge'
			cursor: string
			node: {
				__typename: 'Job'
				id: string
				slug: string
				description?: string | null
				title: string
				expiryDate?: any | null
				contractType?: string | null
				seniorityLevel?: string | null
				jobType?: string | null
				locationType?: string | null
				featuredImage?: string | null
				videoUrl?: string | null
				applyJobExternalUrl?: string | null
				teamLeader?: string | null
				benefits?: string | null
				company?: {
					__typename: 'Company'
					id: string
					logoPath?: string | null
					hasCover?: boolean | null
					hasLogo?: boolean | null
					name?: string | null
					slug: string
					description?: string | null
					coverPath?: string | null
					featuredVideo?: string | null
					industry?: {
						__typename: 'Industry'
						id: string
						key: string
					} | null
				} | null
				_TeamToJobCollection?: {
					__typename?: '_TeamToJobConnection'
					edges: Array<{
						__typename?: '_TeamToJobEdge'
						node: {
							__typename?: '_TeamToJob'
							team: {
								__typename: 'Team'
								id: string
								name: string
								slug: string
								description?: string | null
								hasCover?: boolean | null
								coverPath?: string | null
								teamMemberCollection?: {
									__typename?: 'TeamMemberConnection'
									edges: Array<{
										__typename?: 'TeamMemberEdge'
										node: {
											__typename?: 'TeamMember'
											id: string
											user?: {
												__typename?: 'User'
												id: string
												profileCollection?: {
													__typename?: 'ProfileConnection'
													edges: Array<{
														__typename?: 'ProfileEdge'
														node: {
															__typename?: 'Profile'
															id: string
															firstName: string
															lastName: string
														}
													}>
												} | null
											} | null
										}
									}>
								} | null
							}
						}
					}>
				} | null
				jobSalary?: {
					__typename: 'JobSalary'
					id: string
					currency?: string | null
					amountMin?: any | null
					amountMax?: any | null
					rate?: string | null
				} | null
				_JobToCustomSkillsCollection?: {
					__typename?: '_JobToCustomSkillsConnection'
					edges: Array<{
						__typename?: '_JobToCustomSkillsEdge'
						node: {
							__typename?: '_JobToCustomSkills'
							customSkills: {
								__typename: 'CustomSkills'
								id: string
								key: string
								title: string
							}
						}
					}>
				} | null
				_JobToCompanyOfficesCollection?: {
					__typename?: '_JobToCompanyOfficesConnection'
					edges: Array<{
						__typename?: '_JobToCompanyOfficesEdge'
						node: {
							__typename?: '_JobToCompanyOffices'
							A: string
							B: string
							companyOffices: {
								__typename?: 'CompanyOffices'
								id: string
								address?: string | null
								zipCode?: string | null
								hq?: boolean | null
								roLocations?: {
									__typename?: 'roLocations'
									id: string
									region2?: string | null
									name: string
								} | null
							}
						}
					}>
				} | null
				jobApplicantCollection?: {
					__typename?: 'JobApplicantConnection'
					edges: Array<{
						__typename?: 'JobApplicantEdge'
						node: { __typename: 'JobApplicant'; id: string }
					}>
				} | null
			}
		}>
		pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean }
	} | null
}

export type FeedJobApplicantsQueryVariables = Exact<{
	jobId?: InputMaybe<Scalars['String']['input']>
	applicantName?: InputMaybe<Scalars['String']['input']>
	applicationDateStart?: InputMaybe<Scalars['String']['input']>
	applicationDateEnd?: InputMaybe<Scalars['String']['input']>
	first?: InputMaybe<Scalars['Int']['input']>
	last?: InputMaybe<Scalars['Int']['input']>
	before?: InputMaybe<Scalars['Cursor']['input']>
	after?: InputMaybe<Scalars['Cursor']['input']>
	offset?: InputMaybe<Scalars['Int']['input']>
}>

export type FeedJobApplicantsQuery = {
	__typename?: 'Query'
	feedJobApplicants?: {
		__typename?: 'JobApplicantConnection'
		edges: Array<{
			__typename?: 'JobApplicantEdge'
			cursor: string
			node: {
				__typename?: 'JobApplicant'
				createdAt: any
				user?: {
					__typename?: 'User'
					id: string
					uid: string
					god: boolean
					firebaseToken?: string | null
					profileCollection?: {
						__typename?: 'ProfileConnection'
						edges: Array<{
							__typename?: 'ProfileEdge'
							node: {
								__typename?: 'Profile'
								id: string
								aboutMe?: string | null
								email?: string | null
								firstName: string
								lastName: string
								hasAvatar?: boolean | null
								avatarPath?: string | null
								hasCover?: boolean | null
								coverPath?: string | null
								cvFilePath?: any | null
								cvFileOriginalName?: any | null
								featuredVideo?: string | null
								company_name?: string | null
								userOnBoardingFormVisited?: boolean | null
								user?: {
									__typename?: 'User'
									id: string
									email: string
									_OwnerToCompanyCollection?: {
										__typename?: '_OwnerToCompanyConnection'
										edges: Array<{
											__typename?: '_OwnerToCompanyEdge'
											node: {
												__typename?: '_OwnerToCompany'
												company: {
													__typename?: 'Company'
													id: string
													hasLogo?: boolean | null
													name?: string | null
													slug: string
													logoPath?: string | null
												}
											}
										}>
									} | null
								} | null
								_ProfileToValueCollection?: {
									__typename?: '_ProfileToValueConnection'
									edges: Array<{
										__typename?: '_ProfileToValueEdge'
										node: {
											__typename?: '_ProfileToValue'
											value: {
												__typename?: 'Value'
												id: string
												title?: string | null
											}
										}
									}>
								} | null
								_ProfileToSkillCollection?: {
									__typename?: '_ProfileToSkillConnection'
									edges: Array<{
										__typename?: '_ProfileToSkillEdge'
										node: {
											__typename?: '_ProfileToSkill'
											skill: {
												__typename?: 'Skill'
												id: string
												title: string
											}
										}
									}>
								} | null
								experienceCollection?: {
									__typename?: 'ExperienceConnection'
									edges: Array<{
										__typename?: 'ExperienceEdge'
										node: {
											__typename?: 'Experience'
											id: string
											position?: string | null
											company?: string | null
											startDate?: any | null
											endDate?: any | null
											isCurrent?: boolean | null
											isPresent?: boolean | null
											title?: string | null
											description?: string | null
											roLocations?: {
												__typename?: 'roLocations'
												id: string
												type: string
												name: string
												region2?: string | null
											} | null
										}
									}>
								} | null
							}
						}>
					} | null
					_UserToCompanyRoleCollection?: {
						__typename?: '_UserToCompanyRoleConnection'
						edges: Array<{
							__typename?: '_UserToCompanyRoleEdge'
							node: {
								__typename?: '_UserToCompanyRole'
								companyRole: {
									__typename?: 'CompanyRole'
									id: string
									company?: {
										__typename?: 'Company'
										id: string
										slug: string
										name?: string | null
										hasLogo?: boolean | null
										logoPath?: string | null
										coverPath?: string | null
										hasCover?: boolean | null
										description?: string | null
									} | null
									companyRole_rolesCollection?: {
										__typename?: 'CompanyRole_rolesConnection'
										edges: Array<{
											__typename?: 'CompanyRole_rolesEdge'
											node: {
												__typename?: 'CompanyRole_roles'
												value: string
											}
										}>
									} | null
								}
							}
						}>
					} | null
				} | null
			}
		}>
		pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean }
	} | null
}

export type ApplyJobMutationVariables = Exact<{
	id: Scalars['String']['input']
}>

export type ApplyJobMutation = {
	__typename?: 'Mutation'
	insertIntoJobApplicantCollection?: {
		__typename?: 'JobApplicantInsertResponse'
		affectedCount: number
		records: Array<{
			__typename?: 'JobApplicant'
			id: string
			nodeId: string
		}>
	} | null
}

export type InsertIntoJobCollectionMutationVariables = Exact<{
	data: Array<JobInsertInput> | JobInsertInput
}>

export type InsertIntoJobCollectionMutation = {
	__typename?: 'Mutation'
	insertIntoJobCollection?: {
		__typename?: 'JobInsertResponse'
		records: Array<{
			__typename: 'Job'
			id: string
			slug: string
			description?: string | null
			title: string
			expiryDate?: any | null
			contractType?: string | null
			seniorityLevel?: string | null
			jobType?: string | null
			locationType?: string | null
			featuredImage?: string | null
			videoUrl?: string | null
			applyJobExternalUrl?: string | null
			teamLeader?: string | null
			benefits?: string | null
			company?: {
				__typename: 'Company'
				id: string
				logoPath?: string | null
				hasCover?: boolean | null
				hasLogo?: boolean | null
				name?: string | null
				slug: string
				description?: string | null
				coverPath?: string | null
				featuredVideo?: string | null
				industry?: {
					__typename: 'Industry'
					id: string
					key: string
				} | null
			} | null
			_TeamToJobCollection?: {
				__typename?: '_TeamToJobConnection'
				edges: Array<{
					__typename?: '_TeamToJobEdge'
					node: {
						__typename?: '_TeamToJob'
						team: {
							__typename: 'Team'
							id: string
							name: string
							slug: string
							description?: string | null
							hasCover?: boolean | null
							coverPath?: string | null
							teamMemberCollection?: {
								__typename?: 'TeamMemberConnection'
								edges: Array<{
									__typename?: 'TeamMemberEdge'
									node: {
										__typename?: 'TeamMember'
										id: string
										user?: {
											__typename?: 'User'
											id: string
											profileCollection?: {
												__typename?: 'ProfileConnection'
												edges: Array<{
													__typename?: 'ProfileEdge'
													node: {
														__typename?: 'Profile'
														id: string
														firstName: string
														lastName: string
													}
												}>
											} | null
										} | null
									}
								}>
							} | null
						}
					}
				}>
			} | null
			jobSalary?: {
				__typename: 'JobSalary'
				id: string
				currency?: string | null
				amountMin?: any | null
				amountMax?: any | null
				rate?: string | null
			} | null
			_JobToCustomSkillsCollection?: {
				__typename?: '_JobToCustomSkillsConnection'
				edges: Array<{
					__typename?: '_JobToCustomSkillsEdge'
					node: {
						__typename?: '_JobToCustomSkills'
						customSkills: {
							__typename: 'CustomSkills'
							id: string
							key: string
							title: string
						}
					}
				}>
			} | null
			_JobToCompanyOfficesCollection?: {
				__typename?: '_JobToCompanyOfficesConnection'
				edges: Array<{
					__typename?: '_JobToCompanyOfficesEdge'
					node: {
						__typename?: '_JobToCompanyOffices'
						A: string
						B: string
						companyOffices: {
							__typename?: 'CompanyOffices'
							id: string
							address?: string | null
							zipCode?: string | null
							hq?: boolean | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								region2?: string | null
								name: string
							} | null
						}
					}
				}>
			} | null
			jobApplicantCollection?: {
				__typename?: 'JobApplicantConnection'
				edges: Array<{
					__typename?: 'JobApplicantEdge'
					node: { __typename: 'JobApplicant'; id: string }
				}>
			} | null
		}>
	} | null
}

export type UpdateJobCollectionMutationVariables = Exact<{
	data: JobUpdateInput
}>

export type UpdateJobCollectionMutation = {
	__typename?: 'Mutation'
	updateJobCollection: {
		__typename?: 'JobUpdateResponse'
		records: Array<{
			__typename: 'Job'
			id: string
			slug: string
			description?: string | null
			title: string
			expiryDate?: any | null
			contractType?: string | null
			seniorityLevel?: string | null
			jobType?: string | null
			locationType?: string | null
			featuredImage?: string | null
			videoUrl?: string | null
			applyJobExternalUrl?: string | null
			teamLeader?: string | null
			benefits?: string | null
			company?: {
				__typename: 'Company'
				id: string
				logoPath?: string | null
				hasCover?: boolean | null
				hasLogo?: boolean | null
				name?: string | null
				slug: string
				description?: string | null
				coverPath?: string | null
				featuredVideo?: string | null
				industry?: {
					__typename: 'Industry'
					id: string
					key: string
				} | null
			} | null
			_TeamToJobCollection?: {
				__typename?: '_TeamToJobConnection'
				edges: Array<{
					__typename?: '_TeamToJobEdge'
					node: {
						__typename?: '_TeamToJob'
						team: {
							__typename: 'Team'
							id: string
							name: string
							slug: string
							description?: string | null
							hasCover?: boolean | null
							coverPath?: string | null
							teamMemberCollection?: {
								__typename?: 'TeamMemberConnection'
								edges: Array<{
									__typename?: 'TeamMemberEdge'
									node: {
										__typename?: 'TeamMember'
										id: string
										user?: {
											__typename?: 'User'
											id: string
											profileCollection?: {
												__typename?: 'ProfileConnection'
												edges: Array<{
													__typename?: 'ProfileEdge'
													node: {
														__typename?: 'Profile'
														id: string
														firstName: string
														lastName: string
													}
												}>
											} | null
										} | null
									}
								}>
							} | null
						}
					}
				}>
			} | null
			jobSalary?: {
				__typename: 'JobSalary'
				id: string
				currency?: string | null
				amountMin?: any | null
				amountMax?: any | null
				rate?: string | null
			} | null
			_JobToCustomSkillsCollection?: {
				__typename?: '_JobToCustomSkillsConnection'
				edges: Array<{
					__typename?: '_JobToCustomSkillsEdge'
					node: {
						__typename?: '_JobToCustomSkills'
						customSkills: {
							__typename: 'CustomSkills'
							id: string
							key: string
							title: string
						}
					}
				}>
			} | null
			_JobToCompanyOfficesCollection?: {
				__typename?: '_JobToCompanyOfficesConnection'
				edges: Array<{
					__typename?: '_JobToCompanyOfficesEdge'
					node: {
						__typename?: '_JobToCompanyOffices'
						A: string
						B: string
						companyOffices: {
							__typename?: 'CompanyOffices'
							id: string
							address?: string | null
							zipCode?: string | null
							hq?: boolean | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								region2?: string | null
								name: string
							} | null
						}
					}
				}>
			} | null
			jobApplicantCollection?: {
				__typename?: 'JobApplicantConnection'
				edges: Array<{
					__typename?: 'JobApplicantEdge'
					node: { __typename: 'JobApplicant'; id: string }
				}>
			} | null
		}>
	}
}

export type DeleteJobMutationVariables = Exact<{
	data: JobFilter
}>

export type DeleteJobMutation = {
	__typename?: 'Mutation'
	deleteFromJobCollection: {
		__typename?: 'JobDeleteResponse'
		records: Array<{
			__typename: 'Job'
			id: string
			slug: string
			description?: string | null
			title: string
			expiryDate?: any | null
			contractType?: string | null
			seniorityLevel?: string | null
			jobType?: string | null
			locationType?: string | null
			featuredImage?: string | null
			videoUrl?: string | null
			applyJobExternalUrl?: string | null
			teamLeader?: string | null
			benefits?: string | null
			company?: {
				__typename: 'Company'
				id: string
				logoPath?: string | null
				hasCover?: boolean | null
				hasLogo?: boolean | null
				name?: string | null
				slug: string
				description?: string | null
				coverPath?: string | null
				featuredVideo?: string | null
				industry?: {
					__typename: 'Industry'
					id: string
					key: string
				} | null
			} | null
			_TeamToJobCollection?: {
				__typename?: '_TeamToJobConnection'
				edges: Array<{
					__typename?: '_TeamToJobEdge'
					node: {
						__typename?: '_TeamToJob'
						team: {
							__typename: 'Team'
							id: string
							name: string
							slug: string
							description?: string | null
							hasCover?: boolean | null
							coverPath?: string | null
							teamMemberCollection?: {
								__typename?: 'TeamMemberConnection'
								edges: Array<{
									__typename?: 'TeamMemberEdge'
									node: {
										__typename?: 'TeamMember'
										id: string
										user?: {
											__typename?: 'User'
											id: string
											profileCollection?: {
												__typename?: 'ProfileConnection'
												edges: Array<{
													__typename?: 'ProfileEdge'
													node: {
														__typename?: 'Profile'
														id: string
														firstName: string
														lastName: string
													}
												}>
											} | null
										} | null
									}
								}>
							} | null
						}
					}
				}>
			} | null
			jobSalary?: {
				__typename: 'JobSalary'
				id: string
				currency?: string | null
				amountMin?: any | null
				amountMax?: any | null
				rate?: string | null
			} | null
			_JobToCustomSkillsCollection?: {
				__typename?: '_JobToCustomSkillsConnection'
				edges: Array<{
					__typename?: '_JobToCustomSkillsEdge'
					node: {
						__typename?: '_JobToCustomSkills'
						customSkills: {
							__typename: 'CustomSkills'
							id: string
							key: string
							title: string
						}
					}
				}>
			} | null
			_JobToCompanyOfficesCollection?: {
				__typename?: '_JobToCompanyOfficesConnection'
				edges: Array<{
					__typename?: '_JobToCompanyOfficesEdge'
					node: {
						__typename?: '_JobToCompanyOffices'
						A: string
						B: string
						companyOffices: {
							__typename?: 'CompanyOffices'
							id: string
							address?: string | null
							zipCode?: string | null
							hq?: boolean | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								region2?: string | null
								name: string
							} | null
						}
					}
				}>
			} | null
			jobApplicantCollection?: {
				__typename?: 'JobApplicantConnection'
				edges: Array<{
					__typename?: 'JobApplicantEdge'
					node: { __typename: 'JobApplicant'; id: string }
				}>
			} | null
		}>
	}
}

export type UserQueryQueryVariables = Exact<{
	id?: InputMaybe<Scalars['String']['input']>
	uid?: InputMaybe<Scalars['String']['input']>
}>

export type UserQueryQuery = {
	__typename?: 'Query'
	userCollection?: {
		__typename?: 'UserConnection'
		edges: Array<{
			__typename?: 'UserEdge'
			node: {
				__typename?: 'User'
				id: string
				uid: string
				god: boolean
				firebaseToken?: string | null
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							aboutMe?: string | null
							email?: string | null
							firstName: string
							lastName: string
							hasAvatar?: boolean | null
							avatarPath?: string | null
							hasCover?: boolean | null
							coverPath?: string | null
							cvFilePath?: any | null
							cvFileOriginalName?: any | null
							featuredVideo?: string | null
							company_name?: string | null
							userOnBoardingFormVisited?: boolean | null
							user?: {
								__typename?: 'User'
								id: string
								email: string
								_OwnerToCompanyCollection?: {
									__typename?: '_OwnerToCompanyConnection'
									edges: Array<{
										__typename?: '_OwnerToCompanyEdge'
										node: {
											__typename?: '_OwnerToCompany'
											company: {
												__typename?: 'Company'
												id: string
												hasLogo?: boolean | null
												name?: string | null
												slug: string
												logoPath?: string | null
											}
										}
									}>
								} | null
							} | null
							_ProfileToValueCollection?: {
								__typename?: '_ProfileToValueConnection'
								edges: Array<{
									__typename?: '_ProfileToValueEdge'
									node: {
										__typename?: '_ProfileToValue'
										value: {
											__typename?: 'Value'
											id: string
											title?: string | null
										}
									}
								}>
							} | null
							_ProfileToSkillCollection?: {
								__typename?: '_ProfileToSkillConnection'
								edges: Array<{
									__typename?: '_ProfileToSkillEdge'
									node: {
										__typename?: '_ProfileToSkill'
										skill: {
											__typename?: 'Skill'
											id: string
											title: string
										}
									}
								}>
							} | null
							experienceCollection?: {
								__typename?: 'ExperienceConnection'
								edges: Array<{
									__typename?: 'ExperienceEdge'
									node: {
										__typename?: 'Experience'
										id: string
										position?: string | null
										company?: string | null
										startDate?: any | null
										endDate?: any | null
										isCurrent?: boolean | null
										isPresent?: boolean | null
										title?: string | null
										description?: string | null
										roLocations?: {
											__typename?: 'roLocations'
											id: string
											type: string
											name: string
											region2?: string | null
										} | null
									}
								}>
							} | null
						}
					}>
				} | null
				_UserToCompanyRoleCollection?: {
					__typename?: '_UserToCompanyRoleConnection'
					edges: Array<{
						__typename?: '_UserToCompanyRoleEdge'
						node: {
							__typename?: '_UserToCompanyRole'
							companyRole: {
								__typename?: 'CompanyRole'
								id: string
								company?: {
									__typename?: 'Company'
									id: string
									slug: string
									name?: string | null
									hasLogo?: boolean | null
									logoPath?: string | null
									coverPath?: string | null
									hasCover?: boolean | null
									description?: string | null
								} | null
								companyRole_rolesCollection?: {
									__typename?: 'CompanyRole_rolesConnection'
									edges: Array<{
										__typename?: 'CompanyRole_rolesEdge'
										node: {
											__typename?: 'CompanyRole_roles'
											value: string
										}
									}>
								} | null
							}
						}
					}>
				} | null
			}
		}>
	} | null
}

export type UserProfileQueryVariables = Exact<{
	uid: Scalars['String']['input']
}>

export type UserProfileQuery = {
	__typename?: 'Query'
	profileCollection?: {
		__typename?: 'ProfileConnection'
		edges: Array<{
			__typename?: 'ProfileEdge'
			node: {
				__typename?: 'Profile'
				id: string
				aboutMe?: string | null
				email?: string | null
				firstName: string
				lastName: string
				hasAvatar?: boolean | null
				avatarPath?: string | null
				hasCover?: boolean | null
				coverPath?: string | null
				cvFilePath?: any | null
				cvFileOriginalName?: any | null
				featuredVideo?: string | null
				company_name?: string | null
				userOnBoardingFormVisited?: boolean | null
				user?: {
					__typename?: 'User'
					id: string
					email: string
					_OwnerToCompanyCollection?: {
						__typename?: '_OwnerToCompanyConnection'
						edges: Array<{
							__typename?: '_OwnerToCompanyEdge'
							node: {
								__typename?: '_OwnerToCompany'
								company: {
									__typename?: 'Company'
									id: string
									hasLogo?: boolean | null
									name?: string | null
									slug: string
									logoPath?: string | null
								}
							}
						}>
					} | null
				} | null
				_ProfileToValueCollection?: {
					__typename?: '_ProfileToValueConnection'
					edges: Array<{
						__typename?: '_ProfileToValueEdge'
						node: {
							__typename?: '_ProfileToValue'
							value: {
								__typename?: 'Value'
								id: string
								title?: string | null
							}
						}
					}>
				} | null
				_ProfileToSkillCollection?: {
					__typename?: '_ProfileToSkillConnection'
					edges: Array<{
						__typename?: '_ProfileToSkillEdge'
						node: {
							__typename?: '_ProfileToSkill'
							skill: {
								__typename?: 'Skill'
								id: string
								title: string
							}
						}
					}>
				} | null
				experienceCollection?: {
					__typename?: 'ExperienceConnection'
					edges: Array<{
						__typename?: 'ExperienceEdge'
						node: {
							__typename?: 'Experience'
							id: string
							position?: string | null
							company?: string | null
							startDate?: any | null
							endDate?: any | null
							isCurrent?: boolean | null
							isPresent?: boolean | null
							title?: string | null
							description?: string | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								type: string
								name: string
								region2?: string | null
							} | null
						}
					}>
				} | null
			}
		}>
	} | null
}

export type UsersProfileQueryVariables = Exact<{
	data?: InputMaybe<Scalars['String']['input']>
}>

export type UsersProfileQuery = {
	__typename?: 'Query'
	userCollection?: {
		__typename?: 'UserConnection'
		edges: Array<{
			__typename?: 'UserEdge'
			node: {
				__typename?: 'User'
				id: string
				uid: string
				god: boolean
				firebaseToken?: string | null
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							aboutMe?: string | null
							email?: string | null
							firstName: string
							lastName: string
							hasAvatar?: boolean | null
							avatarPath?: string | null
							hasCover?: boolean | null
							coverPath?: string | null
							cvFilePath?: any | null
							cvFileOriginalName?: any | null
							featuredVideo?: string | null
							company_name?: string | null
							userOnBoardingFormVisited?: boolean | null
							user?: {
								__typename?: 'User'
								id: string
								email: string
								_OwnerToCompanyCollection?: {
									__typename?: '_OwnerToCompanyConnection'
									edges: Array<{
										__typename?: '_OwnerToCompanyEdge'
										node: {
											__typename?: '_OwnerToCompany'
											company: {
												__typename?: 'Company'
												id: string
												hasLogo?: boolean | null
												name?: string | null
												slug: string
												logoPath?: string | null
											}
										}
									}>
								} | null
							} | null
							_ProfileToValueCollection?: {
								__typename?: '_ProfileToValueConnection'
								edges: Array<{
									__typename?: '_ProfileToValueEdge'
									node: {
										__typename?: '_ProfileToValue'
										value: {
											__typename?: 'Value'
											id: string
											title?: string | null
										}
									}
								}>
							} | null
							_ProfileToSkillCollection?: {
								__typename?: '_ProfileToSkillConnection'
								edges: Array<{
									__typename?: '_ProfileToSkillEdge'
									node: {
										__typename?: '_ProfileToSkill'
										skill: {
											__typename?: 'Skill'
											id: string
											title: string
										}
									}
								}>
							} | null
							experienceCollection?: {
								__typename?: 'ExperienceConnection'
								edges: Array<{
									__typename?: 'ExperienceEdge'
									node: {
										__typename?: 'Experience'
										id: string
										position?: string | null
										company?: string | null
										startDate?: any | null
										endDate?: any | null
										isCurrent?: boolean | null
										isPresent?: boolean | null
										title?: string | null
										description?: string | null
										roLocations?: {
											__typename?: 'roLocations'
											id: string
											type: string
											name: string
											region2?: string | null
										} | null
									}
								}>
							} | null
						}
					}>
				} | null
				_UserToCompanyRoleCollection?: {
					__typename?: '_UserToCompanyRoleConnection'
					edges: Array<{
						__typename?: '_UserToCompanyRoleEdge'
						node: {
							__typename?: '_UserToCompanyRole'
							companyRole: {
								__typename?: 'CompanyRole'
								id: string
								company?: {
									__typename?: 'Company'
									id: string
									slug: string
									name?: string | null
									hasLogo?: boolean | null
									logoPath?: string | null
									coverPath?: string | null
									hasCover?: boolean | null
									description?: string | null
								} | null
								companyRole_rolesCollection?: {
									__typename?: 'CompanyRole_rolesConnection'
									edges: Array<{
										__typename?: 'CompanyRole_rolesEdge'
										node: {
											__typename?: 'CompanyRole_roles'
											value: string
										}
									}>
								} | null
							}
						}
					}>
				} | null
			}
		}>
	} | null
}

export type UserProfilesByNameQueryVariables = Exact<{
	UserName?: InputMaybe<Scalars['String']['input']>
}>

export type UserProfilesByNameQuery = {
	__typename?: 'Query'
	profileCollection?: {
		__typename?: 'ProfileConnection'
		edges: Array<{
			__typename?: 'ProfileEdge'
			node: {
				__typename?: 'Profile'
				id: string
				aboutMe?: string | null
				email?: string | null
				firstName: string
				lastName: string
				hasAvatar?: boolean | null
				avatarPath?: string | null
				hasCover?: boolean | null
				coverPath?: string | null
				cvFilePath?: any | null
				cvFileOriginalName?: any | null
				featuredVideo?: string | null
				company_name?: string | null
				userOnBoardingFormVisited?: boolean | null
				user?: {
					__typename?: 'User'
					id: string
					email: string
					_OwnerToCompanyCollection?: {
						__typename?: '_OwnerToCompanyConnection'
						edges: Array<{
							__typename?: '_OwnerToCompanyEdge'
							node: {
								__typename?: '_OwnerToCompany'
								company: {
									__typename?: 'Company'
									id: string
									hasLogo?: boolean | null
									name?: string | null
									slug: string
									logoPath?: string | null
								}
							}
						}>
					} | null
				} | null
				_ProfileToValueCollection?: {
					__typename?: '_ProfileToValueConnection'
					edges: Array<{
						__typename?: '_ProfileToValueEdge'
						node: {
							__typename?: '_ProfileToValue'
							value: {
								__typename?: 'Value'
								id: string
								title?: string | null
							}
						}
					}>
				} | null
				_ProfileToSkillCollection?: {
					__typename?: '_ProfileToSkillConnection'
					edges: Array<{
						__typename?: '_ProfileToSkillEdge'
						node: {
							__typename?: '_ProfileToSkill'
							skill: {
								__typename?: 'Skill'
								id: string
								title: string
							}
						}
					}>
				} | null
				experienceCollection?: {
					__typename?: 'ExperienceConnection'
					edges: Array<{
						__typename?: 'ExperienceEdge'
						node: {
							__typename?: 'Experience'
							id: string
							position?: string | null
							company?: string | null
							startDate?: any | null
							endDate?: any | null
							isCurrent?: boolean | null
							isPresent?: boolean | null
							title?: string | null
							description?: string | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								type: string
								name: string
								region2?: string | null
							} | null
						}
					}>
				} | null
			}
		}>
	} | null
}

export type UserProfilesByEmailQueryVariables = Exact<{
	email?: InputMaybe<Scalars['String']['input']>
}>

export type UserProfilesByEmailQuery = {
	__typename?: 'Query'
	userCollection?: {
		__typename?: 'UserConnection'
		edges: Array<{
			__typename?: 'UserEdge'
			node: {
				__typename?: 'User'
				id: string
				uid: string
				god: boolean
				firebaseToken?: string | null
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							aboutMe?: string | null
							email?: string | null
							firstName: string
							lastName: string
							hasAvatar?: boolean | null
							avatarPath?: string | null
							hasCover?: boolean | null
							coverPath?: string | null
							cvFilePath?: any | null
							cvFileOriginalName?: any | null
							featuredVideo?: string | null
							company_name?: string | null
							userOnBoardingFormVisited?: boolean | null
							user?: {
								__typename?: 'User'
								id: string
								email: string
								_OwnerToCompanyCollection?: {
									__typename?: '_OwnerToCompanyConnection'
									edges: Array<{
										__typename?: '_OwnerToCompanyEdge'
										node: {
											__typename?: '_OwnerToCompany'
											company: {
												__typename?: 'Company'
												id: string
												hasLogo?: boolean | null
												name?: string | null
												slug: string
												logoPath?: string | null
											}
										}
									}>
								} | null
							} | null
							_ProfileToValueCollection?: {
								__typename?: '_ProfileToValueConnection'
								edges: Array<{
									__typename?: '_ProfileToValueEdge'
									node: {
										__typename?: '_ProfileToValue'
										value: {
											__typename?: 'Value'
											id: string
											title?: string | null
										}
									}
								}>
							} | null
							_ProfileToSkillCollection?: {
								__typename?: '_ProfileToSkillConnection'
								edges: Array<{
									__typename?: '_ProfileToSkillEdge'
									node: {
										__typename?: '_ProfileToSkill'
										skill: {
											__typename?: 'Skill'
											id: string
											title: string
										}
									}
								}>
							} | null
							experienceCollection?: {
								__typename?: 'ExperienceConnection'
								edges: Array<{
									__typename?: 'ExperienceEdge'
									node: {
										__typename?: 'Experience'
										id: string
										position?: string | null
										company?: string | null
										startDate?: any | null
										endDate?: any | null
										isCurrent?: boolean | null
										isPresent?: boolean | null
										title?: string | null
										description?: string | null
										roLocations?: {
											__typename?: 'roLocations'
											id: string
											type: string
											name: string
											region2?: string | null
										} | null
									}
								}>
							} | null
						}
					}>
				} | null
				_UserToCompanyRoleCollection?: {
					__typename?: '_UserToCompanyRoleConnection'
					edges: Array<{
						__typename?: '_UserToCompanyRoleEdge'
						node: {
							__typename?: '_UserToCompanyRole'
							companyRole: {
								__typename?: 'CompanyRole'
								id: string
								company?: {
									__typename?: 'Company'
									id: string
									slug: string
									name?: string | null
									hasLogo?: boolean | null
									logoPath?: string | null
									coverPath?: string | null
									hasCover?: boolean | null
									description?: string | null
								} | null
								companyRole_rolesCollection?: {
									__typename?: 'CompanyRole_rolesConnection'
									edges: Array<{
										__typename?: 'CompanyRole_rolesEdge'
										node: {
											__typename?: 'CompanyRole_roles'
											value: string
										}
									}>
								} | null
							}
						}
					}>
				} | null
			}
		}>
	} | null
}

export type CheckusernameQueryVariables = Exact<{
	uid: Scalars['String']['input']
}>

export type CheckusernameQuery = {
	__typename?: 'Query'
	userCollection?: {
		__typename?: 'UserConnection'
		edges: Array<{
			__typename?: 'UserEdge'
			node: { __typename?: 'User'; status: string }
		}>
	} | null
}

export type CheckEmailQueryVariables = Exact<{
	filter?: InputMaybe<UserFilter>
}>

export type CheckEmailQuery = {
	__typename?: 'Query'
	userCollection?: {
		__typename?: 'UserConnection'
		edges: Array<{
			__typename?: 'UserEdge'
			node: { __typename?: 'User'; status: string }
		}>
	} | null
}

export type UpdateProfileDetailsMutationVariables = Exact<{
	details: Array<ProfileInsertInput> | ProfileInsertInput
}>

export type UpdateProfileDetailsMutation = {
	__typename?: 'Mutation'
	insertIntoProfileCollection?: {
		__typename?: 'ProfileInsertResponse'
		records: Array<{
			__typename?: 'Profile'
			id: string
			aboutMe?: string | null
			email?: string | null
			firstName: string
			lastName: string
			hasAvatar?: boolean | null
			avatarPath?: string | null
			hasCover?: boolean | null
			coverPath?: string | null
			cvFilePath?: any | null
			cvFileOriginalName?: any | null
			featuredVideo?: string | null
			company_name?: string | null
			userOnBoardingFormVisited?: boolean | null
			user?: {
				__typename?: 'User'
				id: string
				email: string
				_OwnerToCompanyCollection?: {
					__typename?: '_OwnerToCompanyConnection'
					edges: Array<{
						__typename?: '_OwnerToCompanyEdge'
						node: {
							__typename?: '_OwnerToCompany'
							company: {
								__typename?: 'Company'
								id: string
								hasLogo?: boolean | null
								name?: string | null
								slug: string
								logoPath?: string | null
							}
						}
					}>
				} | null
			} | null
			_ProfileToValueCollection?: {
				__typename?: '_ProfileToValueConnection'
				edges: Array<{
					__typename?: '_ProfileToValueEdge'
					node: {
						__typename?: '_ProfileToValue'
						value: {
							__typename?: 'Value'
							id: string
							title?: string | null
						}
					}
				}>
			} | null
			_ProfileToSkillCollection?: {
				__typename?: '_ProfileToSkillConnection'
				edges: Array<{
					__typename?: '_ProfileToSkillEdge'
					node: {
						__typename?: '_ProfileToSkill'
						skill: {
							__typename?: 'Skill'
							id: string
							title: string
						}
					}
				}>
			} | null
			experienceCollection?: {
				__typename?: 'ExperienceConnection'
				edges: Array<{
					__typename?: 'ExperienceEdge'
					node: {
						__typename?: 'Experience'
						id: string
						position?: string | null
						company?: string | null
						startDate?: any | null
						endDate?: any | null
						isCurrent?: boolean | null
						isPresent?: boolean | null
						title?: string | null
						description?: string | null
						roLocations?: {
							__typename?: 'roLocations'
							id: string
							type: string
							name: string
							region2?: string | null
						} | null
					}
				}>
			} | null
		}>
	} | null
}

export type SetValuesMutationVariables = Exact<{
	values: Array<Scalars['String']['input']> | Scalars['String']['input']
	userId: Scalars['String']['input']
}>

export type SetValuesMutation = {
	__typename?: 'Mutation'
	setvalues?: {
		__typename?: 'ProfileConnection'
		edges: Array<{
			__typename?: 'ProfileEdge'
			node: {
				__typename?: 'Profile'
				id: string
				aboutMe?: string | null
				email?: string | null
				firstName: string
				lastName: string
				hasAvatar?: boolean | null
				avatarPath?: string | null
				hasCover?: boolean | null
				coverPath?: string | null
				cvFilePath?: any | null
				cvFileOriginalName?: any | null
				featuredVideo?: string | null
				company_name?: string | null
				userOnBoardingFormVisited?: boolean | null
				user?: {
					__typename?: 'User'
					id: string
					email: string
					_OwnerToCompanyCollection?: {
						__typename?: '_OwnerToCompanyConnection'
						edges: Array<{
							__typename?: '_OwnerToCompanyEdge'
							node: {
								__typename?: '_OwnerToCompany'
								company: {
									__typename?: 'Company'
									id: string
									hasLogo?: boolean | null
									name?: string | null
									slug: string
									logoPath?: string | null
								}
							}
						}>
					} | null
				} | null
				_ProfileToValueCollection?: {
					__typename?: '_ProfileToValueConnection'
					edges: Array<{
						__typename?: '_ProfileToValueEdge'
						node: {
							__typename?: '_ProfileToValue'
							value: {
								__typename?: 'Value'
								id: string
								title?: string | null
							}
						}
					}>
				} | null
				_ProfileToSkillCollection?: {
					__typename?: '_ProfileToSkillConnection'
					edges: Array<{
						__typename?: '_ProfileToSkillEdge'
						node: {
							__typename?: '_ProfileToSkill'
							skill: {
								__typename?: 'Skill'
								id: string
								title: string
							}
						}
					}>
				} | null
				experienceCollection?: {
					__typename?: 'ExperienceConnection'
					edges: Array<{
						__typename?: 'ExperienceEdge'
						node: {
							__typename?: 'Experience'
							id: string
							position?: string | null
							company?: string | null
							startDate?: any | null
							endDate?: any | null
							isCurrent?: boolean | null
							isPresent?: boolean | null
							title?: string | null
							description?: string | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								type: string
								name: string
								region2?: string | null
							} | null
						}
					}>
				} | null
			}
		}>
	} | null
}

export type SetSkillsMutationVariables = Exact<{
	skills: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type SetSkillsMutation = {
	__typename?: 'Mutation'
	setskills?: {
		__typename?: 'SkillConnection'
		edges: Array<{
			__typename?: 'SkillEdge'
			node: { __typename?: 'Skill'; id: string; title: string }
		}>
	} | null
}

export type UpdateUsernameMutationVariables = Exact<{
	userId?: InputMaybe<Scalars['String']['input']>
	username: Scalars['String']['input']
}>

export type UpdateUsernameMutation = {
	__typename?: 'Mutation'
	updateUserCollection: {
		__typename?: 'UserUpdateResponse'
		affectedCount: number
		records: Array<{ __typename?: 'User'; id: string; uid: string }>
	}
}

export type UpdateUserSettingsMutationVariables = Exact<{
	userID?: InputMaybe<Scalars['String']['input']>
	userSettings: ProfileUpdateInput
}>

export type UpdateUserSettingsMutation = {
	__typename?: 'Mutation'
	updateProfileCollection: {
		__typename?: 'ProfileUpdateResponse'
		records: Array<{
			__typename?: 'Profile'
			id: string
			aboutMe?: string | null
			email?: string | null
			firstName: string
			lastName: string
			hasAvatar?: boolean | null
			avatarPath?: string | null
			hasCover?: boolean | null
			coverPath?: string | null
			cvFilePath?: any | null
			cvFileOriginalName?: any | null
			featuredVideo?: string | null
			company_name?: string | null
			userOnBoardingFormVisited?: boolean | null
			user?: {
				__typename?: 'User'
				id: string
				email: string
				_OwnerToCompanyCollection?: {
					__typename?: '_OwnerToCompanyConnection'
					edges: Array<{
						__typename?: '_OwnerToCompanyEdge'
						node: {
							__typename?: '_OwnerToCompany'
							company: {
								__typename?: 'Company'
								id: string
								hasLogo?: boolean | null
								name?: string | null
								slug: string
								logoPath?: string | null
							}
						}
					}>
				} | null
			} | null
			_ProfileToValueCollection?: {
				__typename?: '_ProfileToValueConnection'
				edges: Array<{
					__typename?: '_ProfileToValueEdge'
					node: {
						__typename?: '_ProfileToValue'
						value: {
							__typename?: 'Value'
							id: string
							title?: string | null
						}
					}
				}>
			} | null
			_ProfileToSkillCollection?: {
				__typename?: '_ProfileToSkillConnection'
				edges: Array<{
					__typename?: '_ProfileToSkillEdge'
					node: {
						__typename?: '_ProfileToSkill'
						skill: {
							__typename?: 'Skill'
							id: string
							title: string
						}
					}
				}>
			} | null
			experienceCollection?: {
				__typename?: 'ExperienceConnection'
				edges: Array<{
					__typename?: 'ExperienceEdge'
					node: {
						__typename?: 'Experience'
						id: string
						position?: string | null
						company?: string | null
						startDate?: any | null
						endDate?: any | null
						isCurrent?: boolean | null
						isPresent?: boolean | null
						title?: string | null
						description?: string | null
						roLocations?: {
							__typename?: 'roLocations'
							id: string
							type: string
							name: string
							region2?: string | null
						} | null
					}
				}>
			} | null
		}>
	}
}

export type SetUpProfileMutationVariables = Exact<{
	profileId: Scalars['String']['input']
	firstName?: InputMaybe<Scalars['String']['input']>
	lastName?: InputMaybe<Scalars['String']['input']>
	aboutMe?: InputMaybe<Scalars['String']['input']>
	avatarPath?: InputMaybe<Scalars['String']['input']>
	coverPath?: InputMaybe<Scalars['String']['input']>
	skills?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	values?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	locationId?: InputMaybe<Scalars['String']['input']>
	cvFilePath?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	cvFileOriginalName?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
}>

export type SetUpProfileMutation = {
	__typename?: 'Mutation'
	setUpProfile?: {
		__typename?: 'UserConnection'
		edges: Array<{
			__typename?: 'UserEdge'
			node: {
				__typename?: 'User'
				id: string
				uid: string
				god: boolean
				firebaseToken?: string | null
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							aboutMe?: string | null
							email?: string | null
							firstName: string
							lastName: string
							hasAvatar?: boolean | null
							avatarPath?: string | null
							hasCover?: boolean | null
							coverPath?: string | null
							cvFilePath?: any | null
							cvFileOriginalName?: any | null
							featuredVideo?: string | null
							company_name?: string | null
							userOnBoardingFormVisited?: boolean | null
							user?: {
								__typename?: 'User'
								id: string
								email: string
								_OwnerToCompanyCollection?: {
									__typename?: '_OwnerToCompanyConnection'
									edges: Array<{
										__typename?: '_OwnerToCompanyEdge'
										node: {
											__typename?: '_OwnerToCompany'
											company: {
												__typename?: 'Company'
												id: string
												hasLogo?: boolean | null
												name?: string | null
												slug: string
												logoPath?: string | null
											}
										}
									}>
								} | null
							} | null
							_ProfileToValueCollection?: {
								__typename?: '_ProfileToValueConnection'
								edges: Array<{
									__typename?: '_ProfileToValueEdge'
									node: {
										__typename?: '_ProfileToValue'
										value: {
											__typename?: 'Value'
											id: string
											title?: string | null
										}
									}
								}>
							} | null
							_ProfileToSkillCollection?: {
								__typename?: '_ProfileToSkillConnection'
								edges: Array<{
									__typename?: '_ProfileToSkillEdge'
									node: {
										__typename?: '_ProfileToSkill'
										skill: {
											__typename?: 'Skill'
											id: string
											title: string
										}
									}
								}>
							} | null
							experienceCollection?: {
								__typename?: 'ExperienceConnection'
								edges: Array<{
									__typename?: 'ExperienceEdge'
									node: {
										__typename?: 'Experience'
										id: string
										position?: string | null
										company?: string | null
										startDate?: any | null
										endDate?: any | null
										isCurrent?: boolean | null
										isPresent?: boolean | null
										title?: string | null
										description?: string | null
										roLocations?: {
											__typename?: 'roLocations'
											id: string
											type: string
											name: string
											region2?: string | null
										} | null
									}
								}>
							} | null
						}
					}>
				} | null
				_UserToCompanyRoleCollection?: {
					__typename?: '_UserToCompanyRoleConnection'
					edges: Array<{
						__typename?: '_UserToCompanyRoleEdge'
						node: {
							__typename?: '_UserToCompanyRole'
							companyRole: {
								__typename?: 'CompanyRole'
								id: string
								company?: {
									__typename?: 'Company'
									id: string
									slug: string
									name?: string | null
									hasLogo?: boolean | null
									logoPath?: string | null
									coverPath?: string | null
									hasCover?: boolean | null
									description?: string | null
								} | null
								companyRole_rolesCollection?: {
									__typename?: 'CompanyRole_rolesConnection'
									edges: Array<{
										__typename?: 'CompanyRole_rolesEdge'
										node: {
											__typename?: 'CompanyRole_roles'
											value: string
										}
									}>
								} | null
							}
						}
					}>
				} | null
			}
		}>
	} | null
}

export type SetCvFileMutationVariables = Exact<{
	cvFilePath?: InputMaybe<Scalars['JSON']['input']>
	cvFileOriginalName?: InputMaybe<Scalars['JSON']['input']>
}>

export type SetCvFileMutation = {
	__typename?: 'Mutation'
	updateProfileCollection: {
		__typename?: 'ProfileUpdateResponse'
		records: Array<{
			__typename?: 'Profile'
			id: string
			aboutMe?: string | null
			email?: string | null
			firstName: string
			lastName: string
			hasAvatar?: boolean | null
			avatarPath?: string | null
			hasCover?: boolean | null
			coverPath?: string | null
			cvFilePath?: any | null
			cvFileOriginalName?: any | null
			featuredVideo?: string | null
			company_name?: string | null
			userOnBoardingFormVisited?: boolean | null
			user?: {
				__typename?: 'User'
				id: string
				email: string
				_OwnerToCompanyCollection?: {
					__typename?: '_OwnerToCompanyConnection'
					edges: Array<{
						__typename?: '_OwnerToCompanyEdge'
						node: {
							__typename?: '_OwnerToCompany'
							company: {
								__typename?: 'Company'
								id: string
								hasLogo?: boolean | null
								name?: string | null
								slug: string
								logoPath?: string | null
							}
						}
					}>
				} | null
			} | null
			_ProfileToValueCollection?: {
				__typename?: '_ProfileToValueConnection'
				edges: Array<{
					__typename?: '_ProfileToValueEdge'
					node: {
						__typename?: '_ProfileToValue'
						value: {
							__typename?: 'Value'
							id: string
							title?: string | null
						}
					}
				}>
			} | null
			_ProfileToSkillCollection?: {
				__typename?: '_ProfileToSkillConnection'
				edges: Array<{
					__typename?: '_ProfileToSkillEdge'
					node: {
						__typename?: '_ProfileToSkill'
						skill: {
							__typename?: 'Skill'
							id: string
							title: string
						}
					}
				}>
			} | null
			experienceCollection?: {
				__typename?: 'ExperienceConnection'
				edges: Array<{
					__typename?: 'ExperienceEdge'
					node: {
						__typename?: 'Experience'
						id: string
						position?: string | null
						company?: string | null
						startDate?: any | null
						endDate?: any | null
						isCurrent?: boolean | null
						isPresent?: boolean | null
						title?: string | null
						description?: string | null
						roLocations?: {
							__typename?: 'roLocations'
							id: string
							type: string
							name: string
							region2?: string | null
						} | null
					}
				}>
			} | null
		}>
	}
}

export type SetUserOnBoardingMutationVariables = Exact<{ [key: string]: never }>

export type SetUserOnBoardingMutation = {
	__typename?: 'Mutation'
	insertIntoProfileCollection?: {
		__typename?: 'ProfileInsertResponse'
		records: Array<{ __typename?: 'Profile'; amount?: any | null }>
	} | null
}

export type RoLocationsCollectionQueryVariables = Exact<{
	data?: InputMaybe<RoLocationsFilter>
}>

export type RoLocationsCollectionQuery = {
	__typename?: 'Query'
	roLocationsCollection?: {
		__typename?: 'roLocationsConnection'
		edges: Array<{
			__typename?: 'roLocationsEdge'
			node: {
				__typename?: 'roLocations'
				id: string
				type: string
				name: string
				region2?: string | null
			}
		}>
	} | null
}

export type AddCompanyLocationsQueryVariables = Exact<{
	data?: InputMaybe<RoLocationsFilter>
}>

export type AddCompanyLocationsQuery = {
	__typename?: 'Query'
	roLocationsCollection?: {
		__typename?: 'roLocationsConnection'
		edges: Array<{
			__typename?: 'roLocationsEdge'
			node: { __typename?: 'roLocations'; id: string; name: string }
		}>
	} | null
}

export type SearchQueryVariables = Exact<{
	data: Scalars['String']['input']
}>

export type SearchQuery = {
	__typename?: 'Query'
	search?: {
		__typename?: 'searchviewConnection'
		edges: Array<{
			__typename?: 'searchviewEdge'
			node: {
				__typename?: 'searchview'
				article: {
					__typename?: 'Article'
					id: string
					worksAt?: string | null
					readDuration?: number | null
					title?: string | null
					body: string
					slug?: string | null
					description?: string | null
					isPost?: boolean | null
					postAs?: string | null
					postingCompany?: string | null
					createdAt: any
					updatedAt: any
					featuredVideo?: string | null
					user?: {
						__typename?: 'User'
						id: string
						uid: string
						email: string
						god: boolean
						profileCollection?: {
							__typename?: 'ProfileConnection'
							edges: Array<{
								__typename?: 'ProfileEdge'
								node: {
									__typename?: 'Profile'
									id: string
									firstName: string
									lastName: string
									cvFilePath?: any | null
									cvFileOriginalName?: any | null
									hasAvatar?: boolean | null
									avatarContentType?: string | null
									avatarPath?: string | null
									experienceCollection?: {
										__typename?: 'ExperienceConnection'
										edges: Array<{
											__typename?: 'ExperienceEdge'
											node: {
												__typename?: 'Experience'
												position?: string | null
												company?: string | null
											}
										}>
									} | null
								}
							}>
						} | null
					} | null
					company?: {
						__typename?: 'Company'
						id: string
						name?: string | null
						slug: string
						hasLogo?: boolean | null
						logoPath?: string | null
						industry?: {
							__typename?: 'Industry'
							id: string
							key: string
						} | null
					} | null
					activeArticleTagCollection?: {
						__typename?: 'ActiveArticleTagConnection'
						edges: Array<{
							__typename?: 'ActiveArticleTagEdge'
							node: {
								__typename?: 'ActiveArticleTag'
								id: string
								votes?: number | null
								articleTag?: {
									__typename?: 'ArticleTag'
									title: string
								} | null
								_ActiveArticleTagToUserCollection?: {
									__typename?: '_ActiveArticleTagToUserConnection'
									edges: Array<{
										__typename?: '_ActiveArticleTagToUserEdge'
										node: {
											__typename?: '_ActiveArticleTagToUser'
											user: {
												__typename?: 'User'
												profileCollection?: {
													__typename?: 'ProfileConnection'
													edges: Array<{
														__typename?: 'ProfileEdge'
														node: {
															__typename?: 'Profile'
															firstName: string
															lastName: string
															user?: {
																__typename?: 'User'
																id: string
																uid: string
															} | null
														}
													}>
												} | null
											}
										}
									}>
								} | null
							}
						}>
					} | null
					image?: {
						__typename?: 'Image'
						id: string
						filename?: string | null
					} | null
				}
				company: {
					__typename?: 'Company'
					id: string
					name?: string | null
					slug: string
					dateFounded?: string | null
					hasLogo?: boolean | null
					logoPath?: string | null
					hasCover?: boolean | null
					coverPath?: string | null
					featuredVideo?: string | null
					industry?: {
						__typename?: 'Industry'
						id: string
						key: string
					} | null
				}
				user: {
					__typename?: 'User'
					id: string
					uid: string
					profileCollection?: {
						__typename?: 'ProfileConnection'
						edges: Array<{
							__typename?: 'ProfileEdge'
							node: {
								__typename?: 'Profile'
								id: string
								firstName: string
								lastName: string
								hasAvatar?: boolean | null
								avatarPath?: string | null
								experienceCollection?: {
									__typename?: 'ExperienceConnection'
									edges: Array<{
										__typename?: 'ExperienceEdge'
										node: {
											__typename?: 'Experience'
											position?: string | null
											company?: string | null
										}
									}>
								} | null
							}
						}>
					} | null
				}
				team: {
					__typename?: 'Team'
					id: string
					name: string
					slug: string
					company?: {
						__typename?: 'Company'
						id: string
						name?: string | null
						slug: string
					} | null
				}
				job: {
					__typename?: 'Job'
					id: string
					slug: string
					description?: string | null
					title: string
					contractType?: string | null
					seniorityLevel?: string | null
					jobType?: string | null
					locationType?: string | null
					featuredImage?: string | null
					company?: {
						__typename?: 'Company'
						id: string
						logoPath?: string | null
						hasCover?: boolean | null
						hasLogo?: boolean | null
						name?: string | null
						slug: string
						description?: string | null
						coverPath?: string | null
						featuredVideo?: string | null
						industry?: {
							__typename?: 'Industry'
							id: string
							key: string
						} | null
					} | null
					_TeamToJobCollection?: {
						__typename?: '_TeamToJobConnection'
						edges: Array<{
							__typename?: '_TeamToJobEdge'
							node: {
								__typename?: '_TeamToJob'
								job: {
									__typename?: 'Job'
									jobSalary?: {
										__typename?: 'JobSalary'
										id: string
										currency?: string | null
										amountMin?: any | null
										amountMax?: any | null
										rate?: string | null
									} | null
								}
							}
						}>
					} | null
					_JobToCompanyOfficesCollection?: {
						__typename?: '_JobToCompanyOfficesConnection'
						edges: Array<{
							__typename?: '_JobToCompanyOfficesEdge'
							node: {
								__typename?: '_JobToCompanyOffices'
								companyOffices: {
									__typename?: 'CompanyOffices'
									id: string
									roLocations?: {
										__typename?: 'roLocations'
										id: string
										name: string
										region2?: string | null
									} | null
								}
							}
						}>
					} | null
				}
			}
		}>
	} | null
}

export type ProfileCollectionQueryVariables = Exact<{
	filter?: InputMaybe<ProfileFilter>
	after?: InputMaybe<Scalars['Cursor']['input']>
	first?: InputMaybe<Scalars['Int']['input']>
}>

export type ProfileCollectionQuery = {
	__typename?: 'Query'
	profileCollection?: {
		__typename?: 'ProfileConnection'
		edges: Array<{
			__typename?: 'ProfileEdge'
			node: {
				__typename?: 'Profile'
				id: string
				firstName: string
				lastName: string
				hasAvatar?: boolean | null
				avatarPath?: string | null
				experienceCollection?: {
					__typename?: 'ExperienceConnection'
					edges: Array<{
						__typename?: 'ExperienceEdge'
						node: {
							__typename?: 'Experience'
							position?: string | null
							company?: string | null
						}
					}>
				} | null
			}
		}>
		pageInfo: {
			__typename?: 'PageInfo'
			hasNextPage: boolean
			endCursor?: string | null
		}
	} | null
}

export type SearchArticlesQueryVariables = Exact<{
	query?: InputMaybe<Scalars['String']['input']>
	after?: InputMaybe<Scalars['Cursor']['input']>
	first?: InputMaybe<Scalars['Int']['input']>
}>

export type SearchArticlesQuery = {
	__typename?: 'Query'
	articleCollection?: {
		__typename?: 'ArticleConnection'
		edges: Array<{
			__typename?: 'ArticleEdge'
			node: {
				__typename?: 'Article'
				id: string
				worksAt?: string | null
				readDuration?: number | null
				title?: string | null
				body: string
				slug?: string | null
				description?: string | null
				isPost?: boolean | null
				postAs?: string | null
				postingCompany?: string | null
				createdAt: any
				updatedAt: any
				featuredVideo?: string | null
				user?: {
					__typename?: 'User'
					id: string
					uid: string
					email: string
					god: boolean
					profileCollection?: {
						__typename?: 'ProfileConnection'
						edges: Array<{
							__typename?: 'ProfileEdge'
							node: {
								__typename?: 'Profile'
								id: string
								firstName: string
								lastName: string
								cvFilePath?: any | null
								cvFileOriginalName?: any | null
								hasAvatar?: boolean | null
								avatarContentType?: string | null
								avatarPath?: string | null
								experienceCollection?: {
									__typename?: 'ExperienceConnection'
									edges: Array<{
										__typename?: 'ExperienceEdge'
										node: {
											__typename?: 'Experience'
											position?: string | null
											company?: string | null
										}
									}>
								} | null
							}
						}>
					} | null
				} | null
				company?: {
					__typename?: 'Company'
					id: string
					name?: string | null
					slug: string
					hasLogo?: boolean | null
					logoPath?: string | null
					industry?: {
						__typename?: 'Industry'
						id: string
						key: string
					} | null
				} | null
				activeArticleTagCollection?: {
					__typename?: 'ActiveArticleTagConnection'
					edges: Array<{
						__typename?: 'ActiveArticleTagEdge'
						node: {
							__typename?: 'ActiveArticleTag'
							id: string
							votes?: number | null
							articleTag?: {
								__typename?: 'ArticleTag'
								title: string
							} | null
							_ActiveArticleTagToUserCollection?: {
								__typename?: '_ActiveArticleTagToUserConnection'
								edges: Array<{
									__typename?: '_ActiveArticleTagToUserEdge'
									node: {
										__typename?: '_ActiveArticleTagToUser'
										user: {
											__typename?: 'User'
											profileCollection?: {
												__typename?: 'ProfileConnection'
												edges: Array<{
													__typename?: 'ProfileEdge'
													node: {
														__typename?: 'Profile'
														firstName: string
														lastName: string
														user?: {
															__typename?: 'User'
															id: string
															uid: string
														} | null
													}
												}>
											} | null
										}
									}
								}>
							} | null
						}
					}>
				} | null
				image?: {
					__typename?: 'Image'
					id: string
					filename?: string | null
				} | null
			}
		}>
		pageInfo: {
			__typename?: 'PageInfo'
			hasNextPage: boolean
			endCursor?: string | null
		}
	} | null
}

export type SkillCollectionQueryVariables = Exact<{
	key: Scalars['String']['input']
}>

export type SkillCollectionQuery = {
	__typename?: 'Query'
	skillCollection?: {
		__typename?: 'SkillConnection'
		edges: Array<{
			__typename?: 'SkillEdge'
			node: { __typename?: 'Skill'; id: string; title: string }
		}>
	} | null
}

export type UniversityCollectionQueryVariables = Exact<{ [key: string]: never }>

export type UniversityCollectionQuery = {
	__typename?: 'Query'
	universityCollection?: {
		__typename?: 'UniversityConnection'
		edges: Array<{
			__typename?: 'UniversityEdge'
			node: { __typename?: 'University'; id: string; name: string }
		}>
	} | null
}

export type FacultyCollectionQueryVariables = Exact<{
	filter?: InputMaybe<FacultyFilter>
}>

export type FacultyCollectionQuery = {
	__typename?: 'Query'
	facultyCollection?: {
		__typename?: 'FacultyConnection'
		edges: Array<{
			__typename?: 'FacultyEdge'
			node: { __typename?: 'Faculty'; id: string; name: string }
		}>
	} | null
}

export type ExportStudentsQueryVariables = Exact<{ [key: string]: never }>

export type ExportStudentsQuery = {
	__typename?: 'Query'
	exportstudents?: {
		__typename?: 'exportstudentkitviewConnection'
		edges: Array<{
			__typename?: 'exportstudentkitviewEdge'
			node: {
				__typename?: 'exportstudentkitview'
				firstname: string
				lastname: string
				email: string
				university: string
				faculty: string
				specialization: string
				hasaccount: string
				location: string
				scandate: any
				scanningagentname: string
				scanningagentemail: string
			}
		}>
	} | null
}

export type FacultySpecializationCollectionQueryVariables = Exact<{
	facultyId: Scalars['String']['input']
	nameFilter: Scalars['String']['input']
}>

export type FacultySpecializationCollectionQuery = {
	__typename?: 'Query'
	facultySpecializationCollection?: {
		__typename?: 'FacultySpecializationConnection'
		edges: Array<{
			__typename?: 'FacultySpecializationEdge'
			node: {
				__typename?: 'FacultySpecialization'
				id: string
				name: string
			}
		}>
	} | null
}

export type AddStudentKitMutationVariables = Exact<{
	data: Array<StudentKitInsertInput> | StudentKitInsertInput
}>

export type AddStudentKitMutation = {
	__typename?: 'Mutation'
	insertIntoStudentKitCollection?: {
		__typename?: 'StudentKitInsertResponse'
		records: Array<{
			__typename?: 'StudentKit'
			id: string
			firstName: string
			lastName: string
			email: string
		}>
	} | null
}

export type SendQrCodeMutationVariables = Exact<{
	email: Scalars['String']['input']
}>

export type SendQrCodeMutation = {
	__typename?: 'Mutation'
	send_qr_code?: any | null
}

export type TagCollectionQueryVariables = Exact<{
	keyword: Scalars['String']['input']
}>

export type TagCollectionQuery = {
	__typename?: 'Query'
	tagCollection?: {
		__typename?: 'TagConnection'
		edges: Array<{
			__typename?: 'TagEdge'
			node: { __typename?: 'Tag'; id: string; title?: string | null }
		}>
	} | null
}

export type AppreciateMutationVariables = Exact<{
	language: Scalars['String']['input']
	tagId: Scalars['String']['input']
	articleId: Scalars['String']['input']
}>

export type AppreciateMutation = {
	__typename?: 'Mutation'
	appreciate?: {
		__typename?: 'standardresponseConnection'
		edges: Array<{
			__typename?: 'standardresponseEdge'
			node: {
				__typename?: 'standardresponse'
				status: boolean
				error: string
			}
		}>
	} | null
}

export type TeamQueryQueryVariables = Exact<{
	companySlug?: InputMaybe<Scalars['String']['input']>
	id?: InputMaybe<Scalars['String']['input']>
	slug?: InputMaybe<Scalars['String']['input']>
	companyId?: InputMaybe<Scalars['String']['input']>
}>

export type TeamQueryQuery = {
	__typename?: 'Query'
	feedteams?: {
		__typename?: 'TeamConnection'
		edges: Array<{
			__typename?: 'TeamEdge'
			node: {
				__typename?: 'Team'
				id: string
				name: string
				slug: string
				description?: string | null
				noOfMembers?: string | null
				disabilityRatio?: number | null
				averageAge?: number | null
				maleRatio?: number | null
				femaleRatio?: number | null
				coverContentType?: string | null
				coverPath?: string | null
				coverBackground?: string | null
				hasLogo?: boolean | null
				logoContentType?: string | null
				logoPath?: string | null
				hasCover?: boolean | null
				featuredVideo?: string | null
				teamDepartment?: {
					__typename?: 'TeamDepartment'
					id: string
					key: string
					roTitle: string
					enTitle: string
					roCategory?: string | null
					enCategory?: string | null
				} | null
				teamMemberCollection?: {
					__typename?: 'TeamMemberConnection'
					edges: Array<{
						__typename?: 'TeamMemberEdge'
						node: {
							__typename?: 'TeamMember'
							id: string
							user?: {
								__typename?: 'User'
								id: string
								uid: string
								profileCollection?: {
									__typename?: 'ProfileConnection'
									edges: Array<{
										__typename?: 'ProfileEdge'
										node: {
											__typename?: 'Profile'
											id: string
											aboutMe?: string | null
											email?: string | null
											firstName: string
											lastName: string
											hasAvatar?: boolean | null
											avatarPath?: string | null
											hasCover?: boolean | null
											coverPath?: string | null
											experienceCollection?: {
												__typename?: 'ExperienceConnection'
												edges: Array<{
													__typename?: 'ExperienceEdge'
													node: {
														__typename?: 'Experience'
														position?: string | null
														company?: string | null
													}
												}>
											} | null
										}
									}>
								} | null
							} | null
						}
					}>
				} | null
				_TeamToCompanyOfficesCollection?: {
					__typename?: '_TeamToCompanyOfficesConnection'
					edges: Array<{
						__typename?: '_TeamToCompanyOfficesEdge'
						node: {
							__typename?: '_TeamToCompanyOffices'
							companyOffices: {
								__typename?: 'CompanyOffices'
								id: string
								address?: string | null
								zipCode?: string | null
								hq?: boolean | null
								roLocations?: {
									__typename?: 'roLocations'
									id: string
									region2?: string | null
									name: string
								} | null
							}
						}
					}>
				} | null
				company?: {
					__typename?: 'Company'
					id: string
					name?: string | null
					slug: string
					hasLogo?: boolean | null
					logoPath?: string | null
					hasCover?: boolean | null
					coverPath?: string | null
					_OwnerToCompanyCollection?: {
						__typename?: '_OwnerToCompanyConnection'
						edges: Array<{
							__typename?: '_OwnerToCompanyEdge'
							node: {
								__typename?: '_OwnerToCompany'
								A: string
								B: string
								company: {
									__typename: 'Company'
									id: string
									name?: string | null
									slug: string
									dateFounded?: string | null
									headline?: string | null
									description?: string | null
									productsAndServices?: string | null
									noOfEmployees?: string | null
									website?: string | null
									phones?: string | null
									emails?: string | null
									featuredVideo?: string | null
									hasLogo?: boolean | null
									logoPath?: string | null
									hasCover?: boolean | null
									aboutTeams?: string | null
									coverPath?: string | null
									_OwnerToCompanyCollection?: {
										__typename?: '_OwnerToCompanyConnection'
										edges: Array<{
											__typename?: '_OwnerToCompanyEdge'
											node: {
												__typename?: '_OwnerToCompany'
												user: {
													__typename?: 'User'
													id: string
													uid: string
												}
											}
										}>
									} | null
									industry?: {
										__typename?: 'Industry'
										id: string
										key: string
									} | null
									companyOfficesCollection?: {
										__typename?: 'CompanyOfficesConnection'
										edges: Array<{
											__typename?: 'CompanyOfficesEdge'
											node: {
												__typename?: 'CompanyOffices'
												id: string
												address?: string | null
												zipCode?: string | null
												hq?: boolean | null
												roLocations?: {
													__typename?: 'roLocations'
													id: string
													name: string
													region2?: string | null
												} | null
											}
										}>
									} | null
									jobCollection?: {
										__typename?: 'JobConnection'
										edges: Array<{
											__typename?: 'JobEdge'
											node: {
												__typename?: 'Job'
												id: string
											}
										}>
									} | null
								}
								user: {
									__typename?: 'User'
									id: string
									uid: string
									god: boolean
									firebaseToken?: string | null
									profileCollection?: {
										__typename?: 'ProfileConnection'
										edges: Array<{
											__typename?: 'ProfileEdge'
											node: {
												__typename?: 'Profile'
												id: string
												aboutMe?: string | null
												email?: string | null
												firstName: string
												lastName: string
												hasAvatar?: boolean | null
												avatarPath?: string | null
												hasCover?: boolean | null
												coverPath?: string | null
												cvFilePath?: any | null
												cvFileOriginalName?: any | null
												featuredVideo?: string | null
												company_name?: string | null
												userOnBoardingFormVisited?:
													| boolean
													| null
												user?: {
													__typename?: 'User'
													id: string
													email: string
													_OwnerToCompanyCollection?: {
														__typename?: '_OwnerToCompanyConnection'
														edges: Array<{
															__typename?: '_OwnerToCompanyEdge'
															node: {
																__typename?: '_OwnerToCompany'
																company: {
																	__typename?: 'Company'
																	id: string
																	hasLogo?:
																		| boolean
																		| null
																	name?:
																		| string
																		| null
																	slug: string
																	logoPath?:
																		| string
																		| null
																}
															}
														}>
													} | null
												} | null
												_ProfileToValueCollection?: {
													__typename?: '_ProfileToValueConnection'
													edges: Array<{
														__typename?: '_ProfileToValueEdge'
														node: {
															__typename?: '_ProfileToValue'
															value: {
																__typename?: 'Value'
																id: string
																title?:
																	| string
																	| null
															}
														}
													}>
												} | null
												_ProfileToSkillCollection?: {
													__typename?: '_ProfileToSkillConnection'
													edges: Array<{
														__typename?: '_ProfileToSkillEdge'
														node: {
															__typename?: '_ProfileToSkill'
															skill: {
																__typename?: 'Skill'
																id: string
																title: string
															}
														}
													}>
												} | null
												experienceCollection?: {
													__typename?: 'ExperienceConnection'
													edges: Array<{
														__typename?: 'ExperienceEdge'
														node: {
															__typename?: 'Experience'
															id: string
															position?:
																| string
																| null
															company?:
																| string
																| null
															startDate?:
																| any
																| null
															endDate?: any | null
															isCurrent?:
																| boolean
																| null
															isPresent?:
																| boolean
																| null
															title?:
																| string
																| null
															description?:
																| string
																| null
															roLocations?: {
																__typename?: 'roLocations'
																id: string
																type: string
																name: string
																region2?:
																	| string
																	| null
															} | null
														}
													}>
												} | null
											}
										}>
									} | null
									_UserToCompanyRoleCollection?: {
										__typename?: '_UserToCompanyRoleConnection'
										edges: Array<{
											__typename?: '_UserToCompanyRoleEdge'
											node: {
												__typename?: '_UserToCompanyRole'
												companyRole: {
													__typename?: 'CompanyRole'
													id: string
													company?: {
														__typename?: 'Company'
														id: string
														slug: string
														name?: string | null
														hasLogo?: boolean | null
														logoPath?: string | null
														coverPath?:
															| string
															| null
														hasCover?:
															| boolean
															| null
														description?:
															| string
															| null
													} | null
													companyRole_rolesCollection?: {
														__typename?: 'CompanyRole_rolesConnection'
														edges: Array<{
															__typename?: 'CompanyRole_rolesEdge'
															node: {
																__typename?: 'CompanyRole_roles'
																value: string
															}
														}>
													} | null
												}
											}
										}>
									} | null
								}
							}
						}>
					} | null
					industry?: {
						__typename?: 'Industry'
						id: string
						key: string
					} | null
					companyOfficesCollection?: {
						__typename?: 'CompanyOfficesConnection'
						edges: Array<{
							__typename?: 'CompanyOfficesEdge'
							node: {
								__typename?: 'CompanyOffices'
								id: string
								address?: string | null
								zipCode?: string | null
								hq?: boolean | null
								roLocations?: {
									__typename?: 'roLocations'
									id: string
									name: string
									region2?: string | null
								} | null
							}
						}>
					} | null
				} | null
			}
		}>
	} | null
}

export type TeamDepartmentsQueryVariables = Exact<{ [key: string]: never }>

export type TeamDepartmentsQuery = {
	__typename?: 'Query'
	teamDepartmentCollection?: {
		__typename?: 'TeamDepartmentConnection'
		edges: Array<{
			__typename?: 'TeamDepartmentEdge'
			node: { __typename?: 'TeamDepartment'; id: string; key: string }
		}>
	} | null
}

export type TeamsQueryQueryVariables = Exact<{
	name?: InputMaybe<Scalars['String']['input']>
	companyId?: InputMaybe<Scalars['String']['input']>
	companySlug?: InputMaybe<Scalars['String']['input']>
	locationids?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
}>

export type TeamsQueryQuery = {
	__typename?: 'Query'
	feedteams?: {
		__typename?: 'TeamConnection'
		edges: Array<{
			__typename?: 'TeamEdge'
			node: {
				__typename?: 'Team'
				id: string
				name: string
				slug: string
				description?: string | null
				noOfMembers?: string | null
				disabilityRatio?: number | null
				averageAge?: number | null
				maleRatio?: number | null
				femaleRatio?: number | null
				coverContentType?: string | null
				coverPath?: string | null
				coverBackground?: string | null
				hasLogo?: boolean | null
				logoContentType?: string | null
				logoPath?: string | null
				hasCover?: boolean | null
				featuredVideo?: string | null
				teamDepartment?: {
					__typename?: 'TeamDepartment'
					id: string
					key: string
					roTitle: string
					enTitle: string
					roCategory?: string | null
					enCategory?: string | null
				} | null
				teamMemberCollection?: {
					__typename?: 'TeamMemberConnection'
					edges: Array<{
						__typename?: 'TeamMemberEdge'
						node: {
							__typename?: 'TeamMember'
							id: string
							user?: {
								__typename?: 'User'
								id: string
								uid: string
								profileCollection?: {
									__typename?: 'ProfileConnection'
									edges: Array<{
										__typename?: 'ProfileEdge'
										node: {
											__typename?: 'Profile'
											id: string
											aboutMe?: string | null
											email?: string | null
											firstName: string
											lastName: string
											hasAvatar?: boolean | null
											avatarPath?: string | null
											hasCover?: boolean | null
											coverPath?: string | null
											experienceCollection?: {
												__typename?: 'ExperienceConnection'
												edges: Array<{
													__typename?: 'ExperienceEdge'
													node: {
														__typename?: 'Experience'
														position?: string | null
														company?: string | null
													}
												}>
											} | null
										}
									}>
								} | null
							} | null
						}
					}>
				} | null
				_TeamToCompanyOfficesCollection?: {
					__typename?: '_TeamToCompanyOfficesConnection'
					edges: Array<{
						__typename?: '_TeamToCompanyOfficesEdge'
						node: {
							__typename?: '_TeamToCompanyOffices'
							companyOffices: {
								__typename?: 'CompanyOffices'
								id: string
								address?: string | null
								zipCode?: string | null
								hq?: boolean | null
								roLocations?: {
									__typename?: 'roLocations'
									id: string
									region2?: string | null
									name: string
								} | null
							}
						}
					}>
				} | null
				company?: {
					__typename?: 'Company'
					id: string
					name?: string | null
					slug: string
					hasLogo?: boolean | null
					logoPath?: string | null
					hasCover?: boolean | null
					coverPath?: string | null
					_OwnerToCompanyCollection?: {
						__typename?: '_OwnerToCompanyConnection'
						edges: Array<{
							__typename?: '_OwnerToCompanyEdge'
							node: {
								__typename?: '_OwnerToCompany'
								A: string
								B: string
								company: {
									__typename: 'Company'
									id: string
									name?: string | null
									slug: string
									dateFounded?: string | null
									headline?: string | null
									description?: string | null
									productsAndServices?: string | null
									noOfEmployees?: string | null
									website?: string | null
									phones?: string | null
									emails?: string | null
									featuredVideo?: string | null
									hasLogo?: boolean | null
									logoPath?: string | null
									hasCover?: boolean | null
									aboutTeams?: string | null
									coverPath?: string | null
									_OwnerToCompanyCollection?: {
										__typename?: '_OwnerToCompanyConnection'
										edges: Array<{
											__typename?: '_OwnerToCompanyEdge'
											node: {
												__typename?: '_OwnerToCompany'
												user: {
													__typename?: 'User'
													id: string
													uid: string
												}
											}
										}>
									} | null
									industry?: {
										__typename?: 'Industry'
										id: string
										key: string
									} | null
									companyOfficesCollection?: {
										__typename?: 'CompanyOfficesConnection'
										edges: Array<{
											__typename?: 'CompanyOfficesEdge'
											node: {
												__typename?: 'CompanyOffices'
												id: string
												address?: string | null
												zipCode?: string | null
												hq?: boolean | null
												roLocations?: {
													__typename?: 'roLocations'
													id: string
													name: string
													region2?: string | null
												} | null
											}
										}>
									} | null
									jobCollection?: {
										__typename?: 'JobConnection'
										edges: Array<{
											__typename?: 'JobEdge'
											node: {
												__typename?: 'Job'
												id: string
											}
										}>
									} | null
								}
								user: {
									__typename?: 'User'
									id: string
									uid: string
									god: boolean
									firebaseToken?: string | null
									profileCollection?: {
										__typename?: 'ProfileConnection'
										edges: Array<{
											__typename?: 'ProfileEdge'
											node: {
												__typename?: 'Profile'
												id: string
												aboutMe?: string | null
												email?: string | null
												firstName: string
												lastName: string
												hasAvatar?: boolean | null
												avatarPath?: string | null
												hasCover?: boolean | null
												coverPath?: string | null
												cvFilePath?: any | null
												cvFileOriginalName?: any | null
												featuredVideo?: string | null
												company_name?: string | null
												userOnBoardingFormVisited?:
													| boolean
													| null
												user?: {
													__typename?: 'User'
													id: string
													email: string
													_OwnerToCompanyCollection?: {
														__typename?: '_OwnerToCompanyConnection'
														edges: Array<{
															__typename?: '_OwnerToCompanyEdge'
															node: {
																__typename?: '_OwnerToCompany'
																company: {
																	__typename?: 'Company'
																	id: string
																	hasLogo?:
																		| boolean
																		| null
																	name?:
																		| string
																		| null
																	slug: string
																	logoPath?:
																		| string
																		| null
																}
															}
														}>
													} | null
												} | null
												_ProfileToValueCollection?: {
													__typename?: '_ProfileToValueConnection'
													edges: Array<{
														__typename?: '_ProfileToValueEdge'
														node: {
															__typename?: '_ProfileToValue'
															value: {
																__typename?: 'Value'
																id: string
																title?:
																	| string
																	| null
															}
														}
													}>
												} | null
												_ProfileToSkillCollection?: {
													__typename?: '_ProfileToSkillConnection'
													edges: Array<{
														__typename?: '_ProfileToSkillEdge'
														node: {
															__typename?: '_ProfileToSkill'
															skill: {
																__typename?: 'Skill'
																id: string
																title: string
															}
														}
													}>
												} | null
												experienceCollection?: {
													__typename?: 'ExperienceConnection'
													edges: Array<{
														__typename?: 'ExperienceEdge'
														node: {
															__typename?: 'Experience'
															id: string
															position?:
																| string
																| null
															company?:
																| string
																| null
															startDate?:
																| any
																| null
															endDate?: any | null
															isCurrent?:
																| boolean
																| null
															isPresent?:
																| boolean
																| null
															title?:
																| string
																| null
															description?:
																| string
																| null
															roLocations?: {
																__typename?: 'roLocations'
																id: string
																type: string
																name: string
																region2?:
																	| string
																	| null
															} | null
														}
													}>
												} | null
											}
										}>
									} | null
									_UserToCompanyRoleCollection?: {
										__typename?: '_UserToCompanyRoleConnection'
										edges: Array<{
											__typename?: '_UserToCompanyRoleEdge'
											node: {
												__typename?: '_UserToCompanyRole'
												companyRole: {
													__typename?: 'CompanyRole'
													id: string
													company?: {
														__typename?: 'Company'
														id: string
														slug: string
														name?: string | null
														hasLogo?: boolean | null
														logoPath?: string | null
														coverPath?:
															| string
															| null
														hasCover?:
															| boolean
															| null
														description?:
															| string
															| null
													} | null
													companyRole_rolesCollection?: {
														__typename?: 'CompanyRole_rolesConnection'
														edges: Array<{
															__typename?: 'CompanyRole_rolesEdge'
															node: {
																__typename?: 'CompanyRole_roles'
																value: string
															}
														}>
													} | null
												}
											}
										}>
									} | null
								}
							}
						}>
					} | null
					industry?: {
						__typename?: 'Industry'
						id: string
						key: string
					} | null
					companyOfficesCollection?: {
						__typename?: 'CompanyOfficesConnection'
						edges: Array<{
							__typename?: 'CompanyOfficesEdge'
							node: {
								__typename?: 'CompanyOffices'
								id: string
								address?: string | null
								zipCode?: string | null
								hq?: boolean | null
								roLocations?: {
									__typename?: 'roLocations'
									id: string
									name: string
									region2?: string | null
								} | null
							}
						}>
					} | null
				} | null
			}
		}>
	} | null
}

export type TeamDepartmentCollectionQueryVariables = Exact<{
	name?: InputMaybe<Scalars['String']['input']>
}>

export type TeamDepartmentCollectionQuery = {
	__typename?: 'Query'
	teamCollection?: {
		__typename?: 'TeamConnection'
		edges: Array<{
			__typename?: 'TeamEdge'
			node: {
				__typename?: 'Team'
				id: string
				name: string
				teamDepartment?: {
					__typename?: 'TeamDepartment'
					id: string
					key: string
					roTitle: string
					enTitle: string
				} | null
			}
		}>
	} | null
}

export type FeedTeamsQueryVariables = Exact<{
	name?: InputMaybe<Scalars['String']['input']>
	industryids?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	departmentids?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	locationids?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	companyid?: InputMaybe<Scalars['String']['input']>
	size?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	averageage?: InputMaybe<
		| Array<InputMaybe<Scalars['String']['input']>>
		| InputMaybe<Scalars['String']['input']>
	>
	first?: InputMaybe<Scalars['Int']['input']>
	after?: InputMaybe<Scalars['Cursor']['input']>
}>

export type FeedTeamsQuery = {
	__typename?: 'Query'
	feedteams?: {
		__typename?: 'TeamConnection'
		edges: Array<{
			__typename?: 'TeamEdge'
			cursor: string
			node: {
				__typename?: 'Team'
				id: string
				name: string
				slug: string
				description?: string | null
				noOfMembers?: string | null
				disabilityRatio?: number | null
				averageAge?: number | null
				maleRatio?: number | null
				femaleRatio?: number | null
				coverContentType?: string | null
				coverPath?: string | null
				coverBackground?: string | null
				hasLogo?: boolean | null
				logoContentType?: string | null
				logoPath?: string | null
				hasCover?: boolean | null
				featuredVideo?: string | null
				teamDepartment?: {
					__typename?: 'TeamDepartment'
					id: string
					key: string
					roTitle: string
					enTitle: string
					roCategory?: string | null
					enCategory?: string | null
				} | null
				teamMemberCollection?: {
					__typename?: 'TeamMemberConnection'
					edges: Array<{
						__typename?: 'TeamMemberEdge'
						node: {
							__typename?: 'TeamMember'
							id: string
							user?: {
								__typename?: 'User'
								id: string
								uid: string
								profileCollection?: {
									__typename?: 'ProfileConnection'
									edges: Array<{
										__typename?: 'ProfileEdge'
										node: {
											__typename?: 'Profile'
											id: string
											aboutMe?: string | null
											email?: string | null
											firstName: string
											lastName: string
											hasAvatar?: boolean | null
											avatarPath?: string | null
											hasCover?: boolean | null
											coverPath?: string | null
											experienceCollection?: {
												__typename?: 'ExperienceConnection'
												edges: Array<{
													__typename?: 'ExperienceEdge'
													node: {
														__typename?: 'Experience'
														position?: string | null
														company?: string | null
													}
												}>
											} | null
										}
									}>
								} | null
							} | null
						}
					}>
				} | null
				_TeamToCompanyOfficesCollection?: {
					__typename?: '_TeamToCompanyOfficesConnection'
					edges: Array<{
						__typename?: '_TeamToCompanyOfficesEdge'
						node: {
							__typename?: '_TeamToCompanyOffices'
							companyOffices: {
								__typename?: 'CompanyOffices'
								id: string
								address?: string | null
								zipCode?: string | null
								hq?: boolean | null
								roLocations?: {
									__typename?: 'roLocations'
									id: string
									region2?: string | null
									name: string
								} | null
							}
						}
					}>
				} | null
				company?: {
					__typename?: 'Company'
					id: string
					name?: string | null
					slug: string
					hasLogo?: boolean | null
					logoPath?: string | null
					hasCover?: boolean | null
					coverPath?: string | null
					_OwnerToCompanyCollection?: {
						__typename?: '_OwnerToCompanyConnection'
						edges: Array<{
							__typename?: '_OwnerToCompanyEdge'
							node: {
								__typename?: '_OwnerToCompany'
								A: string
								B: string
								company: {
									__typename: 'Company'
									id: string
									name?: string | null
									slug: string
									dateFounded?: string | null
									headline?: string | null
									description?: string | null
									productsAndServices?: string | null
									noOfEmployees?: string | null
									website?: string | null
									phones?: string | null
									emails?: string | null
									featuredVideo?: string | null
									hasLogo?: boolean | null
									logoPath?: string | null
									hasCover?: boolean | null
									aboutTeams?: string | null
									coverPath?: string | null
									_OwnerToCompanyCollection?: {
										__typename?: '_OwnerToCompanyConnection'
										edges: Array<{
											__typename?: '_OwnerToCompanyEdge'
											node: {
												__typename?: '_OwnerToCompany'
												user: {
													__typename?: 'User'
													id: string
													uid: string
												}
											}
										}>
									} | null
									industry?: {
										__typename?: 'Industry'
										id: string
										key: string
									} | null
									companyOfficesCollection?: {
										__typename?: 'CompanyOfficesConnection'
										edges: Array<{
											__typename?: 'CompanyOfficesEdge'
											node: {
												__typename?: 'CompanyOffices'
												id: string
												address?: string | null
												zipCode?: string | null
												hq?: boolean | null
												roLocations?: {
													__typename?: 'roLocations'
													id: string
													name: string
													region2?: string | null
												} | null
											}
										}>
									} | null
									jobCollection?: {
										__typename?: 'JobConnection'
										edges: Array<{
											__typename?: 'JobEdge'
											node: {
												__typename?: 'Job'
												id: string
											}
										}>
									} | null
								}
								user: {
									__typename?: 'User'
									id: string
									uid: string
									god: boolean
									firebaseToken?: string | null
									profileCollection?: {
										__typename?: 'ProfileConnection'
										edges: Array<{
											__typename?: 'ProfileEdge'
											node: {
												__typename?: 'Profile'
												id: string
												aboutMe?: string | null
												email?: string | null
												firstName: string
												lastName: string
												hasAvatar?: boolean | null
												avatarPath?: string | null
												hasCover?: boolean | null
												coverPath?: string | null
												cvFilePath?: any | null
												cvFileOriginalName?: any | null
												featuredVideo?: string | null
												company_name?: string | null
												userOnBoardingFormVisited?:
													| boolean
													| null
												user?: {
													__typename?: 'User'
													id: string
													email: string
													_OwnerToCompanyCollection?: {
														__typename?: '_OwnerToCompanyConnection'
														edges: Array<{
															__typename?: '_OwnerToCompanyEdge'
															node: {
																__typename?: '_OwnerToCompany'
																company: {
																	__typename?: 'Company'
																	id: string
																	hasLogo?:
																		| boolean
																		| null
																	name?:
																		| string
																		| null
																	slug: string
																	logoPath?:
																		| string
																		| null
																}
															}
														}>
													} | null
												} | null
												_ProfileToValueCollection?: {
													__typename?: '_ProfileToValueConnection'
													edges: Array<{
														__typename?: '_ProfileToValueEdge'
														node: {
															__typename?: '_ProfileToValue'
															value: {
																__typename?: 'Value'
																id: string
																title?:
																	| string
																	| null
															}
														}
													}>
												} | null
												_ProfileToSkillCollection?: {
													__typename?: '_ProfileToSkillConnection'
													edges: Array<{
														__typename?: '_ProfileToSkillEdge'
														node: {
															__typename?: '_ProfileToSkill'
															skill: {
																__typename?: 'Skill'
																id: string
																title: string
															}
														}
													}>
												} | null
												experienceCollection?: {
													__typename?: 'ExperienceConnection'
													edges: Array<{
														__typename?: 'ExperienceEdge'
														node: {
															__typename?: 'Experience'
															id: string
															position?:
																| string
																| null
															company?:
																| string
																| null
															startDate?:
																| any
																| null
															endDate?: any | null
															isCurrent?:
																| boolean
																| null
															isPresent?:
																| boolean
																| null
															title?:
																| string
																| null
															description?:
																| string
																| null
															roLocations?: {
																__typename?: 'roLocations'
																id: string
																type: string
																name: string
																region2?:
																	| string
																	| null
															} | null
														}
													}>
												} | null
											}
										}>
									} | null
									_UserToCompanyRoleCollection?: {
										__typename?: '_UserToCompanyRoleConnection'
										edges: Array<{
											__typename?: '_UserToCompanyRoleEdge'
											node: {
												__typename?: '_UserToCompanyRole'
												companyRole: {
													__typename?: 'CompanyRole'
													id: string
													company?: {
														__typename?: 'Company'
														id: string
														slug: string
														name?: string | null
														hasLogo?: boolean | null
														logoPath?: string | null
														coverPath?:
															| string
															| null
														hasCover?:
															| boolean
															| null
														description?:
															| string
															| null
													} | null
													companyRole_rolesCollection?: {
														__typename?: 'CompanyRole_rolesConnection'
														edges: Array<{
															__typename?: 'CompanyRole_rolesEdge'
															node: {
																__typename?: 'CompanyRole_roles'
																value: string
															}
														}>
													} | null
												}
											}
										}>
									} | null
								}
							}
						}>
					} | null
					industry?: {
						__typename?: 'Industry'
						id: string
						key: string
					} | null
					companyOfficesCollection?: {
						__typename?: 'CompanyOfficesConnection'
						edges: Array<{
							__typename?: 'CompanyOfficesEdge'
							node: {
								__typename?: 'CompanyOffices'
								id: string
								address?: string | null
								zipCode?: string | null
								hq?: boolean | null
								roLocations?: {
									__typename?: 'roLocations'
									id: string
									name: string
									region2?: string | null
								} | null
							}
						}>
					} | null
				} | null
			}
		}>
		pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean }
	} | null
}

export type HandleTeamMutationVariables = Exact<{
	details: TeamUpdateInput
}>

export type HandleTeamMutation = {
	__typename?: 'Mutation'
	updateTeamCollection: {
		__typename?: 'TeamUpdateResponse'
		records: Array<{
			__typename?: 'Team'
			id: string
			name: string
			slug: string
			description?: string | null
			noOfMembers?: string | null
			disabilityRatio?: number | null
			averageAge?: number | null
			maleRatio?: number | null
			femaleRatio?: number | null
			coverContentType?: string | null
			coverPath?: string | null
			coverBackground?: string | null
			hasLogo?: boolean | null
			logoContentType?: string | null
			logoPath?: string | null
			hasCover?: boolean | null
			featuredVideo?: string | null
			teamDepartment?: {
				__typename?: 'TeamDepartment'
				id: string
				key: string
				roTitle: string
				enTitle: string
				roCategory?: string | null
				enCategory?: string | null
			} | null
			teamMemberCollection?: {
				__typename?: 'TeamMemberConnection'
				edges: Array<{
					__typename?: 'TeamMemberEdge'
					node: {
						__typename?: 'TeamMember'
						id: string
						user?: {
							__typename?: 'User'
							id: string
							uid: string
							profileCollection?: {
								__typename?: 'ProfileConnection'
								edges: Array<{
									__typename?: 'ProfileEdge'
									node: {
										__typename?: 'Profile'
										id: string
										aboutMe?: string | null
										email?: string | null
										firstName: string
										lastName: string
										hasAvatar?: boolean | null
										avatarPath?: string | null
										hasCover?: boolean | null
										coverPath?: string | null
										experienceCollection?: {
											__typename?: 'ExperienceConnection'
											edges: Array<{
												__typename?: 'ExperienceEdge'
												node: {
													__typename?: 'Experience'
													position?: string | null
													company?: string | null
												}
											}>
										} | null
									}
								}>
							} | null
						} | null
					}
				}>
			} | null
			_TeamToCompanyOfficesCollection?: {
				__typename?: '_TeamToCompanyOfficesConnection'
				edges: Array<{
					__typename?: '_TeamToCompanyOfficesEdge'
					node: {
						__typename?: '_TeamToCompanyOffices'
						companyOffices: {
							__typename?: 'CompanyOffices'
							id: string
							address?: string | null
							zipCode?: string | null
							hq?: boolean | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								region2?: string | null
								name: string
							} | null
						}
					}
				}>
			} | null
			company?: {
				__typename?: 'Company'
				id: string
				name?: string | null
				slug: string
				hasLogo?: boolean | null
				logoPath?: string | null
				hasCover?: boolean | null
				coverPath?: string | null
				_OwnerToCompanyCollection?: {
					__typename?: '_OwnerToCompanyConnection'
					edges: Array<{
						__typename?: '_OwnerToCompanyEdge'
						node: {
							__typename?: '_OwnerToCompany'
							A: string
							B: string
							company: {
								__typename: 'Company'
								id: string
								name?: string | null
								slug: string
								dateFounded?: string | null
								headline?: string | null
								description?: string | null
								productsAndServices?: string | null
								noOfEmployees?: string | null
								website?: string | null
								phones?: string | null
								emails?: string | null
								featuredVideo?: string | null
								hasLogo?: boolean | null
								logoPath?: string | null
								hasCover?: boolean | null
								aboutTeams?: string | null
								coverPath?: string | null
								_OwnerToCompanyCollection?: {
									__typename?: '_OwnerToCompanyConnection'
									edges: Array<{
										__typename?: '_OwnerToCompanyEdge'
										node: {
											__typename?: '_OwnerToCompany'
											user: {
												__typename?: 'User'
												id: string
												uid: string
											}
										}
									}>
								} | null
								industry?: {
									__typename?: 'Industry'
									id: string
									key: string
								} | null
								companyOfficesCollection?: {
									__typename?: 'CompanyOfficesConnection'
									edges: Array<{
										__typename?: 'CompanyOfficesEdge'
										node: {
											__typename?: 'CompanyOffices'
											id: string
											address?: string | null
											zipCode?: string | null
											hq?: boolean | null
											roLocations?: {
												__typename?: 'roLocations'
												id: string
												name: string
												region2?: string | null
											} | null
										}
									}>
								} | null
								jobCollection?: {
									__typename?: 'JobConnection'
									edges: Array<{
										__typename?: 'JobEdge'
										node: { __typename?: 'Job'; id: string }
									}>
								} | null
							}
							user: {
								__typename?: 'User'
								id: string
								uid: string
								god: boolean
								firebaseToken?: string | null
								profileCollection?: {
									__typename?: 'ProfileConnection'
									edges: Array<{
										__typename?: 'ProfileEdge'
										node: {
											__typename?: 'Profile'
											id: string
											aboutMe?: string | null
											email?: string | null
											firstName: string
											lastName: string
											hasAvatar?: boolean | null
											avatarPath?: string | null
											hasCover?: boolean | null
											coverPath?: string | null
											cvFilePath?: any | null
											cvFileOriginalName?: any | null
											featuredVideo?: string | null
											company_name?: string | null
											userOnBoardingFormVisited?:
												| boolean
												| null
											user?: {
												__typename?: 'User'
												id: string
												email: string
												_OwnerToCompanyCollection?: {
													__typename?: '_OwnerToCompanyConnection'
													edges: Array<{
														__typename?: '_OwnerToCompanyEdge'
														node: {
															__typename?: '_OwnerToCompany'
															company: {
																__typename?: 'Company'
																id: string
																hasLogo?:
																	| boolean
																	| null
																name?:
																	| string
																	| null
																slug: string
																logoPath?:
																	| string
																	| null
															}
														}
													}>
												} | null
											} | null
											_ProfileToValueCollection?: {
												__typename?: '_ProfileToValueConnection'
												edges: Array<{
													__typename?: '_ProfileToValueEdge'
													node: {
														__typename?: '_ProfileToValue'
														value: {
															__typename?: 'Value'
															id: string
															title?:
																| string
																| null
														}
													}
												}>
											} | null
											_ProfileToSkillCollection?: {
												__typename?: '_ProfileToSkillConnection'
												edges: Array<{
													__typename?: '_ProfileToSkillEdge'
													node: {
														__typename?: '_ProfileToSkill'
														skill: {
															__typename?: 'Skill'
															id: string
															title: string
														}
													}
												}>
											} | null
											experienceCollection?: {
												__typename?: 'ExperienceConnection'
												edges: Array<{
													__typename?: 'ExperienceEdge'
													node: {
														__typename?: 'Experience'
														id: string
														position?: string | null
														company?: string | null
														startDate?: any | null
														endDate?: any | null
														isCurrent?:
															| boolean
															| null
														isPresent?:
															| boolean
															| null
														title?: string | null
														description?:
															| string
															| null
														roLocations?: {
															__typename?: 'roLocations'
															id: string
															type: string
															name: string
															region2?:
																| string
																| null
														} | null
													}
												}>
											} | null
										}
									}>
								} | null
								_UserToCompanyRoleCollection?: {
									__typename?: '_UserToCompanyRoleConnection'
									edges: Array<{
										__typename?: '_UserToCompanyRoleEdge'
										node: {
											__typename?: '_UserToCompanyRole'
											companyRole: {
												__typename?: 'CompanyRole'
												id: string
												company?: {
													__typename?: 'Company'
													id: string
													slug: string
													name?: string | null
													hasLogo?: boolean | null
													logoPath?: string | null
													coverPath?: string | null
													hasCover?: boolean | null
													description?: string | null
												} | null
												companyRole_rolesCollection?: {
													__typename?: 'CompanyRole_rolesConnection'
													edges: Array<{
														__typename?: 'CompanyRole_rolesEdge'
														node: {
															__typename?: 'CompanyRole_roles'
															value: string
														}
													}>
												} | null
											}
										}
									}>
								} | null
							}
						}
					}>
				} | null
				industry?: {
					__typename?: 'Industry'
					id: string
					key: string
				} | null
				companyOfficesCollection?: {
					__typename?: 'CompanyOfficesConnection'
					edges: Array<{
						__typename?: 'CompanyOfficesEdge'
						node: {
							__typename?: 'CompanyOffices'
							id: string
							address?: string | null
							zipCode?: string | null
							hq?: boolean | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								name: string
								region2?: string | null
							} | null
						}
					}>
				} | null
			} | null
		}>
	}
}

export type InsertIntoTeamCollectionMutationVariables = Exact<{
	details: Array<TeamInsertInput> | TeamInsertInput
}>

export type InsertIntoTeamCollectionMutation = {
	__typename?: 'Mutation'
	insertIntoTeamCollection?: {
		__typename?: 'TeamInsertResponse'
		records: Array<{
			__typename?: 'Team'
			id: string
			name: string
			slug: string
			description?: string | null
			noOfMembers?: string | null
			disabilityRatio?: number | null
			averageAge?: number | null
			maleRatio?: number | null
			femaleRatio?: number | null
			coverContentType?: string | null
			coverPath?: string | null
			coverBackground?: string | null
			hasLogo?: boolean | null
			logoContentType?: string | null
			logoPath?: string | null
			hasCover?: boolean | null
			featuredVideo?: string | null
			teamDepartment?: {
				__typename?: 'TeamDepartment'
				id: string
				key: string
				roTitle: string
				enTitle: string
				roCategory?: string | null
				enCategory?: string | null
			} | null
			teamMemberCollection?: {
				__typename?: 'TeamMemberConnection'
				edges: Array<{
					__typename?: 'TeamMemberEdge'
					node: {
						__typename?: 'TeamMember'
						id: string
						user?: {
							__typename?: 'User'
							id: string
							uid: string
							profileCollection?: {
								__typename?: 'ProfileConnection'
								edges: Array<{
									__typename?: 'ProfileEdge'
									node: {
										__typename?: 'Profile'
										id: string
										aboutMe?: string | null
										email?: string | null
										firstName: string
										lastName: string
										hasAvatar?: boolean | null
										avatarPath?: string | null
										hasCover?: boolean | null
										coverPath?: string | null
										experienceCollection?: {
											__typename?: 'ExperienceConnection'
											edges: Array<{
												__typename?: 'ExperienceEdge'
												node: {
													__typename?: 'Experience'
													position?: string | null
													company?: string | null
												}
											}>
										} | null
									}
								}>
							} | null
						} | null
					}
				}>
			} | null
			_TeamToCompanyOfficesCollection?: {
				__typename?: '_TeamToCompanyOfficesConnection'
				edges: Array<{
					__typename?: '_TeamToCompanyOfficesEdge'
					node: {
						__typename?: '_TeamToCompanyOffices'
						companyOffices: {
							__typename?: 'CompanyOffices'
							id: string
							address?: string | null
							zipCode?: string | null
							hq?: boolean | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								region2?: string | null
								name: string
							} | null
						}
					}
				}>
			} | null
			company?: {
				__typename?: 'Company'
				id: string
				name?: string | null
				slug: string
				hasLogo?: boolean | null
				logoPath?: string | null
				hasCover?: boolean | null
				coverPath?: string | null
				_OwnerToCompanyCollection?: {
					__typename?: '_OwnerToCompanyConnection'
					edges: Array<{
						__typename?: '_OwnerToCompanyEdge'
						node: {
							__typename?: '_OwnerToCompany'
							A: string
							B: string
							company: {
								__typename: 'Company'
								id: string
								name?: string | null
								slug: string
								dateFounded?: string | null
								headline?: string | null
								description?: string | null
								productsAndServices?: string | null
								noOfEmployees?: string | null
								website?: string | null
								phones?: string | null
								emails?: string | null
								featuredVideo?: string | null
								hasLogo?: boolean | null
								logoPath?: string | null
								hasCover?: boolean | null
								aboutTeams?: string | null
								coverPath?: string | null
								_OwnerToCompanyCollection?: {
									__typename?: '_OwnerToCompanyConnection'
									edges: Array<{
										__typename?: '_OwnerToCompanyEdge'
										node: {
											__typename?: '_OwnerToCompany'
											user: {
												__typename?: 'User'
												id: string
												uid: string
											}
										}
									}>
								} | null
								industry?: {
									__typename?: 'Industry'
									id: string
									key: string
								} | null
								companyOfficesCollection?: {
									__typename?: 'CompanyOfficesConnection'
									edges: Array<{
										__typename?: 'CompanyOfficesEdge'
										node: {
											__typename?: 'CompanyOffices'
											id: string
											address?: string | null
											zipCode?: string | null
											hq?: boolean | null
											roLocations?: {
												__typename?: 'roLocations'
												id: string
												name: string
												region2?: string | null
											} | null
										}
									}>
								} | null
								jobCollection?: {
									__typename?: 'JobConnection'
									edges: Array<{
										__typename?: 'JobEdge'
										node: { __typename?: 'Job'; id: string }
									}>
								} | null
							}
							user: {
								__typename?: 'User'
								id: string
								uid: string
								god: boolean
								firebaseToken?: string | null
								profileCollection?: {
									__typename?: 'ProfileConnection'
									edges: Array<{
										__typename?: 'ProfileEdge'
										node: {
											__typename?: 'Profile'
											id: string
											aboutMe?: string | null
											email?: string | null
											firstName: string
											lastName: string
											hasAvatar?: boolean | null
											avatarPath?: string | null
											hasCover?: boolean | null
											coverPath?: string | null
											cvFilePath?: any | null
											cvFileOriginalName?: any | null
											featuredVideo?: string | null
											company_name?: string | null
											userOnBoardingFormVisited?:
												| boolean
												| null
											user?: {
												__typename?: 'User'
												id: string
												email: string
												_OwnerToCompanyCollection?: {
													__typename?: '_OwnerToCompanyConnection'
													edges: Array<{
														__typename?: '_OwnerToCompanyEdge'
														node: {
															__typename?: '_OwnerToCompany'
															company: {
																__typename?: 'Company'
																id: string
																hasLogo?:
																	| boolean
																	| null
																name?:
																	| string
																	| null
																slug: string
																logoPath?:
																	| string
																	| null
															}
														}
													}>
												} | null
											} | null
											_ProfileToValueCollection?: {
												__typename?: '_ProfileToValueConnection'
												edges: Array<{
													__typename?: '_ProfileToValueEdge'
													node: {
														__typename?: '_ProfileToValue'
														value: {
															__typename?: 'Value'
															id: string
															title?:
																| string
																| null
														}
													}
												}>
											} | null
											_ProfileToSkillCollection?: {
												__typename?: '_ProfileToSkillConnection'
												edges: Array<{
													__typename?: '_ProfileToSkillEdge'
													node: {
														__typename?: '_ProfileToSkill'
														skill: {
															__typename?: 'Skill'
															id: string
															title: string
														}
													}
												}>
											} | null
											experienceCollection?: {
												__typename?: 'ExperienceConnection'
												edges: Array<{
													__typename?: 'ExperienceEdge'
													node: {
														__typename?: 'Experience'
														id: string
														position?: string | null
														company?: string | null
														startDate?: any | null
														endDate?: any | null
														isCurrent?:
															| boolean
															| null
														isPresent?:
															| boolean
															| null
														title?: string | null
														description?:
															| string
															| null
														roLocations?: {
															__typename?: 'roLocations'
															id: string
															type: string
															name: string
															region2?:
																| string
																| null
														} | null
													}
												}>
											} | null
										}
									}>
								} | null
								_UserToCompanyRoleCollection?: {
									__typename?: '_UserToCompanyRoleConnection'
									edges: Array<{
										__typename?: '_UserToCompanyRoleEdge'
										node: {
											__typename?: '_UserToCompanyRole'
											companyRole: {
												__typename?: 'CompanyRole'
												id: string
												company?: {
													__typename?: 'Company'
													id: string
													slug: string
													name?: string | null
													hasLogo?: boolean | null
													logoPath?: string | null
													coverPath?: string | null
													hasCover?: boolean | null
													description?: string | null
												} | null
												companyRole_rolesCollection?: {
													__typename?: 'CompanyRole_rolesConnection'
													edges: Array<{
														__typename?: 'CompanyRole_rolesEdge'
														node: {
															__typename?: 'CompanyRole_roles'
															value: string
														}
													}>
												} | null
											}
										}
									}>
								} | null
							}
						}
					}>
				} | null
				industry?: {
					__typename?: 'Industry'
					id: string
					key: string
				} | null
				companyOfficesCollection?: {
					__typename?: 'CompanyOfficesConnection'
					edges: Array<{
						__typename?: 'CompanyOfficesEdge'
						node: {
							__typename?: 'CompanyOffices'
							id: string
							address?: string | null
							zipCode?: string | null
							hq?: boolean | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								name: string
								region2?: string | null
							} | null
						}
					}>
				} | null
			} | null
		}>
	} | null
}

export type InsertIntoTeamMemberCollectionMutationVariables = Exact<{
	data: Array<TeamMemberInsertInput> | TeamMemberInsertInput
}>

export type InsertIntoTeamMemberCollectionMutation = {
	__typename?: 'Mutation'
	insertIntoTeamMemberCollection?: {
		__typename?: 'TeamMemberInsertResponse'
		records: Array<{ __typename?: 'TeamMember'; id: string }>
	} | null
}

export type DeleteFromTeamMemberCollectionMutationVariables = Exact<{
	id?: InputMaybe<Scalars['String']['input']>
}>

export type DeleteFromTeamMemberCollectionMutation = {
	__typename?: 'Mutation'
	deleteFromTeamMemberCollection: {
		__typename?: 'TeamMemberDeleteResponse'
		records: Array<{ __typename?: 'TeamMember'; id: string }>
	}
}

export type UpdateTeamCollectionMutationVariables = Exact<{
	id: Scalars['String']['input']
}>

export type UpdateTeamCollectionMutation = {
	__typename?: 'Mutation'
	updateTeamCollection: {
		__typename?: 'TeamUpdateResponse'
		records: Array<{
			__typename?: 'Team'
			id: string
			name: string
			slug: string
			description?: string | null
			noOfMembers?: string | null
			disabilityRatio?: number | null
			averageAge?: number | null
			maleRatio?: number | null
			femaleRatio?: number | null
			coverContentType?: string | null
			coverPath?: string | null
			coverBackground?: string | null
			hasLogo?: boolean | null
			logoContentType?: string | null
			logoPath?: string | null
			hasCover?: boolean | null
			featuredVideo?: string | null
			teamDepartment?: {
				__typename?: 'TeamDepartment'
				id: string
				key: string
				roTitle: string
				enTitle: string
				roCategory?: string | null
				enCategory?: string | null
			} | null
			teamMemberCollection?: {
				__typename?: 'TeamMemberConnection'
				edges: Array<{
					__typename?: 'TeamMemberEdge'
					node: {
						__typename?: 'TeamMember'
						id: string
						user?: {
							__typename?: 'User'
							id: string
							uid: string
							profileCollection?: {
								__typename?: 'ProfileConnection'
								edges: Array<{
									__typename?: 'ProfileEdge'
									node: {
										__typename?: 'Profile'
										id: string
										aboutMe?: string | null
										email?: string | null
										firstName: string
										lastName: string
										hasAvatar?: boolean | null
										avatarPath?: string | null
										hasCover?: boolean | null
										coverPath?: string | null
										experienceCollection?: {
											__typename?: 'ExperienceConnection'
											edges: Array<{
												__typename?: 'ExperienceEdge'
												node: {
													__typename?: 'Experience'
													position?: string | null
													company?: string | null
												}
											}>
										} | null
									}
								}>
							} | null
						} | null
					}
				}>
			} | null
			_TeamToCompanyOfficesCollection?: {
				__typename?: '_TeamToCompanyOfficesConnection'
				edges: Array<{
					__typename?: '_TeamToCompanyOfficesEdge'
					node: {
						__typename?: '_TeamToCompanyOffices'
						companyOffices: {
							__typename?: 'CompanyOffices'
							id: string
							address?: string | null
							zipCode?: string | null
							hq?: boolean | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								region2?: string | null
								name: string
							} | null
						}
					}
				}>
			} | null
			company?: {
				__typename?: 'Company'
				id: string
				name?: string | null
				slug: string
				hasLogo?: boolean | null
				logoPath?: string | null
				hasCover?: boolean | null
				coverPath?: string | null
				_OwnerToCompanyCollection?: {
					__typename?: '_OwnerToCompanyConnection'
					edges: Array<{
						__typename?: '_OwnerToCompanyEdge'
						node: {
							__typename?: '_OwnerToCompany'
							A: string
							B: string
							company: {
								__typename: 'Company'
								id: string
								name?: string | null
								slug: string
								dateFounded?: string | null
								headline?: string | null
								description?: string | null
								productsAndServices?: string | null
								noOfEmployees?: string | null
								website?: string | null
								phones?: string | null
								emails?: string | null
								featuredVideo?: string | null
								hasLogo?: boolean | null
								logoPath?: string | null
								hasCover?: boolean | null
								aboutTeams?: string | null
								coverPath?: string | null
								_OwnerToCompanyCollection?: {
									__typename?: '_OwnerToCompanyConnection'
									edges: Array<{
										__typename?: '_OwnerToCompanyEdge'
										node: {
											__typename?: '_OwnerToCompany'
											user: {
												__typename?: 'User'
												id: string
												uid: string
											}
										}
									}>
								} | null
								industry?: {
									__typename?: 'Industry'
									id: string
									key: string
								} | null
								companyOfficesCollection?: {
									__typename?: 'CompanyOfficesConnection'
									edges: Array<{
										__typename?: 'CompanyOfficesEdge'
										node: {
											__typename?: 'CompanyOffices'
											id: string
											address?: string | null
											zipCode?: string | null
											hq?: boolean | null
											roLocations?: {
												__typename?: 'roLocations'
												id: string
												name: string
												region2?: string | null
											} | null
										}
									}>
								} | null
								jobCollection?: {
									__typename?: 'JobConnection'
									edges: Array<{
										__typename?: 'JobEdge'
										node: { __typename?: 'Job'; id: string }
									}>
								} | null
							}
							user: {
								__typename?: 'User'
								id: string
								uid: string
								god: boolean
								firebaseToken?: string | null
								profileCollection?: {
									__typename?: 'ProfileConnection'
									edges: Array<{
										__typename?: 'ProfileEdge'
										node: {
											__typename?: 'Profile'
											id: string
											aboutMe?: string | null
											email?: string | null
											firstName: string
											lastName: string
											hasAvatar?: boolean | null
											avatarPath?: string | null
											hasCover?: boolean | null
											coverPath?: string | null
											cvFilePath?: any | null
											cvFileOriginalName?: any | null
											featuredVideo?: string | null
											company_name?: string | null
											userOnBoardingFormVisited?:
												| boolean
												| null
											user?: {
												__typename?: 'User'
												id: string
												email: string
												_OwnerToCompanyCollection?: {
													__typename?: '_OwnerToCompanyConnection'
													edges: Array<{
														__typename?: '_OwnerToCompanyEdge'
														node: {
															__typename?: '_OwnerToCompany'
															company: {
																__typename?: 'Company'
																id: string
																hasLogo?:
																	| boolean
																	| null
																name?:
																	| string
																	| null
																slug: string
																logoPath?:
																	| string
																	| null
															}
														}
													}>
												} | null
											} | null
											_ProfileToValueCollection?: {
												__typename?: '_ProfileToValueConnection'
												edges: Array<{
													__typename?: '_ProfileToValueEdge'
													node: {
														__typename?: '_ProfileToValue'
														value: {
															__typename?: 'Value'
															id: string
															title?:
																| string
																| null
														}
													}
												}>
											} | null
											_ProfileToSkillCollection?: {
												__typename?: '_ProfileToSkillConnection'
												edges: Array<{
													__typename?: '_ProfileToSkillEdge'
													node: {
														__typename?: '_ProfileToSkill'
														skill: {
															__typename?: 'Skill'
															id: string
															title: string
														}
													}
												}>
											} | null
											experienceCollection?: {
												__typename?: 'ExperienceConnection'
												edges: Array<{
													__typename?: 'ExperienceEdge'
													node: {
														__typename?: 'Experience'
														id: string
														position?: string | null
														company?: string | null
														startDate?: any | null
														endDate?: any | null
														isCurrent?:
															| boolean
															| null
														isPresent?:
															| boolean
															| null
														title?: string | null
														description?:
															| string
															| null
														roLocations?: {
															__typename?: 'roLocations'
															id: string
															type: string
															name: string
															region2?:
																| string
																| null
														} | null
													}
												}>
											} | null
										}
									}>
								} | null
								_UserToCompanyRoleCollection?: {
									__typename?: '_UserToCompanyRoleConnection'
									edges: Array<{
										__typename?: '_UserToCompanyRoleEdge'
										node: {
											__typename?: '_UserToCompanyRole'
											companyRole: {
												__typename?: 'CompanyRole'
												id: string
												company?: {
													__typename?: 'Company'
													id: string
													slug: string
													name?: string | null
													hasLogo?: boolean | null
													logoPath?: string | null
													coverPath?: string | null
													hasCover?: boolean | null
													description?: string | null
												} | null
												companyRole_rolesCollection?: {
													__typename?: 'CompanyRole_rolesConnection'
													edges: Array<{
														__typename?: 'CompanyRole_rolesEdge'
														node: {
															__typename?: 'CompanyRole_roles'
															value: string
														}
													}>
												} | null
											}
										}
									}>
								} | null
							}
						}
					}>
				} | null
				industry?: {
					__typename?: 'Industry'
					id: string
					key: string
				} | null
				companyOfficesCollection?: {
					__typename?: 'CompanyOfficesConnection'
					edges: Array<{
						__typename?: 'CompanyOfficesEdge'
						node: {
							__typename?: 'CompanyOffices'
							id: string
							address?: string | null
							zipCode?: string | null
							hq?: boolean | null
							roLocations?: {
								__typename?: 'roLocations'
								id: string
								name: string
								region2?: string | null
							} | null
						}
					}>
				} | null
			} | null
		}>
	}
}

export type SetExperienceMutationVariables = Exact<{
	id?: InputMaybe<Scalars['String']['input']>
	title?: InputMaybe<Scalars['String']['input']>
	description?: InputMaybe<Scalars['String']['input']>
	locationId?: InputMaybe<Scalars['String']['input']>
	position?: InputMaybe<Scalars['String']['input']>
	company?: InputMaybe<Scalars['String']['input']>
	startDate?: InputMaybe<Scalars['Datetime']['input']>
	endDate?: InputMaybe<Scalars['Datetime']['input']>
	isPresent?: InputMaybe<Scalars['Boolean']['input']>
	isCurrent?: InputMaybe<Scalars['Boolean']['input']>
}>

export type SetExperienceMutation = {
	__typename?: 'Mutation'
	insertIntoExperienceCollection?: {
		__typename?: 'ExperienceInsertResponse'
		affectedCount: number
		records: Array<{
			__typename?: 'Experience'
			id: string
			title?: string | null
		}>
	} | null
}

export type DeleteFromExperienceCollectionMutationVariables = Exact<{
	id: Scalars['String']['input']
}>

export type DeleteFromExperienceCollectionMutation = {
	__typename?: 'Mutation'
	deleteFromExperienceCollection: {
		__typename?: 'ExperienceDeleteResponse'
		records: Array<{
			__typename?: 'Experience'
			id: string
			position?: string | null
			company?: string | null
			startDate?: any | null
			endDate?: any | null
			isCurrent?: boolean | null
			title?: string | null
			description?: string | null
			roLocations?: {
				__typename?: 'roLocations'
				id: string
				type: string
				name: string
				region2?: string | null
			} | null
		}>
	}
}

export type _UserToCompanyRoleCollectionQueryVariables = Exact<{
	companyId?: InputMaybe<Scalars['String']['input']>
}>

export type _UserToCompanyRoleCollectionQuery = {
	__typename?: 'Query'
	_UserToCompanyRoleCollection?: {
		__typename?: '_UserToCompanyRoleConnection'
		edges: Array<{
			__typename?: '_UserToCompanyRoleEdge'
			node: {
				__typename?: '_UserToCompanyRole'
				A: string
				B: string
				user: {
					__typename?: 'User'
					id: string
					profileCollection?: {
						__typename?: 'ProfileConnection'
						edges: Array<{
							__typename?: 'ProfileEdge'
							node: {
								__typename?: 'Profile'
								id: string
								firstName: string
								lastName: string
								avatarPath?: string | null
							}
						}>
					} | null
				}
			}
		}>
	} | null
}

export type CompanyRoleCollectionQueryVariables = Exact<{
	id?: InputMaybe<Scalars['String']['input']>
}>

export type CompanyRoleCollectionQuery = {
	__typename?: 'Query'
	companyRoleCollection?: {
		__typename?: 'CompanyRoleConnection'
		edges: Array<{
			__typename?: 'CompanyRoleEdge'
			node: { __typename?: 'CompanyRole'; id: string }
		}>
	} | null
}

export type HandleCompanyUsersRoleMutationVariables = Exact<{
	data: Array<_UserToCompanyRoleInsertInput> | _UserToCompanyRoleInsertInput
}>

export type HandleCompanyUsersRoleMutation = {
	__typename?: 'Mutation'
	insertInto_UserToCompanyRoleCollection?: {
		__typename?: '_UserToCompanyRoleInsertResponse'
		records: Array<{
			__typename?: '_UserToCompanyRole'
			A: string
			B: string
			user: {
				__typename?: 'User'
				id: string
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							firstName: string
							lastName: string
							avatarPath?: string | null
						}
					}>
				} | null
			}
		}>
	} | null
}

export type DeleteCompanyUserRoleMutationVariables = Exact<{
	filter?: InputMaybe<_UserToCompanyRoleFilter>
}>

export type DeleteCompanyUserRoleMutation = {
	__typename?: 'Mutation'
	deleteFrom_UserToCompanyRoleCollection: {
		__typename?: '_UserToCompanyRoleDeleteResponse'
		records: Array<{
			__typename?: '_UserToCompanyRole'
			A: string
			B: string
			user: {
				__typename?: 'User'
				id: string
				profileCollection?: {
					__typename?: 'ProfileConnection'
					edges: Array<{
						__typename?: 'ProfileEdge'
						node: {
							__typename?: 'Profile'
							id: string
							firstName: string
							lastName: string
							avatarPath?: string | null
						}
					}>
				} | null
			}
		}>
	}
}

export const ArticlesByEntityResultsFragmentDoc = gql`
	fragment articlesByEntityResults on Article {
		id
		user {
			id
			email
			profileCollection {
				edges {
					node {
						id
						firstName
						lastName
					}
				}
			}
		}
		title
		body
		slug
		description
		isPost
		featuredVideo
		image {
			id
			filename
		}
		updatedAt
	}
`
export const StandardArticleResultFragmentDoc = gql`
	fragment standardArticleResult on Article {
		id
		worksAt
		user {
			id
			uid
			email
			god
			profileCollection {
				edges {
					node {
						id
						firstName
						lastName
						cvFilePath
						cvFileOriginalName
						hasAvatar
						avatarContentType
						avatarPath
						experienceCollection {
							edges {
								node {
									position
									company
								}
							}
						}
					}
				}
			}
		}
		readDuration
		title
		body
		slug
		description
		isPost
		postAs
		postingCompany
		company {
			id
			name
			slug
			hasLogo
			logoPath
			industry {
				id
				key
			}
		}
		public_companies {
			id
			name
			avatar_path
			industry
		}
		activeArticleTagCollection {
			edges {
				node {
					id
					votes
					articleTag {
						title
					}
					_ActiveArticleTagToUserCollection {
						edges {
							node {
								user {
									profileCollection {
										edges {
											node {
												firstName
												lastName
												user {
													id
													uid
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
		createdAt
		updatedAt
		featuredVideo
		image {
			id
			filename
		}
		activeArticleTagCollection {
			edges {
				node {
					id
					votes
					tag {
						id
						title
					}
				}
			}
		}
	}
`
export const PageInfoDataFragmentDoc = gql`
	fragment pageInfoData on PageInfo {
		hasNextPage
	}
`
export const ArticleConnectionDataFragmentDoc = gql`
	fragment articleConnectionData on ArticleConnection {
		edges {
			node {
				...standardArticleResult
			}
			cursor
		}
		pageInfo {
			...pageInfoData
		}
	}
	${StandardArticleResultFragmentDoc}
	${PageInfoDataFragmentDoc}
`
export const StandardCompanyResultFragmentDoc = gql`
	fragment standardCompanyResult on Company {
		id
		_OwnerToCompanyCollection {
			edges {
				node {
					user {
						id
						uid
					}
				}
			}
		}
		name
		slug
		dateFounded
		industry {
			id
			key
		}
		headline
		description
		productsAndServices
		noOfEmployees
		companyOfficesCollection {
			edges {
				node {
					id
					address
					roLocations {
						id
						name
						region2
					}
					zipCode
					hq
				}
			}
		}
		website
		phones
		emails
		featuredVideo
		hasLogo
		logoPath
		hasCover
		aboutTeams
		coverPath
		jobCollection {
			edges {
				node {
					id
				}
			}
		}
		__typename
	}
`
export const NodeFragmentDoc = gql`
	fragment Node on Company {
		...standardCompanyResult
	}
	${StandardCompanyResultFragmentDoc}
`
export const CompanyOfficesResultFragmentDoc = gql`
	fragment companyOfficesResult on CompanyOffices {
		id
		roLocations {
			id
			region2
			name
		}
		address
		zipCode
		hq
	}
`
export const StandardJobResultFragmentDoc = gql`
	fragment standardJobResult on Job {
		__typename
		id
		slug
		description
		title
		expiryDate
		contractType
		seniorityLevel
		jobType
		locationType
		featuredImage
		videoUrl
		applyJobExternalUrl
		benefits
		company {
			__typename
			id
			logoPath
			hasCover
			hasLogo
			name
			slug
			description
			coverPath
			featuredVideo
			industry {
				__typename
				id
				key
			}
		}
		_TeamToJobCollection {
			edges {
				node {
					team {
						__typename
						id
						name
						slug
						description
						hasCover
						coverPath
						teamMemberCollection {
							edges {
								node {
									id
									user {
										id
										profileCollection {
											edges {
												node {
													id
													firstName
													lastName
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
		teamLeader
		jobSalary {
			id
			__typename
			currency
			amountMin
			amountMax
			rate
		}
		benefits
		_JobToCustomSkillsCollection {
			edges {
				node {
					customSkills {
						__typename
						id
						key
						title
					}
				}
			}
		}
		_JobToCompanyOfficesCollection {
			edges {
				node {
					A
					B
					companyOffices {
						...companyOfficesResult
					}
				}
			}
		}
		jobApplicantCollection {
			edges {
				node {
					__typename
					id
				}
			}
		}
	}
	${CompanyOfficesResultFragmentDoc}
`
export const JobConnectionDataFragmentDoc = gql`
	fragment jobConnectionData on Job {
		...standardJobResult
	}
	${StandardJobResultFragmentDoc}
`
export const UserProfileFragmentFragmentDoc = gql`
	fragment UserProfileFragment on Profile {
		id
		aboutMe
		email
		firstName
		lastName
		hasAvatar
		avatarPath
		hasCover
		coverPath
		cvFilePath
		cvFileOriginalName
		featuredVideo
		company_name
		user {
			_OwnerToCompanyCollection {
				edges {
					node {
						company {
							id
							hasLogo
							name
							slug
							logoPath
						}
					}
				}
			}
		}
		_ProfileToValueCollection {
			edges {
				node {
					value {
						id
						title
					}
				}
			}
		}
		_ProfileToSkillCollection {
			edges {
				node {
					skill {
						id
						title
					}
				}
			}
		}
		experienceCollection {
			edges {
				node {
					id
					position
					company
					startDate
					roLocations {
						id
						type
						name
						region2
					}
					endDate
					isCurrent
					isPresent
					title
					description
				}
			}
		}
		user {
			id
			email
		}
		userOnBoardingFormVisited
	}
`
export const AuthenticationUserFragmentDoc = gql`
	fragment AuthenticationUser on User {
		id
		uid
		profileCollection {
			edges {
				node {
					...UserProfileFragment
				}
			}
		}
		_UserToCompanyRoleCollection {
			edges {
				node {
					companyRole {
						id
						company {
							id
							slug
							name
							hasLogo
							logoPath
							coverPath
							hasCover
							description
						}
					}
				}
			}
		}
		_UserToCompanyRoleCollection {
			edges {
				node {
					companyRole {
						companyRole_rolesCollection {
							edges {
								node {
									value
								}
							}
						}
					}
				}
			}
		}
		god
		firebaseToken
	}
	${UserProfileFragmentFragmentDoc}
`
export const JobApplicantsConnectionDataFragmentDoc = gql`
	fragment jobApplicantsConnectionData on JobApplicantConnection {
		edges {
			node {
				user {
					...AuthenticationUser
				}
				createdAt
			}
			cursor
		}
		pageInfo {
			...pageInfoData
		}
	}
	${AuthenticationUserFragmentDoc}
	${PageInfoDataFragmentDoc}
`
export const OwnerToCompanyFragmentFragmentDoc = gql`
	fragment OwnerToCompanyFragment on _OwnerToCompany {
		A
		B
		company {
			...standardCompanyResult
		}
		user {
			id
			uid
			profileCollection {
				edges {
					node {
						...UserProfileFragment
					}
				}
			}
			_UserToCompanyRoleCollection {
				edges {
					node {
						companyRole {
							id
							company {
								id
								slug
								name
								hasLogo
								logoPath
								coverPath
								hasCover
								description
							}
						}
					}
				}
			}
			_UserToCompanyRoleCollection {
				edges {
					node {
						companyRole {
							companyRole_rolesCollection {
								edges {
									node {
										value
									}
								}
							}
						}
					}
				}
			}
			god
			firebaseToken
		}
	}
	${StandardCompanyResultFragmentDoc}
	${UserProfileFragmentFragmentDoc}
`
export const StandardTeamResultFragmentDoc = gql`
	fragment standardTeamResult on Team {
		id
		name
		slug
		description
		teamDepartment {
			id
			key
			roTitle
			enTitle
			roCategory
			enCategory
		}
		noOfMembers
		teamMemberCollection {
			edges {
				node {
					id
					user {
						id
						uid
						profileCollection {
							edges {
								node {
									id
									aboutMe
									email
									firstName
									lastName
									hasAvatar
									avatarPath
									hasCover
									coverPath
									experienceCollection {
										edges {
											node {
												position
												company
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
		disabilityRatio
		averageAge
		maleRatio
		femaleRatio
		coverContentType
		coverPath
		coverBackground
		hasLogo
		logoContentType
		logoPath
		hasCover
		featuredVideo
		_TeamToCompanyOfficesCollection {
			edges {
				node {
					companyOffices {
						id
						roLocations {
							id
							region2
							name
						}
						address
						zipCode
						hq
					}
				}
			}
		}
		company {
			id
			name
			slug
			hasLogo
			logoPath
			hasCover
			coverPath
			_OwnerToCompanyCollection {
				edges {
					node {
						...OwnerToCompanyFragment
					}
				}
			}
			industry {
				id
				key
			}
			companyOfficesCollection {
				edges {
					node {
						id
						address
						zipCode
						roLocations {
							id
							name
							region2
						}
						hq
					}
				}
			}
		}
	}
	${OwnerToCompanyFragmentFragmentDoc}
`
export const TeamConnectionDataFragmentDoc = gql`
	fragment teamConnectionData on TeamConnection {
		edges {
			node {
				...standardTeamResult
			}
			cursor
		}
		pageInfo {
			...pageInfoData
		}
	}
	${StandardTeamResultFragmentDoc}
	${PageInfoDataFragmentDoc}
`
export const UserExperienceFragmentDoc = gql`
	fragment UserExperience on Experience {
		id
		position
		company
		startDate
		roLocations {
			id
			type
			name
			region2
		}
		endDate
		isCurrent
		title
		description
	}
`
export const UserRoleFragmentFragmentDoc = gql`
	fragment UserRoleFragment on _UserToCompanyRole {
		A
		user {
			id
			profileCollection {
				edges {
					node {
						id
						firstName
						lastName
						avatarPath
					}
				}
			}
		}
		B
	}
`
export const HandleArticleDocument = gql`
	mutation handleArticle(
		$articleId: String!
		$userId: String!
		$companyId: String!
		$teamId: String!
		$postAs: String!
		$title: String!
		$description: String!
		$body: String!
		$imageId: String!
		$images: [ImageInsertInput!]!
	) {
		insertIntoImageCollection(objects: $images) {
			affectedCount
			records {
				id
				title
			}
		}
		updateArticleCollection(
			filter: { id: { eq: $articleId }, user: { eq: $userId } }
			set: {
				readDuration: 12
				postingCompany: $companyId
				isFeatured: false
				postingTeam: $teamId
				postAs: $postAs
				title: $title
				isPost: true
				description: $description
				body: $body
				featuredImage: $imageId
			}
		) {
			affectedCount
			records {
				...standardArticleResult
			}
		}
	}
	${StandardArticleResultFragmentDoc}
`
export type HandleArticleMutationFn = Apollo.MutationFunction<
	HandleArticleMutation,
	HandleArticleMutationVariables
>

/**
 * __useHandleArticleMutation__
 *
 * To run a mutation, you first call `useHandleArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleArticleMutation, { data, loading, error }] = useHandleArticleMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      userId: // value for 'userId'
 *      companyId: // value for 'companyId'
 *      teamId: // value for 'teamId'
 *      postAs: // value for 'postAs'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      body: // value for 'body'
 *      imageId: // value for 'imageId'
 *      images: // value for 'images'
 *   },
 * });
 */
export function useHandleArticleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		HandleArticleMutation,
		HandleArticleMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		HandleArticleMutation,
		HandleArticleMutationVariables
	>(HandleArticleDocument, options)
}
export type HandleArticleMutationHookResult = ReturnType<
	typeof useHandleArticleMutation
>
export type HandleArticleMutationResult =
	Apollo.MutationResult<HandleArticleMutation>
export type HandleArticleMutationOptions = Apollo.BaseMutationOptions<
	HandleArticleMutation,
	HandleArticleMutationVariables
>
export const DeleteArticleDocument = gql`
	mutation deleteArticle($id: String!) {
		deleteFromArticleCollection(filter: { id: { eq: $id } }) {
			records {
				...standardArticleResult
			}
		}
	}
	${StandardArticleResultFragmentDoc}
`
export type DeleteArticleMutationFn = Apollo.MutationFunction<
	DeleteArticleMutation,
	DeleteArticleMutationVariables
>

/**
 * __useDeleteArticleMutation__
 *
 * To run a mutation, you first call `useDeleteArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticleMutation, { data, loading, error }] = useDeleteArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteArticleMutation,
		DeleteArticleMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		DeleteArticleMutation,
		DeleteArticleMutationVariables
	>(DeleteArticleDocument, options)
}
export type DeleteArticleMutationHookResult = ReturnType<
	typeof useDeleteArticleMutation
>
export type DeleteArticleMutationResult =
	Apollo.MutationResult<DeleteArticleMutation>
export type DeleteArticleMutationOptions = Apollo.BaseMutationOptions<
	DeleteArticleMutation,
	DeleteArticleMutationVariables
>
export const ArticlesByEntityDocument = gql`
	query articlesByEntity(
		$userId: String
		$companyId: String
		$teamId: String
	) {
		feedArticles(userid: $userId, companyid: $companyId, teamid: $teamId) {
			edges {
				node {
					...articlesByEntityResults
				}
			}
		}
	}
	${ArticlesByEntityResultsFragmentDoc}
`

/**
 * __useArticlesByEntityQuery__
 *
 * To run a query within a React component, call `useArticlesByEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesByEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesByEntityQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      companyId: // value for 'companyId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useArticlesByEntityQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ArticlesByEntityQuery,
		ArticlesByEntityQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		ArticlesByEntityQuery,
		ArticlesByEntityQueryVariables
	>(ArticlesByEntityDocument, options)
}
export function useArticlesByEntityLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ArticlesByEntityQuery,
		ArticlesByEntityQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		ArticlesByEntityQuery,
		ArticlesByEntityQueryVariables
	>(ArticlesByEntityDocument, options)
}
export function useArticlesByEntitySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				ArticlesByEntityQuery,
				ArticlesByEntityQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		ArticlesByEntityQuery,
		ArticlesByEntityQueryVariables
	>(ArticlesByEntityDocument, options)
}
export type ArticlesByEntityQueryHookResult = ReturnType<
	typeof useArticlesByEntityQuery
>
export type ArticlesByEntityLazyQueryHookResult = ReturnType<
	typeof useArticlesByEntityLazyQuery
>
export type ArticlesByEntitySuspenseQueryHookResult = ReturnType<
	typeof useArticlesByEntitySuspenseQuery
>
export type ArticlesByEntityQueryResult = Apollo.QueryResult<
	ArticlesByEntityQuery,
	ArticlesByEntityQueryVariables
>
export const ArticleDocument = gql`
	query article($id: String, $slug: String) {
		feedArticles(filter: { id: { eq: $id }, slug: { ilike: $slug } }) {
			edges {
				node {
					...standardArticleResult
				}
			}
		}
	}
	${StandardArticleResultFragmentDoc}
`

/**
 * __useArticleQuery__
 *
 * To run a query within a React component, call `useArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useArticleQuery(
	baseOptions?: Apollo.QueryHookOptions<ArticleQuery, ArticleQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<ArticleQuery, ArticleQueryVariables>(
		ArticleDocument,
		options,
	)
}
export function useArticleLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ArticleQuery,
		ArticleQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<ArticleQuery, ArticleQueryVariables>(
		ArticleDocument,
		options,
	)
}
export function useArticleSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<ArticleQuery, ArticleQueryVariables>,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<ArticleQuery, ArticleQueryVariables>(
		ArticleDocument,
		options,
	)
}
export type ArticleQueryHookResult = ReturnType<typeof useArticleQuery>
export type ArticleLazyQueryHookResult = ReturnType<typeof useArticleLazyQuery>
export type ArticleSuspenseQueryHookResult = ReturnType<
	typeof useArticleSuspenseQuery
>
export type ArticleQueryResult = Apollo.QueryResult<
	ArticleQuery,
	ArticleQueryVariables
>
export const FeedarticlesDocument = gql`
	query feedArticles(
		$userid: String
		$companyslug: String
		$teamid: String
		$first: Int
		$after: Cursor
	) {
		feedArticles(
			userid: $userid
			companyslug: $companyslug
			teamid: $teamid
			first: $first
			after: $after
			orderBy: [{ updatedAt: DescNullsLast }]
		) {
			...articleConnectionData
		}
	}
	${ArticleConnectionDataFragmentDoc}
`

export function useFeedQuery(
	baseOptions?: Apollo.QueryHookOptions<FeedQuery, FeedQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options)
}

export const FeedDocument = gql`
	query feedCollection($first: Int, $after: Cursor, $companyName: String) {
		feedCollection(
			first: $first
			after: $after
			orderBy: [{ createdAt: DescNullsLast }]
			filter: { company_name: { eq: $companyName } }
		) {
			edges {
				node {
					id
					title
					description
					isFeatured
					isPost
					createdAt
					updatedAt
					featuredImage
					filename
					slug
					type
					body
					total_views_count
					total_comments
					treasure_hunt_participant_count
					user
					article_media
					article_shares
					liked_user_articles
					favorite_user_articles
					company_name
					company_avatar_path
					company_industry
					tags
					post_as
					postAs
				}
				cursor
			}
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
		}
	}
`

export type FeedQueryVariables = Exact<{
	first?: InputMaybe<Scalars['Int']['input']>
	after?: InputMaybe<Scalars['Cursor']['input']>
	companyName?: InputMaybe<Scalars['String']['input']>
}>

export type FeedQuery = {
	__typename?: 'Query'
	feedCollection?: {
		__typename?: 'feedConnection'
		edges: Array<{
			__typename?: 'feedEdge'
			cursor: string
			node: {
				__typename?: 'feed'
				id: string
				post_as?: string | null
				company_name?: string | null
				company_avatar_path?: string | null
				allow_comments?: boolean | null
				allow_comments_until?: any | null
				treasure_hunt_participant_count?: number | null
				title?: string | null
				description?: string | null
				isFeatured?: boolean | null
				isAboutMe?: boolean | null
				isPost?: boolean | null
				postAs?: string | null
				createdAt: any
				updatedAt: any
				featuredImage?: string | null
				slug?: string | null
				type?: string | null
				link?: string | null
				like_type?: string | null
				total_views_count?: number | null
				featuredVideo?: string | null
				readDuration?: number | null
				body?: string | null
				pin_date?: any | null
				userId?: string | null
				filename?: string | null
				user?: string | null
				article_media?: string[] | null
				article_shares?: Array<{
					user_id?: string | null
					created_at?: any | null
					total?: number | null
				}> | null
				liked_user_articles?: Array<{
					user_id?: string | null
					created_at?: any | null
				}> | null
				favorite_user_articles?: Array<{
					user_id?: string | null
					created_at?: any | null
				}> | null
				total_comments?: number | null
				tags?: string[] | null
			}
		}>
		pageInfo: {
			__typename?: 'PageInfo'
			hasNextPage: boolean
			hasPreviousPage: boolean
			startCursor?: string | null
			endCursor?: string | null
		}
	} | null
}

/**
 * __useFeedarticlesQuery__
 *
 * To run a query within a React component, call `useFeedarticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedarticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedarticlesQuery({
 *   variables: {
 *      userid: // value for 'userid'
 *      companyslug: // value for 'companyslug'
 *      teamid: // value for 'teamid'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFeedarticlesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		FeedarticlesQuery,
		FeedarticlesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<FeedarticlesQuery, FeedarticlesQueryVariables>(
		FeedarticlesDocument,
		options,
	)
}
export function useFeedarticlesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		FeedarticlesQuery,
		FeedarticlesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<FeedarticlesQuery, FeedarticlesQueryVariables>(
		FeedarticlesDocument,
		options,
	)
}
export function useFeedarticlesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				FeedarticlesQuery,
				FeedarticlesQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		FeedarticlesQuery,
		FeedarticlesQueryVariables
	>(FeedarticlesDocument, options)
}
export type FeedarticlesQueryHookResult = ReturnType<
	typeof useFeedarticlesQuery
>
export type FeedarticlesLazyQueryHookResult = ReturnType<
	typeof useFeedarticlesLazyQuery
>
export type FeedarticlesSuspenseQueryHookResult = ReturnType<
	typeof useFeedarticlesSuspenseQuery
>
export type FeedarticlesQueryResult = Apollo.QueryResult<
	FeedarticlesQuery,
	FeedarticlesQueryVariables
>
export const FeedTeamArticlesDocument = gql`
	query feedTeamArticles($teamId: String!, $first: Int!, $after: Cursor) {
		feed_team_articles(
			team_id: $teamId
			limit_count: $first
			after: $after
		) {
			...articleConnectionData
		}
	}
	${ArticleConnectionDataFragmentDoc}
`

/**
 * __useFeedTeamArticlesQuery__
 *
 * To run a query within a React component, call `useFeedTeamArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedTeamArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedTeamArticlesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFeedTeamArticlesQuery(
	baseOptions: Apollo.QueryHookOptions<
		FeedTeamArticlesQuery,
		FeedTeamArticlesQueryVariables
	> &
		(
			| { variables: FeedTeamArticlesQueryVariables; skip?: boolean }
			| { skip: boolean }
		),
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		FeedTeamArticlesQuery,
		FeedTeamArticlesQueryVariables
	>(FeedTeamArticlesDocument, options)
}
export function useFeedTeamArticlesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		FeedTeamArticlesQuery,
		FeedTeamArticlesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		FeedTeamArticlesQuery,
		FeedTeamArticlesQueryVariables
	>(FeedTeamArticlesDocument, options)
}
export function useFeedTeamArticlesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				FeedTeamArticlesQuery,
				FeedTeamArticlesQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		FeedTeamArticlesQuery,
		FeedTeamArticlesQueryVariables
	>(FeedTeamArticlesDocument, options)
}
export type FeedTeamArticlesQueryHookResult = ReturnType<
	typeof useFeedTeamArticlesQuery
>
export type FeedTeamArticlesLazyQueryHookResult = ReturnType<
	typeof useFeedTeamArticlesLazyQuery
>
export type FeedTeamArticlesSuspenseQueryHookResult = ReturnType<
	typeof useFeedTeamArticlesSuspenseQuery
>
export type FeedTeamArticlesQueryResult = Apollo.QueryResult<
	FeedTeamArticlesQuery,
	FeedTeamArticlesQueryVariables
>
export const GetArticleTagVotersDocument = gql`
	query getArticleTagVoters($articleId: String!) {
		activeArticleTagCollection(filter: { article: { eq: $articleId } }) {
			edges {
				node {
					articleTag {
						id
						title
					}
					_ActiveArticleTagToUserCollection {
						edges {
							node {
								user {
									id
									uid
									profileCollection {
										edges {
											node {
												id
												firstName
												lastName
												avatarPath
												experienceCollection {
													edges {
														node {
															position
															company
														}
													}
												}
											}
										}
									}
								}
								activeArticleTag {
									votes
									tag
									articleTag {
										id
										title
									}
									article {
										id
										title
										slug
									}
								}
							}
						}
					}
				}
			}
		}
	}
`

/**
 * __useGetArticleTagVotersQuery__
 *
 * To run a query within a React component, call `useGetArticleTagVotersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleTagVotersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleTagVotersQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useGetArticleTagVotersQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetArticleTagVotersQuery,
		GetArticleTagVotersQueryVariables
	> &
		(
			| { variables: GetArticleTagVotersQueryVariables; skip?: boolean }
			| { skip: boolean }
		),
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		GetArticleTagVotersQuery,
		GetArticleTagVotersQueryVariables
	>(GetArticleTagVotersDocument, options)
}
export function useGetArticleTagVotersLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetArticleTagVotersQuery,
		GetArticleTagVotersQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		GetArticleTagVotersQuery,
		GetArticleTagVotersQueryVariables
	>(GetArticleTagVotersDocument, options)
}
export function useGetArticleTagVotersSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetArticleTagVotersQuery,
				GetArticleTagVotersQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		GetArticleTagVotersQuery,
		GetArticleTagVotersQueryVariables
	>(GetArticleTagVotersDocument, options)
}
export type GetArticleTagVotersQueryHookResult = ReturnType<
	typeof useGetArticleTagVotersQuery
>
export type GetArticleTagVotersLazyQueryHookResult = ReturnType<
	typeof useGetArticleTagVotersLazyQuery
>
export type GetArticleTagVotersSuspenseQueryHookResult = ReturnType<
	typeof useGetArticleTagVotersSuspenseQuery
>
export type GetArticleTagVotersQueryResult = Apollo.QueryResult<
	GetArticleTagVotersQuery,
	GetArticleTagVotersQueryVariables
>
export const UserCollectionDocument = gql`
	query userCollection($filter: UserFilter) {
		userCollection(filter: $filter) {
			edges {
				node {
					...AuthenticationUser
				}
			}
		}
	}
	${AuthenticationUserFragmentDoc}
`

/**
 * __useUserCollectionQuery__
 *
 * To run a query within a React component, call `useUserCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCollectionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserCollectionQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UserCollectionQuery,
		UserCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<UserCollectionQuery, UserCollectionQueryVariables>(
		UserCollectionDocument,
		options,
	)
}
export function useUserCollectionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserCollectionQuery,
		UserCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		UserCollectionQuery,
		UserCollectionQueryVariables
	>(UserCollectionDocument, options)
}
export function useUserCollectionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				UserCollectionQuery,
				UserCollectionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		UserCollectionQuery,
		UserCollectionQueryVariables
	>(UserCollectionDocument, options)
}
export type UserCollectionQueryHookResult = ReturnType<
	typeof useUserCollectionQuery
>
export type UserCollectionLazyQueryHookResult = ReturnType<
	typeof useUserCollectionLazyQuery
>
export type UserCollectionSuspenseQueryHookResult = ReturnType<
	typeof useUserCollectionSuspenseQuery
>
export type UserCollectionQueryResult = Apollo.QueryResult<
	UserCollectionQuery,
	UserCollectionQueryVariables
>
export const CheckCredentialsDocument = gql`
	query checkCredentials {
		checkCredentials {
			...AuthenticationUser
		}
	}
	${AuthenticationUserFragmentDoc}
`

/**
 * __useCheckCredentialsQuery__
 *
 * To run a query within a React component, call `useCheckCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCredentialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckCredentialsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CheckCredentialsQuery,
		CheckCredentialsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		CheckCredentialsQuery,
		CheckCredentialsQueryVariables
	>(CheckCredentialsDocument, options)
}
export function useCheckCredentialsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CheckCredentialsQuery,
		CheckCredentialsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		CheckCredentialsQuery,
		CheckCredentialsQueryVariables
	>(CheckCredentialsDocument, options)
}
export function useCheckCredentialsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				CheckCredentialsQuery,
				CheckCredentialsQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		CheckCredentialsQuery,
		CheckCredentialsQueryVariables
	>(CheckCredentialsDocument, options)
}
export type CheckCredentialsQueryHookResult = ReturnType<
	typeof useCheckCredentialsQuery
>
export type CheckCredentialsLazyQueryHookResult = ReturnType<
	typeof useCheckCredentialsLazyQuery
>
export type CheckCredentialsSuspenseQueryHookResult = ReturnType<
	typeof useCheckCredentialsSuspenseQuery
>
export type CheckCredentialsQueryResult = Apollo.QueryResult<
	CheckCredentialsQuery,
	CheckCredentialsQueryVariables
>
export const GetChillPackCompaniesDocument = gql`
	query getChillPackCompanies {
		chillPackCompanyCollection {
			edges {
				node {
					id
					name
				}
			}
		}
	}
`

/**
 * __useGetChillPackCompaniesQuery__
 *
 * To run a query within a React component, call `useGetChillPackCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChillPackCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChillPackCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChillPackCompaniesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetChillPackCompaniesQuery,
		GetChillPackCompaniesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		GetChillPackCompaniesQuery,
		GetChillPackCompaniesQueryVariables
	>(GetChillPackCompaniesDocument, options)
}
export function useGetChillPackCompaniesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetChillPackCompaniesQuery,
		GetChillPackCompaniesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		GetChillPackCompaniesQuery,
		GetChillPackCompaniesQueryVariables
	>(GetChillPackCompaniesDocument, options)
}
export function useGetChillPackCompaniesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetChillPackCompaniesQuery,
				GetChillPackCompaniesQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		GetChillPackCompaniesQuery,
		GetChillPackCompaniesQueryVariables
	>(GetChillPackCompaniesDocument, options)
}
export type GetChillPackCompaniesQueryHookResult = ReturnType<
	typeof useGetChillPackCompaniesQuery
>
export type GetChillPackCompaniesLazyQueryHookResult = ReturnType<
	typeof useGetChillPackCompaniesLazyQuery
>
export type GetChillPackCompaniesSuspenseQueryHookResult = ReturnType<
	typeof useGetChillPackCompaniesSuspenseQuery
>
export type GetChillPackCompaniesQueryResult = Apollo.QueryResult<
	GetChillPackCompaniesQuery,
	GetChillPackCompaniesQueryVariables
>
export const ExportChillPackRecipientsDocument = gql`
	query exportChillPackRecipients {
		export_chill_pack_recipients {
			edges {
				node {
					id
					email
					chillpackrecipientclaim
					createdat
					recipientlastname
					recipientfirstname
					companyname
				}
			}
		}
	}
`

/**
 * __useExportChillPackRecipientsQuery__
 *
 * To run a query within a React component, call `useExportChillPackRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportChillPackRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportChillPackRecipientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportChillPackRecipientsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ExportChillPackRecipientsQuery,
		ExportChillPackRecipientsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		ExportChillPackRecipientsQuery,
		ExportChillPackRecipientsQueryVariables
	>(ExportChillPackRecipientsDocument, options)
}
export function useExportChillPackRecipientsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ExportChillPackRecipientsQuery,
		ExportChillPackRecipientsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		ExportChillPackRecipientsQuery,
		ExportChillPackRecipientsQueryVariables
	>(ExportChillPackRecipientsDocument, options)
}
export function useExportChillPackRecipientsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				ExportChillPackRecipientsQuery,
				ExportChillPackRecipientsQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		ExportChillPackRecipientsQuery,
		ExportChillPackRecipientsQueryVariables
	>(ExportChillPackRecipientsDocument, options)
}
export type ExportChillPackRecipientsQueryHookResult = ReturnType<
	typeof useExportChillPackRecipientsQuery
>
export type ExportChillPackRecipientsLazyQueryHookResult = ReturnType<
	typeof useExportChillPackRecipientsLazyQuery
>
export type ExportChillPackRecipientsSuspenseQueryHookResult = ReturnType<
	typeof useExportChillPackRecipientsSuspenseQuery
>
export type ExportChillPackRecipientsQueryResult = Apollo.QueryResult<
	ExportChillPackRecipientsQuery,
	ExportChillPackRecipientsQueryVariables
>
export const AddChillPackRecipientDocument = gql`
	mutation addChillPackRecipient($data: [ChillPackRecipientInsertInput!]!) {
		insertIntoChillPackRecipientCollection(objects: $data) {
			records {
				firstName
				lastName
				email
				chillPackCompany {
					id
					name
				}
			}
		}
	}
`
export type AddChillPackRecipientMutationFn = Apollo.MutationFunction<
	AddChillPackRecipientMutation,
	AddChillPackRecipientMutationVariables
>

/**
 * __useAddChillPackRecipientMutation__
 *
 * To run a mutation, you first call `useAddChillPackRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChillPackRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChillPackRecipientMutation, { data, loading, error }] = useAddChillPackRecipientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddChillPackRecipientMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddChillPackRecipientMutation,
		AddChillPackRecipientMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		AddChillPackRecipientMutation,
		AddChillPackRecipientMutationVariables
	>(AddChillPackRecipientDocument, options)
}
export type AddChillPackRecipientMutationHookResult = ReturnType<
	typeof useAddChillPackRecipientMutation
>
export type AddChillPackRecipientMutationResult =
	Apollo.MutationResult<AddChillPackRecipientMutation>
export type AddChillPackRecipientMutationOptions = Apollo.BaseMutationOptions<
	AddChillPackRecipientMutation,
	AddChillPackRecipientMutationVariables
>
export const IndustryCollectionDocument = gql`
	query industryCollection {
		industryCollection {
			edges {
				node {
					id
					key
				}
			}
		}
	}
`

/**
 * __useIndustryCollectionQuery__
 *
 * To run a query within a React component, call `useIndustryCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndustryCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndustryCollectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useIndustryCollectionQuery(
	baseOptions?: Apollo.QueryHookOptions<
		IndustryCollectionQuery,
		IndustryCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		IndustryCollectionQuery,
		IndustryCollectionQueryVariables
	>(IndustryCollectionDocument, options)
}
export function useIndustryCollectionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		IndustryCollectionQuery,
		IndustryCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		IndustryCollectionQuery,
		IndustryCollectionQueryVariables
	>(IndustryCollectionDocument, options)
}
export function useIndustryCollectionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				IndustryCollectionQuery,
				IndustryCollectionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		IndustryCollectionQuery,
		IndustryCollectionQueryVariables
	>(IndustryCollectionDocument, options)
}
export type IndustryCollectionQueryHookResult = ReturnType<
	typeof useIndustryCollectionQuery
>
export type IndustryCollectionLazyQueryHookResult = ReturnType<
	typeof useIndustryCollectionLazyQuery
>
export type IndustryCollectionSuspenseQueryHookResult = ReturnType<
	typeof useIndustryCollectionSuspenseQuery
>
export type IndustryCollectionQueryResult = Apollo.QueryResult<
	IndustryCollectionQuery,
	IndustryCollectionQueryVariables
>
export const CompanyTypeCollectionDocument = gql`
	query companyTypeCollection {
		companyTypeCollection {
			edges {
				node {
					id
					title
				}
			}
		}
	}
`

/**
 * __useCompanyTypeCollectionQuery__
 *
 * To run a query within a React component, call `useCompanyTypeCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyTypeCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyTypeCollectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyTypeCollectionQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CompanyTypeCollectionQuery,
		CompanyTypeCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		CompanyTypeCollectionQuery,
		CompanyTypeCollectionQueryVariables
	>(CompanyTypeCollectionDocument, options)
}
export function useCompanyTypeCollectionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CompanyTypeCollectionQuery,
		CompanyTypeCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		CompanyTypeCollectionQuery,
		CompanyTypeCollectionQueryVariables
	>(CompanyTypeCollectionDocument, options)
}
export function useCompanyTypeCollectionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				CompanyTypeCollectionQuery,
				CompanyTypeCollectionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		CompanyTypeCollectionQuery,
		CompanyTypeCollectionQueryVariables
	>(CompanyTypeCollectionDocument, options)
}
export type CompanyTypeCollectionQueryHookResult = ReturnType<
	typeof useCompanyTypeCollectionQuery
>
export type CompanyTypeCollectionLazyQueryHookResult = ReturnType<
	typeof useCompanyTypeCollectionLazyQuery
>
export type CompanyTypeCollectionSuspenseQueryHookResult = ReturnType<
	typeof useCompanyTypeCollectionSuspenseQuery
>
export type CompanyTypeCollectionQueryResult = Apollo.QueryResult<
	CompanyTypeCollectionQuery,
	CompanyTypeCollectionQueryVariables
>
export const CompaniesDocument = gql`
	query companies($filter: CompanyFilter) {
		companyCollection(filter: $filter) {
			edges {
				node {
					id
					name
					slug
				}
			}
		}
	}
`

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCompaniesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CompaniesQuery,
		CompaniesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<CompaniesQuery, CompaniesQueryVariables>(
		CompaniesDocument,
		options,
	)
}
export function useCompaniesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CompaniesQuery,
		CompaniesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(
		CompaniesDocument,
		options,
	)
}
export function useCompaniesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				CompaniesQuery,
				CompaniesQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<CompaniesQuery, CompaniesQueryVariables>(
		CompaniesDocument,
		options,
	)
}
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>
export type CompaniesLazyQueryHookResult = ReturnType<
	typeof useCompaniesLazyQuery
>
export type CompaniesSuspenseQueryHookResult = ReturnType<
	typeof useCompaniesSuspenseQuery
>
export type CompaniesQueryResult = Apollo.QueryResult<
	CompaniesQuery,
	CompaniesQueryVariables
>
export const CompanyDocument = gql`
	query company($id: String, $name: String, $slug: String) {
		companyCollection(
			filter: {
				id: { eq: $id }
				name: { ilike: $name }
				slug: { ilike: $slug }
			}
		) {
			edges {
				node {
					...standardCompanyResult
				}
			}
		}
	}
	${StandardCompanyResultFragmentDoc}
`

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCompanyQuery(
	baseOptions?: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(
		CompanyDocument,
		options,
	)
}
export function useCompanyLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CompanyQuery,
		CompanyQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(
		CompanyDocument,
		options,
	)
}
export function useCompanySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<CompanyQuery, CompanyQueryVariables>,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<CompanyQuery, CompanyQueryVariables>(
		CompanyDocument,
		options,
	)
}
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>
export type CompanySuspenseQueryHookResult = ReturnType<
	typeof useCompanySuspenseQuery
>
export type CompanyQueryResult = Apollo.QueryResult<
	CompanyQuery,
	CompanyQueryVariables
>
export const CompanyOfficeDocument = gql`
	query companyOffice($id: String) {
		companyOfficesCollection(filter: { id: { eq: $id } }) {
			edges {
				node {
					...companyOfficesResult
				}
			}
		}
	}
	${CompanyOfficesResultFragmentDoc}
`

/**
 * __useCompanyOfficeQuery__
 *
 * To run a query within a React component, call `useCompanyOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyOfficeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyOfficeQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CompanyOfficeQuery,
		CompanyOfficeQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<CompanyOfficeQuery, CompanyOfficeQueryVariables>(
		CompanyOfficeDocument,
		options,
	)
}
export function useCompanyOfficeLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CompanyOfficeQuery,
		CompanyOfficeQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<CompanyOfficeQuery, CompanyOfficeQueryVariables>(
		CompanyOfficeDocument,
		options,
	)
}
export function useCompanyOfficeSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				CompanyOfficeQuery,
				CompanyOfficeQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		CompanyOfficeQuery,
		CompanyOfficeQueryVariables
	>(CompanyOfficeDocument, options)
}
export type CompanyOfficeQueryHookResult = ReturnType<
	typeof useCompanyOfficeQuery
>
export type CompanyOfficeLazyQueryHookResult = ReturnType<
	typeof useCompanyOfficeLazyQuery
>
export type CompanyOfficeSuspenseQueryHookResult = ReturnType<
	typeof useCompanyOfficeSuspenseQuery
>
export type CompanyOfficeQueryResult = Apollo.QueryResult<
	CompanyOfficeQuery,
	CompanyOfficeQueryVariables
>
export const CompanyOfficesDocument = gql`
	query companyOffices($companySlug: String, $companyId: String) {
		companyOfficesCollection(filter: { companyId: { like: $companyId } }) {
			edges {
				node {
					...companyOfficesResult
				}
			}
		}
	}
	${CompanyOfficesResultFragmentDoc}
`

/**
 * __useCompanyOfficesQuery__
 *
 * To run a query within a React component, call `useCompanyOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyOfficesQuery({
 *   variables: {
 *      companySlug: // value for 'companySlug'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyOfficesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CompanyOfficesQuery,
		CompanyOfficesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<CompanyOfficesQuery, CompanyOfficesQueryVariables>(
		CompanyOfficesDocument,
		options,
	)
}
export function useCompanyOfficesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CompanyOfficesQuery,
		CompanyOfficesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		CompanyOfficesQuery,
		CompanyOfficesQueryVariables
	>(CompanyOfficesDocument, options)
}
export function useCompanyOfficesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				CompanyOfficesQuery,
				CompanyOfficesQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		CompanyOfficesQuery,
		CompanyOfficesQueryVariables
	>(CompanyOfficesDocument, options)
}
export type CompanyOfficesQueryHookResult = ReturnType<
	typeof useCompanyOfficesQuery
>
export type CompanyOfficesLazyQueryHookResult = ReturnType<
	typeof useCompanyOfficesLazyQuery
>
export type CompanyOfficesSuspenseQueryHookResult = ReturnType<
	typeof useCompanyOfficesSuspenseQuery
>
export type CompanyOfficesQueryResult = Apollo.QueryResult<
	CompanyOfficesQuery,
	CompanyOfficesQueryVariables
>
export const FeedcompaniesDocument = gql`
	query feedcompanies(
		$name: String
		$sizes: [String]
		$industryids: [String]
		$locationsids: [String]
		$after: Cursor
		$first: Int
	) {
		feedcompanies(
			name: $name
			sizes: $sizes
			industryids: $industryids
			locationids: $locationsids
			after: $after
			first: $first
		) {
			edges {
				node {
					...Node
				}
				cursor
			}
			pageInfo {
				...pageInfoData
			}
		}
	}
	${NodeFragmentDoc}
	${PageInfoDataFragmentDoc}
`

/**
 * __useFeedcompaniesQuery__
 *
 * To run a query within a React component, call `useFeedcompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedcompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedcompaniesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      sizes: // value for 'sizes'
 *      industryids: // value for 'industryids'
 *      locationsids: // value for 'locationsids'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFeedcompaniesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		FeedcompaniesQuery,
		FeedcompaniesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<FeedcompaniesQuery, FeedcompaniesQueryVariables>(
		FeedcompaniesDocument,
		options,
	)
}
export function useFeedcompaniesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		FeedcompaniesQuery,
		FeedcompaniesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<FeedcompaniesQuery, FeedcompaniesQueryVariables>(
		FeedcompaniesDocument,
		options,
	)
}
export function useFeedcompaniesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				FeedcompaniesQuery,
				FeedcompaniesQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		FeedcompaniesQuery,
		FeedcompaniesQueryVariables
	>(FeedcompaniesDocument, options)
}
export type FeedcompaniesQueryHookResult = ReturnType<
	typeof useFeedcompaniesQuery
>
export type FeedcompaniesLazyQueryHookResult = ReturnType<
	typeof useFeedcompaniesLazyQuery
>
export type FeedcompaniesSuspenseQueryHookResult = ReturnType<
	typeof useFeedcompaniesSuspenseQuery
>
export type FeedcompaniesQueryResult = Apollo.QueryResult<
	FeedcompaniesQuery,
	FeedcompaniesQueryVariables
>
export const InsertIntoCompanyCollectionDocument = gql`
	mutation insertIntoCompanyCollection($details: [CompanyInsertInput!]!) {
		insertIntoCompanyCollection(objects: $details) {
			records {
				...standardCompanyResult
			}
		}
	}
	${StandardCompanyResultFragmentDoc}
`
export type InsertIntoCompanyCollectionMutationFn = Apollo.MutationFunction<
	InsertIntoCompanyCollectionMutation,
	InsertIntoCompanyCollectionMutationVariables
>

/**
 * __useInsertIntoCompanyCollectionMutation__
 *
 * To run a mutation, you first call `useInsertIntoCompanyCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertIntoCompanyCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertIntoCompanyCollectionMutation, { data, loading, error }] = useInsertIntoCompanyCollectionMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useInsertIntoCompanyCollectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InsertIntoCompanyCollectionMutation,
		InsertIntoCompanyCollectionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		InsertIntoCompanyCollectionMutation,
		InsertIntoCompanyCollectionMutationVariables
	>(InsertIntoCompanyCollectionDocument, options)
}
export type InsertIntoCompanyCollectionMutationHookResult = ReturnType<
	typeof useInsertIntoCompanyCollectionMutation
>
export type InsertIntoCompanyCollectionMutationResult =
	Apollo.MutationResult<InsertIntoCompanyCollectionMutation>
export type InsertIntoCompanyCollectionMutationOptions =
	Apollo.BaseMutationOptions<
		InsertIntoCompanyCollectionMutation,
		InsertIntoCompanyCollectionMutationVariables
	>
export const UpdateCompanyCollectionDocument = gql`
	mutation updateCompanyCollection($details: CompanyUpdateInput!) {
		updateCompanyCollection(set: $details) {
			records {
				...standardCompanyResult
			}
		}
	}
	${StandardCompanyResultFragmentDoc}
`
export type UpdateCompanyCollectionMutationFn = Apollo.MutationFunction<
	UpdateCompanyCollectionMutation,
	UpdateCompanyCollectionMutationVariables
>

/**
 * __useUpdateCompanyCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyCollectionMutation, { data, loading, error }] = useUpdateCompanyCollectionMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useUpdateCompanyCollectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateCompanyCollectionMutation,
		UpdateCompanyCollectionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		UpdateCompanyCollectionMutation,
		UpdateCompanyCollectionMutationVariables
	>(UpdateCompanyCollectionDocument, options)
}
export type UpdateCompanyCollectionMutationHookResult = ReturnType<
	typeof useUpdateCompanyCollectionMutation
>
export type UpdateCompanyCollectionMutationResult =
	Apollo.MutationResult<UpdateCompanyCollectionMutation>
export type UpdateCompanyCollectionMutationOptions = Apollo.BaseMutationOptions<
	UpdateCompanyCollectionMutation,
	UpdateCompanyCollectionMutationVariables
>
export const InsertIntoArticleCollectionDocument = gql`
	mutation insertIntoArticleCollection($story: [ArticleInsertInput!]!) {
		insertIntoArticleCollection(objects: $story) {
			records {
				...standardArticleResult
			}
		}
	}
	${StandardArticleResultFragmentDoc}
`
export type InsertIntoArticleCollectionMutationFn = Apollo.MutationFunction<
	InsertIntoArticleCollectionMutation,
	InsertIntoArticleCollectionMutationVariables
>

/**
 * __useInsertIntoArticleCollectionMutation__
 *
 * To run a mutation, you first call `useInsertIntoArticleCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertIntoArticleCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertIntoArticleCollectionMutation, { data, loading, error }] = useInsertIntoArticleCollectionMutation({
 *   variables: {
 *      story: // value for 'story'
 *   },
 * });
 */
export function useInsertIntoArticleCollectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InsertIntoArticleCollectionMutation,
		InsertIntoArticleCollectionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		InsertIntoArticleCollectionMutation,
		InsertIntoArticleCollectionMutationVariables
	>(InsertIntoArticleCollectionDocument, options)
}
export type InsertIntoArticleCollectionMutationHookResult = ReturnType<
	typeof useInsertIntoArticleCollectionMutation
>
export type InsertIntoArticleCollectionMutationResult =
	Apollo.MutationResult<InsertIntoArticleCollectionMutation>
export type InsertIntoArticleCollectionMutationOptions =
	Apollo.BaseMutationOptions<
		InsertIntoArticleCollectionMutation,
		InsertIntoArticleCollectionMutationVariables
	>
export const DeleteFromArticleCollectionDocument = gql`
	mutation deleteFromArticleCollection($storyId: String!) {
		deleteFromArticleCollection(filter: { id: { eq: $storyId } }) {
			records {
				...standardArticleResult
			}
		}
	}
	${StandardArticleResultFragmentDoc}
`
export type DeleteFromArticleCollectionMutationFn = Apollo.MutationFunction<
	DeleteFromArticleCollectionMutation,
	DeleteFromArticleCollectionMutationVariables
>

/**
 * __useDeleteFromArticleCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteFromArticleCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFromArticleCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFromArticleCollectionMutation, { data, loading, error }] = useDeleteFromArticleCollectionMutation({
 *   variables: {
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useDeleteFromArticleCollectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteFromArticleCollectionMutation,
		DeleteFromArticleCollectionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		DeleteFromArticleCollectionMutation,
		DeleteFromArticleCollectionMutationVariables
	>(DeleteFromArticleCollectionDocument, options)
}
export type DeleteFromArticleCollectionMutationHookResult = ReturnType<
	typeof useDeleteFromArticleCollectionMutation
>
export type DeleteFromArticleCollectionMutationResult =
	Apollo.MutationResult<DeleteFromArticleCollectionMutation>
export type DeleteFromArticleCollectionMutationOptions =
	Apollo.BaseMutationOptions<
		DeleteFromArticleCollectionMutation,
		DeleteFromArticleCollectionMutationVariables
	>
export const InsertIntoCompanyOfficesCollectionDocument = gql`
	mutation insertIntoCompanyOfficesCollection(
		$data: [CompanyOfficesInsertInput!]!
	) {
		insertIntoCompanyOfficesCollection(objects: $data) {
			records {
				...companyOfficesResult
			}
		}
	}
	${CompanyOfficesResultFragmentDoc}
`
export type InsertIntoCompanyOfficesCollectionMutationFn =
	Apollo.MutationFunction<
		InsertIntoCompanyOfficesCollectionMutation,
		InsertIntoCompanyOfficesCollectionMutationVariables
	>

/**
 * __useInsertIntoCompanyOfficesCollectionMutation__
 *
 * To run a mutation, you first call `useInsertIntoCompanyOfficesCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertIntoCompanyOfficesCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertIntoCompanyOfficesCollectionMutation, { data, loading, error }] = useInsertIntoCompanyOfficesCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInsertIntoCompanyOfficesCollectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InsertIntoCompanyOfficesCollectionMutation,
		InsertIntoCompanyOfficesCollectionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		InsertIntoCompanyOfficesCollectionMutation,
		InsertIntoCompanyOfficesCollectionMutationVariables
	>(InsertIntoCompanyOfficesCollectionDocument, options)
}
export type InsertIntoCompanyOfficesCollectionMutationHookResult = ReturnType<
	typeof useInsertIntoCompanyOfficesCollectionMutation
>
export type InsertIntoCompanyOfficesCollectionMutationResult =
	Apollo.MutationResult<InsertIntoCompanyOfficesCollectionMutation>
export type InsertIntoCompanyOfficesCollectionMutationOptions =
	Apollo.BaseMutationOptions<
		InsertIntoCompanyOfficesCollectionMutation,
		InsertIntoCompanyOfficesCollectionMutationVariables
	>
export const HandleCompanyOfficesDocument = gql`
	mutation handleCompanyOffices($data: CompanyOfficesUpdateInput!) {
		updateCompanyOfficesCollection(set: $data) {
			records {
				...companyOfficesResult
			}
		}
	}
	${CompanyOfficesResultFragmentDoc}
`
export type HandleCompanyOfficesMutationFn = Apollo.MutationFunction<
	HandleCompanyOfficesMutation,
	HandleCompanyOfficesMutationVariables
>

/**
 * __useHandleCompanyOfficesMutation__
 *
 * To run a mutation, you first call `useHandleCompanyOfficesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleCompanyOfficesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleCompanyOfficesMutation, { data, loading, error }] = useHandleCompanyOfficesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useHandleCompanyOfficesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		HandleCompanyOfficesMutation,
		HandleCompanyOfficesMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		HandleCompanyOfficesMutation,
		HandleCompanyOfficesMutationVariables
	>(HandleCompanyOfficesDocument, options)
}
export type HandleCompanyOfficesMutationHookResult = ReturnType<
	typeof useHandleCompanyOfficesMutation
>
export type HandleCompanyOfficesMutationResult =
	Apollo.MutationResult<HandleCompanyOfficesMutation>
export type HandleCompanyOfficesMutationOptions = Apollo.BaseMutationOptions<
	HandleCompanyOfficesMutation,
	HandleCompanyOfficesMutationVariables
>
export const DeleteFromCompanyOfficesCollectionDocument = gql`
	mutation deleteFromCompanyOfficesCollection($id: String) {
		deleteFromCompanyOfficesCollection(filter: { id: { eq: $id } }) {
			records {
				...companyOfficesResult
			}
		}
	}
	${CompanyOfficesResultFragmentDoc}
`
export type DeleteFromCompanyOfficesCollectionMutationFn =
	Apollo.MutationFunction<
		DeleteFromCompanyOfficesCollectionMutation,
		DeleteFromCompanyOfficesCollectionMutationVariables
	>

/**
 * __useDeleteFromCompanyOfficesCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteFromCompanyOfficesCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFromCompanyOfficesCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFromCompanyOfficesCollectionMutation, { data, loading, error }] = useDeleteFromCompanyOfficesCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFromCompanyOfficesCollectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteFromCompanyOfficesCollectionMutation,
		DeleteFromCompanyOfficesCollectionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		DeleteFromCompanyOfficesCollectionMutation,
		DeleteFromCompanyOfficesCollectionMutationVariables
	>(DeleteFromCompanyOfficesCollectionDocument, options)
}
export type DeleteFromCompanyOfficesCollectionMutationHookResult = ReturnType<
	typeof useDeleteFromCompanyOfficesCollectionMutation
>
export type DeleteFromCompanyOfficesCollectionMutationResult =
	Apollo.MutationResult<DeleteFromCompanyOfficesCollectionMutation>
export type DeleteFromCompanyOfficesCollectionMutationOptions =
	Apollo.BaseMutationOptions<
		DeleteFromCompanyOfficesCollectionMutation,
		DeleteFromCompanyOfficesCollectionMutationVariables
	>
export const ChangeCompanyHqDocument = gql`
	mutation changeCompanyHq($companyId: String!, $officeId: String!) {
		resetHq: updateCompanyOfficesCollection(
			filter: { companyId: { eq: $companyId } }
			set: { hq: false }
		) {
			records {
				...companyOfficesResult
			}
		}
		setNewHq: updateCompanyOfficesCollection(
			filter: { id: { eq: $officeId } }
			set: { hq: true }
		) {
			records {
				...companyOfficesResult
			}
		}
	}
	${CompanyOfficesResultFragmentDoc}
`
export type ChangeCompanyHqMutationFn = Apollo.MutationFunction<
	ChangeCompanyHqMutation,
	ChangeCompanyHqMutationVariables
>

/**
 * __useChangeCompanyHqMutation__
 *
 * To run a mutation, you first call `useChangeCompanyHqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCompanyHqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCompanyHqMutation, { data, loading, error }] = useChangeCompanyHqMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      officeId: // value for 'officeId'
 *   },
 * });
 */
export function useChangeCompanyHqMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ChangeCompanyHqMutation,
		ChangeCompanyHqMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		ChangeCompanyHqMutation,
		ChangeCompanyHqMutationVariables
	>(ChangeCompanyHqDocument, options)
}
export type ChangeCompanyHqMutationHookResult = ReturnType<
	typeof useChangeCompanyHqMutation
>
export type ChangeCompanyHqMutationResult =
	Apollo.MutationResult<ChangeCompanyHqMutation>
export type ChangeCompanyHqMutationOptions = Apollo.BaseMutationOptions<
	ChangeCompanyHqMutation,
	ChangeCompanyHqMutationVariables
>
export const DeleteCompanyMutationDocument = gql`
	mutation deleteCompanyMutation($id: String, $checkText: String!) {
		deleteFromCompanyCollection(filter: { id: { eq: $id } }) {
			records {
				...standardCompanyResult
			}
		}
	}
	${StandardCompanyResultFragmentDoc}
`
export type DeleteCompanyMutationMutationFn = Apollo.MutationFunction<
	DeleteCompanyMutationMutation,
	DeleteCompanyMutationMutationVariables
>

/**
 * __useDeleteCompanyMutationMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMutationMutation, { data, loading, error }] = useDeleteCompanyMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      checkText: // value for 'checkText'
 *   },
 * });
 */
export function useDeleteCompanyMutationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteCompanyMutationMutation,
		DeleteCompanyMutationMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		DeleteCompanyMutationMutation,
		DeleteCompanyMutationMutationVariables
	>(DeleteCompanyMutationDocument, options)
}
export type DeleteCompanyMutationMutationHookResult = ReturnType<
	typeof useDeleteCompanyMutationMutation
>
export type DeleteCompanyMutationMutationResult =
	Apollo.MutationResult<DeleteCompanyMutationMutation>
export type DeleteCompanyMutationMutationOptions = Apollo.BaseMutationOptions<
	DeleteCompanyMutationMutation,
	DeleteCompanyMutationMutationVariables
>
export const JobQueryDocument = gql`
	query jobQuery($filter: JobFilter) {
		jobCollection(filter: $filter) {
			edges {
				node {
					...standardJobResult
				}
			}
		}
	}
	${StandardJobResultFragmentDoc}
`

/**
 * __useJobQueryQuery__
 *
 * To run a query within a React component, call `useJobQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobQueryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useJobQueryQuery(
	baseOptions?: Apollo.QueryHookOptions<
		JobQueryQuery,
		JobQueryQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<JobQueryQuery, JobQueryQueryVariables>(
		JobQueryDocument,
		options,
	)
}
export function useJobQueryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		JobQueryQuery,
		JobQueryQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<JobQueryQuery, JobQueryQueryVariables>(
		JobQueryDocument,
		options,
	)
}
export function useJobQuerySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				JobQueryQuery,
				JobQueryQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<JobQueryQuery, JobQueryQueryVariables>(
		JobQueryDocument,
		options,
	)
}
export type JobQueryQueryHookResult = ReturnType<typeof useJobQueryQuery>
export type JobQueryLazyQueryHookResult = ReturnType<
	typeof useJobQueryLazyQuery
>
export type JobQuerySuspenseQueryHookResult = ReturnType<
	typeof useJobQuerySuspenseQuery
>
export type JobQueryQueryResult = Apollo.QueryResult<
	JobQueryQuery,
	JobQueryQueryVariables
>
export const FeedJobsDocument = gql`
	query feedJobs(
		$name: String
		$companyname: String
		$companyslug: String
		$teamname: String
		$locationsids: [String]
		$departmentids: [String]
		$sizes: [String]
		$salarymin: String
		$salarymax: String
		$typeofjob: [String]
		$senioritylevels: [String]
		$currency: String
		$contracttypes: [String]
		$locationtypes: [String]
		$skills: [String]
		$first: Int
		$last: Int
		$before: Cursor
		$after: Cursor
		$offset: Int
		$filter: JobFilter
		$orderBy: [JobOrderBy!]
	) {
		feedjobs(
			name: $name
			companyname: $companyname
			companyslug: $companyslug
			teamname: $teamname
			locationsids: $locationsids
			departmentids: $departmentids
			sizes: $sizes
			salarymin: $salarymin
			salarymax: $salarymax
			typeofjob: $typeofjob
			senioritylevels: $senioritylevels
			currency: $currency
			contracttypes: $contracttypes
			locationtypes: $locationtypes
			skills: $skills
			first: $first
			last: $last
			before: $before
			after: $after
			offset: $offset
			filter: $filter
			orderBy: $orderBy
		) {
			edges {
				node {
					...jobConnectionData
				}
				cursor
			}
			pageInfo {
				...pageInfoData
			}
		}
	}
	${JobConnectionDataFragmentDoc}
	${PageInfoDataFragmentDoc}
`

/**
 * __useFeedJobsQuery__
 *
 * To run a query within a React component, call `useFeedJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedJobsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      companyname: // value for 'companyname'
 *      companyslug: // value for 'companyslug'
 *      teamname: // value for 'teamname'
 *      locationsids: // value for 'locationsids'
 *      departmentids: // value for 'departmentids'
 *      sizes: // value for 'sizes'
 *      salarymin: // value for 'salarymin'
 *      salarymax: // value for 'salarymax'
 *      typeofjob: // value for 'typeofjob'
 *      senioritylevels: // value for 'senioritylevels'
 *      currency: // value for 'currency'
 *      contracttypes: // value for 'contracttypes'
 *      locationtypes: // value for 'locationtypes'
 *      skills: // value for 'skills'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFeedJobsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		FeedJobsQuery,
		FeedJobsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<FeedJobsQuery, FeedJobsQueryVariables>(
		FeedJobsDocument,
		options,
	)
}
export function useFeedJobsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		FeedJobsQuery,
		FeedJobsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<FeedJobsQuery, FeedJobsQueryVariables>(
		FeedJobsDocument,
		options,
	)
}
export function useFeedJobsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				FeedJobsQuery,
				FeedJobsQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<FeedJobsQuery, FeedJobsQueryVariables>(
		FeedJobsDocument,
		options,
	)
}
export type FeedJobsQueryHookResult = ReturnType<typeof useFeedJobsQuery>
export type FeedJobsLazyQueryHookResult = ReturnType<
	typeof useFeedJobsLazyQuery
>
export type FeedJobsSuspenseQueryHookResult = ReturnType<
	typeof useFeedJobsSuspenseQuery
>
export type FeedJobsQueryResult = Apollo.QueryResult<
	FeedJobsQuery,
	FeedJobsQueryVariables
>
export const FeedJobApplicantsDocument = gql`
	query feedJobApplicants(
		$jobId: String
		$applicantName: String
		$applicationDateStart: String
		$applicationDateEnd: String
		$first: Int
		$last: Int
		$before: Cursor
		$after: Cursor
		$offset: Int
	) {
		feedJobApplicants(
			jobId: $jobId
			applicantName: $applicantName
			applicationDateStart: $applicationDateStart
			applicationDateEnd: $applicationDateEnd
			first: $first
			last: $last
			before: $before
			after: $after
			offset: $offset
		) {
			...jobApplicantsConnectionData
		}
	}
	${JobApplicantsConnectionDataFragmentDoc}
`

/**
 * __useFeedJobApplicantsQuery__
 *
 * To run a query within a React component, call `useFeedJobApplicantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedJobApplicantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedJobApplicantsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      applicantName: // value for 'applicantName'
 *      applicationDateStart: // value for 'applicationDateStart'
 *      applicationDateEnd: // value for 'applicationDateEnd'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFeedJobApplicantsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		FeedJobApplicantsQuery,
		FeedJobApplicantsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		FeedJobApplicantsQuery,
		FeedJobApplicantsQueryVariables
	>(FeedJobApplicantsDocument, options)
}
export function useFeedJobApplicantsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		FeedJobApplicantsQuery,
		FeedJobApplicantsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		FeedJobApplicantsQuery,
		FeedJobApplicantsQueryVariables
	>(FeedJobApplicantsDocument, options)
}
export function useFeedJobApplicantsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				FeedJobApplicantsQuery,
				FeedJobApplicantsQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		FeedJobApplicantsQuery,
		FeedJobApplicantsQueryVariables
	>(FeedJobApplicantsDocument, options)
}
export type FeedJobApplicantsQueryHookResult = ReturnType<
	typeof useFeedJobApplicantsQuery
>
export type FeedJobApplicantsLazyQueryHookResult = ReturnType<
	typeof useFeedJobApplicantsLazyQuery
>
export type FeedJobApplicantsSuspenseQueryHookResult = ReturnType<
	typeof useFeedJobApplicantsSuspenseQuery
>
export type FeedJobApplicantsQueryResult = Apollo.QueryResult<
	FeedJobApplicantsQuery,
	FeedJobApplicantsQueryVariables
>
export const ApplyJobDocument = gql`
	mutation applyJob($id: String!) {
		insertIntoJobApplicantCollection(objects: { id: $id }) {
			affectedCount
			records {
				id
				nodeId
			}
		}
	}
`
export type ApplyJobMutationFn = Apollo.MutationFunction<
	ApplyJobMutation,
	ApplyJobMutationVariables
>

/**
 * __useApplyJobMutation__
 *
 * To run a mutation, you first call `useApplyJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyJobMutation, { data, loading, error }] = useApplyJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplyJobMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApplyJobMutation,
		ApplyJobMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<ApplyJobMutation, ApplyJobMutationVariables>(
		ApplyJobDocument,
		options,
	)
}
export type ApplyJobMutationHookResult = ReturnType<typeof useApplyJobMutation>
export type ApplyJobMutationResult = Apollo.MutationResult<ApplyJobMutation>
export type ApplyJobMutationOptions = Apollo.BaseMutationOptions<
	ApplyJobMutation,
	ApplyJobMutationVariables
>
export const InsertIntoJobCollectionDocument = gql`
	mutation insertIntoJobCollection($data: [JobInsertInput!]!) {
		insertIntoJobCollection(objects: $data) {
			records {
				...standardJobResult
			}
		}
	}
	${StandardJobResultFragmentDoc}
`
export type InsertIntoJobCollectionMutationFn = Apollo.MutationFunction<
	InsertIntoJobCollectionMutation,
	InsertIntoJobCollectionMutationVariables
>

/**
 * __useInsertIntoJobCollectionMutation__
 *
 * To run a mutation, you first call `useInsertIntoJobCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertIntoJobCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertIntoJobCollectionMutation, { data, loading, error }] = useInsertIntoJobCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInsertIntoJobCollectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InsertIntoJobCollectionMutation,
		InsertIntoJobCollectionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		InsertIntoJobCollectionMutation,
		InsertIntoJobCollectionMutationVariables
	>(InsertIntoJobCollectionDocument, options)
}
export type InsertIntoJobCollectionMutationHookResult = ReturnType<
	typeof useInsertIntoJobCollectionMutation
>
export type InsertIntoJobCollectionMutationResult =
	Apollo.MutationResult<InsertIntoJobCollectionMutation>
export type InsertIntoJobCollectionMutationOptions = Apollo.BaseMutationOptions<
	InsertIntoJobCollectionMutation,
	InsertIntoJobCollectionMutationVariables
>
export const UpdateJobCollectionDocument = gql`
	mutation updateJobCollection($data: JobUpdateInput!) {
		updateJobCollection(set: $data) {
			records {
				...standardJobResult
			}
		}
	}
	${StandardJobResultFragmentDoc}
`
export type UpdateJobCollectionMutationFn = Apollo.MutationFunction<
	UpdateJobCollectionMutation,
	UpdateJobCollectionMutationVariables
>

/**
 * __useUpdateJobCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateJobCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobCollectionMutation, { data, loading, error }] = useUpdateJobCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateJobCollectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateJobCollectionMutation,
		UpdateJobCollectionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		UpdateJobCollectionMutation,
		UpdateJobCollectionMutationVariables
	>(UpdateJobCollectionDocument, options)
}
export type UpdateJobCollectionMutationHookResult = ReturnType<
	typeof useUpdateJobCollectionMutation
>
export type UpdateJobCollectionMutationResult =
	Apollo.MutationResult<UpdateJobCollectionMutation>
export type UpdateJobCollectionMutationOptions = Apollo.BaseMutationOptions<
	UpdateJobCollectionMutation,
	UpdateJobCollectionMutationVariables
>
export const DeleteJobDocument = gql`
	mutation deleteJob($data: JobFilter!) {
		deleteFromJobCollection(filter: $data) {
			records {
				...standardJobResult
			}
		}
	}
	${StandardJobResultFragmentDoc}
`
export type DeleteJobMutationFn = Apollo.MutationFunction<
	DeleteJobMutation,
	DeleteJobMutationVariables
>

/**
 * __useDeleteJobMutation__
 *
 * To run a mutation, you first call `useDeleteJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobMutation, { data, loading, error }] = useDeleteJobMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteJobMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteJobMutation,
		DeleteJobMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<DeleteJobMutation, DeleteJobMutationVariables>(
		DeleteJobDocument,
		options,
	)
}
export type DeleteJobMutationHookResult = ReturnType<
	typeof useDeleteJobMutation
>
export type DeleteJobMutationResult = Apollo.MutationResult<DeleteJobMutation>
export type DeleteJobMutationOptions = Apollo.BaseMutationOptions<
	DeleteJobMutation,
	DeleteJobMutationVariables
>
export const UserQueryDocument = gql`
	query userQuery($id: String, $uid: String) {
		userCollection(
			first: 1
			filter: { or: [{ id: { eq: $id } }, { uid: { eq: $uid } }] }
		) {
			edges {
				node {
					...AuthenticationUser
				}
			}
		}
	}
	${AuthenticationUserFragmentDoc}
`

/**
 * __useUserQueryQuery__
 *
 * To run a query within a React component, call `useUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useUserQueryQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UserQueryQuery,
		UserQueryQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<UserQueryQuery, UserQueryQueryVariables>(
		UserQueryDocument,
		options,
	)
}
export function useUserQueryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserQueryQuery,
		UserQueryQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<UserQueryQuery, UserQueryQueryVariables>(
		UserQueryDocument,
		options,
	)
}
export function useUserQuerySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				UserQueryQuery,
				UserQueryQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<UserQueryQuery, UserQueryQueryVariables>(
		UserQueryDocument,
		options,
	)
}
export type UserQueryQueryHookResult = ReturnType<typeof useUserQueryQuery>
export type UserQueryLazyQueryHookResult = ReturnType<
	typeof useUserQueryLazyQuery
>
export type UserQuerySuspenseQueryHookResult = ReturnType<
	typeof useUserQuerySuspenseQuery
>
export type UserQueryQueryResult = Apollo.QueryResult<
	UserQueryQuery,
	UserQueryQueryVariables
>
export const UserProfileDocument = gql`
	query userProfile($uid: String!) {
		profileCollection(first: 1, filter: { id: { eq: $uid } }) {
			edges {
				node {
					...UserProfileFragment
				}
			}
		}
	}
	${UserProfileFragmentFragmentDoc}
`

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useUserProfileQuery(
	baseOptions: Apollo.QueryHookOptions<
		UserProfileQuery,
		UserProfileQueryVariables
	> &
		(
			| { variables: UserProfileQueryVariables; skip?: boolean }
			| { skip: boolean }
		),
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(
		UserProfileDocument,
		options,
	)
}
export function useUserProfileLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserProfileQuery,
		UserProfileQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(
		UserProfileDocument,
		options,
	)
}
export function useUserProfileSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				UserProfileQuery,
				UserProfileQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<UserProfileQuery, UserProfileQueryVariables>(
		UserProfileDocument,
		options,
	)
}
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>
export type UserProfileLazyQueryHookResult = ReturnType<
	typeof useUserProfileLazyQuery
>
export type UserProfileSuspenseQueryHookResult = ReturnType<
	typeof useUserProfileSuspenseQuery
>
export type UserProfileQueryResult = Apollo.QueryResult<
	UserProfileQuery,
	UserProfileQueryVariables
>
export const UsersProfileDocument = gql`
	query usersProfile($data: String) {
		userCollection(first: 1, filter: { uid: { eq: $data } }) {
			edges {
				node {
					...AuthenticationUser
				}
			}
		}
	}
	${AuthenticationUserFragmentDoc}
`

/**
 * __useUsersProfileQuery__
 *
 * To run a query within a React component, call `useUsersProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersProfileQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUsersProfileQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UsersProfileQuery,
		UsersProfileQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<UsersProfileQuery, UsersProfileQueryVariables>(
		UsersProfileDocument,
		options,
	)
}
export function useUsersProfileLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UsersProfileQuery,
		UsersProfileQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<UsersProfileQuery, UsersProfileQueryVariables>(
		UsersProfileDocument,
		options,
	)
}
export function useUsersProfileSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				UsersProfileQuery,
				UsersProfileQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		UsersProfileQuery,
		UsersProfileQueryVariables
	>(UsersProfileDocument, options)
}
export type UsersProfileQueryHookResult = ReturnType<
	typeof useUsersProfileQuery
>
export type UsersProfileLazyQueryHookResult = ReturnType<
	typeof useUsersProfileLazyQuery
>
export type UsersProfileSuspenseQueryHookResult = ReturnType<
	typeof useUsersProfileSuspenseQuery
>
export type UsersProfileQueryResult = Apollo.QueryResult<
	UsersProfileQuery,
	UsersProfileQueryVariables
>
export const UserProfilesByNameDocument = gql`
	query userProfilesByName($UserName: String) {
		profileCollection(
			first: 15
			orderBy: { userName: AscNullsLast }
			filter: { userName: { ilike: $UserName } }
		) {
			edges {
				node {
					...UserProfileFragment
				}
			}
		}
	}
	${UserProfileFragmentFragmentDoc}
`

/**
 * __useUserProfilesByNameQuery__
 *
 * To run a query within a React component, call `useUserProfilesByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfilesByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfilesByNameQuery({
 *   variables: {
 *      UserName: // value for 'UserName'
 *   },
 * });
 */
export function useUserProfilesByNameQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UserProfilesByNameQuery,
		UserProfilesByNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		UserProfilesByNameQuery,
		UserProfilesByNameQueryVariables
	>(UserProfilesByNameDocument, options)
}
export function useUserProfilesByNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserProfilesByNameQuery,
		UserProfilesByNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		UserProfilesByNameQuery,
		UserProfilesByNameQueryVariables
	>(UserProfilesByNameDocument, options)
}
export function useUserProfilesByNameSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				UserProfilesByNameQuery,
				UserProfilesByNameQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		UserProfilesByNameQuery,
		UserProfilesByNameQueryVariables
	>(UserProfilesByNameDocument, options)
}
export type UserProfilesByNameQueryHookResult = ReturnType<
	typeof useUserProfilesByNameQuery
>
export type UserProfilesByNameLazyQueryHookResult = ReturnType<
	typeof useUserProfilesByNameLazyQuery
>
export type UserProfilesByNameSuspenseQueryHookResult = ReturnType<
	typeof useUserProfilesByNameSuspenseQuery
>
export type UserProfilesByNameQueryResult = Apollo.QueryResult<
	UserProfilesByNameQuery,
	UserProfilesByNameQueryVariables
>
export const UserProfilesByEmailDocument = gql`
	query userProfilesByEmail($email: String) {
		userCollection(
			first: 15
			orderBy: { email: AscNullsLast }
			filter: { email: { ilike: $email } }
		) {
			edges {
				node {
					...AuthenticationUser
				}
			}
		}
	}
	${AuthenticationUserFragmentDoc}
`

/**
 * __useUserProfilesByEmailQuery__
 *
 * To run a query within a React component, call `useUserProfilesByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfilesByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfilesByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserProfilesByEmailQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UserProfilesByEmailQuery,
		UserProfilesByEmailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		UserProfilesByEmailQuery,
		UserProfilesByEmailQueryVariables
	>(UserProfilesByEmailDocument, options)
}
export function useUserProfilesByEmailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserProfilesByEmailQuery,
		UserProfilesByEmailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		UserProfilesByEmailQuery,
		UserProfilesByEmailQueryVariables
	>(UserProfilesByEmailDocument, options)
}
export function useUserProfilesByEmailSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				UserProfilesByEmailQuery,
				UserProfilesByEmailQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		UserProfilesByEmailQuery,
		UserProfilesByEmailQueryVariables
	>(UserProfilesByEmailDocument, options)
}
export type UserProfilesByEmailQueryHookResult = ReturnType<
	typeof useUserProfilesByEmailQuery
>
export type UserProfilesByEmailLazyQueryHookResult = ReturnType<
	typeof useUserProfilesByEmailLazyQuery
>
export type UserProfilesByEmailSuspenseQueryHookResult = ReturnType<
	typeof useUserProfilesByEmailSuspenseQuery
>
export type UserProfilesByEmailQueryResult = Apollo.QueryResult<
	UserProfilesByEmailQuery,
	UserProfilesByEmailQueryVariables
>
export const CheckusernameDocument = gql`
	query checkusername($uid: String!) {
		userCollection(first: 1, filter: { uid: { eq: $uid } }) {
			edges {
				node {
					status
				}
			}
		}
	}
`

/**
 * __useCheckusernameQuery__
 *
 * To run a query within a React component, call `useCheckusernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckusernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckusernameQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useCheckusernameQuery(
	baseOptions: Apollo.QueryHookOptions<
		CheckusernameQuery,
		CheckusernameQueryVariables
	> &
		(
			| { variables: CheckusernameQueryVariables; skip?: boolean }
			| { skip: boolean }
		),
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<CheckusernameQuery, CheckusernameQueryVariables>(
		CheckusernameDocument,
		options,
	)
}
export function useCheckusernameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CheckusernameQuery,
		CheckusernameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<CheckusernameQuery, CheckusernameQueryVariables>(
		CheckusernameDocument,
		options,
	)
}
export function useCheckusernameSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				CheckusernameQuery,
				CheckusernameQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		CheckusernameQuery,
		CheckusernameQueryVariables
	>(CheckusernameDocument, options)
}
export type CheckusernameQueryHookResult = ReturnType<
	typeof useCheckusernameQuery
>
export type CheckusernameLazyQueryHookResult = ReturnType<
	typeof useCheckusernameLazyQuery
>
export type CheckusernameSuspenseQueryHookResult = ReturnType<
	typeof useCheckusernameSuspenseQuery
>
export type CheckusernameQueryResult = Apollo.QueryResult<
	CheckusernameQuery,
	CheckusernameQueryVariables
>
export const CheckEmailDocument = gql`
	query checkEmail($filter: UserFilter) {
		userCollection(filter: $filter) {
			edges {
				node {
					status
				}
			}
		}
	}
`

/**
 * __useCheckEmailQuery__
 *
 * To run a query within a React component, call `useCheckEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEmailQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCheckEmailQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CheckEmailQuery,
		CheckEmailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<CheckEmailQuery, CheckEmailQueryVariables>(
		CheckEmailDocument,
		options,
	)
}
export function useCheckEmailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CheckEmailQuery,
		CheckEmailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<CheckEmailQuery, CheckEmailQueryVariables>(
		CheckEmailDocument,
		options,
	)
}
export function useCheckEmailSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				CheckEmailQuery,
				CheckEmailQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<CheckEmailQuery, CheckEmailQueryVariables>(
		CheckEmailDocument,
		options,
	)
}
export type CheckEmailQueryHookResult = ReturnType<typeof useCheckEmailQuery>
export type CheckEmailLazyQueryHookResult = ReturnType<
	typeof useCheckEmailLazyQuery
>
export type CheckEmailSuspenseQueryHookResult = ReturnType<
	typeof useCheckEmailSuspenseQuery
>
export type CheckEmailQueryResult = Apollo.QueryResult<
	CheckEmailQuery,
	CheckEmailQueryVariables
>
export const UpdateProfileDetailsDocument = gql`
	mutation updateProfileDetails($details: [ProfileInsertInput!]!) {
		insertIntoProfileCollection(objects: $details) {
			records {
				...UserProfileFragment
			}
		}
	}
	${UserProfileFragmentFragmentDoc}
`
export type UpdateProfileDetailsMutationFn = Apollo.MutationFunction<
	UpdateProfileDetailsMutation,
	UpdateProfileDetailsMutationVariables
>

/**
 * __useUpdateProfileDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateProfileDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileDetailsMutation, { data, loading, error }] = useUpdateProfileDetailsMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useUpdateProfileDetailsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateProfileDetailsMutation,
		UpdateProfileDetailsMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		UpdateProfileDetailsMutation,
		UpdateProfileDetailsMutationVariables
	>(UpdateProfileDetailsDocument, options)
}
export type UpdateProfileDetailsMutationHookResult = ReturnType<
	typeof useUpdateProfileDetailsMutation
>
export type UpdateProfileDetailsMutationResult =
	Apollo.MutationResult<UpdateProfileDetailsMutation>
export type UpdateProfileDetailsMutationOptions = Apollo.BaseMutationOptions<
	UpdateProfileDetailsMutation,
	UpdateProfileDetailsMutationVariables
>
export const SetValuesDocument = gql`
	mutation setValues($values: [String!]!, $userId: String!) {
		setvalues(valuetitles: $values, userid: $userId) {
			edges {
				node {
					...UserProfileFragment
				}
			}
		}
	}
	${UserProfileFragmentFragmentDoc}
`
export type SetValuesMutationFn = Apollo.MutationFunction<
	SetValuesMutation,
	SetValuesMutationVariables
>

/**
 * __useSetValuesMutation__
 *
 * To run a mutation, you first call `useSetValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setValuesMutation, { data, loading, error }] = useSetValuesMutation({
 *   variables: {
 *      values: // value for 'values'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetValuesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetValuesMutation,
		SetValuesMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<SetValuesMutation, SetValuesMutationVariables>(
		SetValuesDocument,
		options,
	)
}
export type SetValuesMutationHookResult = ReturnType<
	typeof useSetValuesMutation
>
export type SetValuesMutationResult = Apollo.MutationResult<SetValuesMutation>
export type SetValuesMutationOptions = Apollo.BaseMutationOptions<
	SetValuesMutation,
	SetValuesMutationVariables
>
export const SetSkillsDocument = gql`
	mutation setSkills($skills: [String!]!) {
		setskills(skills: $skills) {
			edges {
				node {
					id
					title
				}
			}
		}
	}
`
export type SetSkillsMutationFn = Apollo.MutationFunction<
	SetSkillsMutation,
	SetSkillsMutationVariables
>

/**
 * __useSetSkillsMutation__
 *
 * To run a mutation, you first call `useSetSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSkillsMutation, { data, loading, error }] = useSetSkillsMutation({
 *   variables: {
 *      skills: // value for 'skills'
 *   },
 * });
 */
export function useSetSkillsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetSkillsMutation,
		SetSkillsMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<SetSkillsMutation, SetSkillsMutationVariables>(
		SetSkillsDocument,
		options,
	)
}
export type SetSkillsMutationHookResult = ReturnType<
	typeof useSetSkillsMutation
>
export type SetSkillsMutationResult = Apollo.MutationResult<SetSkillsMutation>
export type SetSkillsMutationOptions = Apollo.BaseMutationOptions<
	SetSkillsMutation,
	SetSkillsMutationVariables
>
export const UpdateUsernameDocument = gql`
	mutation updateUsername($userId: String, $username: String!) {
		updateUserCollection(
			filter: { id: { eq: $userId } }
			set: { uid: $username }
		) {
			affectedCount
			records {
				id
				uid
			}
		}
	}
`
export type UpdateUsernameMutationFn = Apollo.MutationFunction<
	UpdateUsernameMutation,
	UpdateUsernameMutationVariables
>

/**
 * __useUpdateUsernameMutation__
 *
 * To run a mutation, you first call `useUpdateUsernameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsernameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsernameMutation, { data, loading, error }] = useUpdateUsernameMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useUpdateUsernameMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateUsernameMutation,
		UpdateUsernameMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		UpdateUsernameMutation,
		UpdateUsernameMutationVariables
	>(UpdateUsernameDocument, options)
}
export type UpdateUsernameMutationHookResult = ReturnType<
	typeof useUpdateUsernameMutation
>
export type UpdateUsernameMutationResult =
	Apollo.MutationResult<UpdateUsernameMutation>
export type UpdateUsernameMutationOptions = Apollo.BaseMutationOptions<
	UpdateUsernameMutation,
	UpdateUsernameMutationVariables
>
export const UpdateUserSettingsDocument = gql`
	mutation updateUserSettings(
		$userID: String
		$userSettings: ProfileUpdateInput!
	) {
		updateProfileCollection(
			filter: { user: { eq: $userID } }
			set: $userSettings
		) {
			records {
				...UserProfileFragment
			}
		}
	}
	${UserProfileFragmentFragmentDoc}
`
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<
	UpdateUserSettingsMutation,
	UpdateUserSettingsMutationVariables
>

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *      userSettings: // value for 'userSettings'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateUserSettingsMutation,
		UpdateUserSettingsMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		UpdateUserSettingsMutation,
		UpdateUserSettingsMutationVariables
	>(UpdateUserSettingsDocument, options)
}
export type UpdateUserSettingsMutationHookResult = ReturnType<
	typeof useUpdateUserSettingsMutation
>
export type UpdateUserSettingsMutationResult =
	Apollo.MutationResult<UpdateUserSettingsMutation>
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<
	UpdateUserSettingsMutation,
	UpdateUserSettingsMutationVariables
>
export const SetUpProfileDocument = gql`
	mutation setUpProfile(
		$profileId: String!
		$firstName: String
		$lastName: String
		$aboutMe: String
		$avatarPath: String
		$coverPath: String
		$skills: [String]
		$values: [String]
		$locationId: String
		$cvFilePath: [String]
		$cvFileOriginalName: [String]
	) {
		setUpProfile(
			profileId: $profileId
			firstName: $firstName
			lastName: $lastName
			aboutMe: $aboutMe
			avatarPath: $avatarPath
			coverPath: $coverPath
			skills: $skills
			values: $values
			locationId: $locationId
			cvFilePath: $cvFilePath
			cvFileOriginalName: $cvFileOriginalName
		) {
			edges {
				node {
					...AuthenticationUser
				}
			}
		}
	}
	${AuthenticationUserFragmentDoc}
`
export type SetUpProfileMutationFn = Apollo.MutationFunction<
	SetUpProfileMutation,
	SetUpProfileMutationVariables
>

/**
 * __useSetUpProfileMutation__
 *
 * To run a mutation, you first call `useSetUpProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUpProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUpProfileMutation, { data, loading, error }] = useSetUpProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      aboutMe: // value for 'aboutMe'
 *      avatarPath: // value for 'avatarPath'
 *      coverPath: // value for 'coverPath'
 *      skills: // value for 'skills'
 *      values: // value for 'values'
 *      locationId: // value for 'locationId'
 *      cvFilePath: // value for 'cvFilePath'
 *      cvFileOriginalName: // value for 'cvFileOriginalName'
 *   },
 * });
 */
export function useSetUpProfileMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetUpProfileMutation,
		SetUpProfileMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		SetUpProfileMutation,
		SetUpProfileMutationVariables
	>(SetUpProfileDocument, options)
}
export type SetUpProfileMutationHookResult = ReturnType<
	typeof useSetUpProfileMutation
>
export type SetUpProfileMutationResult =
	Apollo.MutationResult<SetUpProfileMutation>
export type SetUpProfileMutationOptions = Apollo.BaseMutationOptions<
	SetUpProfileMutation,
	SetUpProfileMutationVariables
>
export const SetCvFileDocument = gql`
	mutation setCVFile($cvFilePath: JSON, $cvFileOriginalName: JSON) {
		updateProfileCollection(
			set: {
				cvFilePath: $cvFilePath
				cvFileOriginalName: $cvFileOriginalName
			}
		) {
			records {
				...UserProfileFragment
			}
		}
	}
	${UserProfileFragmentFragmentDoc}
`
export type SetCvFileMutationFn = Apollo.MutationFunction<
	SetCvFileMutation,
	SetCvFileMutationVariables
>

/**
 * __useSetCvFileMutation__
 *
 * To run a mutation, you first call `useSetCvFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCvFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCvFileMutation, { data, loading, error }] = useSetCvFileMutation({
 *   variables: {
 *      cvFilePath: // value for 'cvFilePath'
 *      cvFileOriginalName: // value for 'cvFileOriginalName'
 *   },
 * });
 */
export function useSetCvFileMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetCvFileMutation,
		SetCvFileMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<SetCvFileMutation, SetCvFileMutationVariables>(
		SetCvFileDocument,
		options,
	)
}
export type SetCvFileMutationHookResult = ReturnType<
	typeof useSetCvFileMutation
>
export type SetCvFileMutationResult = Apollo.MutationResult<SetCvFileMutation>
export type SetCvFileMutationOptions = Apollo.BaseMutationOptions<
	SetCvFileMutation,
	SetCvFileMutationVariables
>
export const SetUserOnBoardingDocument = gql`
	mutation setUserOnBoarding {
		insertIntoProfileCollection(
			objects: { userOnBoardingFormVisited: true }
		) {
			records {
				amount
			}
		}
	}
`
export type SetUserOnBoardingMutationFn = Apollo.MutationFunction<
	SetUserOnBoardingMutation,
	SetUserOnBoardingMutationVariables
>

/**
 * __useSetUserOnBoardingMutation__
 *
 * To run a mutation, you first call `useSetUserOnBoardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserOnBoardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserOnBoardingMutation, { data, loading, error }] = useSetUserOnBoardingMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetUserOnBoardingMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetUserOnBoardingMutation,
		SetUserOnBoardingMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		SetUserOnBoardingMutation,
		SetUserOnBoardingMutationVariables
	>(SetUserOnBoardingDocument, options)
}
export type SetUserOnBoardingMutationHookResult = ReturnType<
	typeof useSetUserOnBoardingMutation
>
export type SetUserOnBoardingMutationResult =
	Apollo.MutationResult<SetUserOnBoardingMutation>
export type SetUserOnBoardingMutationOptions = Apollo.BaseMutationOptions<
	SetUserOnBoardingMutation,
	SetUserOnBoardingMutationVariables
>
export const RoLocationsCollectionDocument = gql`
	query roLocationsCollection($data: roLocationsFilter) {
		roLocationsCollection(filter: $data) {
			edges {
				node {
					id
					type
					name
					region2
				}
			}
		}
	}
`

/**
 * __useRoLocationsCollectionQuery__
 *
 * To run a query within a React component, call `useRoLocationsCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoLocationsCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoLocationsCollectionQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRoLocationsCollectionQuery(
	baseOptions?: Apollo.QueryHookOptions<
		RoLocationsCollectionQuery,
		RoLocationsCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		RoLocationsCollectionQuery,
		RoLocationsCollectionQueryVariables
	>(RoLocationsCollectionDocument, options)
}
export function useRoLocationsCollectionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		RoLocationsCollectionQuery,
		RoLocationsCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		RoLocationsCollectionQuery,
		RoLocationsCollectionQueryVariables
	>(RoLocationsCollectionDocument, options)
}
export function useRoLocationsCollectionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				RoLocationsCollectionQuery,
				RoLocationsCollectionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		RoLocationsCollectionQuery,
		RoLocationsCollectionQueryVariables
	>(RoLocationsCollectionDocument, options)
}
export type RoLocationsCollectionQueryHookResult = ReturnType<
	typeof useRoLocationsCollectionQuery
>
export type RoLocationsCollectionLazyQueryHookResult = ReturnType<
	typeof useRoLocationsCollectionLazyQuery
>
export type RoLocationsCollectionSuspenseQueryHookResult = ReturnType<
	typeof useRoLocationsCollectionSuspenseQuery
>
export type RoLocationsCollectionQueryResult = Apollo.QueryResult<
	RoLocationsCollectionQuery,
	RoLocationsCollectionQueryVariables
>
export const AddCompanyLocationsDocument = gql`
	query addCompanyLocations($data: roLocationsFilter) {
		roLocationsCollection(filter: $data) {
			edges {
				node {
					id
					name
				}
			}
		}
	}
`

/**
 * __useAddCompanyLocationsQuery__
 *
 * To run a query within a React component, call `useAddCompanyLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddCompanyLocationsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddCompanyLocationsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		AddCompanyLocationsQuery,
		AddCompanyLocationsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		AddCompanyLocationsQuery,
		AddCompanyLocationsQueryVariables
	>(AddCompanyLocationsDocument, options)
}
export function useAddCompanyLocationsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AddCompanyLocationsQuery,
		AddCompanyLocationsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		AddCompanyLocationsQuery,
		AddCompanyLocationsQueryVariables
	>(AddCompanyLocationsDocument, options)
}
export function useAddCompanyLocationsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				AddCompanyLocationsQuery,
				AddCompanyLocationsQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		AddCompanyLocationsQuery,
		AddCompanyLocationsQueryVariables
	>(AddCompanyLocationsDocument, options)
}
export type AddCompanyLocationsQueryHookResult = ReturnType<
	typeof useAddCompanyLocationsQuery
>
export type AddCompanyLocationsLazyQueryHookResult = ReturnType<
	typeof useAddCompanyLocationsLazyQuery
>
export type AddCompanyLocationsSuspenseQueryHookResult = ReturnType<
	typeof useAddCompanyLocationsSuspenseQuery
>
export type AddCompanyLocationsQueryResult = Apollo.QueryResult<
	AddCompanyLocationsQuery,
	AddCompanyLocationsQueryVariables
>
export const SearchDocument = gql`
	query search($data: String!) {
		search(data: $data) {
			edges {
				node {
					article {
						...standardArticleResult
					}
					company {
						id
						name
						slug
						dateFounded
						industry {
							id
							key
						}
						hasLogo
						logoPath
						hasCover
						coverPath
						featuredVideo
					}
					user {
						id
						uid
						profileCollection {
							edges {
								node {
									id
									firstName
									lastName
									hasAvatar
									avatarPath
									experienceCollection {
										edges {
											node {
												position
												company
											}
										}
									}
								}
							}
						}
					}
					team {
						id
						name
						slug
						company {
							id
							name
							slug
						}
					}
					job {
						id
						slug
						description
						title
						contractType
						seniorityLevel
						jobType
						locationType
						featuredImage
						company {
							id
							logoPath
							hasCover
							hasLogo
							name
							slug
							description
							coverPath
							featuredVideo
							industry {
								id
								key
							}
						}
						_TeamToJobCollection {
							edges {
								node {
									job {
										jobSalary {
											id
											currency
											amountMin
											amountMax
											rate
										}
									}
								}
							}
						}
						_JobToCompanyOfficesCollection {
							edges {
								node {
									companyOffices {
										id
										roLocations {
											id
											name
											region2
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
	${StandardArticleResultFragmentDoc}
`

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSearchQuery(
	baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables> &
		(
			| { variables: SearchQueryVariables; skip?: boolean }
			| { skip: boolean }
		),
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<SearchQuery, SearchQueryVariables>(
		SearchDocument,
		options,
	)
}
export function useSearchLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SearchQuery,
		SearchQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(
		SearchDocument,
		options,
	)
}
export function useSearchSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<SearchQuery, SearchQueryVariables>(
		SearchDocument,
		options,
	)
}
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>
export type SearchSuspenseQueryHookResult = ReturnType<
	typeof useSearchSuspenseQuery
>
export type SearchQueryResult = Apollo.QueryResult<
	SearchQuery,
	SearchQueryVariables
>
export const ProfileCollectionDocument = gql`
	query profileCollection(
		$filter: ProfileFilter
		$first: Int
		$after: Cursor
	) {
		profileCollection(filter: $filter, first: $first, after: $after) {
			edges {
				node {
					id
					firstName
					lastName
					hasAvatar
					avatarPath
					user {
						uid
					}
					experienceCollection {
						edges {
							node {
								position
								company
							}
						}
					}
				}
			}
			pageInfo {
				endCursor
				hasNextPage
			}
		}
	}
`

/**
 * __useProfileCollectionQuery__
 *
 * To run a query within a React component, call `useProfileCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileCollectionQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProfileCollectionQuery(
	baseOptions: Apollo.QueryHookOptions<
		ProfileCollectionQuery,
		ProfileCollectionQueryVariables
	> &
		(
			| { variables: ProfileCollectionQueryVariables; skip?: boolean }
			| { skip: boolean }
		),
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		ProfileCollectionQuery,
		ProfileCollectionQueryVariables
	>(ProfileCollectionDocument, options)
}
export function useProfileCollectionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ProfileCollectionQuery,
		ProfileCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		ProfileCollectionQuery,
		ProfileCollectionQueryVariables
	>(ProfileCollectionDocument, options)
}
export function useProfileCollectionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				ProfileCollectionQuery,
				ProfileCollectionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		ProfileCollectionQuery,
		ProfileCollectionQueryVariables
	>(ProfileCollectionDocument, options)
}
export type ProfileCollectionQueryHookResult = ReturnType<
	typeof useProfileCollectionQuery
>
export type ProfileCollectionLazyQueryHookResult = ReturnType<
	typeof useProfileCollectionLazyQuery
>
export type ProfileCollectionSuspenseQueryHookResult = ReturnType<
	typeof useProfileCollectionSuspenseQuery
>
export type ProfileCollectionQueryResult = Apollo.QueryResult<
	ProfileCollectionQuery,
	ProfileCollectionQueryVariables
>
export const SearchArticlesDocument = gql`
	query searchArticles($query: String, $first: Int, $after: Cursor) {
		articleCollection(
			first: $first
			after: $after
			orderBy: { createdAt: DescNullsLast, updatedAt: DescNullsLast }
			filter: {
				or: [
					{ title: { ilike: $query } }
					{ description: { ilike: $query } }
					{ body: { ilike: $query } }
				]
			}
		) {
			edges {
				node {
					...standardArticleResult
				}
			}
			pageInfo {
				endCursor
				hasNextPage
			}
		}
	}
	${StandardArticleResultFragmentDoc}
`

/**
 * __useSearchArticlesQuery__
 *
 * To run a query within a React component, call `useSearchArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchArticlesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchArticlesQuery(
	baseOptions: Apollo.QueryHookOptions<
		SearchArticlesQuery,
		SearchArticlesQueryVariables
	> &
		(
			| { variables: SearchArticlesQueryVariables; skip?: boolean }
			| { skip: boolean }
		),
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(
		SearchArticlesDocument,
		options,
	)
}
export function useSearchArticlesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SearchArticlesQuery,
		SearchArticlesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		SearchArticlesQuery,
		SearchArticlesQueryVariables
	>(SearchArticlesDocument, options)
}
export function useSearchArticlesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				SearchArticlesQuery,
				SearchArticlesQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		SearchArticlesQuery,
		SearchArticlesQueryVariables
	>(SearchArticlesDocument, options)
}
export type SearchArticlesQueryHookResult = ReturnType<
	typeof useSearchArticlesQuery
>
export type SearchArticlesLazyQueryHookResult = ReturnType<
	typeof useSearchArticlesLazyQuery
>
export type SearchArticlesSuspenseQueryHookResult = ReturnType<
	typeof useSearchArticlesSuspenseQuery
>
export type SearchArticlesQueryResult = Apollo.QueryResult<
	SearchArticlesQuery,
	SearchArticlesQueryVariables
>
export const SkillCollectionDocument = gql`
	query skillCollection($key: String!) {
		skillCollection(
			filter: { key: { startsWith: $key } }
			first: 25
			orderBy: { title: AscNullsLast }
		) {
			edges {
				node {
					id
					title
				}
			}
		}
	}
`

/**
 * __useSkillCollectionQuery__
 *
 * To run a query within a React component, call `useSkillCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillCollectionQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useSkillCollectionQuery(
	baseOptions: Apollo.QueryHookOptions<
		SkillCollectionQuery,
		SkillCollectionQueryVariables
	> &
		(
			| { variables: SkillCollectionQueryVariables; skip?: boolean }
			| { skip: boolean }
		),
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<SkillCollectionQuery, SkillCollectionQueryVariables>(
		SkillCollectionDocument,
		options,
	)
}
export function useSkillCollectionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		SkillCollectionQuery,
		SkillCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		SkillCollectionQuery,
		SkillCollectionQueryVariables
	>(SkillCollectionDocument, options)
}
export function useSkillCollectionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				SkillCollectionQuery,
				SkillCollectionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		SkillCollectionQuery,
		SkillCollectionQueryVariables
	>(SkillCollectionDocument, options)
}
export type SkillCollectionQueryHookResult = ReturnType<
	typeof useSkillCollectionQuery
>
export type SkillCollectionLazyQueryHookResult = ReturnType<
	typeof useSkillCollectionLazyQuery
>
export type SkillCollectionSuspenseQueryHookResult = ReturnType<
	typeof useSkillCollectionSuspenseQuery
>
export type SkillCollectionQueryResult = Apollo.QueryResult<
	SkillCollectionQuery,
	SkillCollectionQueryVariables
>
export const UniversityCollectionDocument = gql`
	query universityCollection {
		universityCollection {
			edges {
				node {
					id
					name
				}
			}
		}
	}
`

/**
 * __useUniversityCollectionQuery__
 *
 * To run a query within a React component, call `useUniversityCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversityCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversityCollectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useUniversityCollectionQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UniversityCollectionQuery,
		UniversityCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		UniversityCollectionQuery,
		UniversityCollectionQueryVariables
	>(UniversityCollectionDocument, options)
}
export function useUniversityCollectionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UniversityCollectionQuery,
		UniversityCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		UniversityCollectionQuery,
		UniversityCollectionQueryVariables
	>(UniversityCollectionDocument, options)
}
export function useUniversityCollectionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				UniversityCollectionQuery,
				UniversityCollectionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		UniversityCollectionQuery,
		UniversityCollectionQueryVariables
	>(UniversityCollectionDocument, options)
}
export type UniversityCollectionQueryHookResult = ReturnType<
	typeof useUniversityCollectionQuery
>
export type UniversityCollectionLazyQueryHookResult = ReturnType<
	typeof useUniversityCollectionLazyQuery
>
export type UniversityCollectionSuspenseQueryHookResult = ReturnType<
	typeof useUniversityCollectionSuspenseQuery
>
export type UniversityCollectionQueryResult = Apollo.QueryResult<
	UniversityCollectionQuery,
	UniversityCollectionQueryVariables
>
export const FacultyCollectionDocument = gql`
	query facultyCollection($filter: FacultyFilter) {
		facultyCollection(filter: $filter) {
			edges {
				node {
					id
					name
				}
			}
		}
	}
`

/**
 * __useFacultyCollectionQuery__
 *
 * To run a query within a React component, call `useFacultyCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacultyCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacultyCollectionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFacultyCollectionQuery(
	baseOptions?: Apollo.QueryHookOptions<
		FacultyCollectionQuery,
		FacultyCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		FacultyCollectionQuery,
		FacultyCollectionQueryVariables
	>(FacultyCollectionDocument, options)
}
export function useFacultyCollectionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		FacultyCollectionQuery,
		FacultyCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		FacultyCollectionQuery,
		FacultyCollectionQueryVariables
	>(FacultyCollectionDocument, options)
}
export function useFacultyCollectionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				FacultyCollectionQuery,
				FacultyCollectionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		FacultyCollectionQuery,
		FacultyCollectionQueryVariables
	>(FacultyCollectionDocument, options)
}
export type FacultyCollectionQueryHookResult = ReturnType<
	typeof useFacultyCollectionQuery
>
export type FacultyCollectionLazyQueryHookResult = ReturnType<
	typeof useFacultyCollectionLazyQuery
>
export type FacultyCollectionSuspenseQueryHookResult = ReturnType<
	typeof useFacultyCollectionSuspenseQuery
>
export type FacultyCollectionQueryResult = Apollo.QueryResult<
	FacultyCollectionQuery,
	FacultyCollectionQueryVariables
>
export const ExportStudentsDocument = gql`
	query exportStudents {
		exportstudents {
			edges {
				node {
					firstname
					lastname
					email
					university
					faculty
					specialization
					hasaccount
					location
					scandate
					scanningagentname
					scanningagentemail
				}
			}
		}
	}
`

/**
 * __useExportStudentsQuery__
 *
 * To run a query within a React component, call `useExportStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportStudentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportStudentsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ExportStudentsQuery,
		ExportStudentsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<ExportStudentsQuery, ExportStudentsQueryVariables>(
		ExportStudentsDocument,
		options,
	)
}
export function useExportStudentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ExportStudentsQuery,
		ExportStudentsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		ExportStudentsQuery,
		ExportStudentsQueryVariables
	>(ExportStudentsDocument, options)
}
export function useExportStudentsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				ExportStudentsQuery,
				ExportStudentsQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		ExportStudentsQuery,
		ExportStudentsQueryVariables
	>(ExportStudentsDocument, options)
}
export type ExportStudentsQueryHookResult = ReturnType<
	typeof useExportStudentsQuery
>
export type ExportStudentsLazyQueryHookResult = ReturnType<
	typeof useExportStudentsLazyQuery
>
export type ExportStudentsSuspenseQueryHookResult = ReturnType<
	typeof useExportStudentsSuspenseQuery
>
export type ExportStudentsQueryResult = Apollo.QueryResult<
	ExportStudentsQuery,
	ExportStudentsQueryVariables
>
export const FacultySpecializationCollectionDocument = gql`
	query facultySpecializationCollection(
		$facultyId: String!
		$nameFilter: String!
	) {
		facultySpecializationCollection(
			first: 10
			orderBy: { name: AscNullsLast }
			filter: {
				name: { ilike: $nameFilter }
				faculty: { eq: $facultyId }
			}
		) {
			edges {
				node {
					id
					name
				}
			}
		}
	}
`

/**
 * __useFacultySpecializationCollectionQuery__
 *
 * To run a query within a React component, call `useFacultySpecializationCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacultySpecializationCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacultySpecializationCollectionQuery({
 *   variables: {
 *      facultyId: // value for 'facultyId'
 *      nameFilter: // value for 'nameFilter'
 *   },
 * });
 */
export function useFacultySpecializationCollectionQuery(
	baseOptions: Apollo.QueryHookOptions<
		FacultySpecializationCollectionQuery,
		FacultySpecializationCollectionQueryVariables
	> &
		(
			| {
					variables: FacultySpecializationCollectionQueryVariables
					skip?: boolean
			  }
			| { skip: boolean }
		),
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		FacultySpecializationCollectionQuery,
		FacultySpecializationCollectionQueryVariables
	>(FacultySpecializationCollectionDocument, options)
}
export function useFacultySpecializationCollectionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		FacultySpecializationCollectionQuery,
		FacultySpecializationCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		FacultySpecializationCollectionQuery,
		FacultySpecializationCollectionQueryVariables
	>(FacultySpecializationCollectionDocument, options)
}
export function useFacultySpecializationCollectionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				FacultySpecializationCollectionQuery,
				FacultySpecializationCollectionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		FacultySpecializationCollectionQuery,
		FacultySpecializationCollectionQueryVariables
	>(FacultySpecializationCollectionDocument, options)
}
export type FacultySpecializationCollectionQueryHookResult = ReturnType<
	typeof useFacultySpecializationCollectionQuery
>
export type FacultySpecializationCollectionLazyQueryHookResult = ReturnType<
	typeof useFacultySpecializationCollectionLazyQuery
>
export type FacultySpecializationCollectionSuspenseQueryHookResult = ReturnType<
	typeof useFacultySpecializationCollectionSuspenseQuery
>
export type FacultySpecializationCollectionQueryResult = Apollo.QueryResult<
	FacultySpecializationCollectionQuery,
	FacultySpecializationCollectionQueryVariables
>
export const AddStudentKitDocument = gql`
	mutation addStudentKit($data: [StudentKitInsertInput!]!) {
		insertIntoStudentKitCollection(objects: $data) {
			records {
				id
				firstName
				lastName
				email
			}
		}
	}
`
export type AddStudentKitMutationFn = Apollo.MutationFunction<
	AddStudentKitMutation,
	AddStudentKitMutationVariables
>

/**
 * __useAddStudentKitMutation__
 *
 * To run a mutation, you first call `useAddStudentKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStudentKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStudentKitMutation, { data, loading, error }] = useAddStudentKitMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddStudentKitMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AddStudentKitMutation,
		AddStudentKitMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		AddStudentKitMutation,
		AddStudentKitMutationVariables
	>(AddStudentKitDocument, options)
}
export type AddStudentKitMutationHookResult = ReturnType<
	typeof useAddStudentKitMutation
>
export type AddStudentKitMutationResult =
	Apollo.MutationResult<AddStudentKitMutation>
export type AddStudentKitMutationOptions = Apollo.BaseMutationOptions<
	AddStudentKitMutation,
	AddStudentKitMutationVariables
>
export const SendQrCodeDocument = gql`
	mutation sendQRCode($email: String!) {
		send_qr_code(email: $email)
	}
`
export type SendQrCodeMutationFn = Apollo.MutationFunction<
	SendQrCodeMutation,
	SendQrCodeMutationVariables
>

/**
 * __useSendQrCodeMutation__
 *
 * To run a mutation, you first call `useSendQrCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendQrCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendQrCodeMutation, { data, loading, error }] = useSendQrCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendQrCodeMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SendQrCodeMutation,
		SendQrCodeMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<SendQrCodeMutation, SendQrCodeMutationVariables>(
		SendQrCodeDocument,
		options,
	)
}
export type SendQrCodeMutationHookResult = ReturnType<
	typeof useSendQrCodeMutation
>
export type SendQrCodeMutationResult = Apollo.MutationResult<SendQrCodeMutation>
export type SendQrCodeMutationOptions = Apollo.BaseMutationOptions<
	SendQrCodeMutation,
	SendQrCodeMutationVariables
>
export const TagCollectionDocument = gql`
	query tagCollection($keyword: String!) {
		tagCollection(filter: { title: { ilike: $keyword } }) {
			edges {
				node {
					id
					title
				}
			}
		}
	}
`

/**
 * __useTagCollectionQuery__
 *
 * To run a query within a React component, call `useTagCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagCollectionQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useTagCollectionQuery(
	baseOptions: Apollo.QueryHookOptions<
		TagCollectionQuery,
		TagCollectionQueryVariables
	> &
		(
			| { variables: TagCollectionQueryVariables; skip?: boolean }
			| { skip: boolean }
		),
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<TagCollectionQuery, TagCollectionQueryVariables>(
		TagCollectionDocument,
		options,
	)
}
export function useTagCollectionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TagCollectionQuery,
		TagCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<TagCollectionQuery, TagCollectionQueryVariables>(
		TagCollectionDocument,
		options,
	)
}
export function useTagCollectionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				TagCollectionQuery,
				TagCollectionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		TagCollectionQuery,
		TagCollectionQueryVariables
	>(TagCollectionDocument, options)
}
export type TagCollectionQueryHookResult = ReturnType<
	typeof useTagCollectionQuery
>
export type TagCollectionLazyQueryHookResult = ReturnType<
	typeof useTagCollectionLazyQuery
>
export type TagCollectionSuspenseQueryHookResult = ReturnType<
	typeof useTagCollectionSuspenseQuery
>
export type TagCollectionQueryResult = Apollo.QueryResult<
	TagCollectionQuery,
	TagCollectionQueryVariables
>
export const AppreciateDocument = gql`
	mutation appreciate(
		$language: String!
		$tagId: String!
		$articleId: String!
	) {
		appreciate(language: $language, tagId: $tagId, articleId: $articleId) {
			edges {
				node {
					status
					error
				}
			}
		}
	}
`
export type AppreciateMutationFn = Apollo.MutationFunction<
	AppreciateMutation,
	AppreciateMutationVariables
>

/**
 * __useAppreciateMutation__
 *
 * To run a mutation, you first call `useAppreciateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppreciateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appreciateMutation, { data, loading, error }] = useAppreciateMutation({
 *   variables: {
 *      language: // value for 'language'
 *      tagId: // value for 'tagId'
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useAppreciateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AppreciateMutation,
		AppreciateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<AppreciateMutation, AppreciateMutationVariables>(
		AppreciateDocument,
		options,
	)
}
export type AppreciateMutationHookResult = ReturnType<
	typeof useAppreciateMutation
>
export type AppreciateMutationResult = Apollo.MutationResult<AppreciateMutation>
export type AppreciateMutationOptions = Apollo.BaseMutationOptions<
	AppreciateMutation,
	AppreciateMutationVariables
>
export const TeamQueryDocument = gql`
	query teamQuery(
		$companySlug: String
		$id: String
		$slug: String
		$companyId: String
	) {
		feedteams(
			companyslug: $companySlug
			slug: $slug
			companyid: $companyId
		) {
			edges {
				node {
					...standardTeamResult
				}
			}
		}
	}
	${StandardTeamResultFragmentDoc}
`

/**
 * __useTeamQueryQuery__
 *
 * To run a query within a React component, call `useTeamQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQueryQuery({
 *   variables: {
 *      companySlug: // value for 'companySlug'
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useTeamQueryQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeamQueryQuery,
		TeamQueryQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<TeamQueryQuery, TeamQueryQueryVariables>(
		TeamQueryDocument,
		options,
	)
}
export function useTeamQueryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeamQueryQuery,
		TeamQueryQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<TeamQueryQuery, TeamQueryQueryVariables>(
		TeamQueryDocument,
		options,
	)
}
export function useTeamQuerySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				TeamQueryQuery,
				TeamQueryQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<TeamQueryQuery, TeamQueryQueryVariables>(
		TeamQueryDocument,
		options,
	)
}
export type TeamQueryQueryHookResult = ReturnType<typeof useTeamQueryQuery>
export type TeamQueryLazyQueryHookResult = ReturnType<
	typeof useTeamQueryLazyQuery
>
export type TeamQuerySuspenseQueryHookResult = ReturnType<
	typeof useTeamQuerySuspenseQuery
>
export type TeamQueryQueryResult = Apollo.QueryResult<
	TeamQueryQuery,
	TeamQueryQueryVariables
>
export const TeamDepartmentsDocument = gql`
	query teamDepartments {
		teamDepartmentCollection {
			edges {
				node {
					id
					key
				}
			}
		}
	}
`

/**
 * __useTeamDepartmentsQuery__
 *
 * To run a query within a React component, call `useTeamDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamDepartmentsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeamDepartmentsQuery,
		TeamDepartmentsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<TeamDepartmentsQuery, TeamDepartmentsQueryVariables>(
		TeamDepartmentsDocument,
		options,
	)
}
export function useTeamDepartmentsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeamDepartmentsQuery,
		TeamDepartmentsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		TeamDepartmentsQuery,
		TeamDepartmentsQueryVariables
	>(TeamDepartmentsDocument, options)
}
export function useTeamDepartmentsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				TeamDepartmentsQuery,
				TeamDepartmentsQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		TeamDepartmentsQuery,
		TeamDepartmentsQueryVariables
	>(TeamDepartmentsDocument, options)
}
export type TeamDepartmentsQueryHookResult = ReturnType<
	typeof useTeamDepartmentsQuery
>
export type TeamDepartmentsLazyQueryHookResult = ReturnType<
	typeof useTeamDepartmentsLazyQuery
>
export type TeamDepartmentsSuspenseQueryHookResult = ReturnType<
	typeof useTeamDepartmentsSuspenseQuery
>
export type TeamDepartmentsQueryResult = Apollo.QueryResult<
	TeamDepartmentsQuery,
	TeamDepartmentsQueryVariables
>
export const TeamsQueryDocument = gql`
	query teamsQuery(
		$name: String
		$companyId: String
		$companySlug: String
		$locationids: [String]
	) {
		feedteams(
			name: $name
			companyid: $companyId
			companyslug: $companySlug
			locationids: $locationids
		) {
			edges {
				node {
					...standardTeamResult
				}
			}
		}
	}
	${StandardTeamResultFragmentDoc}
`

/**
 * __useTeamsQueryQuery__
 *
 * To run a query within a React component, call `useTeamsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQueryQuery({
 *   variables: {
 *      name: // value for 'name'
 *      companyId: // value for 'companyId'
 *      companySlug: // value for 'companySlug'
 *      locationids: // value for 'locationids'
 *   },
 * });
 */
export function useTeamsQueryQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeamsQueryQuery,
		TeamsQueryQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<TeamsQueryQuery, TeamsQueryQueryVariables>(
		TeamsQueryDocument,
		options,
	)
}
export function useTeamsQueryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeamsQueryQuery,
		TeamsQueryQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<TeamsQueryQuery, TeamsQueryQueryVariables>(
		TeamsQueryDocument,
		options,
	)
}
export function useTeamsQuerySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				TeamsQueryQuery,
				TeamsQueryQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<TeamsQueryQuery, TeamsQueryQueryVariables>(
		TeamsQueryDocument,
		options,
	)
}
export type TeamsQueryQueryHookResult = ReturnType<typeof useTeamsQueryQuery>
export type TeamsQueryLazyQueryHookResult = ReturnType<
	typeof useTeamsQueryLazyQuery
>
export type TeamsQuerySuspenseQueryHookResult = ReturnType<
	typeof useTeamsQuerySuspenseQuery
>
export type TeamsQueryQueryResult = Apollo.QueryResult<
	TeamsQueryQuery,
	TeamsQueryQueryVariables
>
export const TeamDepartmentCollectionDocument = gql`
	query teamDepartmentCollection($name: String) {
		teamCollection(
			filter: { name: { ilike: $name }, active: { eq: true } }
		) {
			edges {
				node {
					id
					name
					teamDepartment {
						id
						key
						roTitle
						enTitle
					}
				}
			}
		}
	}
`

/**
 * __useTeamDepartmentCollectionQuery__
 *
 * To run a query within a React component, call `useTeamDepartmentCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamDepartmentCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamDepartmentCollectionQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTeamDepartmentCollectionQuery(
	baseOptions?: Apollo.QueryHookOptions<
		TeamDepartmentCollectionQuery,
		TeamDepartmentCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		TeamDepartmentCollectionQuery,
		TeamDepartmentCollectionQueryVariables
	>(TeamDepartmentCollectionDocument, options)
}
export function useTeamDepartmentCollectionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		TeamDepartmentCollectionQuery,
		TeamDepartmentCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		TeamDepartmentCollectionQuery,
		TeamDepartmentCollectionQueryVariables
	>(TeamDepartmentCollectionDocument, options)
}
export function useTeamDepartmentCollectionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				TeamDepartmentCollectionQuery,
				TeamDepartmentCollectionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		TeamDepartmentCollectionQuery,
		TeamDepartmentCollectionQueryVariables
	>(TeamDepartmentCollectionDocument, options)
}
export type TeamDepartmentCollectionQueryHookResult = ReturnType<
	typeof useTeamDepartmentCollectionQuery
>
export type TeamDepartmentCollectionLazyQueryHookResult = ReturnType<
	typeof useTeamDepartmentCollectionLazyQuery
>
export type TeamDepartmentCollectionSuspenseQueryHookResult = ReturnType<
	typeof useTeamDepartmentCollectionSuspenseQuery
>
export type TeamDepartmentCollectionQueryResult = Apollo.QueryResult<
	TeamDepartmentCollectionQuery,
	TeamDepartmentCollectionQueryVariables
>
export const FeedTeamsDocument = gql`
	query feedTeams(
		$name: String
		$industryids: [String]
		$departmentids: [String]
		$locationids: [String]
		$companyid: String
		$size: [String]
		$averageage: [String]
		$first: Int
		$after: Cursor
	) {
		feedteams(
			name: $name
			industryids: $industryids
			departmentids: $departmentids
			locationids: $locationids
			companyid: $companyid
			size: $size
			averageage: $averageage
			first: $first
			after: $after
		) {
			...teamConnectionData
		}
	}
	${TeamConnectionDataFragmentDoc}
`

/**
 * __useFeedTeamsQuery__
 *
 * To run a query within a React component, call `useFeedTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedTeamsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      industryids: // value for 'industryids'
 *      departmentids: // value for 'departmentids'
 *      locationids: // value for 'locationids'
 *      companyid: // value for 'companyid'
 *      size: // value for 'size'
 *      averageage: // value for 'averageage'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFeedTeamsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		FeedTeamsQuery,
		FeedTeamsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<FeedTeamsQuery, FeedTeamsQueryVariables>(
		FeedTeamsDocument,
		options,
	)
}
export function useFeedTeamsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		FeedTeamsQuery,
		FeedTeamsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<FeedTeamsQuery, FeedTeamsQueryVariables>(
		FeedTeamsDocument,
		options,
	)
}
export function useFeedTeamsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				FeedTeamsQuery,
				FeedTeamsQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<FeedTeamsQuery, FeedTeamsQueryVariables>(
		FeedTeamsDocument,
		options,
	)
}
export type FeedTeamsQueryHookResult = ReturnType<typeof useFeedTeamsQuery>
export type FeedTeamsLazyQueryHookResult = ReturnType<
	typeof useFeedTeamsLazyQuery
>
export type FeedTeamsSuspenseQueryHookResult = ReturnType<
	typeof useFeedTeamsSuspenseQuery
>
export type FeedTeamsQueryResult = Apollo.QueryResult<
	FeedTeamsQuery,
	FeedTeamsQueryVariables
>
export const HandleTeamDocument = gql`
	mutation handleTeam($details: TeamUpdateInput!) {
		updateTeamCollection(set: $details) {
			records {
				...standardTeamResult
			}
		}
	}
	${StandardTeamResultFragmentDoc}
`
export type HandleTeamMutationFn = Apollo.MutationFunction<
	HandleTeamMutation,
	HandleTeamMutationVariables
>

/**
 * __useHandleTeamMutation__
 *
 * To run a mutation, you first call `useHandleTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleTeamMutation, { data, loading, error }] = useHandleTeamMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useHandleTeamMutation(
	baseOptions?: Apollo.MutationHookOptions<
		HandleTeamMutation,
		HandleTeamMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<HandleTeamMutation, HandleTeamMutationVariables>(
		HandleTeamDocument,
		options,
	)
}
export type HandleTeamMutationHookResult = ReturnType<
	typeof useHandleTeamMutation
>
export type HandleTeamMutationResult = Apollo.MutationResult<HandleTeamMutation>
export type HandleTeamMutationOptions = Apollo.BaseMutationOptions<
	HandleTeamMutation,
	HandleTeamMutationVariables
>
export const InsertIntoTeamCollectionDocument = gql`
	mutation insertIntoTeamCollection($details: [TeamInsertInput!]!) {
		insertIntoTeamCollection(objects: $details) {
			records {
				...standardTeamResult
			}
		}
	}
	${StandardTeamResultFragmentDoc}
`
export type InsertIntoTeamCollectionMutationFn = Apollo.MutationFunction<
	InsertIntoTeamCollectionMutation,
	InsertIntoTeamCollectionMutationVariables
>

/**
 * __useInsertIntoTeamCollectionMutation__
 *
 * To run a mutation, you first call `useInsertIntoTeamCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertIntoTeamCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertIntoTeamCollectionMutation, { data, loading, error }] = useInsertIntoTeamCollectionMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useInsertIntoTeamCollectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InsertIntoTeamCollectionMutation,
		InsertIntoTeamCollectionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		InsertIntoTeamCollectionMutation,
		InsertIntoTeamCollectionMutationVariables
	>(InsertIntoTeamCollectionDocument, options)
}
export type InsertIntoTeamCollectionMutationHookResult = ReturnType<
	typeof useInsertIntoTeamCollectionMutation
>
export type InsertIntoTeamCollectionMutationResult =
	Apollo.MutationResult<InsertIntoTeamCollectionMutation>
export type InsertIntoTeamCollectionMutationOptions =
	Apollo.BaseMutationOptions<
		InsertIntoTeamCollectionMutation,
		InsertIntoTeamCollectionMutationVariables
	>
export const InsertIntoTeamMemberCollectionDocument = gql`
	mutation insertIntoTeamMemberCollection($data: [TeamMemberInsertInput!]!) {
		insertIntoTeamMemberCollection(objects: $data) {
			records {
				id
			}
		}
	}
`
export type InsertIntoTeamMemberCollectionMutationFn = Apollo.MutationFunction<
	InsertIntoTeamMemberCollectionMutation,
	InsertIntoTeamMemberCollectionMutationVariables
>

/**
 * __useInsertIntoTeamMemberCollectionMutation__
 *
 * To run a mutation, you first call `useInsertIntoTeamMemberCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertIntoTeamMemberCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertIntoTeamMemberCollectionMutation, { data, loading, error }] = useInsertIntoTeamMemberCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInsertIntoTeamMemberCollectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		InsertIntoTeamMemberCollectionMutation,
		InsertIntoTeamMemberCollectionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		InsertIntoTeamMemberCollectionMutation,
		InsertIntoTeamMemberCollectionMutationVariables
	>(InsertIntoTeamMemberCollectionDocument, options)
}
export type InsertIntoTeamMemberCollectionMutationHookResult = ReturnType<
	typeof useInsertIntoTeamMemberCollectionMutation
>
export type InsertIntoTeamMemberCollectionMutationResult =
	Apollo.MutationResult<InsertIntoTeamMemberCollectionMutation>
export type InsertIntoTeamMemberCollectionMutationOptions =
	Apollo.BaseMutationOptions<
		InsertIntoTeamMemberCollectionMutation,
		InsertIntoTeamMemberCollectionMutationVariables
	>
export const DeleteFromTeamMemberCollectionDocument = gql`
	mutation deleteFromTeamMemberCollection($id: String) {
		deleteFromTeamMemberCollection(filter: { id: { eq: $id } }) {
			records {
				id
			}
		}
	}
`
export type DeleteFromTeamMemberCollectionMutationFn = Apollo.MutationFunction<
	DeleteFromTeamMemberCollectionMutation,
	DeleteFromTeamMemberCollectionMutationVariables
>

/**
 * __useDeleteFromTeamMemberCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteFromTeamMemberCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFromTeamMemberCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFromTeamMemberCollectionMutation, { data, loading, error }] = useDeleteFromTeamMemberCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFromTeamMemberCollectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteFromTeamMemberCollectionMutation,
		DeleteFromTeamMemberCollectionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		DeleteFromTeamMemberCollectionMutation,
		DeleteFromTeamMemberCollectionMutationVariables
	>(DeleteFromTeamMemberCollectionDocument, options)
}
export type DeleteFromTeamMemberCollectionMutationHookResult = ReturnType<
	typeof useDeleteFromTeamMemberCollectionMutation
>
export type DeleteFromTeamMemberCollectionMutationResult =
	Apollo.MutationResult<DeleteFromTeamMemberCollectionMutation>
export type DeleteFromTeamMemberCollectionMutationOptions =
	Apollo.BaseMutationOptions<
		DeleteFromTeamMemberCollectionMutation,
		DeleteFromTeamMemberCollectionMutationVariables
	>
export const UpdateTeamCollectionDocument = gql`
	mutation updateTeamCollection($id: String!) {
		updateTeamCollection(
			filter: { id: { eq: $id } }
			set: { active: false }
		) {
			records {
				...standardTeamResult
			}
		}
	}
	${StandardTeamResultFragmentDoc}
`
export type UpdateTeamCollectionMutationFn = Apollo.MutationFunction<
	UpdateTeamCollectionMutation,
	UpdateTeamCollectionMutationVariables
>

/**
 * __useUpdateTeamCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateTeamCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamCollectionMutation, { data, loading, error }] = useUpdateTeamCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateTeamCollectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateTeamCollectionMutation,
		UpdateTeamCollectionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		UpdateTeamCollectionMutation,
		UpdateTeamCollectionMutationVariables
	>(UpdateTeamCollectionDocument, options)
}
export type UpdateTeamCollectionMutationHookResult = ReturnType<
	typeof useUpdateTeamCollectionMutation
>
export type UpdateTeamCollectionMutationResult =
	Apollo.MutationResult<UpdateTeamCollectionMutation>
export type UpdateTeamCollectionMutationOptions = Apollo.BaseMutationOptions<
	UpdateTeamCollectionMutation,
	UpdateTeamCollectionMutationVariables
>
export const SetExperienceDocument = gql`
	mutation setExperience(
		$id: String
		$title: String
		$description: String
		$locationId: String
		$position: String
		$company: String
		$startDate: Datetime
		$endDate: Datetime
		$isPresent: Boolean
		$isCurrent: Boolean
	) {
		insertIntoExperienceCollection(
			objects: {
				id: $id
				title: $title
				description: $description
				location: $locationId
				position: $position
				company: $company
				startDate: $startDate
				endDate: $endDate
				isPresent: $isPresent
				isCurrent: $isCurrent
			}
		) {
			affectedCount
			records {
				id
				title
			}
		}
	}
`
export type SetExperienceMutationFn = Apollo.MutationFunction<
	SetExperienceMutation,
	SetExperienceMutationVariables
>

/**
 * __useSetExperienceMutation__
 *
 * To run a mutation, you first call `useSetExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExperienceMutation, { data, loading, error }] = useSetExperienceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      locationId: // value for 'locationId'
 *      position: // value for 'position'
 *      company: // value for 'company'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      isPresent: // value for 'isPresent'
 *      isCurrent: // value for 'isCurrent'
 *   },
 * });
 */
export function useSetExperienceMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SetExperienceMutation,
		SetExperienceMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		SetExperienceMutation,
		SetExperienceMutationVariables
	>(SetExperienceDocument, options)
}
export type SetExperienceMutationHookResult = ReturnType<
	typeof useSetExperienceMutation
>
export type SetExperienceMutationResult =
	Apollo.MutationResult<SetExperienceMutation>
export type SetExperienceMutationOptions = Apollo.BaseMutationOptions<
	SetExperienceMutation,
	SetExperienceMutationVariables
>
export const DeleteFromExperienceCollectionDocument = gql`
	mutation deleteFromExperienceCollection($id: String!) {
		deleteFromExperienceCollection(filter: { id: { eq: $id } }) {
			records {
				...UserExperience
			}
		}
	}
	${UserExperienceFragmentDoc}
`
export type DeleteFromExperienceCollectionMutationFn = Apollo.MutationFunction<
	DeleteFromExperienceCollectionMutation,
	DeleteFromExperienceCollectionMutationVariables
>

/**
 * __useDeleteFromExperienceCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteFromExperienceCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFromExperienceCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFromExperienceCollectionMutation, { data, loading, error }] = useDeleteFromExperienceCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFromExperienceCollectionMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteFromExperienceCollectionMutation,
		DeleteFromExperienceCollectionMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		DeleteFromExperienceCollectionMutation,
		DeleteFromExperienceCollectionMutationVariables
	>(DeleteFromExperienceCollectionDocument, options)
}
export type DeleteFromExperienceCollectionMutationHookResult = ReturnType<
	typeof useDeleteFromExperienceCollectionMutation
>
export type DeleteFromExperienceCollectionMutationResult =
	Apollo.MutationResult<DeleteFromExperienceCollectionMutation>
export type DeleteFromExperienceCollectionMutationOptions =
	Apollo.BaseMutationOptions<
		DeleteFromExperienceCollectionMutation,
		DeleteFromExperienceCollectionMutationVariables
	>
export const _UserToCompanyRoleCollectionDocument = gql`
	query _UserToCompanyRoleCollection($companyId: String) {
		_UserToCompanyRoleCollection(filter: { B: { eq: $companyId } }) {
			edges {
				node {
					...UserRoleFragment
				}
			}
		}
	}
	${UserRoleFragmentFragmentDoc}
`

/**
 * __use_UserToCompanyRoleCollectionQuery__
 *
 * To run a query within a React component, call `use_UserToCompanyRoleCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `use_UserToCompanyRoleCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = use_UserToCompanyRoleCollectionQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function use_UserToCompanyRoleCollectionQuery(
	baseOptions?: Apollo.QueryHookOptions<
		_UserToCompanyRoleCollectionQuery,
		_UserToCompanyRoleCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		_UserToCompanyRoleCollectionQuery,
		_UserToCompanyRoleCollectionQueryVariables
	>(_UserToCompanyRoleCollectionDocument, options)
}
export function use_UserToCompanyRoleCollectionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		_UserToCompanyRoleCollectionQuery,
		_UserToCompanyRoleCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		_UserToCompanyRoleCollectionQuery,
		_UserToCompanyRoleCollectionQueryVariables
	>(_UserToCompanyRoleCollectionDocument, options)
}
export function use_UserToCompanyRoleCollectionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				_UserToCompanyRoleCollectionQuery,
				_UserToCompanyRoleCollectionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		_UserToCompanyRoleCollectionQuery,
		_UserToCompanyRoleCollectionQueryVariables
	>(_UserToCompanyRoleCollectionDocument, options)
}
export type _UserToCompanyRoleCollectionQueryHookResult = ReturnType<
	typeof use_UserToCompanyRoleCollectionQuery
>
export type _UserToCompanyRoleCollectionLazyQueryHookResult = ReturnType<
	typeof use_UserToCompanyRoleCollectionLazyQuery
>
export type _UserToCompanyRoleCollectionSuspenseQueryHookResult = ReturnType<
	typeof use_UserToCompanyRoleCollectionSuspenseQuery
>
export type _UserToCompanyRoleCollectionQueryResult = Apollo.QueryResult<
	_UserToCompanyRoleCollectionQuery,
	_UserToCompanyRoleCollectionQueryVariables
>
export const CompanyRoleCollectionDocument = gql`
	query companyRoleCollection($id: String) {
		companyRoleCollection(filter: { companyId: { eq: $id } }) {
			edges {
				node {
					id
				}
			}
		}
	}
`

/**
 * __useCompanyRoleCollectionQuery__
 *
 * To run a query within a React component, call `useCompanyRoleCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyRoleCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyRoleCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyRoleCollectionQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CompanyRoleCollectionQuery,
		CompanyRoleCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useQuery<
		CompanyRoleCollectionQuery,
		CompanyRoleCollectionQueryVariables
	>(CompanyRoleCollectionDocument, options)
}
export function useCompanyRoleCollectionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CompanyRoleCollectionQuery,
		CompanyRoleCollectionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useLazyQuery<
		CompanyRoleCollectionQuery,
		CompanyRoleCollectionQueryVariables
	>(CompanyRoleCollectionDocument, options)
}
export function useCompanyRoleCollectionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				CompanyRoleCollectionQuery,
				CompanyRoleCollectionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions }
	return Apollo.useSuspenseQuery<
		CompanyRoleCollectionQuery,
		CompanyRoleCollectionQueryVariables
	>(CompanyRoleCollectionDocument, options)
}
export type CompanyRoleCollectionQueryHookResult = ReturnType<
	typeof useCompanyRoleCollectionQuery
>
export type CompanyRoleCollectionLazyQueryHookResult = ReturnType<
	typeof useCompanyRoleCollectionLazyQuery
>
export type CompanyRoleCollectionSuspenseQueryHookResult = ReturnType<
	typeof useCompanyRoleCollectionSuspenseQuery
>
export type CompanyRoleCollectionQueryResult = Apollo.QueryResult<
	CompanyRoleCollectionQuery,
	CompanyRoleCollectionQueryVariables
>
export const HandleCompanyUsersRoleDocument = gql`
	mutation handleCompanyUsersRole($data: [_UserToCompanyRoleInsertInput!]!) {
		insertInto_UserToCompanyRoleCollection(objects: $data) {
			records {
				...UserRoleFragment
			}
		}
	}
	${UserRoleFragmentFragmentDoc}
`
export type HandleCompanyUsersRoleMutationFn = Apollo.MutationFunction<
	HandleCompanyUsersRoleMutation,
	HandleCompanyUsersRoleMutationVariables
>

/**
 * __useHandleCompanyUsersRoleMutation__
 *
 * To run a mutation, you first call `useHandleCompanyUsersRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleCompanyUsersRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleCompanyUsersRoleMutation, { data, loading, error }] = useHandleCompanyUsersRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useHandleCompanyUsersRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		HandleCompanyUsersRoleMutation,
		HandleCompanyUsersRoleMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		HandleCompanyUsersRoleMutation,
		HandleCompanyUsersRoleMutationVariables
	>(HandleCompanyUsersRoleDocument, options)
}
export type HandleCompanyUsersRoleMutationHookResult = ReturnType<
	typeof useHandleCompanyUsersRoleMutation
>
export type HandleCompanyUsersRoleMutationResult =
	Apollo.MutationResult<HandleCompanyUsersRoleMutation>
export type HandleCompanyUsersRoleMutationOptions = Apollo.BaseMutationOptions<
	HandleCompanyUsersRoleMutation,
	HandleCompanyUsersRoleMutationVariables
>
export const DeleteCompanyUserRoleDocument = gql`
	mutation deleteCompanyUserRole($filter: _UserToCompanyRoleFilter) {
		deleteFrom_UserToCompanyRoleCollection(filter: $filter) {
			records {
				...UserRoleFragment
			}
		}
	}
	${UserRoleFragmentFragmentDoc}
`
export type DeleteCompanyUserRoleMutationFn = Apollo.MutationFunction<
	DeleteCompanyUserRoleMutation,
	DeleteCompanyUserRoleMutationVariables
>

/**
 * __useDeleteCompanyUserRoleMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyUserRoleMutation, { data, loading, error }] = useDeleteCompanyUserRoleMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteCompanyUserRoleMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteCompanyUserRoleMutation,
		DeleteCompanyUserRoleMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions }
	return Apollo.useMutation<
		DeleteCompanyUserRoleMutation,
		DeleteCompanyUserRoleMutationVariables
	>(DeleteCompanyUserRoleDocument, options)
}
export type DeleteCompanyUserRoleMutationHookResult = ReturnType<
	typeof useDeleteCompanyUserRoleMutation
>
export type DeleteCompanyUserRoleMutationResult =
	Apollo.MutationResult<DeleteCompanyUserRoleMutation>
export type DeleteCompanyUserRoleMutationOptions = Apollo.BaseMutationOptions<
	DeleteCompanyUserRoleMutation,
	DeleteCompanyUserRoleMutationVariables
>
